/* eslint-disable */
import { DateOnly } from 'src/utils/dates';
import { DateTime } from 'src/utils/dates';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: DateOnly;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: DateTime;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `BigInt` scalar type represents non-fractional signed whole numeric values. */
  BigInt: any;
};

export type Address = {
  __typename?: 'Address';
  id: Scalars['ID'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  state: Scalars['String'];
  postalCode: Scalars['String'];
  country: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type SaveAddressResult = {
  __typename?: 'SaveAddressResult';
  address: Address;
};

export type Mutation = {
  __typename?: 'Mutation';
  saveAnchorFloatingDrawModel: SaveAnchorFloatingDrawModelResult;
  refreshDrawModelBlueprintData: EmptyResult;
  saveAnchorFloatingDrawModelCostItem: SaveAnchorFloatingDrawModelCostItemResult;
  saveAnchorMultilotDrawModel: SaveAnchorMultilotDrawModelResult;
  saveAnchorMultilotDrawModelCostItem: SaveAnchorMultilotDrawModelCostItemResult;
  /**  Creates an asset upload url with the following  key structure `assets/${UUID}`.  */
  createAssetUploadUrl: CreateAssetUploadUrlResult;
  saveConfiguration: SaveConfigurationResult;
  importConfiguration: EmptyResult;
  saveConfigurationToOption: SaveConfigurationToOptionResult;
  saveConfigurationToOptions: SaveConfigurationToOptionsResult;
  importConfigurationToOption: EmptyResult;
  saveCreditFacilityDraw: SaveCreditFacilityDrawResult;
  deleteCreditFacilityDraw: EmptyResult;
  createOffsettingPaymentForCreditFacilityDraw: CreateOffsettingPaymentForCreditFacilityDrawResult;
  saveCreditFacilityDrawRequest: SaveCreditFacilityDrawRequestResult;
  deleteCreditFacilityDrawRequest: EmptyResult;
  saveCreditFacilityInvoice: SaveCreditFacilityInvoiceResult;
  deleteCreditFacilityInvoice: EmptyResult;
  saveCreditFacilityInvoiceDrawInterest: SaveCreditFacilityInvoiceDrawInterestResult;
  saveCreditFacilityPayment: SaveCreditFacilityPaymentResult;
  addOpenDrawsToCreditFacilityPayment: AddOpenDrawsToCreditFacilityPaymentResult;
  deleteCreditFacilityPayment: EmptyResult;
  saveDocuments: SaveDocumentsResult;
  deleteDocument: EmptyResult;
  saveElevation: SaveElevationResult;
  importElevation: EmptyResult;
  saveElevationStyle: SaveElevationStyleResult;
  importElevationStyle: EmptyResult;
  saveEquityFinancingCost: SaveEquityFinancingCostResult;
  deleteEquityFinancingCost: EmptyResult;
  regenerateAllMonthlyEquityFinanceValues: RegenerateAllMonthlyEquityFinanceValuesResult;
  saveExteriorImage: SaveExteriorImageResult;
  importExteriorImage: EmptyResult;
  saveFloor: SaveFloorResult;
  importFloor: EmptyResult;
  saveFund: SaveFundResult;
  exportBillsForDraw: ExportBillsForDrawResult;
  saveFundMetro: SaveFundMetroResult;
  ensureAllFundMetros: EnsureAllFundMetrosResult;
  saveFundOwnerEntity: SaveFundOwnerEntityResult;
  saveGoldmanDrawModels: SaveGoldmanDrawModelsResult;
  saveGoldmanDrawModelCostItem: SaveGoldmanDrawModelCostItemResult;
  saveHelloWorld: SaveHelloWorldResult;
  saveHomeowner: SaveHomeownerResult;
  saveInteriorImage: SaveInteriorImageResult;
  importInteriorImage: EmptyResult;
  saveInternalUser: SaveInternalUserResult;
  addJobs: EmptyResult;
  saveLot: SaveLotResult;
  saveLots: SaveLotsResult;
  backfillUnderwrittenReturnMetrics: BackfillUnderwrittenReturnMetricsResult;
  sendCustomerInformationToBlueprint: SendCustomerInformationToBlueprintResult;
  createDirectUnderwritingContracts: CreateDirectUnderwritingContractsResult;
  saveLotAcqPurchaseAgreement: SaveLotAcqPurchaseAgreementResult;
  deleteLotAcqPurchaseAgreement: EmptyResult;
  saveLotAcqSettlementStatement: SaveLotAcqSettlementStatementResult;
  deleteLotAcqSettlementStatement: EmptyResult;
  processLotAcqSettlementStatementOcr: LotAcqSettlementStatement;
  sendLotAcqSettlementStatementForBooking: LotAcqSettlementStatement;
  saveLotPartition: SaveLotPartitionResult;
  saveLotPartitions: SaveLotPartitionsResult;
  backfillLotPartitionUnderwrittenCosts: BackfillLotPartitionUnderwrittenCostsResult;
  saveLotPartitionContract: SaveLotPartitionContractResult;
  saveLotPartitionContracts: SaveLotPartitionContractsResult;
  deleteLotPartitionContract: EmptyResult;
  deleteLotPartitionContracts: EmptyResult;
  saveLotPartitionDraw: SaveLotPartitionDrawResult;
  saveLotPartitionDrawPayment: SaveLotPartitionDrawPaymentResult;
  saveLotPartitionDrawRequest: SaveLotPartitionDrawRequestResult;
  saveLotPartitionDrawRequests: SaveLotPartitionDrawRequestsResult;
  saveLotPartitionEstimate: SaveLotPartitionEstimateResult;
  deleteLotPartitionEstimate: EmptyResult;
  saveLotPartitionInvoices: SaveLotPartitionInvoicesResult;
  saveLotPartitionPayments: SaveLotPartitionPaymentsResult;
  saveLotPartitionValuation: SaveLotPartitionValuationResult;
  saveLotPartitionValuations: SaveLotPartitionValuationsResult;
  saveMetro: SaveMetroResult;
  recalculateSeasonalityForMetro: RecalculateSeasonalityForMetroResult;
  saveOption: SaveOptionResult;
  importOption: EmptyResult;
  syncDeleteOptions: EmptyResult;
  saveOptionToOption: SaveOptionToOptionResult;
  importOptionToOption: EmptyResult;
  saveOptionToSpecLevel: SaveOptionToSpecLevelResult;
  importOptionToSpecLevel: EmptyResult;
  savePlan: SavePlanResult;
  importPlan: EmptyResult;
  importAll: EmptyResult;
  savePropertySaleSettlementStatement: SavePropertySaleSettlementStatementResult;
  deletePropertySaleSettlementStatement: EmptyResult;
  sendPropertySaleSettlementStatementForBooking: PropertySaleSettlementStatement;
  saveSeasonalityMonthlyMultiplier: SaveSeasonalityMonthlyMultiplierResult;
  saveSpecLevel: SaveSpecLevelResult;
  importSpecLevel: EmptyResult;
  saveSpecLevelStyle: SaveSpecLevelStyleResult;
  importSpecLevelStyle: EmptyResult;
  saveUnderwritingConfig: SaveUnderwritingConfigResult;
  saveUnderwritingConfigMetro: SaveUnderwritingConfigMetroResult;
  saveUser: SaveUserResult;
  activateUser: ActivateUserResult;
  deactivateUser: DeactivateUserResult;
};


export type MutationSaveAnchorFloatingDrawModelArgs = {
  input: SaveAnchorFloatingDrawModelInput;
};


export type MutationRefreshDrawModelBlueprintDataArgs = {
  input: RefreshDrawModelBlueprintDataInput;
};


export type MutationSaveAnchorFloatingDrawModelCostItemArgs = {
  input: SaveAnchorFloatingDrawModelCostItemInput;
};


export type MutationSaveAnchorMultilotDrawModelArgs = {
  input: SaveAnchorMultilotDrawModelInput;
};


export type MutationSaveAnchorMultilotDrawModelCostItemArgs = {
  input: SaveAnchorMultilotDrawModelCostItemInput;
};


export type MutationCreateAssetUploadUrlArgs = {
  input: CreateAssetUploadUrlInput;
};


export type MutationSaveConfigurationArgs = {
  input: SaveConfigurationInput;
};


export type MutationSaveConfigurationToOptionArgs = {
  input: SaveConfigurationToOptionInput;
};


export type MutationSaveConfigurationToOptionsArgs = {
  input: SaveConfigurationToOptionsInput;
};


export type MutationSaveCreditFacilityDrawArgs = {
  input: SaveCreditFacilityDrawInput;
};


export type MutationDeleteCreditFacilityDrawArgs = {
  input: DeleteEntityInput;
};


export type MutationCreateOffsettingPaymentForCreditFacilityDrawArgs = {
  input: CreateOffsettingPaymentForCreditFacilityDrawInput;
};


export type MutationSaveCreditFacilityDrawRequestArgs = {
  input: SaveCreditFacilityDrawRequestInput;
};


export type MutationDeleteCreditFacilityDrawRequestArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveCreditFacilityInvoiceArgs = {
  input: SaveCreditFacilityInvoiceInput;
};


export type MutationDeleteCreditFacilityInvoiceArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveCreditFacilityInvoiceDrawInterestArgs = {
  input: SaveCreditFacilityInvoiceDrawInterestInput;
};


export type MutationSaveCreditFacilityPaymentArgs = {
  input: SaveCreditFacilityPaymentInput;
};


export type MutationAddOpenDrawsToCreditFacilityPaymentArgs = {
  input: AddOpenDrawsToCreditFacilityPaymentInput;
};


export type MutationDeleteCreditFacilityPaymentArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveDocumentsArgs = {
  input: SaveDocumentsInput;
};


export type MutationDeleteDocumentArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveElevationArgs = {
  input: SaveElevationInput;
};


export type MutationSaveElevationStyleArgs = {
  input: SaveElevationStyleInput;
};


export type MutationSaveEquityFinancingCostArgs = {
  input: SaveEquityFinancingCostInput;
};


export type MutationDeleteEquityFinancingCostArgs = {
  input: DeleteEntityInput;
};


export type MutationRegenerateAllMonthlyEquityFinanceValuesArgs = {
  input: RegenerateAllMonthlyEquityFinanceValuesInput;
};


export type MutationSaveExteriorImageArgs = {
  input: SaveExteriorImageInput;
};


export type MutationSaveFloorArgs = {
  input: SaveFloorInput;
};


export type MutationSaveFundArgs = {
  input: SaveFundInput;
};


export type MutationExportBillsForDrawArgs = {
  input: ExportBillsForDrawInput;
};


export type MutationSaveFundMetroArgs = {
  input: SaveFundMetroInput;
};


export type MutationEnsureAllFundMetrosArgs = {
  input: EnsureAllFundMetrosInput;
};


export type MutationSaveFundOwnerEntityArgs = {
  input: SaveFundOwnerEntityInput;
};


export type MutationSaveGoldmanDrawModelsArgs = {
  input: SaveGoldmanDrawModelsInput;
};


export type MutationSaveGoldmanDrawModelCostItemArgs = {
  input: SaveGoldmanDrawModelCostItemInput;
};


export type MutationSaveHelloWorldArgs = {
  input: SaveHelloWorldInput;
};


export type MutationSaveHomeownerArgs = {
  input: SaveHomeownerInput;
};


export type MutationSaveInteriorImageArgs = {
  input: SaveInteriorImageInput;
};


export type MutationSaveInternalUserArgs = {
  input: SaveInternalUserInput;
};


export type MutationAddJobsArgs = {
  input: AddJobsInput;
};


export type MutationSaveLotArgs = {
  input: SaveLotInput;
};


export type MutationSaveLotsArgs = {
  input: SaveLotsInput;
};


export type MutationBackfillUnderwrittenReturnMetricsArgs = {
  input: BackfillUnderwrittenReturnMetricsInput;
};


export type MutationSendCustomerInformationToBlueprintArgs = {
  input: SendCustomerInformationToBlueprintInput;
};


export type MutationCreateDirectUnderwritingContractsArgs = {
  input: CreateDirectUnderwritingContractsInput;
};


export type MutationSaveLotAcqPurchaseAgreementArgs = {
  input: SaveLotAcqPurchaseAgreementInput;
};


export type MutationDeleteLotAcqPurchaseAgreementArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveLotAcqSettlementStatementArgs = {
  input: SaveLotAcqSettlementStatementInput;
};


export type MutationDeleteLotAcqSettlementStatementArgs = {
  input: DeleteEntityInput;
};


export type MutationProcessLotAcqSettlementStatementOcrArgs = {
  input: ProcessLotAcqSettlementStatementOcrInput;
};


export type MutationSendLotAcqSettlementStatementForBookingArgs = {
  input: SendLotAcqSettlementStatementForBookingInput;
};


export type MutationSaveLotPartitionArgs = {
  input: SaveLotPartitionInput;
};


export type MutationSaveLotPartitionsArgs = {
  input: SaveLotPartitionsInput;
};


export type MutationBackfillLotPartitionUnderwrittenCostsArgs = {
  input: BackfillLotPartitionUnderwrittenCostsInput;
};


export type MutationSaveLotPartitionContractArgs = {
  input: SaveLotPartitionContractInput;
};


export type MutationSaveLotPartitionContractsArgs = {
  input: SaveLotPartitionContractsInput;
};


export type MutationDeleteLotPartitionContractArgs = {
  input: DeleteEntityInput;
};


export type MutationDeleteLotPartitionContractsArgs = {
  input: DeleteEntitiesInput;
};


export type MutationSaveLotPartitionDrawArgs = {
  input: SaveLotPartitionDrawInput;
};


export type MutationSaveLotPartitionDrawPaymentArgs = {
  input: SaveLotPartitionDrawPaymentInput;
};


export type MutationSaveLotPartitionDrawRequestArgs = {
  input: SaveLotPartitionDrawRequestInput;
};


export type MutationSaveLotPartitionDrawRequestsArgs = {
  input: SaveLotPartitionDrawRequestsInput;
};


export type MutationSaveLotPartitionEstimateArgs = {
  input: SaveLotPartitionEstimateInput;
};


export type MutationDeleteLotPartitionEstimateArgs = {
  input: DeleteEntityInput;
};


export type MutationSaveLotPartitionInvoicesArgs = {
  input: SaveLotPartitionInvoicesInput;
};


export type MutationSaveLotPartitionPaymentsArgs = {
  input: SaveLotPartitionPaymentsInput;
};


export type MutationSaveLotPartitionValuationArgs = {
  input: SaveLotPartitionValuationInput;
};


export type MutationSaveLotPartitionValuationsArgs = {
  input: SaveLotPartitionValuationsInput;
};


export type MutationSaveMetroArgs = {
  input: SaveMetroInput;
};


export type MutationRecalculateSeasonalityForMetroArgs = {
  input: RecalculateSeasonalityForMetroInput;
};


export type MutationSaveOptionArgs = {
  input: SaveOptionInput;
};


export type MutationSaveOptionToOptionArgs = {
  input: SaveOptionToOptionInput;
};


export type MutationSaveOptionToSpecLevelArgs = {
  input: SaveOptionToSpecLevelInput;
};


export type MutationSavePlanArgs = {
  input: SavePlanInput;
};


export type MutationSavePropertySaleSettlementStatementArgs = {
  input: SavePropertySaleSettlementStatementInput;
};


export type MutationDeletePropertySaleSettlementStatementArgs = {
  input: DeleteEntityInput;
};


export type MutationSendPropertySaleSettlementStatementForBookingArgs = {
  input: SendPropertySaleSettlementStatementForBookingInput;
};


export type MutationSaveSeasonalityMonthlyMultiplierArgs = {
  input: SaveSeasonalityMonthlyMultiplierInput;
};


export type MutationSaveSpecLevelArgs = {
  input: SaveSpecLevelInput;
};


export type MutationSaveSpecLevelStyleArgs = {
  input: SaveSpecLevelStyleInput;
};


export type MutationSaveUnderwritingConfigArgs = {
  input: SaveUnderwritingConfigInput;
};


export type MutationSaveUnderwritingConfigMetroArgs = {
  input: SaveUnderwritingConfigMetroInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};

export type AnchorFloatingDrawModel = {
  __typename?: 'AnchorFloatingDrawModel';
  id: Scalars['ID'];
  asOfDate: Scalars['Date'];
  isBlueprintCostDataSet?: Maybe<Scalars['Boolean']>;
  lotPartition: LotPartition;
  lotPartitionDrawRequest?: Maybe<LotPartitionDrawRequest>;
  costItems: Array<AnchorFloatingDrawModelCostItem>;
  completedSoftCostsInCents: Scalars['Int'];
  completedIndirectCostsInCents: Scalars['Int'];
  completedDirectCostsInCents: Scalars['Int'];
  completedBuilderFeeInCents: Scalars['Int'];
  completedConstructionExpensesInCents: Scalars['Int'];
};

export type SaveAnchorFloatingDrawModelResult = {
  __typename?: 'SaveAnchorFloatingDrawModelResult';
  anchorFloatingDrawModel: AnchorFloatingDrawModel;
};

export type AnchorFloatingDrawModelCostItem = {
  __typename?: 'AnchorFloatingDrawModelCostItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  builderFeeInCents: Scalars['Int'];
  fullCostCodeNumber: Scalars['String'];
  costType: CostTypeDetail;
  anchorFloatingDrawModel: AnchorFloatingDrawModel;
  date: Scalars['Date'];
};

export type SaveAnchorFloatingDrawModelCostItemResult = {
  __typename?: 'SaveAnchorFloatingDrawModelCostItemResult';
  anchorFloatingDrawModelCostItem: AnchorFloatingDrawModelCostItem;
};

export type AnchorMultilotDrawModel = {
  __typename?: 'AnchorMultilotDrawModel';
  id: Scalars['ID'];
  realizedSoftCostsInCents: Scalars['Int'];
  realizedIndirectCostsInCents: Scalars['Int'];
  realizedDirectCostsInCents: Scalars['Int'];
  realizedBuilderFeeInCents: Scalars['Int'];
  realizedConstructionExpensesInCents: Scalars['Int'];
  lotPartition: LotPartition;
  costItems: Array<AnchorMultilotDrawModelCostItem>;
  asOfDate: Scalars['Date'];
  isBlueprintCostDataSet?: Maybe<Scalars['Boolean']>;
  lotPartitionDrawRequest?: Maybe<LotPartitionDrawRequest>;
};

export type SaveAnchorMultilotDrawModelResult = {
  __typename?: 'SaveAnchorMultilotDrawModelResult';
  anchorMultilotDrawModel: AnchorMultilotDrawModel;
};

export type AnchorMultilotDrawModelCostItem = {
  __typename?: 'AnchorMultilotDrawModelCostItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  fullCostCodeNumber: Scalars['String'];
  costType: CostTypeDetail;
  anchorMultilotDrawModel: AnchorMultilotDrawModel;
  builderFeeInCents: Scalars['Int'];
  date: Scalars['Date'];
  billNumber?: Maybe<Scalars['String']>;
};

export type SaveAnchorMultilotDrawModelCostItemResult = {
  __typename?: 'SaveAnchorMultilotDrawModelCostItemResult';
  anchorMultilotDrawModelCostItem: AnchorMultilotDrawModelCostItem;
};

export type Asset = {
  __typename?: 'Asset';
  id: Scalars['ID'];
  contentType: Scalars['String'];
  /**
   * After the asset is uploaded, it can be downloaded from this URL.
   *
   * This is an S3 signed url, which means the user has already been authed when
   * creating the returned URL, and so can directly access this URL without any extra auth.
   * However, that also means this URL is unique per request (it has timestamps in it)
   * and so won't be cached.
   *
   * It expires after 1 week.
   */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
  /**
   * Similar to downloadUrl, but is a consistent path like `/asset?id=assetId` so
   * that caching works.
   *
   * Note that auth will be done on access to `/asset` and so currently this only
   * works for internal users.
   */
  url: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  sizeInBytes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
  document?: Maybe<Document>;
};


export type AssetPreviewUrlArgs = {
  resizing: AssetResizing;
};

export type CreateAssetUploadUrlResult = {
  __typename?: 'CreateAssetUploadUrlResult';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
  /** After the asset is uploaded, it can be viewed at this URL. */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   * Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Only generated if previewResizing is provided as mutation input
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  configuration: Configuration;
  creditFacilityDraws: Array<CreditFacilityDraw>;
  creditFacilityDrawRequests: Array<CreditFacilityDrawRequest>;
  creditFacilityInvoices: Array<CreditFacilityInvoice>;
  creditFacilityPayments: Array<CreditFacilityPayment>;
  documents: Array<Document>;
  funds: Array<Fund>;
  homePriceAppreciationMonthlyMultiplier: Array<HomePriceAppreciationMonthlyMultiplier>;
  lots: Array<Lot>;
  lotPartitions: Array<LotPartition>;
  estimateDirectMarginImpactToLotPartition: EstimateDirectMarginImpactToLotPartitionResult;
  lotPartitionContracts: Array<LotPartitionContract>;
  lotPartitionEstimates: Array<LotPartitionEstimate>;
  metros: Array<Metro>;
  options: Array<Option>;
  plans: Array<Plan>;
  /**  fuzzy search for properties matching address  */
  properties: Array<Property>;
  /**  property details  */
  property?: Maybe<Property>;
  testQuery: Scalars['Int'];
  seasonalityMonthlyMultiplier: Array<SeasonalityMonthlyMultiplier>;
  specLevels: Array<SpecLevel>;
  underwritingConfigs: Array<UnderwritingConfig>;
  underwritingInternalRateOfReturnCalculator: UnderwritingInternalRateOfReturnCalculatorResult;
};


export type QueryConfigurationArgs = {
  code: Scalars['String'];
};


export type QueryCreditFacilityDrawsArgs = {
  filter?: InputMaybe<CreditFacilityDrawFilter>;
};


export type QueryCreditFacilityDrawRequestsArgs = {
  filter?: InputMaybe<CreditFacilityDrawRequestFilter>;
};


export type QueryCreditFacilityInvoicesArgs = {
  filter?: InputMaybe<CreditFacilityInvoiceFilter>;
};


export type QueryCreditFacilityPaymentsArgs = {
  filter?: InputMaybe<CreditFacilityPaymentFilter>;
};


export type QueryDocumentsArgs = {
  filter?: InputMaybe<DocumentsFilter>;
  limit?: InputMaybe<Scalars['Int']>;
};


export type QueryFundsArgs = {
  filter?: InputMaybe<FundFilter>;
};


export type QueryHomePriceAppreciationMonthlyMultiplierArgs = {
  filter: HomePriceAppreciationMonthlyMultiplierFilter;
};


export type QueryLotsArgs = {
  filter?: InputMaybe<LotFilter>;
};


export type QueryLotPartitionsArgs = {
  filter?: InputMaybe<LotPartitionsFilter>;
};


export type QueryEstimateDirectMarginImpactToLotPartitionArgs = {
  input: EstimateDirectMarginImpactToLotPartitionInput;
};


export type QueryLotPartitionContractsArgs = {
  filter: LotPartitionContractFilter;
};


export type QueryLotPartitionEstimatesArgs = {
  filter: LotPartitionEstimateFilter;
};


export type QueryMetrosArgs = {
  filter?: InputMaybe<MetrosFilter>;
};


export type QueryOptionsArgs = {
  specLevelId: Scalars['ID'];
};


export type QueryPlansArgs = {
  filter: PlansFilter;
};


export type QueryPropertiesArgs = {
  address: Scalars['String'];
};


export type QueryPropertyArgs = {
  dpid: Scalars['ID'];
};


export type QueryTestQueryArgs = {
  error?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySeasonalityMonthlyMultiplierArgs = {
  filter: SeasonalityMonthlyMultiplierFilter;
};


export type QuerySpecLevelsArgs = {
  elevationId: Scalars['ID'];
};


export type QueryUnderwritingConfigsArgs = {
  filter?: InputMaybe<UnderwritingConfigFilter>;
};


export type QueryUnderwritingInternalRateOfReturnCalculatorArgs = {
  input: UnderwritingInternalRateOfReturnCalculatorInput;
};

export type Configuration = {
  __typename?: 'Configuration';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  elevationStyle: ElevationStyle;
  plan: Plan;
  specLevel: SpecLevel;
  specLevelStyle: SpecLevelStyle;
  toOptions: Array<ConfigurationToOption>;
  completedDate?: Maybe<Scalars['DateTime']>;
  address?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type SaveConfigurationResult = {
  __typename?: 'SaveConfigurationResult';
  configuration: Configuration;
};

export type ConfigurationToOption = {
  __typename?: 'ConfigurationToOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  airtableId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  configuration: Configuration;
  option: Option;
};

export type SaveConfigurationToOptionResult = {
  __typename?: 'SaveConfigurationToOptionResult';
  configurationToOption: ConfigurationToOption;
};

export type SaveConfigurationToOptionsResult = {
  __typename?: 'SaveConfigurationToOptionsResult';
  configurationToOptions: Array<ConfigurationToOption>;
};

export type CreditFacilityDraw = {
  __typename?: 'CreditFacilityDraw';
  id: Scalars['ID'];
  drawDate: Scalars['Date'];
  amountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fund: Fund;
  lotPartitionDraws: Array<LotPartitionDraw>;
  canDelete: PotentialOperation;
  fixedRateThousandthsBasisPoints?: Maybe<Scalars['Int']>;
  request?: Maybe<CreditFacilityDrawRequest>;
};

export type SaveCreditFacilityDrawResult = {
  __typename?: 'SaveCreditFacilityDrawResult';
  creditFacilityDraw: CreditFacilityDraw;
};

export type CreateOffsettingPaymentForCreditFacilityDrawResult = {
  __typename?: 'CreateOffsettingPaymentForCreditFacilityDrawResult';
  creditFacilityPayment: CreditFacilityPayment;
};

export type CreditFacilityDrawRequest = {
  __typename?: 'CreditFacilityDrawRequest';
  id: Scalars['ID'];
  preparationDate: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fund: Fund;
  lotPartitionDrawRequests: Array<LotPartitionDrawRequest>;
  amountInCents: Scalars['Int'];
  canEdit: PotentialOperation;
  creditFacilityDraw?: Maybe<CreditFacilityDraw>;
  canDelete: PotentialOperation;
};

export type SaveCreditFacilityDrawRequestResult = {
  __typename?: 'SaveCreditFacilityDrawRequestResult';
  creditFacilityDrawRequest: CreditFacilityDrawRequest;
};

export type CreditFacilityInvoice = {
  __typename?: 'CreditFacilityInvoice';
  id: Scalars['ID'];
  invoiceDate: Scalars['Date'];
  amountInCents: Scalars['Int'];
  allocatedAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fund: Fund;
  drawInterests: Array<CreditFacilityInvoiceDrawInterest>;
  canDelete: PotentialOperation;
  drawInterestsByLotPartitionDraw: Array<CreditFacilityInvoiceDrawInterestByLotPartitionDraw>;
  lotPartitionDrawInvoices: Array<LotPartitionDrawInvoice>;
  isInterestPopulated: Scalars['Boolean'];
  baseRateThousandthsBasisPoints?: Maybe<Scalars['Int']>;
};

export type SaveCreditFacilityInvoiceResult = {
  __typename?: 'SaveCreditFacilityInvoiceResult';
  creditFacilityInvoice: CreditFacilityInvoice;
};

export type CreditFacilityInvoiceDrawInterestByLotPartitionDraw = {
  __typename?: 'CreditFacilityInvoiceDrawInterestByLotPartitionDraw';
  lotPartitionDraw: LotPartitionDraw;
  amountInCents: Scalars['Int'];
  drawInterests: Array<CreditFacilityInvoiceDrawInterest>;
};

export type CreditFacilityInvoiceDrawInterest = {
  __typename?: 'CreditFacilityInvoiceDrawInterest';
  id: Scalars['ID'];
  interestDate: Scalars['Date'];
  amountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  creditFacilityInvoice: CreditFacilityInvoice;
  lotPartitionDraw: LotPartitionDraw;
  drawAmountInCents: Scalars['Int'];
  lotPartitionDrawInvoice?: Maybe<LotPartitionDrawInvoice>;
};

export type SaveCreditFacilityInvoiceDrawInterestResult = {
  __typename?: 'SaveCreditFacilityInvoiceDrawInterestResult';
  creditFacilityInvoiceDrawInterest: CreditFacilityInvoiceDrawInterest;
};

export type CreditFacilityPayment = {
  __typename?: 'CreditFacilityPayment';
  id: Scalars['ID'];
  paymentDate: Scalars['Date'];
  amountInCents: Scalars['Int'];
  allocatedAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fund: Fund;
  lotPartitionDrawPayments: Array<LotPartitionDrawPayment>;
  canDelete: PotentialOperation;
};

export type SaveCreditFacilityPaymentResult = {
  __typename?: 'SaveCreditFacilityPaymentResult';
  creditFacilityPayment: CreditFacilityPayment;
};

export type AddOpenDrawsToCreditFacilityPaymentResult = {
  __typename?: 'AddOpenDrawsToCreditFacilityPaymentResult';
  creditFacilityPayment: CreditFacilityPayment;
};

export type Document = {
  __typename?: 'Document';
  id: Scalars['ID'];
  asset: Asset;
  blueprintDocumentId?: Maybe<Scalars['String']>;
  documentType: DocumentTypeDetail;
  parent: DocumentParent;
  lotAcqSettlementStatement?: Maybe<LotAcqSettlementStatement>;
  canCreateLotAcqSettlementStatement: PotentialOperation;
  canViewLotAcqSettlementStatement: PotentialOperation;
  lotAcqPurchaseAgreement?: Maybe<LotAcqPurchaseAgreement>;
  canCreateLotAcqPurchaseAgreement: PotentialOperation;
  canViewLotAcqPurchaseAgreement: PotentialOperation;
  propertySaleSettlementStatement?: Maybe<PropertySaleSettlementStatement>;
  canCreatePropertySaleSettlementStatement: PotentialOperation;
  canViewPropertySaleSettlementStatement: PotentialOperation;
};

export type SaveDocumentsResult = {
  __typename?: 'SaveDocumentsResult';
  documents: Array<Document>;
};

export type Elevation = {
  __typename?: 'Elevation';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  configurations: Array<Configuration>;
  styles: Array<ElevationStyle>;
  specLevels: Array<SpecLevel>;
};

export type SaveElevationResult = {
  __typename?: 'SaveElevationResult';
  elevation: Elevation;
};

export type ElevationStyle = {
  __typename?: 'ElevationStyle';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  configurations: Array<Configuration>;
  exteriorImages: Array<ExteriorImage>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveElevationStyleResult = {
  __typename?: 'SaveElevationStyleResult';
  elevationStyle: ElevationStyle;
};

export type CostTypeDetail = {
  __typename?: 'CostTypeDetail';
  code: CostType;
  name: Scalars['String'];
};

export type CreditFacilityInterestTypeDetail = {
  __typename?: 'CreditFacilityInterestTypeDetail';
  code: CreditFacilityInterestType;
  name: Scalars['String'];
};

export type DocumentTypeDetail = {
  __typename?: 'DocumentTypeDetail';
  code: DocumentType;
  name: Scalars['String'];
};

export type FundCreditFacilityDrawModelDetail = {
  __typename?: 'FundCreditFacilityDrawModelDetail';
  code: FundCreditFacilityDrawModel;
  name: Scalars['String'];
};

export type LotAcqSettlementStatementLineItemTypeDetail = {
  __typename?: 'LotAcqSettlementStatementLineItemTypeDetail';
  code: LotAcqSettlementStatementLineItemType;
  name: Scalars['String'];
};

export type LotInvestmentStatusDetail = {
  __typename?: 'LotInvestmentStatusDetail';
  code: LotInvestmentStatus;
  name: Scalars['String'];
};

export type LotPartitionEstimateStatusDetail = {
  __typename?: 'LotPartitionEstimateStatusDetail';
  code: LotPartitionEstimateStatus;
  name: Scalars['String'];
};

export type LotPartitionEstimateTypeDetail = {
  __typename?: 'LotPartitionEstimateTypeDetail';
  code: LotPartitionEstimateType;
  name: Scalars['String'];
};

export type LotPartitionSalesStatusDetail = {
  __typename?: 'LotPartitionSalesStatusDetail';
  code: LotPartitionSalesStatus;
  name: Scalars['String'];
};

export type LotTypeDetail = {
  __typename?: 'LotTypeDetail';
  code: LotType;
  name: Scalars['String'];
};

export type PropertySaleSettlementStatementLineItemTypeDetail = {
  __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail';
  code: PropertySaleSettlementStatementLineItemType;
  name: Scalars['String'];
};

export type UserTypeDetail = {
  __typename?: 'UserTypeDetail';
  code: UserType;
  name: Scalars['String'];
};

export type AllEnumDetails = {
  __typename?: 'AllEnumDetails';
  costType: Array<CostTypeDetail>;
  creditFacilityInterestType: Array<CreditFacilityInterestTypeDetail>;
  documentType: Array<DocumentTypeDetail>;
  fundCreditFacilityDrawModel: Array<FundCreditFacilityDrawModelDetail>;
  lotAcqSettlementStatementLineItemType: Array<LotAcqSettlementStatementLineItemTypeDetail>;
  lotInvestmentStatus: Array<LotInvestmentStatusDetail>;
  lotPartitionEstimateStatus: Array<LotPartitionEstimateStatusDetail>;
  lotPartitionEstimateType: Array<LotPartitionEstimateTypeDetail>;
  lotPartitionSalesStatus: Array<LotPartitionSalesStatusDetail>;
  lotType: Array<LotTypeDetail>;
  propertySaleSettlementStatementLineItemType: Array<PropertySaleSettlementStatementLineItemTypeDetail>;
  userType: Array<UserTypeDetail>;
};

export type EquityFinancingCost = {
  __typename?: 'EquityFinancingCost';
  id: Scalars['ID'];
  interestDate: Scalars['Date'];
  interestAmountInCents: Scalars['Int'];
  equityAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lot?: Maybe<Lot>;
  lotPartition?: Maybe<LotPartition>;
};

export type SaveEquityFinancingCostResult = {
  __typename?: 'SaveEquityFinancingCostResult';
  equityFinancingCost: EquityFinancingCost;
};

export type RegenerateAllMonthlyEquityFinanceValuesResult = {
  __typename?: 'RegenerateAllMonthlyEquityFinanceValuesResult';
  lots: Array<Lot>;
  lotPartitions: Array<LotPartition>;
};

export type ExteriorImage = {
  __typename?: 'ExteriorImage';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevationStyle: ElevationStyle;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveExteriorImageResult = {
  __typename?: 'SaveExteriorImageResult';
  exteriorImage: ExteriorImage;
};

export type Floor = {
  __typename?: 'Floor';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  options: Array<Option>;
};

export type SaveFloorResult = {
  __typename?: 'SaveFloorResult';
  floor: Floor;
};

export type Fund = {
  __typename?: 'Fund';
  id: Scalars['ID'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lots: Array<Lot>;
  targetInvestorMarginBasisPoints: Scalars['Int'];
  opcoDirectHardCostMarkupBasisPoints: Scalars['Int'];
  opcoIndirectHardCostMarkupBasisPoints: Scalars['Int'];
  opcoSoftCostMarkupBasisPoints: Scalars['Int'];
  creditFacilityFixedRateBasisPoints: Scalars['Int'];
  opcoSiteAcquisitionMarkupBasisPoints: Scalars['Int'];
  creditFacilityCanBorrowDirectCosts: Scalars['Boolean'];
  creditFacilityCanBorrowIndirectCosts: Scalars['Boolean'];
  creditFacilityCanBorrowSoftCosts: Scalars['Boolean'];
  creditFacilityDraws: Array<CreditFacilityDraw>;
  creditFacilityPayments: Array<CreditFacilityPayment>;
  creditFacilityInvoices: Array<CreditFacilityInvoice>;
  metros: Array<FundMetro>;
  equityFinancingBasisPoints: Scalars['Int'];
  salesforceName?: Maybe<Scalars['String']>;
  closedBooksDate?: Maybe<Scalars['Date']>;
  blueprintCustomerId?: Maybe<Scalars['String']>;
  creditFacilityDrawModel?: Maybe<FundCreditFacilityDrawModelDetail>;
  creditFacilityDrawRequests: Array<CreditFacilityDrawRequest>;
  ownerEntities: Array<FundOwnerEntity>;
  creditFacilityInterestType: CreditFacilityInterestTypeDetail;
};

export type SaveFundResult = {
  __typename?: 'SaveFundResult';
  fund: Fund;
};

export type ExportBillsForDrawResult = {
  __typename?: 'ExportBillsForDrawResult';
  googleDriveFolderId: Scalars['String'];
};

export type FundMetro = {
  __typename?: 'FundMetro';
  id: Scalars['ID'];
  targetInvestorMarginBasisPoints: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fund: Fund;
  metro: Metro;
};

export type SaveFundMetroResult = {
  __typename?: 'SaveFundMetroResult';
  fundMetro: FundMetro;
};

export type EnsureAllFundMetrosResult = {
  __typename?: 'EnsureAllFundMetrosResult';
  fundMetros: Array<FundMetro>;
};

export type FundOwnerEntity = {
  __typename?: 'FundOwnerEntity';
  id: Scalars['ID'];
  name: Scalars['String'];
  fund?: Maybe<Fund>;
  lots: Array<Lot>;
};

export type SaveFundOwnerEntityResult = {
  __typename?: 'SaveFundOwnerEntityResult';
  fundOwnerEntity: FundOwnerEntity;
};

export type GoldmanDrawModel = {
  __typename?: 'GoldmanDrawModel';
  id: Scalars['ID'];
  borrowingBaseInCents: Scalars['Int'];
  realizedConstructionExpensesInCents: Scalars['Int'];
  isFinishedProperty: Scalars['Boolean'];
  isPropertySold: Scalars['Boolean'];
  currentAppraisalValueInCents?: Maybe<Scalars['Int']>;
  advanceRateBasisPoints: Scalars['Int'];
  adjustedAdvanceRateBasisPoints: Scalars['Int'];
  landCostsInCents: Scalars['Int'];
  adjustedCollateralValueInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lotPartition: LotPartition;
  asOfDate: Scalars['Date'];
  realizedSoftCostsInCents: Scalars['Int'];
  realizedIndirectCostsInCents: Scalars['Int'];
  realizedDirectCostsInCents: Scalars['Int'];
  realizedBuilderFeeInCents: Scalars['Int'];
  homeboundPortionInCents: Scalars['Int'];
  adjustedConstructionExpensesInCents: Scalars['Int'];
  lotCostToUnderwrittenNetSalesPriceBasisPoints: Scalars['Int'];
  isEligibleForGoldmanDraw: Scalars['Boolean'];
  isLotCostToUnderwrittenNetSalesPriceEligible: Scalars['Boolean'];
  isOwnedLessThan_721Days: Scalars['Boolean'];
  isHorizontalComplete: Scalars['Boolean'];
  isAppraisalAgeAcceptable: Scalars['Boolean'];
  isInfillOrDeveloperCommunity: Scalars['Boolean'];
  isLandCostEligible: Scalars['Boolean'];
  isUnderwrittenHardCostEligible: Scalars['Boolean'];
  isLandCostAndConstructionExpensesEligible: Scalars['Boolean'];
  isUnderwrittenMarginEligible: Scalars['Boolean'];
  isBedroomsEligible: Scalars['Boolean'];
  isSqftEligible: Scalars['Boolean'];
  isBathroomsEligible: Scalars['Boolean'];
  isExpandedBuy: Scalars['Boolean'];
  isTargetBuy: Scalars['Boolean'];
  isLandCostTargetEligible: Scalars['Boolean'];
  isLotCostToUnderwrittenNetSalesPriceTargetEligible: Scalars['Boolean'];
  isConstructionExpensesTargetEligible: Scalars['Boolean'];
  isLandCostAndConstructionExpensesTargetEligible: Scalars['Boolean'];
  lotPartitionDrawRequest?: Maybe<LotPartitionDrawRequest>;
  borrowingBaseWithExcessConcentrationLimitInCents: Scalars['Int'];
  advanceRatePreconBasisPoints: Scalars['Int'];
  isBlueprintCostDataSet?: Maybe<Scalars['Boolean']>;
  costItems: Array<GoldmanDrawModelCostItem>;
  isVictoryOverride?: Maybe<Scalars['Boolean']>;
  isVerticalComplete: Scalars['Boolean'];
  underwrittenSalesPriceMarginBasisPoints: Scalars['Int'];
};

export type SaveGoldmanDrawModelsResult = {
  __typename?: 'SaveGoldmanDrawModelsResult';
  goldmanDrawModels: Array<GoldmanDrawModel>;
};

export type GoldmanDrawModelCostItem = {
  __typename?: 'GoldmanDrawModelCostItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  costCodeNumber: Scalars['String'];
  goldmanDrawModel: GoldmanDrawModel;
  costType: CostTypeDetail;
  date: Scalars['Date'];
  billNumber?: Maybe<Scalars['String']>;
};

export type SaveGoldmanDrawModelCostItemResult = {
  __typename?: 'SaveGoldmanDrawModelCostItemResult';
  goldmanDrawModelCostItem: GoldmanDrawModelCostItem;
};

export type HelloWorld = {
  __typename?: 'HelloWorld';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveHelloWorldResult = {
  __typename?: 'SaveHelloWorldResult';
  helloWorld: HelloWorld;
};

export type HomePriceAppreciationMonthlyMultiplier = {
  __typename?: 'HomePriceAppreciationMonthlyMultiplier';
  id: Scalars['ID'];
  valuationDate: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  percentile_10: Scalars['Float'];
  percentile_20: Scalars['Float'];
  percentile_50: Scalars['Float'];
  percentile_80: Scalars['Float'];
  percentile_90: Scalars['Float'];
  postalCode: Scalars['String'];
};

export type Homeowner = {
  __typename?: 'Homeowner';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  lastActive?: Maybe<Scalars['DateTime']>;
};

export type SaveHomeownerResult = {
  __typename?: 'SaveHomeownerResult';
  homeowner: Homeowner;
};

export type InteriorImage = {
  __typename?: 'InteriorImage';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  specLevelStyle: SpecLevelStyle;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveInteriorImageResult = {
  __typename?: 'SaveInteriorImageResult';
  interiorImage: InteriorImage;
};

export type InternalUser = {
  __typename?: 'InternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  avatarUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type SaveInternalUserResult = {
  __typename?: 'SaveInternalUserResult';
  internalUser: InternalUser;
};

export type Lot = {
  __typename?: 'Lot';
  id: Scalars['ID'];
  purchasePriceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lotInvestmentStatus: LotInvestmentStatusDetail;
  partitions: Array<LotPartition>;
  salesforceOpportunityId?: Maybe<Scalars['String']>;
  dpid?: Maybe<Scalars['String']>;
  originalUwReportId?: Maybe<Scalars['Int']>;
  primeEstimateSoftCostInCents: Scalars['Int'];
  primeEstimateHardCostInCents: Scalars['Int'];
  primeEstimateDirectHardCostInCents: Scalars['Int'];
  primeEstimateIndirectHardCostInCents: Scalars['Int'];
  primeEstimateOpcoMarkupInCents: Scalars['Int'];
  primeEstimateReadyForClearToCloseReport: Scalars['Boolean'];
  primeEstimateBlueprintIds: Array<Scalars['String']>;
  primeEstimateContingencyPriceInCents: Scalars['Int'];
  underwrittenSoftCostInCents: Scalars['BigInt'];
  underwrittenIndirectHardCostInCents: Scalars['BigInt'];
  underwrittenDirectHardCostInCents: Scalars['BigInt'];
  underwrittenOpcoMarkupInCents: Scalars['BigInt'];
  softCostInCents: Scalars['BigInt'];
  indirectHardCostInCents: Scalars['BigInt'];
  directHardCostInCents: Scalars['BigInt'];
  opcoMarkupInCents: Scalars['BigInt'];
  opcoTotalCostInCents: Scalars['BigInt'];
  underwrittenOpcoTotalCostInCents: Scalars['BigInt'];
  underwrittenInterestRateBasisPoints: Scalars['Int'];
  underwrittenProjectedLoanDurationInDays: Scalars['Int'];
  underwrittenSiteAcquisitionMarkupBasisPoints: Scalars['Int'];
  underwrittenLoanToCostBasisPoints: Scalars['Int'];
  weightedDurationOfDrawBasisPoints: Scalars['Int'];
  address?: Maybe<Address>;
  underwrittenTotalSaleValueInCents: Scalars['BigInt'];
  underwrittenTotalNetSaleRevenueInCents: Scalars['BigInt'];
  investorMarginBasisPoints: Scalars['Int'];
  underwrittenFinancingCostInCents: Scalars['Int'];
  underwrittenTotalCostInCents: Scalars['BigInt'];
  underwrittenInvestorMarginBasisPoints: Scalars['Int'];
  totalCostInCents: Scalars['BigInt'];
  financingCostInCents: Scalars['Int'];
  opcoSiteAcquisitionMarkupInCents: Scalars['Int'];
  clearToCloseUwReportId?: Maybe<Scalars['Int']>;
  underwrittenDate?: Maybe<Scalars['Date']>;
  totalSaleValueInCents: Scalars['BigInt'];
  totalNetSaleRevenueInCents: Scalars['BigInt'];
  fund?: Maybe<Fund>;
  underwrittenPurchasePriceInCents: Scalars['Int'];
  underwrittenClosingCostsInCents: Scalars['Int'];
  underwrittenTotalLotAcquisitionCostsInCents: Scalars['Int'];
  isLegacyUwPurchasePrice?: Maybe<Scalars['Boolean']>;
  isLegacyUwFinancingCosts?: Maybe<Scalars['Boolean']>;
  acquisitionDate?: Maybe<Scalars['Date']>;
  equityFinancingCostInCents: Scalars['Int'];
  equityFinancingCosts: Array<EquityFinancingCost>;
  totalEquityFinancingCostInCents: Scalars['Int'];
  legalEntityName?: Maybe<Scalars['String']>;
  fundContributionDate?: Maybe<Scalars['Date']>;
  metro?: Maybe<Metro>;
  origin?: Maybe<Scalars['String']>;
  underContractAmountInCents: Scalars['Int'];
  underContractDate?: Maybe<Scalars['Date']>;
  contingencyExpirationDate?: Maybe<Scalars['Date']>;
  expectedCloseDate?: Maybe<Scalars['Date']>;
  underwrittenPreconDurationInMonths?: Maybe<Scalars['Float']>;
  underwrittenConstructionDurationInMonths?: Maybe<Scalars['Float']>;
  underwrittenSalesDurationInMonths?: Maybe<Scalars['Float']>;
  underwrittenDebtInterestRateThousandthsBasisPoints?: Maybe<Scalars['Int']>;
  underwrittenUnleveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  underwrittenUnleveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  underwrittenLeveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  underwrittenLeveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedPreconDurationInMonths?: Maybe<Scalars['Int']>;
  realizedConstructionDurationInMonths?: Maybe<Scalars['Int']>;
  realizedSalesDurationInMonths?: Maybe<Scalars['Int']>;
  realizedUnleveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedUnleveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedLeveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedLeveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedDeltaBetweenOpcoContractedAndInvoicedInCents?: Maybe<Scalars['Int']>;
  realizedUwUnleveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedUwUnleveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedUwLeveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedUwLeveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedExpUnleveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedExpUnleveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedExpLeveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedExpLeveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  documents: Array<Document>;
  underwrittenUnleveredReturnOnCostBasisPoints?: Maybe<Scalars['Int']>;
  underwrittenLeveredReturnOnCostBasisPoints?: Maybe<Scalars['Int']>;
  underwrittenSeniorDebtInterestAmountInCents?: Maybe<Scalars['Int']>;
  lotAcqSettlementStatement?: Maybe<LotAcqSettlementStatement>;
  lotAcqPurchaseAgreement?: Maybe<LotAcqPurchaseAgreement>;
  canEditFund: PotentialOperation;
  fundOwnerEntity?: Maybe<FundOwnerEntity>;
  canSendCustomerInformationToBlueprint: PotentialOperation;
  isLegacyIrr: Scalars['Boolean'];
  ownerEntitySentToBlueprint: Scalars['Boolean'];
  canContractDirectUnderwriting: PotentialOperation;
  isSuburban: Scalars['Boolean'];
};

export type SaveLotResult = {
  __typename?: 'SaveLotResult';
  lot: Lot;
};

export type SaveLotsResult = {
  __typename?: 'SaveLotsResult';
  lots: Array<Lot>;
};

export type BackfillUnderwrittenReturnMetricsResult = {
  __typename?: 'BackfillUnderwrittenReturnMetricsResult';
  lots: Array<Lot>;
};

export type SendCustomerInformationToBlueprintResult = {
  __typename?: 'SendCustomerInformationToBlueprintResult';
  lot: Lot;
};

export type CreateDirectUnderwritingContractsResult = {
  __typename?: 'CreateDirectUnderwritingContractsResult';
  lot: Lot;
};

export type LotAcqPurchaseAgreement = {
  __typename?: 'LotAcqPurchaseAgreement';
  id: Scalars['ID'];
  purchasePriceInCents: Scalars['Int'];
  earnestMoneyInCents: Scalars['Int'];
  optionFeeInCents: Scalars['Int'];
  document: Document;
  lot: Lot;
};

export type SaveLotAcqPurchaseAgreementResult = {
  __typename?: 'SaveLotAcqPurchaseAgreementResult';
  lotAcqPurchaseAgreement: LotAcqPurchaseAgreement;
};

export type LotAcqSettlementStatement = {
  __typename?: 'LotAcqSettlementStatement';
  id: Scalars['ID'];
  document: Document;
  lot: Lot;
  lineItems: Array<LotAcqSettlementStatementLineItem>;
  totalDebitsInCents: Scalars['Int'];
  totalCreditsInCents: Scalars['Int'];
  ocrRawJson?: Maybe<Scalars['String']>;
  bookingEventRawJson?: Maybe<Scalars['String']>;
  bookingEventSent: Scalars['Boolean'];
  canSendForBooking: PotentialOperation;
  buyerName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['Date']>;
};

export type SaveLotAcqSettlementStatementResult = {
  __typename?: 'SaveLotAcqSettlementStatementResult';
  lotAcqSettlementStatement: LotAcqSettlementStatement;
};

export type LotAcqSettlementStatementLineItem = {
  __typename?: 'LotAcqSettlementStatementLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  type: LotAcqSettlementStatementLineItemTypeDetail;
  lotAcqSettlementStatement: LotAcqSettlementStatement;
  notes?: Maybe<Scalars['String']>;
};

export type LotPartition = {
  __typename?: 'LotPartition';
  id: Scalars['ID'];
  basePriceInCents?: Maybe<Scalars['Int']>;
  listPriceInCents?: Maybe<Scalars['Int']>;
  salePriceInCents?: Maybe<Scalars['Int']>;
  moveInDate?: Maybe<Scalars['Date']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lot: Lot;
  blueprintProjectId?: Maybe<Scalars['String']>;
  lotPartitionSalesStatus: LotPartitionSalesStatusDetail;
  estimates: Array<LotPartitionEstimate>;
  underwrittenSoftCostInCents: Scalars['Int'];
  underwrittenIndirectHardCostInCents: Scalars['Int'];
  underwrittenDirectHardCostInCents: Scalars['Int'];
  underwrittenOpcoMarkupInCents: Scalars['Int'];
  underwrittenOpcoTotalCostInCents: Scalars['Int'];
  softCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  directHardCostInCents: Scalars['Int'];
  opcoMarkupInCents: Scalars['Int'];
  opcoTotalCostInCents: Scalars['Int'];
  contracts: Array<LotPartitionContract>;
  underwrittenSalesPriceInCents: Scalars['Int'];
  underwrittenSalesCommissionBasisPoints: Scalars['Int'];
  valuations: Array<LotPartitionValuation>;
  salesPriceAtValuationDateInCents: Scalars['Int'];
  valuationDate: Scalars['Date'];
  expectedCompletionDate?: Maybe<Scalars['Date']>;
  expectedSalePriceInCents: Scalars['Int'];
  appreciationMultiplier: Scalars['Float'];
  draws: Array<LotPartitionDraw>;
  underwrittenSalesPriceWithoutAppreciationInCents: Scalars['Int'];
  valuationReportId?: Maybe<Scalars['Int']>;
  underwrittenReadyPlanId?: Maybe<Scalars['String']>;
  underwrittenReadyPlanOptionIds?: Maybe<Scalars['String']>;
  listDate?: Maybe<Scalars['Date']>;
  isLegacyUwRevenue?: Maybe<Scalars['Boolean']>;
  underwrittenNetSalesPriceInCents: Scalars['Int'];
  payments: Array<LotPartitionPayment>;
  equityFinancingCostInCents: Scalars['Int'];
  equityFinancingCosts: Array<EquityFinancingCost>;
  saleDate?: Maybe<Scalars['Date']>;
  lotOwnershipBasisPoints: Scalars['Int'];
  salesforceOpportunityId?: Maybe<Scalars['String']>;
  underContractPriceInCents?: Maybe<Scalars['Int']>;
  commissionBuyerBasisPoints?: Maybe<Scalars['Int']>;
  commissionSellerBasisPoints?: Maybe<Scalars['Int']>;
  saleIncentiveAmountInCents?: Maybe<Scalars['Int']>;
  assumedSaleIncentiveAmountInCents?: Maybe<Scalars['Int']>;
  assumedCommissionBuyerBasisPoints?: Maybe<Scalars['Int']>;
  assumedCommissionSellerBasisPoints?: Maybe<Scalars['Int']>;
  salesforceHomeListingId?: Maybe<Scalars['String']>;
  underwrittenNetSalesPriceWithoutAppreciationInCents: Scalars['Int'];
  netSalesPriceInCents: Scalars['Int'];
  realizedNetSalesPriceInCents?: Maybe<Scalars['Int']>;
  underContractNetSalesPriceInCents?: Maybe<Scalars['Int']>;
  listedNetSalesPriceInCents?: Maybe<Scalars['Int']>;
  estimateNetSalesPriceInCents: Scalars['Int'];
  grossSalesPriceInCents: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  underwrittenLotOwnershipBasisPoints: Scalars['Int'];
  underwrittenTotalCostInCents: Scalars['Int'];
  underwrittenInvestorMarginBasisPoints: Scalars['Int'];
  salesReadyDate?: Maybe<Scalars['Date']>;
  preListDate?: Maybe<Scalars['Date']>;
  valuationAtSalesReadyDateInCents?: Maybe<Scalars['Int']>;
  valuationAtPreListDateInCents?: Maybe<Scalars['Int']>;
  salesReadyAppreciationMultiplier: Scalars['Float'];
  preListAppreciationMultiplier: Scalars['Float'];
  seasonalityMultiplier: Scalars['Float'];
  expectedSalePriceSeasonalityOnlyInCents: Scalars['Int'];
  salesReadySeasonalityMultiplier: Scalars['Float'];
  valuationAtSalesReadyDateSeasonalityOnlyInCents?: Maybe<Scalars['Int']>;
  preListSeasonalityMultiplier: Scalars['Float'];
  valuationAtPreListDateSeasonalityOnlyInCents?: Maybe<Scalars['Int']>;
  underwrittenOpcoMarkupBasisPoints: Scalars['Int'];
  opcoMarkupBasisPoints: Scalars['Int'];
  expectedListSeasonalityMultiplier: Scalars['Int'];
  valuationAtExpectedListDateSeasonalityOnlyInCents?: Maybe<Scalars['Int']>;
  grossSalesPriceLessIncentivesInCents: Scalars['Int'];
  closingCostsInCents: Scalars['Int'];
  assumedClosingCostsInCents: Scalars['Int'];
  assumedCommissionEstimateBuyerInCents: Scalars['Int'];
  assumedCommissionEstimateSellerInCents: Scalars['Int'];
  assumedCommissionListBuyerInCents: Scalars['Int'];
  assumedCommissionListSellerInCents: Scalars['Int'];
  commissionUnderContractBuyerInCents: Scalars['Int'];
  commissionUnderContractSellerInCents: Scalars['Int'];
  commissionRealizedBuyerInCents: Scalars['Int'];
  commissionRealizedSellerInCents: Scalars['Int'];
  appliedSeasonalityMultiplier: Scalars['Float'];
  appliedListToCloseRatioBasisPoints?: Maybe<Scalars['Int']>;
  appliedClosingCostsInCents: Scalars['Int'];
  permitSubmittedDate?: Maybe<Scalars['Date']>;
  permitApprovedDate?: Maybe<Scalars['Date']>;
  verticalBuildStartDate?: Maybe<Scalars['Date']>;
  underContractDate?: Maybe<Scalars['Date']>;
  goldmanDrawModel?: Maybe<GoldmanDrawModel>;
  isVerticalConstructionComplete: Scalars['Boolean'];
  isVerticalConstructionStarted: Scalars['Boolean'];
  drawRequests: Array<LotPartitionDrawRequest>;
  borrowedAmountInCents: Scalars['Int'];
  modeledAmountToBorrowInCents: Scalars['Int'];
  goldmanDrawModels: Array<GoldmanDrawModel>;
  appraisalValueInCents?: Maybe<Scalars['Int']>;
  appraisalDate?: Maybe<Scalars['Date']>;
  invoices: Array<LotPartitionInvoice>;
  realizedUnleveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedUnleveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedLeveredMultipleOnInvestedCapital?: Maybe<Scalars['Float']>;
  realizedLeveredInternalRateOfReturnBasisPoints?: Maybe<Scalars['Int']>;
  realizedDeltaBetweenOpcoContractedAndInvoicedInCents?: Maybe<Scalars['Int']>;
  underContractPersonalizationPriceInCents: Scalars['Int'];
  underContractGrossSalesPriceInCents?: Maybe<Scalars['Int']>;
  commissionBuyerFixedAmountInCents?: Maybe<Scalars['Int']>;
  commissionSellerFixedAmountInCents?: Maybe<Scalars['Int']>;
  blueprintRemediationProjectId?: Maybe<Scalars['String']>;
  remediationExpectedCompletionDate?: Maybe<Scalars['Date']>;
  isRemediationVerticalConstructionComplete: Scalars['Boolean'];
  underwrittenDirectMarginBasisPoints: Scalars['Int'];
  directMarginBasisPoints: Scalars['Int'];
  manualExpectedSaleDate?: Maybe<Scalars['Date']>;
  expectedSaleDate?: Maybe<Scalars['Date']>;
  anchorMultilotBaseDrawModel?: Maybe<AnchorMultilotDrawModel>;
  anchorMultilotDrawModels: Array<AnchorMultilotDrawModel>;
  readyPlanId?: Maybe<Scalars['String']>;
  readyPlanOptionIds?: Maybe<Scalars['String']>;
  unleveredReturnOnCostBasisPoints: Scalars['Int'];
  purchasePriceInCents?: Maybe<Scalars['Int']>;
  closingCostsForDirectMarginInCents: Scalars['Int'];
  directUnderwritingSoftCostsInCents?: Maybe<Scalars['Int']>;
  directUnderwritingHardCostsInCents?: Maybe<Scalars['Int']>;
  directUnderwritingHardCostMarkupBasisPoints?: Maybe<Scalars['Int']>;
  anchorFloatingBaseDrawModel?: Maybe<AnchorFloatingDrawModel>;
  anchorFloatingDrawModels: Array<AnchorFloatingDrawModel>;
  documents: Array<Document>;
  propertySaleSettlementStatement?: Maybe<PropertySaleSettlementStatement>;
  proposedBasePriceInCents?: Maybe<Scalars['Int']>;
  showInCheckout: Scalars['Boolean'];
};

export type SaveLotPartitionResult = {
  __typename?: 'SaveLotPartitionResult';
  lotPartition: LotPartition;
};

export type SaveLotPartitionsResult = {
  __typename?: 'SaveLotPartitionsResult';
  lotPartitions: Array<LotPartition>;
};

export type BackfillLotPartitionUnderwrittenCostsResult = {
  __typename?: 'BackfillLotPartitionUnderwrittenCostsResult';
  lotPartitions: Array<LotPartition>;
};

export type EstimateDirectMarginImpactToLotPartitionResult = {
  __typename?: 'EstimateDirectMarginImpactToLotPartitionResult';
  lotPartition: LotPartition;
  estimatedDirectMarginBasisPoints: Scalars['Int'];
};

export type LotPartitionContract = {
  __typename?: 'LotPartitionContract';
  id: Scalars['ID'];
  softCostInCents: Scalars['Int'];
  indirectHardCostInCents: Scalars['Int'];
  directHardCostInCents: Scalars['Int'];
  opcoMarkupInCents: Scalars['Int'];
  blueprintContractId?: Maybe<Scalars['String']>;
  blueprintChangeOrderId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lotPartition: LotPartition;
  opcoTotalCostInCents: Scalars['Int'];
};

export type SaveLotPartitionContractResult = {
  __typename?: 'SaveLotPartitionContractResult';
  lotPartitionContract: LotPartitionContract;
};

export type SaveLotPartitionContractsResult = {
  __typename?: 'SaveLotPartitionContractsResult';
  lotPartitionContracts: Array<LotPartitionContract>;
};

export type LotPartitionDraw = {
  __typename?: 'LotPartitionDraw';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  remainingAmountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  creditFacilityDraw: CreditFacilityDraw;
  lotPartition: LotPartition;
  payments: Array<LotPartitionDrawPayment>;
  creditFacilityInvoiceDrawInterests: Array<CreditFacilityInvoiceDrawInterest>;
  invoices: Array<LotPartitionDrawInvoice>;
};

export type SaveLotPartitionDrawResult = {
  __typename?: 'SaveLotPartitionDrawResult';
  lotPartitionDraw: LotPartitionDraw;
};

export type LotPartitionDrawInvoice = {
  __typename?: 'LotPartitionDrawInvoice';
  id: Scalars['ID'];
  creditFacilityInvoice: CreditFacilityInvoice;
  lotPartitionDraw: LotPartitionDraw;
  interestAmountInCents: Scalars['Int'];
  creditFacilityInvoiceDrawInterests: Array<CreditFacilityInvoiceDrawInterest>;
  isInterestPopulated: Scalars['Boolean'];
};

export type LotPartitionDrawPayment = {
  __typename?: 'LotPartitionDrawPayment';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  creditFacilityPayment: CreditFacilityPayment;
  lotPartitionDraw: LotPartitionDraw;
};

export type SaveLotPartitionDrawPaymentResult = {
  __typename?: 'SaveLotPartitionDrawPaymentResult';
  lotPartitionDrawPayment: LotPartitionDrawPayment;
};

export type LotPartitionDrawRequest = {
  __typename?: 'LotPartitionDrawRequest';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  creditFacilityDrawRequest: CreditFacilityDrawRequest;
  lotPartition: LotPartition;
  modeledIndividualAmountToBorrowInCents: Scalars['Int'];
  modeledCollectiveAmountToBorrowInCents: Scalars['Int'];
  goldmanDrawModel?: Maybe<GoldmanDrawModel>;
  anchorMultilotDrawModel?: Maybe<AnchorMultilotDrawModel>;
  anchorFloatingDrawModel?: Maybe<AnchorFloatingDrawModel>;
};

export type SaveLotPartitionDrawRequestResult = {
  __typename?: 'SaveLotPartitionDrawRequestResult';
  lotPartitionDrawRequest: LotPartitionDrawRequest;
};

export type SaveLotPartitionDrawRequestsResult = {
  __typename?: 'SaveLotPartitionDrawRequestsResult';
  lotPartitionDrawRequests: Array<LotPartitionDrawRequest>;
};

export type LotPartitionEstimate = {
  __typename?: 'LotPartitionEstimate';
  id: Scalars['ID'];
  softCostInCents: Scalars['Int'];
  hardCostInCents: Scalars['Int'];
  opcoMarkupInCents: Scalars['Int'];
  blueprintEstimateId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  estimateStatus: LotPartitionEstimateStatusDetail;
  estimateType: LotPartitionEstimateTypeDetail;
  lotPartition: LotPartition;
  indirectHardCostInCents: Scalars['Int'];
  directHardCostInCents: Scalars['Int'];
  contingencyPriceInCents: Scalars['Int'];
};

export type SaveLotPartitionEstimateResult = {
  __typename?: 'SaveLotPartitionEstimateResult';
  lotPartitionEstimate: LotPartitionEstimate;
};

export type LotPartitionInvoice = {
  __typename?: 'LotPartitionInvoice';
  id: Scalars['ID'];
  blueprintInvoiceId?: Maybe<Scalars['String']>;
  amountInCents: Scalars['Int'];
  lotPartition: LotPartition;
  invoiceDate: Scalars['Date'];
  description?: Maybe<Scalars['String']>;
};

export type SaveLotPartitionInvoicesResult = {
  __typename?: 'SaveLotPartitionInvoicesResult';
  lotPartitionInvoices: Array<LotPartitionInvoice>;
};

export type LotPartitionPayment = {
  __typename?: 'LotPartitionPayment';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  paymentDate: Scalars['Date'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lotPartition: LotPartition;
};

export type SaveLotPartitionPaymentsResult = {
  __typename?: 'SaveLotPartitionPaymentsResult';
  lotPartitionPayments: Array<LotPartitionPayment>;
};

export type LotPartitionValuation = {
  __typename?: 'LotPartitionValuation';
  id: Scalars['ID'];
  valuationReportId?: Maybe<Scalars['Int']>;
  valuationDate: Scalars['Date'];
  expectedSalesPriceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  lotPartition: LotPartition;
};

export type SaveLotPartitionValuationResult = {
  __typename?: 'SaveLotPartitionValuationResult';
  lotPartitionValuation: LotPartitionValuation;
};

export type SaveLotPartitionValuationsResult = {
  __typename?: 'SaveLotPartitionValuationsResult';
  lotPartitionValuations: Array<LotPartitionValuation>;
};

export type Metro = {
  __typename?: 'Metro';
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  fundMetros: Array<FundMetro>;
  listToCloseRatioBasisPoints: Scalars['Int'];
  lots: Array<Lot>;
  deliveryToSalesReadyInDays: Scalars['Int'];
  underwritingConfigMetros: Array<UnderwritingConfigMetro>;
  preListPremiumBasisPoints: Scalars['Int'];
};

export type SaveMetroResult = {
  __typename?: 'SaveMetroResult';
  metro: Metro;
};

export type RecalculateSeasonalityForMetroResult = {
  __typename?: 'RecalculateSeasonalityForMetroResult';
  metro: Metro;
  lotPartitions: Array<LotPartition>;
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  optionCode: Scalars['String'];
  bedrooms: Scalars['String'];
  bathrooms: Scalars['String'];
  garageParking: Scalars['String'];
  sqft: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  floor?: Maybe<Floor>;
  /**  computed field calc'd from m2m option_to_spec_level lookup  */
  priceInCents: Scalars['Int'];
  /**  computed field calc'd from location  */
  group: Scalars['String'];
  configurationTos: Array<ConfigurationToOption>;
  conflictOptionToOptions: Array<OptionToOption>;
  optionToOptions: Array<OptionToOption>;
  toSpecLevels: Array<OptionToSpecLevel>;
  /**  minimum sqft option adds to plan  */
  baseSqft: Scalars['Int'];
  floorPlanImage?: Maybe<Scalars['String']>;
  baseFullBathrooms: Scalars['Int'];
  baseHalfBathrooms: Scalars['Int'];
  baseBedrooms: Scalars['Int'];
};


export type OptionPriceInCentsArgs = {
  specLevelId: Scalars['ID'];
};

export type SaveOptionResult = {
  __typename?: 'SaveOptionResult';
  option: Option;
};

export type OptionToOption = {
  __typename?: 'OptionToOption';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  conflictOption: Option;
  option: Option;
};

export type SaveOptionToOptionResult = {
  __typename?: 'SaveOptionToOptionResult';
  optionToOption: OptionToOption;
};

export type OptionToSpecLevel = {
  __typename?: 'OptionToSpecLevel';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  airtableId: Scalars['String'];
  priceInCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  option: Option;
  specLevel: SpecLevel;
};

export type SaveOptionToSpecLevelResult = {
  __typename?: 'SaveOptionToSpecLevelResult';
  optionToSpecLevel: OptionToSpecLevel;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  bedrooms?: Maybe<Scalars['String']>;
  bathrooms?: Maybe<Scalars['String']>;
  garageParking?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  configurations: Array<Configuration>;
  elevations: Array<Elevation>;
  floors: Array<Floor>;
  /**  sqft of plan with no options  */
  baseSqft: Scalars['Int'];
  baseFullBathrooms: Scalars['Int'];
  baseHalfBathrooms: Scalars['Int'];
  baseBedrooms: Scalars['Int'];
};

export type SavePlanResult = {
  __typename?: 'SavePlanResult';
  plan: Plan;
};

export type Property = {
  __typename?: 'Property';
  dpid: Scalars['ID'];
  fullStreetAddress: Scalars['String'];
  cityName: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  unitNumber?: Maybe<Scalars['String']>;
  propertyTypeSimple?: Maybe<Scalars['String']>;
  lotSize?: Maybe<Scalars['Int']>;
  yearBuiltOrRenovated?: Maybe<Scalars['String']>;
  finishedSqft?: Maybe<Scalars['Int']>;
  totalSqft?: Maybe<Scalars['Int']>;
  numBedrooms?: Maybe<Scalars['Float']>;
  numBaths?: Maybe<Scalars['Float']>;
  numStories?: Maybe<Scalars['Float']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  garageNumCars?: Maybe<Scalars['Int']>;
  buildableSqft?: Maybe<Scalars['Float']>;
  lotFrontageFeet?: Maybe<Scalars['Int']>;
  lotDepthFeet?: Maybe<Scalars['Int']>;
  zoning?: Maybe<Scalars['String']>;
};

export type PropertySaleSettlementStatement = {
  __typename?: 'PropertySaleSettlementStatement';
  id: Scalars['ID'];
  totalDebitsInCents: Scalars['Int'];
  totalCreditsInCents: Scalars['Int'];
  sellerName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['Date']>;
  document: Document;
  lotPartition: LotPartition;
  lineItems: Array<PropertySaleSettlementStatementLineItem>;
  bookingEventRawJson?: Maybe<Scalars['String']>;
  bookingEventSent: Scalars['Boolean'];
  ocrRawJson?: Maybe<Scalars['String']>;
  canSendForBooking: PotentialOperation;
};

export type SavePropertySaleSettlementStatementResult = {
  __typename?: 'SavePropertySaleSettlementStatementResult';
  propertySaleSettlementStatement: PropertySaleSettlementStatement;
};

export type PropertySaleSettlementStatementLineItem = {
  __typename?: 'PropertySaleSettlementStatementLineItem';
  id: Scalars['ID'];
  amountInCents: Scalars['Int'];
  notes?: Maybe<Scalars['String']>;
  type: PropertySaleSettlementStatementLineItemTypeDetail;
  propertySaleSettlementStatement: PropertySaleSettlementStatement;
};

export type Url = {
  __typename?: 'Url';
  /** Absolute path of the url, e.g. `/thing/a:123/` */
  path: Scalars['String'];
  /** Fully qualified http url, e.g. `https://checkout.homebound.com/thing/a:123/` */
  url: Scalars['String'];
};

/**
 * Represents both whether an operation is performable, and if not the reasons.
 * When the reason relates to a specific entity, we return it for convenient UI navigation.
 */
export type PotentialOperation = {
  __typename?: 'PotentialOperation';
  allowed: Scalars['Boolean'];
  disabledReasons: Array<Reason>;
};

export type Reason = {
  __typename?: 'Reason';
  message: Scalars['String'];
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String'];
};

/** A standard result for when we're not returning any user errors, and instead will just fail the request */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  emptyResult?: Maybe<Scalars['String']>;
};

/**
 * Pagination info.
 *
 * Eventually this would have `lastCursor` and `totalCount` but we don't currently need that.
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  hasNextPage: Scalars['Boolean'];
};

export type History = {
  __typename?: 'History';
  recordedAt: Scalars['DateTime'];
  avatar: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type SeasonalityMonthlyMultiplier = {
  __typename?: 'SeasonalityMonthlyMultiplier';
  id: Scalars['ID'];
  metroName: Scalars['String'];
  month: Scalars['Int'];
  seasonalityValue: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
};

export type SaveSeasonalityMonthlyMultiplierResult = {
  __typename?: 'SaveSeasonalityMonthlyMultiplierResult';
  seasonalityMonthlyMultiplier: SeasonalityMonthlyMultiplier;
};

export type SpecLevel = {
  __typename?: 'SpecLevel';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  configurations: Array<Configuration>;
  optionTos: Array<OptionToSpecLevel>;
  styles: Array<SpecLevelStyle>;
};

export type SaveSpecLevelResult = {
  __typename?: 'SaveSpecLevelResult';
  specLevel: SpecLevel;
};

export type SpecLevelStyle = {
  __typename?: 'SpecLevelStyle';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  specLevel: SpecLevel;
  configurations: Array<Configuration>;
  interiorImages: Array<InteriorImage>;
};

export type SaveSpecLevelStyleResult = {
  __typename?: 'SaveSpecLevelStyleResult';
  specLevelStyle: SpecLevelStyle;
};

export type UnderwritingConfig = {
  __typename?: 'UnderwritingConfig';
  id: Scalars['ID'];
  targetInvestorMarginBasisPoints: Scalars['Int'];
  debtFacilityBaseRateBasisPoints: Scalars['Int'];
  debtFacilitySpreadBasisPoints: Scalars['Int'];
  metros: Array<UnderwritingConfigMetro>;
  buildMarginBasisPoints: Scalars['Int'];
  siteAcquisitionMarkupBasisPoints: Scalars['Int'];
  weightedFinancingRate: Scalars['Float'];
  financingRate: Scalars['Float'];
  percentDebtFinancedBasisPoints: Scalars['Int'];
  preConMonths: Scalars['Float'];
  constructionMonths: Scalars['Float'];
  salesPeriodMonths: Scalars['Float'];
  exitRealtorFeeBasisPoints: Scalars['Int'];
  acquisitionClosingCostsBasisPoints: Scalars['Int'];
};

export type SaveUnderwritingConfigResult = {
  __typename?: 'SaveUnderwritingConfigResult';
  underwritingConfig: UnderwritingConfig;
};

export type UnderwritingConfigMetro = {
  __typename?: 'UnderwritingConfigMetro';
  id: Scalars['ID'];
  targetInvestorMarginBasisPoints: Scalars['Int'];
  metro: Metro;
  underwritingConfig: UnderwritingConfig;
  buildMarginBasisPoints: Scalars['Int'];
  siteAcquisitionMarkupBasisPoints: Scalars['Int'];
  weightedFinancingRate: Scalars['Float'];
  financingRate: Scalars['Float'];
  percentDebtFinancedBasisPoints: Scalars['Int'];
  preConMonths: Scalars['Float'];
  constructionMonths: Scalars['Float'];
  salesPeriodMonths: Scalars['Float'];
  exitRealtorFeeBasisPoints: Scalars['Int'];
  acquisitionClosingCostsBasisPoints: Scalars['Int'];
};

export type SaveUnderwritingConfigMetroResult = {
  __typename?: 'SaveUnderwritingConfigMetroResult';
  underwritingConfigMetro: UnderwritingConfigMetro;
};

export type UnderwritingInternalRateOfReturnCalculatorResult = {
  __typename?: 'UnderwritingInternalRateOfReturnCalculatorResult';
  leveredInternalRateOfReturnBasisPoints: Scalars['Int'];
  leveredMultipleOnInvestedCapital: Scalars['Float'];
  leveredReturnOnCostBasisPoints: Scalars['Int'];
  unleveredInternalRateOfReturnBasisPoints: Scalars['Int'];
  unleveredMultipleOnInvestedCapital: Scalars['Float'];
  unleveredReturnOnCostBasisPoints: Scalars['Int'];
  seniorDebtInterestAmountInCents: Scalars['Int'];
};

export type User = {
  __typename?: 'User';
  /** Note ID is not required because a system user would not have it. */
  id?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: UserTypeDetail;
  homeowner?: Maybe<Homeowner>;
  internalUser?: Maybe<InternalUser>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveUserResult = {
  __typename?: 'SaveUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUserResult = {
  __typename?: 'DeactivateUserResult';
  userErrors: Array<UserError>;
};

export type ActivateUserResult = {
  __typename?: 'ActivateUserResult';
  userErrors: Array<UserError>;
};

export type DocumentParent = LotPartition | Lot;

export enum AssetResizingFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export enum AssetResizingRegion {
  Square = 'SQUARE',
  Full = 'FULL',
  Auto = 'AUTO'
}

export enum CostType {
  Soft = 'SOFT',
  Direct = 'DIRECT',
  Indirect = 'INDIRECT'
}

export enum CreditFacilityInterestType {
  FixedAtDraw = 'FIXED_AT_DRAW',
  Floating = 'FLOATING'
}

export enum DocumentType {
  General = 'GENERAL',
  LotAcqSettlementStatementFinal = 'LOT_ACQ_SETTLEMENT_STATEMENT_FINAL',
  LotAcqSettlementStatementPrelim = 'LOT_ACQ_SETTLEMENT_STATEMENT_PRELIM',
  PurchaseAgreement = 'PURCHASE_AGREEMENT',
  PurchaseAgreementAmendment = 'PURCHASE_AGREEMENT_AMENDMENT',
  UnderwritingProforma = 'UNDERWRITING_PROFORMA',
  PropertySale = 'PROPERTY_SALE'
}

export enum FundCreditFacilityDrawModel {
  None = 'NONE',
  Goldman = 'GOLDMAN',
  AnchorMultilot = 'ANCHOR_MULTILOT',
  AnchorFloating = 'ANCHOR_FLOATING'
}

export enum LotAcqSettlementStatementLineItemType {
  Other = 'OTHER',
  GrossPurchasePrice = 'GROSS_PURCHASE_PRICE',
  EarnestMoney = 'EARNEST_MONEY',
  PropertyTaxes = 'PROPERTY_TAXES',
  Prorations = 'PRORATIONS',
  LoanProceeds = 'LOAN_PROCEEDS',
  OriginationFee = 'ORIGINATION_FEE',
  FinancingFees = 'FINANCING_FEES',
  EscrowFees = 'ESCROW_FEES',
  LegalFees = 'LEGAL_FEES',
  PolicyGuarantyFee = 'POLICY_GUARANTY_FEE',
  TitleInsurance = 'TITLE_INSURANCE',
  WarrantyDeed = 'WARRANTY_DEED',
  MiscTitleEscrowFees = 'MISC_TITLE_ESCROW_FEES',
  Survey = 'SURVEY',
  MiscDisbursementsPaid = 'MISC_DISBURSEMENTS_PAID',
  CashToClose = 'CASH_TO_CLOSE'
}

export enum LotInvestmentStatus {
  Pending = 'PENDING',
  Active = 'ACTIVE',
  Closed = 'CLOSED'
}

export enum LotPartitionEstimateStatus {
  Rejected = 'REJECTED',
  AwaitingAcceptance = 'AWAITING_ACCEPTANCE',
  Accepted = 'ACCEPTED',
  Contracted = 'CONTRACTED'
}

export enum LotPartitionEstimateType {
  Prime = 'PRIME',
  ChangeOrder = 'CHANGE_ORDER'
}

export enum LotPartitionSalesStatus {
  PreForSale = 'PRE_FOR_SALE',
  ForSale = 'FOR_SALE',
  Reserved = 'RESERVED',
  Sold = 'SOLD'
}

export enum LotType {
  Boyl = 'BOYL',
  Bool = 'BOOL'
}

export enum PropertySaleSettlementStatementLineItemType {
  GrossSalePrice = 'GROSS_SALE_PRICE',
  Deposits = 'DEPOSITS',
  SalesIncentive = 'SALES_INCENTIVE',
  PropertyTaxes = 'PROPERTY_TAXES',
  Prorations = 'PRORATIONS',
  BrokerageFeeSeller = 'BROKERAGE_FEE_SELLER',
  BrokerageFeeBuyer = 'BROKERAGE_FEE_BUYER',
  BuyerLoanProceeds = 'BUYER_LOAN_PROCEEDS',
  LoanPayoff = 'LOAN_PAYOFF',
  InterestExpense = 'INTEREST_EXPENSE',
  FinancingFees = 'FINANCING_FEES',
  ClosingCosts = 'CLOSING_COSTS',
  HomeownerInsurance = 'HOMEOWNER_INSURANCE',
  MiscDisbursementsPaid = 'MISC_DISBURSEMENTS_PAID',
  CashReceivedAtClose = 'CASH_RECEIVED_AT_CLOSE',
  Other = 'OTHER'
}

export enum UserType {
  Anonymous = 'ANONYMOUS',
  System = 'SYSTEM',
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER'
}

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DateOperation {
  Before = 'BEFORE',
  On = 'ON',
  After = 'AFTER',
  Between = 'BETWEEN'
}

export enum UnderwritingInternalRateOfReturnCalculatorMethod {
  BaseUnderwriting = 'BASE_UNDERWRITING',
  BaseWith_206020 = 'BASE_WITH_206020'
}

export type SaveAddressInput = {
  id?: InputMaybe<Scalars['ID']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
};

export type SaveAnchorFloatingDrawModelInput = {
  id?: InputMaybe<Scalars['ID']>;
  isBlueprintCostDataSet?: InputMaybe<Scalars['Boolean']>;
  asOfDate?: InputMaybe<Scalars['Date']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  lotPartitionDrawRequestId?: InputMaybe<Scalars['ID']>;
  completedSoftCostsInCents?: InputMaybe<Scalars['Int']>;
  completedIndirectCostsInCents?: InputMaybe<Scalars['Int']>;
  completedDirectCostsInCents?: InputMaybe<Scalars['Int']>;
  completedBuilderFeeInCents?: InputMaybe<Scalars['Int']>;
  completedConstructionExpensesInCents?: InputMaybe<Scalars['Int']>;
};

export type RefreshDrawModelBlueprintDataInput = {
  drawModelId?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveAnchorFloatingDrawModelCostItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  builderFeeInCents?: InputMaybe<Scalars['Int']>;
  fullCostCodeNumber?: InputMaybe<Scalars['String']>;
  costType?: InputMaybe<CostType>;
  anchorFloatingDrawModelId?: InputMaybe<Scalars['ID']>;
  date?: InputMaybe<Scalars['Date']>;
};

export type SaveAnchorMultilotDrawModelInput = {
  id?: InputMaybe<Scalars['ID']>;
  realizedSoftCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedIndirectCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedDirectCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedBuilderFeeInCents?: InputMaybe<Scalars['Int']>;
  realizedConstructionExpensesInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  asOfDate?: InputMaybe<Scalars['Date']>;
  isBlueprintCostDataSet?: InputMaybe<Scalars['Boolean']>;
  lotPartitionDrawRequestId?: InputMaybe<Scalars['ID']>;
};

export type SaveAnchorMultilotDrawModelCostItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  fullCostCodeNumber?: InputMaybe<Scalars['String']>;
  costType?: InputMaybe<CostType>;
  anchorMultilotDrawModelId?: InputMaybe<Scalars['ID']>;
  builderFeeInCents?: InputMaybe<Scalars['Int']>;
  date?: InputMaybe<Scalars['Date']>;
  billNumber?: InputMaybe<Scalars['String']>;
};

export type CreateAssetUploadUrlInput = {
  contentType: Scalars['String'];
  previewResizing?: InputMaybe<AssetResizing>;
};

export type AssetResizing = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<AssetResizingRegion>;
  /** Optional output image format, e.g. "jpg", "png", defaults to original asset format. */
  format?: InputMaybe<AssetResizingFormat>;
};

export type AssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  /** This field is only accepted for Asset creation */
  contentType?: InputMaybe<Scalars['String']>;
  /** This field is accepted for Asset creation and update */
  fileName?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  s3Key?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  sizeInBytes?: InputMaybe<Scalars['Int']>;
};

export type SaveConfigurationInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['ID']>;
  elevationStyleId?: InputMaybe<Scalars['ID']>;
  planId?: InputMaybe<Scalars['ID']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
  specLevelStyleId?: InputMaybe<Scalars['ID']>;
  completedDate?: InputMaybe<Scalars['DateTime']>;
  address?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type SaveConfigurationToOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['ID']>;
  optionId?: InputMaybe<Scalars['ID']>;
};

export type SaveConfigurationToOptionsInput = {
  configurationToOptions: Array<SaveConfigurationToOptionInput>;
};

export type SaveCreditFacilityDrawInput = {
  id?: InputMaybe<Scalars['ID']>;
  drawDate?: InputMaybe<Scalars['Date']>;
  fundId?: InputMaybe<Scalars['ID']>;
  fixedRateThousandthsBasisPoints?: InputMaybe<Scalars['Int']>;
  requestId?: InputMaybe<Scalars['ID']>;
};

export type CreditFacilityDrawFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type CreateOffsettingPaymentForCreditFacilityDrawInput = {
  id: Scalars['ID'];
};

export type SaveCreditFacilityDrawRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  preparationDate?: InputMaybe<Scalars['Date']>;
  fundId?: InputMaybe<Scalars['ID']>;
};

export type CreditFacilityDrawRequestFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  fund?: InputMaybe<Array<Scalars['ID']>>;
  isDrawn?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCreditFacilityInvoiceInput = {
  id?: InputMaybe<Scalars['ID']>;
  invoiceDate?: InputMaybe<Scalars['Date']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  fundId?: InputMaybe<Scalars['ID']>;
  baseRateThousandthsBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type CreditFacilityInvoiceFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  fund?: InputMaybe<Array<Scalars['ID']>>;
  isInterestPopulated?: InputMaybe<Scalars['Boolean']>;
};

export type SaveCreditFacilityInvoiceDrawInterestInput = {
  id?: InputMaybe<Scalars['ID']>;
  interestDate?: InputMaybe<Scalars['Date']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  creditFacilityInvoiceId?: InputMaybe<Scalars['ID']>;
  lotPartitionDrawId?: InputMaybe<Scalars['ID']>;
  drawAmountInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionDrawInvoiceId?: InputMaybe<Scalars['ID']>;
};

export type SaveCreditFacilityPaymentInput = {
  id?: InputMaybe<Scalars['ID']>;
  paymentDate?: InputMaybe<Scalars['Date']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  fundId?: InputMaybe<Scalars['ID']>;
};

export type CreditFacilityPaymentFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type AddOpenDrawsToCreditFacilityPaymentInput = {
  creditFacilityPaymentId: Scalars['ID'];
  lotPartitionIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveDocumentsInput = {
  documents: Array<SaveDocumentInput>;
};

export type SaveDocumentInput = {
  id?: InputMaybe<Scalars['ID']>;
  asset?: InputMaybe<AssetInput>;
  parentId?: InputMaybe<Scalars['ID']>;
  deleted?: InputMaybe<Scalars['Boolean']>;
  blueprintDocumentId?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<DocumentType>;
};

export type DocumentsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  parentIds?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveElevationInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['ID']>;
};

export type SaveElevationStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveEquityFinancingCostInput = {
  id?: InputMaybe<Scalars['ID']>;
  interestDate?: InputMaybe<Scalars['Date']>;
  interestAmountInCents?: InputMaybe<Scalars['Int']>;
  equityAmountInCents?: InputMaybe<Scalars['Int']>;
  lotId?: InputMaybe<Scalars['ID']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
};

export type RegenerateAllMonthlyEquityFinanceValuesInput = {
  lotId?: InputMaybe<Array<Scalars['ID']>>;
  lotPartitionId?: InputMaybe<Array<Scalars['ID']>>;
  endDate: Scalars['Date'];
};

export type SaveExteriorImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  elevationStyleId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveFloorInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
};

export type SaveFundInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  targetInvestorMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  opcoDirectHardCostMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  opcoIndirectHardCostMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  opcoSoftCostMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  opcoSiteAcquisitionMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  creditFacilityFixedRateBasisPoints?: InputMaybe<Scalars['Int']>;
  creditFacilityCanBorrowDirectCosts?: InputMaybe<Scalars['Boolean']>;
  creditFacilityCanBorrowIndirectCosts?: InputMaybe<Scalars['Boolean']>;
  creditFacilityCanBorrowSoftCosts?: InputMaybe<Scalars['Boolean']>;
  equityFinancingBasisPoints?: InputMaybe<Scalars['Int']>;
  salesforceName?: InputMaybe<Scalars['String']>;
  closedBooksDate?: InputMaybe<Scalars['Date']>;
  blueprintCustomerId?: InputMaybe<Scalars['String']>;
  creditFacilityDrawModel?: InputMaybe<FundCreditFacilityDrawModel>;
  creditFacilityInterestType?: InputMaybe<CreditFacilityInterestType>;
};

export type FundFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  salesforceName?: InputMaybe<Array<Scalars['String']>>;
};

export type ExportBillsForDrawInput = {
  fundId: Scalars['ID'];
  startDate: Scalars['Date'];
  endDate: Scalars['Date'];
  minBillAmountInCents?: InputMaybe<Scalars['Int']>;
};

export type SaveFundMetroInput = {
  id?: InputMaybe<Scalars['ID']>;
  targetInvestorMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  fundId?: InputMaybe<Scalars['ID']>;
  metroId?: InputMaybe<Scalars['ID']>;
};

export type EnsureAllFundMetrosInput = {
  fundId?: InputMaybe<Scalars['ID']>;
};

export type SaveFundOwnerEntityInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  fundId?: InputMaybe<Scalars['ID']>;
};

export type SaveGoldmanDrawModelInput = {
  id?: InputMaybe<Scalars['ID']>;
  currentAppraisalValueInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  asOfDate?: InputMaybe<Scalars['Date']>;
  realizedSoftCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedIndirectCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedDirectCostsInCents?: InputMaybe<Scalars['Int']>;
  realizedBuilderFeeInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionDrawRequestId?: InputMaybe<Scalars['ID']>;
  isBlueprintCostDataSet?: InputMaybe<Scalars['Boolean']>;
  isVictoryOverride?: InputMaybe<Scalars['Boolean']>;
};

export type SaveGoldmanDrawModelsInput = {
  goldmanDrawModels: Array<SaveGoldmanDrawModelInput>;
};

export type SaveGoldmanDrawModelCostItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  costCodeNumber?: InputMaybe<Scalars['String']>;
  goldmanDrawModelId?: InputMaybe<Scalars['ID']>;
  costType?: InputMaybe<CostType>;
  date?: InputMaybe<Scalars['Date']>;
  billNumber?: InputMaybe<Scalars['String']>;
};

export type SaveHelloWorldInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type HomePriceAppreciationMonthlyMultiplierFilter = {
  postalCode: Scalars['String'];
  valuationDate?: InputMaybe<Array<Scalars['Date']>>;
};

export type SaveHomeownerInput = {
  id?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  lastActive?: InputMaybe<Scalars['DateTime']>;
};

export type SaveInteriorImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  specLevelStyleId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveInternalUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type AddJobsInput = {
  name: Scalars['String'];
  payloads: Array<Scalars['JSONObject']>;
};

export type SaveLotInput = {
  id?: InputMaybe<Scalars['ID']>;
  purchasePriceInCents?: InputMaybe<Scalars['Int']>;
  lotInvestmentStatus?: InputMaybe<LotInvestmentStatus>;
  partitions?: InputMaybe<Array<InputMaybe<SaveLotPartitionInput>>>;
  salesforceOpportunityId?: InputMaybe<Scalars['String']>;
  dpid?: InputMaybe<Scalars['String']>;
  originalUwReportId?: InputMaybe<Scalars['Int']>;
  underwrittenInterestRateBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenProjectedLoanDurationInDays?: InputMaybe<Scalars['Int']>;
  underwrittenSiteAcquisitionMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenLoanToCostBasisPoints?: InputMaybe<Scalars['Int']>;
  weightedDurationOfDrawBasisPoints?: InputMaybe<Scalars['Int']>;
  address?: InputMaybe<SaveAddressInput>;
  clearToCloseUwReportId?: InputMaybe<Scalars['Int']>;
  underwrittenDate?: InputMaybe<Scalars['Date']>;
  fundId?: InputMaybe<Scalars['ID']>;
  underwrittenPurchasePriceInCents?: InputMaybe<Scalars['Int']>;
  underwrittenClosingCostsInCents?: InputMaybe<Scalars['Int']>;
  isLegacyUwPurchasePrice?: InputMaybe<Scalars['Boolean']>;
  isLegacyUwFinancingCosts?: InputMaybe<Scalars['Boolean']>;
  underwrittenFinancingCostInCents?: InputMaybe<Scalars['Int']>;
  acquisitionDate?: InputMaybe<Scalars['Date']>;
  equityFinancingCostInCents?: InputMaybe<Scalars['Int']>;
  legalEntityName?: InputMaybe<Scalars['String']>;
  fundContributionDate?: InputMaybe<Scalars['Date']>;
  metroId?: InputMaybe<Scalars['ID']>;
  metroCode?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<Scalars['String']>;
  underContractAmountInCents?: InputMaybe<Scalars['Int']>;
  underContractDate?: InputMaybe<Scalars['Date']>;
  contingencyExpirationDate?: InputMaybe<Scalars['Date']>;
  expectedCloseDate?: InputMaybe<Scalars['Date']>;
  underwrittenPreconDurationInMonths?: InputMaybe<Scalars['Float']>;
  underwrittenConstructionDurationInMonths?: InputMaybe<Scalars['Float']>;
  underwrittenSalesDurationInMonths?: InputMaybe<Scalars['Float']>;
  underwrittenDebtInterestRateThousandthsBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenUnleveredInternalRateOfReturnBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenUnleveredMultipleOnInvestedCapital?: InputMaybe<Scalars['Float']>;
  underwrittenLeveredInternalRateOfReturnBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenLeveredMultipleOnInvestedCapital?: InputMaybe<Scalars['Float']>;
  realizedUwUnleveredInternalRateOfReturnBasisPoints?: InputMaybe<Scalars['Int']>;
  realizedUwUnleveredMultipleOnInvestedCapital?: InputMaybe<Scalars['Float']>;
  realizedUwLeveredInternalRateOfReturnBasisPoints?: InputMaybe<Scalars['Int']>;
  realizedUwLeveredMultipleOnInvestedCapital?: InputMaybe<Scalars['Float']>;
  underwrittenUnleveredReturnOnCostBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenLeveredReturnOnCostBasisPoints?: InputMaybe<Scalars['Int']>;
  underwrittenSeniorDebtInterestAmountInCents?: InputMaybe<Scalars['Int']>;
  fundOwnerEntityId?: InputMaybe<Scalars['ID']>;
  isLegacyIrr?: InputMaybe<Scalars['Boolean']>;
  ownerEntitySentToBlueprint?: InputMaybe<Scalars['Boolean']>;
  isSuburban?: InputMaybe<Scalars['Boolean']>;
};

export type LotFilter = {
  id?: InputMaybe<Scalars['ID']>;
  salesforceOpportunityId?: InputMaybe<Scalars['String']>;
  dpid?: InputMaybe<Scalars['String']>;
};

export type SaveLotsInput = {
  lots: Array<SaveLotInput>;
};

export type BackfillUnderwrittenReturnMetricsInput = {
  lotMetrics: Array<BackfillUnderwrittenReturnMetricsLotInput>;
};

export type BackfillUnderwrittenReturnMetricsLotInput = {
  dpid: Scalars['String'];
  underwrittenPreconDurationInMonths: Scalars['Float'];
  underwrittenConstructionDurationInMonths: Scalars['Float'];
  underwrittenSalesDurationInMonths: Scalars['Float'];
  underwrittenDebtInterestRateThousandthsBasisPoints: Scalars['Int'];
};

export type SendCustomerInformationToBlueprintInput = {
  lotId: Scalars['ID'];
};

export type CreateDirectUnderwritingContractsInput = {
  lotId: Scalars['ID'];
};

export type SaveLotAcqPurchaseAgreementInput = {
  id?: InputMaybe<Scalars['ID']>;
  purchasePriceInCents?: InputMaybe<Scalars['Int']>;
  earnestMoneyInCents?: InputMaybe<Scalars['Int']>;
  optionFeeInCents?: InputMaybe<Scalars['Int']>;
  documentId?: InputMaybe<Scalars['ID']>;
  lotId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotAcqSettlementStatementInput = {
  id?: InputMaybe<Scalars['ID']>;
  documentId?: InputMaybe<Scalars['ID']>;
  lotId?: InputMaybe<Scalars['ID']>;
  lineItems?: InputMaybe<Array<SaveLotAcqSettlementStatementLineItemInput>>;
  ocrRawJson?: InputMaybe<Scalars['String']>;
  bookingEventSent?: InputMaybe<Scalars['Boolean']>;
  buyerName?: InputMaybe<Scalars['String']>;
  settlementDate?: InputMaybe<Scalars['Date']>;
};

export type ProcessLotAcqSettlementStatementOcrInput = {
  id: Scalars['ID'];
};

export type SendLotAcqSettlementStatementForBookingInput = {
  id: Scalars['ID'];
};

export type SaveLotAcqSettlementStatementLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<LotAcqSettlementStatementLineItemType>;
  notes?: InputMaybe<Scalars['String']>;
};

export type SaveLotPartitionInput = {
  id?: InputMaybe<Scalars['ID']>;
  basePriceInCents?: InputMaybe<Scalars['Int']>;
  listPriceInCents?: InputMaybe<Scalars['Int']>;
  salePriceInCents?: InputMaybe<Scalars['Int']>;
  moveInDate?: InputMaybe<Scalars['Date']>;
  lotId?: InputMaybe<Scalars['ID']>;
  blueprintProjectId?: InputMaybe<Scalars['String']>;
  lotPartitionSalesStatus?: InputMaybe<LotPartitionSalesStatus>;
  underwrittenSalesPriceInCents?: InputMaybe<Scalars['Int']>;
  underwrittenSalesCommissionBasisPoints?: InputMaybe<Scalars['Int']>;
  expectedCompletionDate?: InputMaybe<Scalars['Date']>;
  appreciationMultiplier?: InputMaybe<Scalars['Float']>;
  valuationReportId?: InputMaybe<Scalars['Int']>;
  underwrittenSalesPriceWithoutAppreciationInCents?: InputMaybe<Scalars['Int']>;
  underwrittenReadyPlanId?: InputMaybe<Scalars['String']>;
  underwrittenReadyPlanOptionIds?: InputMaybe<Scalars['String']>;
  isLegacyUwRevenue?: InputMaybe<Scalars['Boolean']>;
  saleDate?: InputMaybe<Scalars['Date']>;
  lotOwnershipBasisPoints?: InputMaybe<Scalars['Int']>;
  salesforceOpportunityId?: InputMaybe<Scalars['String']>;
  underContractPriceInCents?: InputMaybe<Scalars['Int']>;
  commissionBuyerBasisPoints?: InputMaybe<Scalars['Int']>;
  commissionSellerBasisPoints?: InputMaybe<Scalars['Int']>;
  saleIncentiveAmountInCents?: InputMaybe<Scalars['Int']>;
  assumedSaleIncentiveAmountInCents?: InputMaybe<Scalars['Int']>;
  assumedCommissionBuyerBasisPoints?: InputMaybe<Scalars['Int']>;
  assumedCommissionSellerBasisPoints?: InputMaybe<Scalars['Int']>;
  salesforceHomeListingId?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  underwrittenLotOwnershipBasisPoints?: InputMaybe<Scalars['Int']>;
  salesReadyAppreciationMultiplier?: InputMaybe<Scalars['Float']>;
  preListAppreciationMultiplier?: InputMaybe<Scalars['Float']>;
  seasonalityMultiplier?: InputMaybe<Scalars['Float']>;
  salesReadySeasonalityMultiplier?: InputMaybe<Scalars['Float']>;
  preListSeasonalityMultiplier?: InputMaybe<Scalars['Float']>;
  expectedListSeasonalityMultiplier?: InputMaybe<Scalars['Int']>;
  closingCostsInCents?: InputMaybe<Scalars['Int']>;
  permitSubmittedDate?: InputMaybe<Scalars['Date']>;
  permitApprovedDate?: InputMaybe<Scalars['Date']>;
  verticalBuildStartDate?: InputMaybe<Scalars['Date']>;
  underContractDate?: InputMaybe<Scalars['Date']>;
  isVerticalConstructionComplete?: InputMaybe<Scalars['Boolean']>;
  isVerticalConstructionStarted?: InputMaybe<Scalars['Boolean']>;
  appraisalValueInCents?: InputMaybe<Scalars['Int']>;
  appraisalDate?: InputMaybe<Scalars['Date']>;
  underContractPersonalizationPriceInCents?: InputMaybe<Scalars['Int']>;
  commissionBuyerFixedAmountInCents?: InputMaybe<Scalars['Int']>;
  commissionSellerFixedAmountInCents?: InputMaybe<Scalars['Int']>;
  blueprintRemediationProjectId?: InputMaybe<Scalars['String']>;
  remediationExpectedCompletionDate?: InputMaybe<Scalars['Date']>;
  isRemediationVerticalConstructionComplete?: InputMaybe<Scalars['Boolean']>;
  manualExpectedSaleDate?: InputMaybe<Scalars['Date']>;
  readyPlanId?: InputMaybe<Scalars['String']>;
  readyPlanOptionIds?: InputMaybe<Scalars['String']>;
  directUnderwritingSoftCostsInCents?: InputMaybe<Scalars['Int']>;
  directUnderwritingHardCostsInCents?: InputMaybe<Scalars['Int']>;
  directUnderwritingHardCostMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
};

export type SaveLotPartitionsInput = {
  lotPartitions: Array<SaveLotPartitionInput>;
};

export type LotPartitionsFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
  blueprintProjectId?: InputMaybe<Array<Scalars['String']>>;
  blueprintRemediationProjectId?: InputMaybe<Array<Scalars['String']>>;
  salesforceOpportunityId?: InputMaybe<Array<Scalars['String']>>;
  showInCheckout?: InputMaybe<Scalars['Boolean']>;
  lotPartitionSalesStatus?: InputMaybe<Array<LotPartitionSalesStatus>>;
  lotInvestmentStatus?: InputMaybe<Array<LotInvestmentStatus>>;
};

export type BackfillLotPartitionUnderwrittenCostsInput = {
  lotPartitionIds: Array<Scalars['ID']>;
};

export type EstimateDirectMarginImpactToLotPartitionInput = {
  lotPartitionId: Scalars['ID'];
  buildCostChangeInCents: Scalars['Int'];
  grossSalePriceChangeInCents: Scalars['Int'];
};

export type SaveLotPartitionContractInput = {
  id?: InputMaybe<Scalars['ID']>;
  softCostInCents?: InputMaybe<Scalars['Int']>;
  indirectHardCostInCents?: InputMaybe<Scalars['Int']>;
  directHardCostInCents?: InputMaybe<Scalars['Int']>;
  opcoMarkupInCents?: InputMaybe<Scalars['Int']>;
  blueprintContractId?: InputMaybe<Scalars['String']>;
  blueprintChangeOrderId?: InputMaybe<Scalars['String']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
};

export type LotPartitionContractFilter = {
  blueprintContractId?: InputMaybe<Array<Scalars['String']>>;
  blueprintChangeOrderId?: InputMaybe<Array<Scalars['String']>>;
};

export type SaveLotPartitionContractsInput = {
  lotPartitionContracts: Array<SaveLotPartitionContractInput>;
};

export type SaveLotPartitionDrawInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  creditFacilityDrawId?: InputMaybe<Scalars['ID']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotPartitionDrawInvoiceInput = {
  isInterestPopulated?: InputMaybe<Scalars['Boolean']>;
};

export type SaveLotPartitionDrawPaymentInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  creditFacilityPaymentId?: InputMaybe<Scalars['ID']>;
  lotPartitionDrawId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotPartitionDrawRequestInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  creditFacilityDrawRequestId?: InputMaybe<Scalars['ID']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotPartitionDrawRequestsInput = {
  lotPartitionDrawRequests: Array<SaveLotPartitionDrawRequestInput>;
};

export type SaveLotPartitionEstimateInput = {
  id?: InputMaybe<Scalars['ID']>;
  softCostInCents?: InputMaybe<Scalars['Int']>;
  hardCostInCents?: InputMaybe<Scalars['Int']>;
  /** Deprecated: use indirect and direct instead */
  opcoMarkupInCents?: InputMaybe<Scalars['Int']>;
  blueprintEstimateId?: InputMaybe<Scalars['String']>;
  estimateStatus?: InputMaybe<LotPartitionEstimateStatus>;
  estimateType?: InputMaybe<LotPartitionEstimateType>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  indirectHardCostInCents?: InputMaybe<Scalars['Int']>;
  directHardCostInCents?: InputMaybe<Scalars['Int']>;
  contingencyPriceInCents?: InputMaybe<Scalars['Int']>;
};

export type LotPartitionEstimateFilter = {
  id?: InputMaybe<Scalars['ID']>;
  blueprintEstimateId?: InputMaybe<Array<Scalars['String']>>;
};

export type SaveLotPartitionInvoiceInput = {
  id?: InputMaybe<Scalars['ID']>;
  blueprintInvoiceId?: InputMaybe<Scalars['String']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  invoiceDate?: InputMaybe<Scalars['Date']>;
  blueprintProjectId?: InputMaybe<Scalars['ID']>;
  description?: InputMaybe<Scalars['String']>;
};

export type SaveLotPartitionInvoicesInput = {
  lotPartitionInvoices: Array<SaveLotPartitionInvoiceInput>;
};

export type SaveLotPartitionPaymentInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  paymentDate?: InputMaybe<Scalars['Date']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  blueprintProjectId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotPartitionPaymentsInput = {
  lotPartitionPayments: Array<SaveLotPartitionPaymentInput>;
};

export type SaveLotPartitionValuationInput = {
  id?: InputMaybe<Scalars['ID']>;
  valuationReportId?: InputMaybe<Scalars['Int']>;
  valuationDate?: InputMaybe<Scalars['Date']>;
  expectedSalesPriceInCents?: InputMaybe<Scalars['Int']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
};

export type SaveLotPartitionValuationsInput = {
  lotPartitionValuations: Array<SaveLotPartitionValuationInput>;
};

export type SaveMetroInput = {
  id?: InputMaybe<Scalars['ID']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  listToCloseRatioBasisPoints?: InputMaybe<Scalars['Int']>;
  deliveryToSalesReadyInDays?: InputMaybe<Scalars['Int']>;
  preListPremiumBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type MetrosFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type RecalculateSeasonalityForMetroInput = {
  metroCode: Scalars['String'];
};

export type SaveOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  optionCode?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['String']>;
  garageParking?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['ID']>;
  baseSqft?: InputMaybe<Scalars['Int']>;
  floorPlanImage?: InputMaybe<Scalars['String']>;
  baseFullBathrooms?: InputMaybe<Scalars['Int']>;
  baseHalfBathrooms?: InputMaybe<Scalars['Int']>;
  baseBedrooms?: InputMaybe<Scalars['Int']>;
};

export type SaveOptionToOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  conflictOptionId?: InputMaybe<Scalars['ID']>;
  optionId?: InputMaybe<Scalars['ID']>;
};

export type SaveOptionToSpecLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  optionId?: InputMaybe<Scalars['ID']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
};

export type SavePlanInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['String']>;
  garageParking?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  baseSqft?: InputMaybe<Scalars['Int']>;
  baseFullBathrooms?: InputMaybe<Scalars['Int']>;
  baseHalfBathrooms?: InputMaybe<Scalars['Int']>;
  baseBedrooms?: InputMaybe<Scalars['Int']>;
};

export type PlansFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type SavePropertySaleSettlementStatementInput = {
  id?: InputMaybe<Scalars['ID']>;
  sellerName?: InputMaybe<Scalars['String']>;
  settlementDate?: InputMaybe<Scalars['Date']>;
  documentId?: InputMaybe<Scalars['ID']>;
  lotPartitionId?: InputMaybe<Scalars['ID']>;
  lineItems?: InputMaybe<Array<SavePropertySaleSettlementStatementLineItemInput>>;
  bookingEventRawJson?: InputMaybe<Scalars['String']>;
  bookingEventSent?: InputMaybe<Scalars['Boolean']>;
  ocrRawJson?: InputMaybe<Scalars['String']>;
};

export type SendPropertySaleSettlementStatementForBookingInput = {
  id: Scalars['ID'];
};

export type SavePropertySaleSettlementStatementLineItemInput = {
  id?: InputMaybe<Scalars['ID']>;
  amountInCents?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<PropertySaleSettlementStatementLineItemType>;
  notes?: InputMaybe<Scalars['String']>;
  propertySaleSettlementStatementId?: InputMaybe<Scalars['ID']>;
};

/** Generic bulk delete input type */
export type DeleteEntitiesInput = {
  id: Array<Scalars['ID']>;
};

/** Generic delete input type */
export type DeleteEntityInput = {
  id: Scalars['ID'];
};

export type SaveSeasonalityMonthlyMultiplierInput = {
  id?: InputMaybe<Scalars['ID']>;
  metroName?: InputMaybe<Scalars['String']>;
  month?: InputMaybe<Scalars['Int']>;
  seasonalityValue?: InputMaybe<Scalars['Int']>;
};

export type SeasonalityMonthlyMultiplierFilter = {
  metroName: Scalars['String'];
};

export type SaveSpecLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  elevationId?: InputMaybe<Scalars['ID']>;
};

export type SaveSpecLevelStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
};

export type SaveUnderwritingConfigInput = {
  id?: InputMaybe<Scalars['ID']>;
  targetInvestorMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  debtFacilityBaseRateBasisPoints?: InputMaybe<Scalars['Int']>;
  debtFacilitySpreadBasisPoints?: InputMaybe<Scalars['Int']>;
  buildMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  siteAcquisitionMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  weightedFinancingRate?: InputMaybe<Scalars['Float']>;
  financingRate?: InputMaybe<Scalars['Float']>;
  percentDebtFinancedBasisPoints?: InputMaybe<Scalars['Int']>;
  preConMonths?: InputMaybe<Scalars['Float']>;
  constructionMonths?: InputMaybe<Scalars['Float']>;
  salesPeriodMonths?: InputMaybe<Scalars['Float']>;
  exitRealtorFeeBasisPoints?: InputMaybe<Scalars['Int']>;
  acquisitionClosingCostsBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type UnderwritingConfigFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type SaveUnderwritingConfigMetroInput = {
  id?: InputMaybe<Scalars['ID']>;
  targetInvestorMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  metroId?: InputMaybe<Scalars['ID']>;
  underwritingConfigId?: InputMaybe<Scalars['ID']>;
  buildMarginBasisPoints?: InputMaybe<Scalars['Int']>;
  siteAcquisitionMarkupBasisPoints?: InputMaybe<Scalars['Int']>;
  weightedFinancingRate?: InputMaybe<Scalars['Float']>;
  financingRate?: InputMaybe<Scalars['Float']>;
  percentDebtFinancedBasisPoints?: InputMaybe<Scalars['Int']>;
  preConMonths?: InputMaybe<Scalars['Float']>;
  constructionMonths?: InputMaybe<Scalars['Float']>;
  salesPeriodMonths?: InputMaybe<Scalars['Float']>;
  exitRealtorFeeBasisPoints?: InputMaybe<Scalars['Int']>;
  acquisitionClosingCostsBasisPoints?: InputMaybe<Scalars['Int']>;
};

export type UnderwritingInternalRateOfReturnCalculatorInput = {
  lotAcquisitionCostWithFeeInCents: Scalars['Int'];
  lotAcquisitionDate?: InputMaybe<Scalars['Date']>;
  softCostInCents: Scalars['Int'];
  hardCostWithBuildFeeInCents: Scalars['Int'];
  debtInterestRateThousandthsBasisPoints: Scalars['Int'];
  preconMonths: Scalars['Float'];
  constructionMonths: Scalars['Float'];
  salesMonths: Scalars['Float'];
  netSalesPriceInCents: Scalars['Int'];
  calculationMethod: UnderwritingInternalRateOfReturnCalculatorMethod;
};

export type SaveUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
  internalUserId?: InputMaybe<Scalars['ID']>;
};

export type DeactivateUserInput = {
  email: Scalars['String'];
};

export type ActivateUserInput = {
  email: Scalars['String'];
};

export type FundAllocationsPageLotsQueryVariables = Exact<{ [key: string]: never; }>;


export type FundAllocationsPageLotsQuery = { __typename?: 'Query', lots: Array<{ __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underContractDate?: DateOnly | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string } | null | undefined, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', name: string, code: LotInvestmentStatus }, canEditFund: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, fundOwnerEntity?: { __typename?: 'FundOwnerEntity', id: string, name: string } | null | undefined, canSendCustomerInformationToBlueprint: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type FundAllocationsPageFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type FundAllocationsPageFundsQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string, ownerEntities: Array<{ __typename?: 'FundOwnerEntity', id: string, name: string }> }> };

export type SaveLotsMutationVariables = Exact<{
  input: SaveLotsInput;
}>;


export type SaveLotsMutation = { __typename?: 'Mutation', saveLots: { __typename?: 'SaveLotsResult', lots: Array<{ __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underContractDate?: DateOnly | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string } | null | undefined, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', name: string, code: LotInvestmentStatus }, canEditFund: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, fundOwnerEntity?: { __typename?: 'FundOwnerEntity', id: string, name: string } | null | undefined, canSendCustomerInformationToBlueprint: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> } };

export type SendCustomerInformationToBlueprintMutationVariables = Exact<{
  input: SendCustomerInformationToBlueprintInput;
}>;


export type SendCustomerInformationToBlueprintMutation = { __typename?: 'Mutation', sendCustomerInformationToBlueprint: { __typename?: 'SendCustomerInformationToBlueprintResult', lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underContractDate?: DateOnly | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string } | null | undefined, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', name: string, code: LotInvestmentStatus }, canEditFund: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, fundOwnerEntity?: { __typename?: 'FundOwnerEntity', id: string, name: string } | null | undefined, canSendCustomerInformationToBlueprint: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type FundAllocationsPageLotFragment = { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underContractDate?: DateOnly | null | undefined, address?: { __typename?: 'Address', id: string, street1: string, city: string } | null | undefined, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', name: string, code: LotInvestmentStatus }, canEditFund: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, fundOwnerEntity?: { __typename?: 'FundOwnerEntity', id: string, name: string } | null | undefined, canSendCustomerInformationToBlueprint: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type FundAllocationsPageFundFragment = { __typename?: 'Fund', id: string, name: string, ownerEntities: Array<{ __typename?: 'FundOwnerEntity', id: string, name: string }> };

export type CreateAssetUploadUrlMutationVariables = Exact<{
  input: CreateAssetUploadUrlInput;
}>;


export type CreateAssetUploadUrlMutation = { __typename?: 'Mutation', createAssetUploadUrl: { __typename?: 'CreateAssetUploadUrlResult', s3Key: string, uploadUrl: string, downloadUrl: string, previewUrl?: string | null | undefined } };

export type FundsPageFundsQueryVariables = Exact<{ [key: string]: never; }>;


export type FundsPageFundsQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string }> };

export type FundsPageFundFragment = { __typename?: 'Fund', id: string, name: string };

export type CheckoutControlsQueryVariables = Exact<{ [key: string]: never; }>;


export type CheckoutControlsQuery = { __typename?: 'Query', lotPartitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, underwrittenSalesPriceWithoutAppreciationInCents: number, listPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, salesPriceAtValuationDateInCents: number, valuationReportId?: number | null | undefined, showInCheckout: boolean, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }> };

export type CheckoutControls_LotPartitionFragment = { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, underwrittenSalesPriceWithoutAppreciationInCents: number, listPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, salesPriceAtValuationDateInCents: number, valuationReportId?: number | null | undefined, showInCheckout: boolean, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } };

export type MetrosPageMetrosQueryVariables = Exact<{ [key: string]: never; }>;


export type MetrosPageMetrosQuery = { __typename?: 'Query', metros: Array<{ __typename?: 'Metro', id: string, name: string, code: string, listToCloseRatioBasisPoints: number, deliveryToSalesReadyInDays: number, preListPremiumBasisPoints: number }> };

export type MetrosPageMetroFragment = { __typename?: 'Metro', id: string, name: string, code: string, listToCloseRatioBasisPoints: number, deliveryToSalesReadyInDays: number, preListPremiumBasisPoints: number };

export type SaveMetroMutationVariables = Exact<{
  input: SaveMetroInput;
}>;


export type SaveMetroMutation = { __typename?: 'Mutation', saveMetro: { __typename?: 'SaveMetroResult', metro: { __typename?: 'Metro', id: string, name: string, code: string, listToCloseRatioBasisPoints: number, deliveryToSalesReadyInDays: number, preListPremiumBasisPoints: number } } };

export type UnderwritingOverviewUnderwritingConfigQueryVariables = Exact<{
  underwritingConfigId: Scalars['ID'];
}>;


export type UnderwritingOverviewUnderwritingConfigQuery = { __typename?: 'Query', underwritingConfigs: Array<{ __typename?: 'UnderwritingConfig', id: string, targetInvestorMarginBasisPoints: number, debtFacilityBaseRateBasisPoints: number, debtFacilitySpreadBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metros: Array<{ __typename?: 'UnderwritingConfigMetro', id: string, targetInvestorMarginBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }> }> };

export type SaveUnderwritingConfigMutationVariables = Exact<{
  input: SaveUnderwritingConfigInput;
}>;


export type SaveUnderwritingConfigMutation = { __typename?: 'Mutation', saveUnderwritingConfig: { __typename?: 'SaveUnderwritingConfigResult', underwritingConfig: { __typename?: 'UnderwritingConfig', id: string, targetInvestorMarginBasisPoints: number, debtFacilityBaseRateBasisPoints: number, debtFacilitySpreadBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metros: Array<{ __typename?: 'UnderwritingConfigMetro', id: string, targetInvestorMarginBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }> } } };

export type SaveUnderwritingConfigMetroMutationVariables = Exact<{
  input: SaveUnderwritingConfigMetroInput;
}>;


export type SaveUnderwritingConfigMetroMutation = { __typename?: 'Mutation', saveUnderwritingConfigMetro: { __typename?: 'SaveUnderwritingConfigMetroResult', underwritingConfigMetro: { __typename?: 'UnderwritingConfigMetro', id: string, targetInvestorMarginBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } } } };

export type UnderwritingOverviewPageUnderwritingConfigFragment = { __typename?: 'UnderwritingConfig', id: string, targetInvestorMarginBasisPoints: number, debtFacilityBaseRateBasisPoints: number, debtFacilitySpreadBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metros: Array<{ __typename?: 'UnderwritingConfigMetro', id: string, targetInvestorMarginBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }> };

export type UnderwritingOverviewPageUnderwritingConfigMetroFragment = { __typename?: 'UnderwritingConfigMetro', id: string, targetInvestorMarginBasisPoints: number, buildMarginBasisPoints: number, siteAcquisitionMarkupBasisPoints: number, weightedFinancingRate: number, financingRate: number, percentDebtFinancedBasisPoints: number, preConMonths: number, constructionMonths: number, salesPeriodMonths: number, exitRealtorFeeBasisPoints: number, acquisitionClosingCostsBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } };

export type LotsPageLotsQueryVariables = Exact<{ [key: string]: never; }>;


export type LotsPageLotsQuery = { __typename?: 'Query', lots: Array<{ __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underwrittenInvestorMarginBasisPoints: number, investorMarginBasisPoints: number, salesforceOpportunityId?: string | null | undefined, dpid?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined }> };

export type LotsPageLotFragment = { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, underwrittenInvestorMarginBasisPoints: number, investorMarginBasisPoints: number, salesforceOpportunityId?: string | null | undefined, dpid?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, fund?: { __typename?: 'Fund', id: string, name: string } | null | undefined };

export type DrawOverviewDrawQueryVariables = Exact<{
  drawId: Scalars['ID'];
}>;


export type DrawOverviewDrawQuery = { __typename?: 'Query', creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly, fixedRateThousandthsBasisPoints?: number | null | undefined, lotPartitionDraws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType } }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type SaveLotPartitionDrawMutationVariables = Exact<{
  input: SaveLotPartitionDrawInput;
}>;


export type SaveLotPartitionDrawMutation = { __typename?: 'Mutation', saveLotPartitionDraw: { __typename?: 'SaveLotPartitionDrawResult', lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } } };

export type SaveCreditFacilityDrawMutationVariables = Exact<{
  input: SaveCreditFacilityDrawInput;
}>;


export type SaveCreditFacilityDrawMutation = { __typename?: 'Mutation', saveCreditFacilityDraw: { __typename?: 'SaveCreditFacilityDrawResult', creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly, fixedRateThousandthsBasisPoints?: number | null | undefined, lotPartitionDraws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType } }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type DeleteDrawMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteDrawMutation = { __typename?: 'Mutation', deleteCreditFacilityDraw: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type DrawOverviewPageDrawFragment = { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly, fixedRateThousandthsBasisPoints?: number | null | undefined, lotPartitionDraws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType } }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type DrawOverviewPageLotPartitionDrawFragment = { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } };

export type ExportBillsForDrawMutationVariables = Exact<{
  input: ExportBillsForDrawInput;
}>;


export type ExportBillsForDrawMutation = { __typename?: 'Mutation', exportBillsForDraw: { __typename?: 'ExportBillsForDrawResult', googleDriveFolderId: string } };

export type CreateCreditFacilityDrawMutationVariables = Exact<{
  input: SaveCreditFacilityDrawInput;
}>;


export type CreateCreditFacilityDrawMutation = { __typename?: 'Mutation', saveCreditFacilityDraw: { __typename?: 'SaveCreditFacilityDrawResult', creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string } } };

export type InvoiceOverviewInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['ID'];
}>;


export type InvoiceOverviewInvoiceQuery = { __typename?: 'Query', creditFacilityInvoices: Array<{ __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number, fund: { __typename?: 'Fund', id: string, name: string }, drawInterests: Array<{ __typename?: 'CreditFacilityInvoiceDrawInterest', id: string, amountInCents: number, drawAmountInCents: number, interestDate: DateOnly, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }>, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, drawInterestsByLotPartitionDraw: Array<{ __typename?: 'CreditFacilityInvoiceDrawInterestByLotPartitionDraw', amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }> }> };

export type SaveDrawInterestMutationVariables = Exact<{
  input: SaveCreditFacilityInvoiceDrawInterestInput;
}>;


export type SaveDrawInterestMutation = { __typename?: 'Mutation', saveCreditFacilityInvoiceDrawInterest: { __typename?: 'SaveCreditFacilityInvoiceDrawInterestResult', creditFacilityInvoiceDrawInterest: { __typename?: 'CreditFacilityInvoiceDrawInterest', id: string, amountInCents: number, drawAmountInCents: number, interestDate: DateOnly, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } } } };

export type DeleteInvoiceMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteInvoiceMutation = { __typename?: 'Mutation', deleteCreditFacilityInvoice: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type InvoiceOverviewPageInvoiceFragment = { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number, fund: { __typename?: 'Fund', id: string, name: string }, drawInterests: Array<{ __typename?: 'CreditFacilityInvoiceDrawInterest', id: string, amountInCents: number, drawAmountInCents: number, interestDate: DateOnly, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }>, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, drawInterestsByLotPartitionDraw: Array<{ __typename?: 'CreditFacilityInvoiceDrawInterestByLotPartitionDraw', amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }> };

export type InvoiceOverviewPageDrawInterestFragment = { __typename?: 'CreditFacilityInvoiceDrawInterest', id: string, amountInCents: number, drawAmountInCents: number, interestDate: DateOnly, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } };

export type InvoiceOverPageLotPartitionDrawFragment = { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } };

export type InvoiceOverviewPageGroupedDrawInterestFragment = { __typename?: 'CreditFacilityInvoiceDrawInterestByLotPartitionDraw', amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } };

export type DrawRequestOverviewDrawRequestQueryVariables = Exact<{
  drawRequestId: Scalars['ID'];
}>;


export type DrawRequestOverviewDrawRequestQuery = { __typename?: 'Query', creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, preparationDate: DateOnly, lotPartitionDrawRequests: Array<{ __typename?: 'LotPartitionDrawRequest', id: string, amountInCents: number, modeledIndividualAmountToBorrowInCents: number, modeledCollectiveAmountToBorrowInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, borrowedAmountInCents: number, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, goldmanDrawModel?: { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined } | null | undefined, anchorMultilotDrawModel?: { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined, anchorFloatingDrawModel?: { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType }, creditFacilityDrawModel?: { __typename?: 'FundCreditFacilityDrawModelDetail', code: FundCreditFacilityDrawModel } | null | undefined }, canEdit: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type SaveLotPartitionDrawRequestsMutationVariables = Exact<{
  input: SaveLotPartitionDrawRequestsInput;
}>;


export type SaveLotPartitionDrawRequestsMutation = { __typename?: 'Mutation', saveLotPartitionDrawRequests: { __typename?: 'SaveLotPartitionDrawRequestsResult', lotPartitionDrawRequests: Array<{ __typename?: 'LotPartitionDrawRequest', id: string, amountInCents: number, modeledIndividualAmountToBorrowInCents: number, modeledCollectiveAmountToBorrowInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, borrowedAmountInCents: number, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, goldmanDrawModel?: { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined } | null | undefined, anchorMultilotDrawModel?: { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined, anchorFloatingDrawModel?: { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined }> } };

export type SaveCreditFacilityDrawRequestMutationVariables = Exact<{
  input: SaveCreditFacilityDrawRequestInput;
}>;


export type SaveCreditFacilityDrawRequestMutation = { __typename?: 'Mutation', saveCreditFacilityDrawRequest: { __typename?: 'SaveCreditFacilityDrawRequestResult', creditFacilityDrawRequest: { __typename?: 'CreditFacilityDrawRequest', id: string, preparationDate: DateOnly, lotPartitionDrawRequests: Array<{ __typename?: 'LotPartitionDrawRequest', id: string, amountInCents: number, modeledIndividualAmountToBorrowInCents: number, modeledCollectiveAmountToBorrowInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, borrowedAmountInCents: number, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, goldmanDrawModel?: { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined } | null | undefined, anchorMultilotDrawModel?: { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined, anchorFloatingDrawModel?: { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType }, creditFacilityDrawModel?: { __typename?: 'FundCreditFacilityDrawModelDetail', code: FundCreditFacilityDrawModel } | null | undefined }, canEdit: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type RefreshDrawModelBlueprintDataMutationVariables = Exact<{
  input: RefreshDrawModelBlueprintDataInput;
}>;


export type RefreshDrawModelBlueprintDataMutation = { __typename?: 'Mutation', refreshDrawModelBlueprintData: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type DrawRequestOverviewPageDrawRequestFragment = { __typename?: 'CreditFacilityDrawRequest', id: string, preparationDate: DateOnly, lotPartitionDrawRequests: Array<{ __typename?: 'LotPartitionDrawRequest', id: string, amountInCents: number, modeledIndividualAmountToBorrowInCents: number, modeledCollectiveAmountToBorrowInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, borrowedAmountInCents: number, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, goldmanDrawModel?: { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined } | null | undefined, anchorMultilotDrawModel?: { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined, anchorFloatingDrawModel?: { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined }>, fund: { __typename?: 'Fund', id: string, name: string, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType }, creditFacilityDrawModel?: { __typename?: 'FundCreditFacilityDrawModelDetail', code: FundCreditFacilityDrawModel } | null | undefined }, canEdit: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type DrawRequestOverviewPageLotPartitionDrawRequestFragment = { __typename?: 'LotPartitionDrawRequest', id: string, amountInCents: number, modeledIndividualAmountToBorrowInCents: number, modeledCollectiveAmountToBorrowInCents: number, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, borrowedAmountInCents: number, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, goldmanDrawModel?: { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined } | null | undefined, anchorMultilotDrawModel?: { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined, anchorFloatingDrawModel?: { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined } | null | undefined };

export type DrawRequestOverviewPageGoldmanDrawModelFragment = { __typename?: 'GoldmanDrawModel', id: string, isEligibleForGoldmanDraw: boolean, isTargetBuy: boolean, isExpandedBuy: boolean, isFinishedProperty: boolean, currentAppraisalValueInCents?: number | null | undefined, advanceRateBasisPoints: number, adjustedCollateralValueInCents: number, adjustedAdvanceRateBasisPoints: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined, landCostsInCents: number, homeboundPortionInCents: number, isLotCostToUnderwrittenNetSalesPriceEligible: boolean, isOwnedLessThan_721Days: boolean, isAppraisalAgeAcceptable: boolean, isInfillOrDeveloperCommunity: boolean, isLandCostEligible: boolean, isUnderwrittenHardCostEligible: boolean, isLandCostAndConstructionExpensesEligible: boolean, isUnderwrittenMarginEligible: boolean, isBedroomsEligible: boolean, isSqftEligible: boolean, isBathroomsEligible: boolean, isLandCostTargetEligible: boolean, isLotCostToUnderwrittenNetSalesPriceTargetEligible: boolean, isConstructionExpensesTargetEligible: boolean, isLandCostAndConstructionExpensesTargetEligible: boolean, advanceRatePreconBasisPoints: number, underwrittenSalesPriceMarginBasisPoints: number, isVictoryOverride?: boolean | null | undefined };

export type DrawRequestOverviewPageAnchorMultilotDrawModelFragment = { __typename?: 'AnchorMultilotDrawModel', id: string, realizedSoftCostsInCents: number, realizedIndirectCostsInCents: number, realizedDirectCostsInCents: number, realizedBuilderFeeInCents: number, realizedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined };

export type DrawRequestOverviewPageAnchorFloatingDrawModelFragment = { __typename?: 'AnchorFloatingDrawModel', id: string, completedSoftCostsInCents: number, completedIndirectCostsInCents: number, completedDirectCostsInCents: number, completedBuilderFeeInCents: number, completedConstructionExpensesInCents: number, isBlueprintCostDataSet?: boolean | null | undefined };

export type FundOverviewFundQueryVariables = Exact<{
  fundId: Scalars['ID'];
}>;


export type FundOverviewFundQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string, targetInvestorMarginBasisPoints: number, opcoDirectHardCostMarkupBasisPoints: number, opcoIndirectHardCostMarkupBasisPoints: number, opcoSoftCostMarkupBasisPoints: number, opcoSiteAcquisitionMarkupBasisPoints: number, creditFacilityFixedRateBasisPoints: number, creditFacilityCanBorrowDirectCosts: boolean, creditFacilityCanBorrowIndirectCosts: boolean, creditFacilityCanBorrowSoftCosts: boolean, equityFinancingBasisPoints: number, lots: Array<{ __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, softCostInCents: number, indirectHardCostInCents: number, directHardCostInCents: number, opcoMarkupInCents: number, netSalesPriceInCents: number, saleDate?: DateOnly | null | undefined, realizedUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedUnleveredMultipleOnInvestedCapital?: number | null | undefined, realizedLeveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedLeveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenLotOwnershipBasisPoints: number, underwrittenSoftCostInCents: number, underwrittenIndirectHardCostInCents: number, underwrittenDirectHardCostInCents: number, underwrittenOpcoMarkupInCents: number, underwrittenNetSalesPriceInCents: number, underwrittenDirectMarginBasisPoints: number, directMarginBasisPoints: number, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, unleveredReturnOnCostBasisPoints: number, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number }> }>, lot: { __typename?: 'Lot', id: string, fundContributionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, underwrittenPurchasePriceInCents: number, underwrittenUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, underwrittenUnleveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenUnleveredReturnOnCostBasisPoints?: number | null | undefined, underwrittenLeveredReturnOnCostBasisPoints?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }>, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus } }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, amountInCents: number, drawDate: DateOnly }>, creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly }>, metros: Array<{ __typename?: 'FundMetro', id: string, targetInvestorMarginBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }>, creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined }> }> };

export type FundOverviewExpectedSaleDateFundQueryVariables = Exact<{
  fundId: Scalars['ID'];
}>;


export type FundOverviewExpectedSaleDateFundQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string, lots: Array<{ __typename?: 'Lot', id: string, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, saleDate?: DateOnly | null | undefined, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }> }> }> };

export type SaveFundMutationVariables = Exact<{
  input: SaveFundInput;
}>;


export type SaveFundMutation = { __typename?: 'Mutation', saveFund: { __typename?: 'SaveFundResult', fund: { __typename?: 'Fund', id: string, name: string, targetInvestorMarginBasisPoints: number, opcoDirectHardCostMarkupBasisPoints: number, opcoIndirectHardCostMarkupBasisPoints: number, opcoSoftCostMarkupBasisPoints: number, opcoSiteAcquisitionMarkupBasisPoints: number, creditFacilityFixedRateBasisPoints: number, creditFacilityCanBorrowDirectCosts: boolean, creditFacilityCanBorrowIndirectCosts: boolean, creditFacilityCanBorrowSoftCosts: boolean, equityFinancingBasisPoints: number, lots: Array<{ __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, softCostInCents: number, indirectHardCostInCents: number, directHardCostInCents: number, opcoMarkupInCents: number, netSalesPriceInCents: number, saleDate?: DateOnly | null | undefined, realizedUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedUnleveredMultipleOnInvestedCapital?: number | null | undefined, realizedLeveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedLeveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenLotOwnershipBasisPoints: number, underwrittenSoftCostInCents: number, underwrittenIndirectHardCostInCents: number, underwrittenDirectHardCostInCents: number, underwrittenOpcoMarkupInCents: number, underwrittenNetSalesPriceInCents: number, underwrittenDirectMarginBasisPoints: number, directMarginBasisPoints: number, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, unleveredReturnOnCostBasisPoints: number, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number }> }>, lot: { __typename?: 'Lot', id: string, fundContributionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, underwrittenPurchasePriceInCents: number, underwrittenUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, underwrittenUnleveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenUnleveredReturnOnCostBasisPoints?: number | null | undefined, underwrittenLeveredReturnOnCostBasisPoints?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }>, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus } }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, amountInCents: number, drawDate: DateOnly }>, creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly }>, metros: Array<{ __typename?: 'FundMetro', id: string, targetInvestorMarginBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }>, creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined }> } } };

export type SaveFundMetroMutationVariables = Exact<{
  input: SaveFundMetroInput;
}>;


export type SaveFundMetroMutation = { __typename?: 'Mutation', saveFundMetro: { __typename?: 'SaveFundMetroResult', fundMetro: { __typename?: 'FundMetro', id: string, targetInvestorMarginBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } } } };

export type FundOverviewPageFundFragment = { __typename?: 'Fund', id: string, name: string, targetInvestorMarginBasisPoints: number, opcoDirectHardCostMarkupBasisPoints: number, opcoIndirectHardCostMarkupBasisPoints: number, opcoSoftCostMarkupBasisPoints: number, opcoSiteAcquisitionMarkupBasisPoints: number, creditFacilityFixedRateBasisPoints: number, creditFacilityCanBorrowDirectCosts: boolean, creditFacilityCanBorrowIndirectCosts: boolean, creditFacilityCanBorrowSoftCosts: boolean, equityFinancingBasisPoints: number, lots: Array<{ __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, softCostInCents: number, indirectHardCostInCents: number, directHardCostInCents: number, opcoMarkupInCents: number, netSalesPriceInCents: number, saleDate?: DateOnly | null | undefined, realizedUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedUnleveredMultipleOnInvestedCapital?: number | null | undefined, realizedLeveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedLeveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenLotOwnershipBasisPoints: number, underwrittenSoftCostInCents: number, underwrittenIndirectHardCostInCents: number, underwrittenDirectHardCostInCents: number, underwrittenOpcoMarkupInCents: number, underwrittenNetSalesPriceInCents: number, underwrittenDirectMarginBasisPoints: number, directMarginBasisPoints: number, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, unleveredReturnOnCostBasisPoints: number, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number }> }>, lot: { __typename?: 'Lot', id: string, fundContributionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, underwrittenPurchasePriceInCents: number, underwrittenUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, underwrittenUnleveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenUnleveredReturnOnCostBasisPoints?: number | null | undefined, underwrittenLeveredReturnOnCostBasisPoints?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }>, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus } }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, amountInCents: number, drawDate: DateOnly }>, creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly }>, metros: Array<{ __typename?: 'FundMetro', id: string, targetInvestorMarginBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } }>, creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined }> };

export type FundOverviewPageExpectedSaleDateFundFragment = { __typename?: 'Fund', id: string, name: string, lots: Array<{ __typename?: 'Lot', id: string, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, saleDate?: DateOnly | null | undefined, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }> }> };

export type FundOverviewPageLotFragment = { __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, softCostInCents: number, indirectHardCostInCents: number, directHardCostInCents: number, opcoMarkupInCents: number, netSalesPriceInCents: number, saleDate?: DateOnly | null | undefined, realizedUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedUnleveredMultipleOnInvestedCapital?: number | null | undefined, realizedLeveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedLeveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenLotOwnershipBasisPoints: number, underwrittenSoftCostInCents: number, underwrittenIndirectHardCostInCents: number, underwrittenDirectHardCostInCents: number, underwrittenOpcoMarkupInCents: number, underwrittenNetSalesPriceInCents: number, underwrittenDirectMarginBasisPoints: number, directMarginBasisPoints: number, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, unleveredReturnOnCostBasisPoints: number, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number }> }>, lot: { __typename?: 'Lot', id: string, fundContributionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, underwrittenPurchasePriceInCents: number, underwrittenUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, underwrittenUnleveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenUnleveredReturnOnCostBasisPoints?: number | null | undefined, underwrittenLeveredReturnOnCostBasisPoints?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }>, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus } }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> };

export type FundOverviewPageDrawFragment = { __typename?: 'CreditFacilityDraw', id: string, amountInCents: number, drawDate: DateOnly };

export type FundOverviewPageDrawRequestFragment = { __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined };

export type FundOverviewPagePaymentFragment = { __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly };

export type FundOverviewPageInvoiceFragment = { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number };

export type FundOverviewPageFundMetroFragment = { __typename?: 'FundMetro', id: string, targetInvestorMarginBasisPoints: number, metro: { __typename?: 'Metro', id: string, code: string, name: string } };

export type FundOverviewPageLotPartitionFragment = { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, softCostInCents: number, indirectHardCostInCents: number, directHardCostInCents: number, opcoMarkupInCents: number, netSalesPriceInCents: number, saleDate?: DateOnly | null | undefined, realizedUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedUnleveredMultipleOnInvestedCapital?: number | null | undefined, realizedLeveredInternalRateOfReturnBasisPoints?: number | null | undefined, realizedLeveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenLotOwnershipBasisPoints: number, underwrittenSoftCostInCents: number, underwrittenIndirectHardCostInCents: number, underwrittenDirectHardCostInCents: number, underwrittenOpcoMarkupInCents: number, underwrittenNetSalesPriceInCents: number, underwrittenDirectMarginBasisPoints: number, directMarginBasisPoints: number, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, unleveredReturnOnCostBasisPoints: number, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number }> }>, lot: { __typename?: 'Lot', id: string, fundContributionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, underwrittenPurchasePriceInCents: number, underwrittenUnleveredInternalRateOfReturnBasisPoints?: number | null | undefined, underwrittenUnleveredMultipleOnInvestedCapital?: number | null | undefined, underwrittenUnleveredReturnOnCostBasisPoints?: number | null | undefined, underwrittenLeveredReturnOnCostBasisPoints?: number | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }>, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', name: string, code: LotPartitionSalesStatus } };

export type FundOverviewPageExpectedSaleDateLotPartitionFragment = { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, saleDate?: DateOnly | null | undefined, expectedSaleDate?: DateOnly | null | undefined, manualExpectedSaleDate?: DateOnly | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } };

export type CreateCreditFacilityPaymentMutationVariables = Exact<{
  input: SaveCreditFacilityPaymentInput;
}>;


export type CreateCreditFacilityPaymentMutation = { __typename?: 'Mutation', saveCreditFacilityPayment: { __typename?: 'SaveCreditFacilityPaymentResult', creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string } } };

export type PaymentOverviewPaymentQueryVariables = Exact<{
  paymentId: Scalars['ID'];
}>;


export type PaymentOverviewPaymentQuery = { __typename?: 'Query', creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly, allocatedAmountInCents: number, amountInCents: number, lotPartitionDrawPayments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }>, fund: { __typename?: 'Fund', id: string, name: string, lots: Array<{ __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined }> }> }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type SaveLotPartitionDrawPaymentMutationVariables = Exact<{
  input: SaveLotPartitionDrawPaymentInput;
}>;


export type SaveLotPartitionDrawPaymentMutation = { __typename?: 'Mutation', saveLotPartitionDrawPayment: { __typename?: 'SaveLotPartitionDrawPaymentResult', lotPartitionDrawPayment: { __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } } } };

export type SaveCreditFacilityPaymentMutationVariables = Exact<{
  input: SaveCreditFacilityPaymentInput;
}>;


export type SaveCreditFacilityPaymentMutation = { __typename?: 'Mutation', saveCreditFacilityPayment: { __typename?: 'SaveCreditFacilityPaymentResult', creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly, allocatedAmountInCents: number, amountInCents: number, lotPartitionDrawPayments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }>, fund: { __typename?: 'Fund', id: string, name: string, lots: Array<{ __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined }> }> }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type DeletePaymentMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeletePaymentMutation = { __typename?: 'Mutation', deleteCreditFacilityPayment: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type PaymentOverviewPagePaymentFragment = { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly, allocatedAmountInCents: number, amountInCents: number, lotPartitionDrawPayments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } }>, fund: { __typename?: 'Fund', id: string, name: string, lots: Array<{ __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined }> }> }, canDelete: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type PaymentOverviewPageLotFragment = { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined }> };

export type PaymentOverviewPageLotPartitionDrawPaymentFragment = { __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, lotPartitionDraw: { __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } } };

export type SaveCreditFacilityInvoiceMutationVariables = Exact<{
  input: SaveCreditFacilityInvoiceInput;
}>;


export type SaveCreditFacilityInvoiceMutation = { __typename?: 'Mutation', saveCreditFacilityInvoice: { __typename?: 'SaveCreditFacilityInvoiceResult', creditFacilityInvoice: { __typename?: 'CreditFacilityInvoice', id: string } } };

export type CreditFacilityInvoicePopulatedQueryVariables = Exact<{
  filter: CreditFacilityInvoiceFilter;
}>;


export type CreditFacilityInvoicePopulatedQuery = { __typename?: 'Query', creditFacilityInvoices: Array<{ __typename?: 'CreditFacilityInvoice', id: string, isInterestPopulated: boolean }> };

export type FundLoanManagementFundQueryVariables = Exact<{
  fundId: Scalars['ID'];
}>;


export type FundLoanManagementFundQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string, creditFacilityFixedRateBasisPoints: number, creditFacilityCanBorrowDirectCosts: boolean, creditFacilityCanBorrowIndirectCosts: boolean, creditFacilityCanBorrowSoftCosts: boolean, equityFinancingBasisPoints: number, lots: Array<{ __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number, creditFacilityInvoice: { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly } }> }>, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, fixedRateThousandthsBasisPoints?: number | null | undefined, amountInCents: number, drawDate: DateOnly }>, creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly }>, creditFacilityInvoices: Array<{ __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number }>, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType } }> };

export type FundLoanManagementFundDrawRequestsQueryVariables = Exact<{
  fundId: Scalars['ID'];
}>;


export type FundLoanManagementFundDrawRequestsQuery = { __typename?: 'Query', funds: Array<{ __typename?: 'Fund', id: string, name: string, creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, canDelete: { __typename?: 'PotentialOperation', allowed: boolean }, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined }> }> };

export type DeleteCreditFacilityDrawRequestMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteCreditFacilityDrawRequestMutation = { __typename?: 'Mutation', deleteCreditFacilityDrawRequest: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type QueueJobsMutationVariables = Exact<{
  input: AddJobsInput;
}>;


export type QueueJobsMutation = { __typename?: 'Mutation', addJobs: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type CreditFacilityDrawRequestCreatePollingQueryVariables = Exact<{
  fundId: Scalars['ID'];
}>;


export type CreditFacilityDrawRequestCreatePollingQuery = { __typename?: 'Query', creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string }> };

export type FundLoanManagementPageFundDrawRequestsFragment = { __typename?: 'Fund', id: string, name: string, creditFacilityDrawRequests: Array<{ __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, canDelete: { __typename?: 'PotentialOperation', allowed: boolean }, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined }> };

export type FundLoanManagementPageFundFragment = { __typename?: 'Fund', id: string, name: string, creditFacilityFixedRateBasisPoints: number, creditFacilityCanBorrowDirectCosts: boolean, creditFacilityCanBorrowIndirectCosts: boolean, creditFacilityCanBorrowSoftCosts: boolean, equityFinancingBasisPoints: number, lots: Array<{ __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number, creditFacilityInvoice: { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly } }> }>, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, creditFacilityDraws: Array<{ __typename?: 'CreditFacilityDraw', id: string, fixedRateThousandthsBasisPoints?: number | null | undefined, amountInCents: number, drawDate: DateOnly }>, creditFacilityPayments: Array<{ __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly }>, creditFacilityInvoices: Array<{ __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number }>, creditFacilityInterestType: { __typename?: 'CreditFacilityInterestTypeDetail', code: CreditFacilityInterestType } };

export type FundLoanManagementPageLotFragment = { __typename?: 'Lot', id: string, acquisitionDate?: DateOnly | null | undefined, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, partitions: Array<{ __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number, creditFacilityInvoice: { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly } }> }>, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> };

export type FundLoanManagementPageDrawFragment = { __typename?: 'CreditFacilityDraw', id: string, fixedRateThousandthsBasisPoints?: number | null | undefined, amountInCents: number, drawDate: DateOnly };

export type FundLoanManagementPageDrawRequestFragment = { __typename?: 'CreditFacilityDrawRequest', id: string, amountInCents: number, preparationDate: DateOnly, canDelete: { __typename?: 'PotentialOperation', allowed: boolean }, creditFacilityDraw?: { __typename?: 'CreditFacilityDraw', id: string } | null | undefined };

export type FundLoanManagementPagePaymentFragment = { __typename?: 'CreditFacilityPayment', id: string, amountInCents: number, allocatedAmountInCents: number, paymentDate: DateOnly };

export type FundLoanManagementPageInvoiceFragment = { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly, amountInCents: number, allocatedAmountInCents: number };

export type FundLoanManagementPageLotPartitionFragment = { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, draws: Array<{ __typename?: 'LotPartitionDraw', id: string, amountInCents: number, remainingAmountInCents: number, payments: Array<{ __typename?: 'LotPartitionDrawPayment', id: string, amountInCents: number, creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string, paymentDate: DateOnly } }>, creditFacilityDraw: { __typename?: 'CreditFacilityDraw', id: string, drawDate: DateOnly }, invoices: Array<{ __typename?: 'LotPartitionDrawInvoice', id: string, interestAmountInCents: number, creditFacilityInvoice: { __typename?: 'CreditFacilityInvoice', id: string, invoiceDate: DateOnly } }> }>, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined }, payments: Array<{ __typename?: 'LotPartitionPayment', id: string, amountInCents: number, paymentDate: DateOnly }>, equityFinancingCosts: Array<{ __typename?: 'EquityFinancingCost', id: string, interestAmountInCents: number, interestDate: DateOnly }> };

export type AddDrawsToPaymentMutationVariables = Exact<{
  input: AddOpenDrawsToCreditFacilityPaymentInput;
}>;


export type AddDrawsToPaymentMutation = { __typename?: 'Mutation', addOpenDrawsToCreditFacilityPayment: { __typename?: 'AddOpenDrawsToCreditFacilityPaymentResult', creditFacilityPayment: { __typename?: 'CreditFacilityPayment', id: string } } };

export type SaveLotAcqPurchaseAgreementMutationVariables = Exact<{
  input: SaveLotAcqPurchaseAgreementInput;
}>;


export type SaveLotAcqPurchaseAgreementMutation = { __typename?: 'Mutation', saveLotAcqPurchaseAgreement: { __typename?: 'SaveLotAcqPurchaseAgreementResult', lotAcqPurchaseAgreement: { __typename?: 'LotAcqPurchaseAgreement', id: string, purchasePriceInCents: number, earnestMoneyInCents: number, optionFeeInCents: number, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string } } } };

export type DeleteLotAcqPurchaseAgreementMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteLotAcqPurchaseAgreementMutation = { __typename?: 'Mutation', deleteLotAcqPurchaseAgreement: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type LotAcqLotAcqPurchaseAgreementFragment = { __typename?: 'LotAcqPurchaseAgreement', id: string, purchasePriceInCents: number, earnestMoneyInCents: number, optionFeeInCents: number, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string } };

export type LotAcqPurchaseAgreementDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LotAcqPurchaseAgreementDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, parent: { __typename?: 'LotPartition' } | { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined }, lotAcqPurchaseAgreement?: { __typename?: 'LotAcqPurchaseAgreement', id: string, purchasePriceInCents: number, earnestMoneyInCents: number, optionFeeInCents: number, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string } } | null | undefined }> };

export type SaveLotAcqSettlementStatementMutationVariables = Exact<{
  input: SaveLotAcqSettlementStatementInput;
}>;


export type SaveLotAcqSettlementStatementMutation = { __typename?: 'Mutation', saveLotAcqSettlementStatement: { __typename?: 'SaveLotAcqSettlementStatementResult', lotAcqSettlementStatement: { __typename?: 'LotAcqSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, buyerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } }>, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type DeleteLotAcqSettlementStatementMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeleteLotAcqSettlementStatementMutation = { __typename?: 'Mutation', deleteLotAcqSettlementStatement: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type SendLotAcqSettlementStatementForBookingMutationVariables = Exact<{
  input: SendLotAcqSettlementStatementForBookingInput;
}>;


export type SendLotAcqSettlementStatementForBookingMutation = { __typename?: 'Mutation', sendLotAcqSettlementStatementForBooking: { __typename?: 'LotAcqSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, buyerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } }>, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type ProcessLotAcqSettlementStatementOcrMutationVariables = Exact<{
  input: ProcessLotAcqSettlementStatementOcrInput;
}>;


export type ProcessLotAcqSettlementStatementOcrMutation = { __typename?: 'Mutation', processLotAcqSettlementStatementOcr: { __typename?: 'LotAcqSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, buyerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } }>, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type LotAcqLotAcqSettlementStatementFragment = { __typename?: 'LotAcqSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, buyerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } }>, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type LotAcqLotAcqSettlementStatementLineItemFragment = { __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } };

export type LotAcqLotFragment = { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } };

export type LotAcqSettlementStatementDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type LotAcqSettlementStatementDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, parent: { __typename?: 'LotPartition' } | { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined }, lotAcqSettlementStatement?: { __typename?: 'LotAcqSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, buyerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'LotAcqSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'LotAcqSettlementStatementLineItemTypeDetail', code: LotAcqSettlementStatementLineItemType, name: string } }>, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined }> };

export type AssetInfoFragment = { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined };

export type LotPartitionDocumentsQueryVariables = Exact<{
  lotPartitionId: Scalars['ID'];
}>;


export type LotPartitionDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, canCreatePropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canViewPropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } }>, lotPartitions: Array<{ __typename?: 'LotPartition', id: string, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }> };

export type LotPartitionDocuments_DocumentFragment = { __typename?: 'Document', id: string, canCreatePropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canViewPropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } };

export type LotPartitionDocuments_LotPartitionFragment = { __typename?: 'LotPartition', id: string, lot: { __typename?: 'Lot', id: string, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } };

export type SaveLotPartitionDocumentsMutationVariables = Exact<{
  input: SaveDocumentsInput;
}>;


export type SaveLotPartitionDocumentsMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', id: string, canCreatePropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, canViewPropertySaleSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } }> } };

export type SavePropertySaleSettlementStatementMutationVariables = Exact<{
  input: SavePropertySaleSettlementStatementInput;
}>;


export type SavePropertySaleSettlementStatementMutation = { __typename?: 'Mutation', savePropertySaleSettlementStatement: { __typename?: 'SavePropertySaleSettlementStatementResult', propertySaleSettlementStatement: { __typename?: 'PropertySaleSettlementStatement', id: string } } };

export type LotOverviewLotQueryVariables = Exact<{
  lotId: Scalars['ID'];
}>;


export type LotOverviewLotQuery = { __typename?: 'Query', lots: Array<{ __typename?: 'Lot', id: string, salesforceOpportunityId?: string | null | undefined, purchasePriceInCents: number, isSuburban: boolean, opcoSiteAcquisitionMarkupInCents: number, softCostInCents: any, indirectHardCostInCents: any, directHardCostInCents: any, opcoMarkupInCents: any, financingCostInCents: number, totalCostInCents: any, totalSaleValueInCents: any, totalNetSaleRevenueInCents: any, investorMarginBasisPoints: number, underwrittenSoftCostInCents: any, underwrittenIndirectHardCostInCents: any, underwrittenDirectHardCostInCents: any, underwrittenOpcoMarkupInCents: any, underwrittenOpcoTotalCostInCents: any, underwrittenSiteAcquisitionMarkupBasisPoints: number, underwrittenFinancingCostInCents: number, underwrittenTotalSaleValueInCents: any, underwrittenTotalNetSaleRevenueInCents: any, underwrittenTotalCostInCents: any, underwrittenInvestorMarginBasisPoints: number, underwrittenPurchasePriceInCents: number, underwrittenClosingCostsInCents: number, underwrittenTotalLotAcquisitionCostsInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus }, partitions: Array<{ __typename?: 'LotPartition', id: string, moveInDate?: DateOnly | null | undefined, blueprintProjectId?: string | null | undefined, underwrittenSalesPriceInCents: number, expectedSalePriceInCents: number, underwrittenOpcoTotalCostInCents: number, underwrittenLotOwnershipBasisPoints: number, opcoTotalCostInCents: number, isLegacyUwRevenue?: boolean | null | undefined, expectedCompletionDate?: DateOnly | null | undefined, salesPriceAtValuationDateInCents: number, valuationDate: DateOnly, valuationReportId?: number | null | undefined, appreciationMultiplier: number, saleDate?: DateOnly | null | undefined, lotOwnershipBasisPoints: number, salesforceOpportunityId?: string | null | undefined, salePriceInCents?: number | null | undefined, realizedNetSalesPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, underContractPriceInCents?: number | null | undefined, underContractNetSalesPriceInCents?: number | null | undefined, listPriceInCents?: number | null | undefined, listedNetSalesPriceInCents?: number | null | undefined, netSalesPriceInCents: number, notes?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, directUnderwritingSoftCostsInCents?: number | null | undefined, directUnderwritingHardCostsInCents?: number | null | undefined, directUnderwritingHardCostMarkupBasisPoints?: number | null | undefined, underwrittenSalesCommissionBasisPoints: number, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', code: LotPartitionSalesStatus, name: string }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined }, documents: Array<{ __typename?: 'Document', id: string }> }>, canContractDirectUnderwriting: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } }> };

export type SaveLotPartitionsMutationVariables = Exact<{
  input: SaveLotPartitionsInput;
}>;


export type SaveLotPartitionsMutation = { __typename?: 'Mutation', saveLotPartitions: { __typename?: 'SaveLotPartitionsResult', lotPartitions: Array<{ __typename?: 'LotPartition', id: string, moveInDate?: DateOnly | null | undefined, blueprintProjectId?: string | null | undefined, underwrittenSalesPriceInCents: number, expectedSalePriceInCents: number, underwrittenOpcoTotalCostInCents: number, underwrittenLotOwnershipBasisPoints: number, opcoTotalCostInCents: number, isLegacyUwRevenue?: boolean | null | undefined, expectedCompletionDate?: DateOnly | null | undefined, salesPriceAtValuationDateInCents: number, valuationDate: DateOnly, valuationReportId?: number | null | undefined, appreciationMultiplier: number, saleDate?: DateOnly | null | undefined, lotOwnershipBasisPoints: number, salesforceOpportunityId?: string | null | undefined, salePriceInCents?: number | null | undefined, realizedNetSalesPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, underContractPriceInCents?: number | null | undefined, underContractNetSalesPriceInCents?: number | null | undefined, listPriceInCents?: number | null | undefined, listedNetSalesPriceInCents?: number | null | undefined, netSalesPriceInCents: number, notes?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, directUnderwritingSoftCostsInCents?: number | null | undefined, directUnderwritingHardCostsInCents?: number | null | undefined, directUnderwritingHardCostMarkupBasisPoints?: number | null | undefined, underwrittenSalesCommissionBasisPoints: number, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', code: LotPartitionSalesStatus, name: string }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined }, documents: Array<{ __typename?: 'Document', id: string }> }> } };

export type SaveDocumentsMutationVariables = Exact<{
  input: SaveDocumentsInput;
}>;


export type SaveDocumentsMutation = { __typename?: 'Mutation', saveDocuments: { __typename?: 'SaveDocumentsResult', documents: Array<{ __typename?: 'Document', id: string, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, canViewLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canViewLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } }> } };

export type LotDocumentsQueryVariables = Exact<{
  lotId: Scalars['ID'];
}>;


export type LotDocumentsQuery = { __typename?: 'Query', lots: Array<{ __typename?: 'Lot', id: string, documents: Array<{ __typename?: 'Document', id: string, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, canViewLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canViewLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } }> }> };

export type LotOverviewPageLotFragment = { __typename?: 'Lot', id: string, salesforceOpportunityId?: string | null | undefined, purchasePriceInCents: number, isSuburban: boolean, opcoSiteAcquisitionMarkupInCents: number, softCostInCents: any, indirectHardCostInCents: any, directHardCostInCents: any, opcoMarkupInCents: any, financingCostInCents: number, totalCostInCents: any, totalSaleValueInCents: any, totalNetSaleRevenueInCents: any, investorMarginBasisPoints: number, underwrittenSoftCostInCents: any, underwrittenIndirectHardCostInCents: any, underwrittenDirectHardCostInCents: any, underwrittenOpcoMarkupInCents: any, underwrittenOpcoTotalCostInCents: any, underwrittenSiteAcquisitionMarkupBasisPoints: number, underwrittenFinancingCostInCents: number, underwrittenTotalSaleValueInCents: any, underwrittenTotalNetSaleRevenueInCents: any, underwrittenTotalCostInCents: any, underwrittenInvestorMarginBasisPoints: number, underwrittenPurchasePriceInCents: number, underwrittenClosingCostsInCents: number, underwrittenTotalLotAcquisitionCostsInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus }, partitions: Array<{ __typename?: 'LotPartition', id: string, moveInDate?: DateOnly | null | undefined, blueprintProjectId?: string | null | undefined, underwrittenSalesPriceInCents: number, expectedSalePriceInCents: number, underwrittenOpcoTotalCostInCents: number, underwrittenLotOwnershipBasisPoints: number, opcoTotalCostInCents: number, isLegacyUwRevenue?: boolean | null | undefined, expectedCompletionDate?: DateOnly | null | undefined, salesPriceAtValuationDateInCents: number, valuationDate: DateOnly, valuationReportId?: number | null | undefined, appreciationMultiplier: number, saleDate?: DateOnly | null | undefined, lotOwnershipBasisPoints: number, salesforceOpportunityId?: string | null | undefined, salePriceInCents?: number | null | undefined, realizedNetSalesPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, underContractPriceInCents?: number | null | undefined, underContractNetSalesPriceInCents?: number | null | undefined, listPriceInCents?: number | null | undefined, listedNetSalesPriceInCents?: number | null | undefined, netSalesPriceInCents: number, notes?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, directUnderwritingSoftCostsInCents?: number | null | undefined, directUnderwritingHardCostsInCents?: number | null | undefined, directUnderwritingHardCostMarkupBasisPoints?: number | null | undefined, underwrittenSalesCommissionBasisPoints: number, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', code: LotPartitionSalesStatus, name: string }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined }, documents: Array<{ __typename?: 'Document', id: string }> }>, canContractDirectUnderwriting: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type LotOverviewPageLotDocumentsLotFragment = { __typename?: 'Lot', id: string, documents: Array<{ __typename?: 'Document', id: string, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, canViewLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canViewLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } }> };

export type LotOverviewPageLotDocumentFragment = { __typename?: 'Document', id: string, asset: { __typename?: 'Asset', id: string, fileName?: string | null | undefined, downloadUrl: string }, canViewLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqSettlementStatement: { __typename?: 'PotentialOperation', allowed: boolean }, canViewLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, canCreateLotAcqPurchaseAgreement: { __typename?: 'PotentialOperation', allowed: boolean }, documentType: { __typename?: 'DocumentTypeDetail', code: DocumentType, name: string } };

export type LotPartitionFragment = { __typename?: 'LotPartition', id: string, moveInDate?: DateOnly | null | undefined, blueprintProjectId?: string | null | undefined, underwrittenSalesPriceInCents: number, expectedSalePriceInCents: number, underwrittenOpcoTotalCostInCents: number, underwrittenLotOwnershipBasisPoints: number, opcoTotalCostInCents: number, isLegacyUwRevenue?: boolean | null | undefined, expectedCompletionDate?: DateOnly | null | undefined, salesPriceAtValuationDateInCents: number, valuationDate: DateOnly, valuationReportId?: number | null | undefined, appreciationMultiplier: number, saleDate?: DateOnly | null | undefined, lotOwnershipBasisPoints: number, salesforceOpportunityId?: string | null | undefined, salePriceInCents?: number | null | undefined, realizedNetSalesPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, underContractPriceInCents?: number | null | undefined, underContractNetSalesPriceInCents?: number | null | undefined, listPriceInCents?: number | null | undefined, listedNetSalesPriceInCents?: number | null | undefined, netSalesPriceInCents: number, notes?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, directUnderwritingSoftCostsInCents?: number | null | undefined, directUnderwritingHardCostsInCents?: number | null | undefined, directUnderwritingHardCostMarkupBasisPoints?: number | null | undefined, underwrittenSalesCommissionBasisPoints: number, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', code: LotPartitionSalesStatus, name: string }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined }, documents: Array<{ __typename?: 'Document', id: string }> };

export type LotInvestorMarginFragment = { __typename?: 'Lot', id: string, purchasePriceInCents: number, opcoSiteAcquisitionMarkupInCents: number, softCostInCents: any, indirectHardCostInCents: any, directHardCostInCents: any, opcoMarkupInCents: any, financingCostInCents: number, totalCostInCents: any, totalSaleValueInCents: any, totalNetSaleRevenueInCents: any, investorMarginBasisPoints: number, underwrittenSoftCostInCents: any, underwrittenIndirectHardCostInCents: any, underwrittenDirectHardCostInCents: any, underwrittenOpcoMarkupInCents: any, underwrittenOpcoTotalCostInCents: any, underwrittenSiteAcquisitionMarkupBasisPoints: number, underwrittenFinancingCostInCents: number, underwrittenTotalSaleValueInCents: any, underwrittenTotalNetSaleRevenueInCents: any, underwrittenTotalCostInCents: any, underwrittenInvestorMarginBasisPoints: number, underwrittenPurchasePriceInCents: number, underwrittenClosingCostsInCents: number, underwrittenTotalLotAcquisitionCostsInCents: number };

export type CreateDirectUnderwritingContractsMutationVariables = Exact<{
  input: CreateDirectUnderwritingContractsInput;
}>;


export type CreateDirectUnderwritingContractsMutation = { __typename?: 'Mutation', createDirectUnderwritingContracts: { __typename?: 'CreateDirectUnderwritingContractsResult', lot: { __typename?: 'Lot', id: string, salesforceOpportunityId?: string | null | undefined, purchasePriceInCents: number, isSuburban: boolean, opcoSiteAcquisitionMarkupInCents: number, softCostInCents: any, indirectHardCostInCents: any, directHardCostInCents: any, opcoMarkupInCents: any, financingCostInCents: number, totalCostInCents: any, totalSaleValueInCents: any, totalNetSaleRevenueInCents: any, investorMarginBasisPoints: number, underwrittenSoftCostInCents: any, underwrittenIndirectHardCostInCents: any, underwrittenDirectHardCostInCents: any, underwrittenOpcoMarkupInCents: any, underwrittenOpcoTotalCostInCents: any, underwrittenSiteAcquisitionMarkupBasisPoints: number, underwrittenFinancingCostInCents: number, underwrittenTotalSaleValueInCents: any, underwrittenTotalNetSaleRevenueInCents: any, underwrittenTotalCostInCents: any, underwrittenInvestorMarginBasisPoints: number, underwrittenPurchasePriceInCents: number, underwrittenClosingCostsInCents: number, underwrittenTotalLotAcquisitionCostsInCents: number, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus }, partitions: Array<{ __typename?: 'LotPartition', id: string, moveInDate?: DateOnly | null | undefined, blueprintProjectId?: string | null | undefined, underwrittenSalesPriceInCents: number, expectedSalePriceInCents: number, underwrittenOpcoTotalCostInCents: number, underwrittenLotOwnershipBasisPoints: number, opcoTotalCostInCents: number, isLegacyUwRevenue?: boolean | null | undefined, expectedCompletionDate?: DateOnly | null | undefined, salesPriceAtValuationDateInCents: number, valuationDate: DateOnly, valuationReportId?: number | null | undefined, appreciationMultiplier: number, saleDate?: DateOnly | null | undefined, lotOwnershipBasisPoints: number, salesforceOpportunityId?: string | null | undefined, salePriceInCents?: number | null | undefined, realizedNetSalesPriceInCents?: number | null | undefined, salesforceHomeListingId?: string | null | undefined, underContractPriceInCents?: number | null | undefined, underContractNetSalesPriceInCents?: number | null | undefined, listPriceInCents?: number | null | undefined, listedNetSalesPriceInCents?: number | null | undefined, netSalesPriceInCents: number, notes?: string | null | undefined, appraisalDate?: DateOnly | null | undefined, appraisalValueInCents?: number | null | undefined, directUnderwritingSoftCostsInCents?: number | null | undefined, directUnderwritingHardCostsInCents?: number | null | undefined, directUnderwritingHardCostMarkupBasisPoints?: number | null | undefined, underwrittenSalesCommissionBasisPoints: number, basePriceInCents?: number | null | undefined, proposedBasePriceInCents?: number | null | undefined, lotPartitionSalesStatus: { __typename?: 'LotPartitionSalesStatusDetail', code: LotPartitionSalesStatus, name: string }, lot: { __typename?: 'Lot', id: string, dpid?: string | null | undefined, clearToCloseUwReportId?: number | null | undefined }, documents: Array<{ __typename?: 'Document', id: string }> }>, canContractDirectUnderwriting: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type SavePropertySaleSettlementStatementEditorMutationVariables = Exact<{
  input: SavePropertySaleSettlementStatementInput;
}>;


export type SavePropertySaleSettlementStatementEditorMutation = { __typename?: 'Mutation', savePropertySaleSettlementStatement: { __typename?: 'SavePropertySaleSettlementStatementResult', propertySaleSettlementStatement: { __typename?: 'PropertySaleSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, sellerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'PropertySaleSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail', code: PropertySaleSettlementStatementLineItemType, name: string } }>, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } } };

export type DeletePropertySaleSettlementStatementMutationVariables = Exact<{
  input: DeleteEntityInput;
}>;


export type DeletePropertySaleSettlementStatementMutation = { __typename?: 'Mutation', deletePropertySaleSettlementStatement: { __typename?: 'EmptyResult', emptyResult?: string | null | undefined } };

export type SendPropertySaleSettlementStatementForBookingMutationVariables = Exact<{
  input: SendPropertySaleSettlementStatementForBookingInput;
}>;


export type SendPropertySaleSettlementStatementForBookingMutation = { __typename?: 'Mutation', sendPropertySaleSettlementStatementForBooking: { __typename?: 'PropertySaleSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, sellerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'PropertySaleSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail', code: PropertySaleSettlementStatementLineItemType, name: string } }>, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } };

export type PropertySaleSettlementStatementFragment = { __typename?: 'PropertySaleSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, sellerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'PropertySaleSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail', code: PropertySaleSettlementStatementLineItemType, name: string } }>, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } };

export type PropertySaleSettlementStatementLineItemFragment = { __typename?: 'PropertySaleSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail', code: PropertySaleSettlementStatementLineItemType, name: string } };

export type PropertySaleSettlementStatement_LotPartitionFragment = { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } };

export type PropertySaleSettlementStatementDocumentsQueryVariables = Exact<{
  documentIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type PropertySaleSettlementStatementDocumentsQuery = { __typename?: 'Query', documents: Array<{ __typename?: 'Document', id: string, parent: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } } | { __typename?: 'Lot' }, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: DateTime, previewUrl?: string | null | undefined }, propertySaleSettlementStatement?: { __typename?: 'PropertySaleSettlementStatement', id: string, totalCreditsInCents: number, totalDebitsInCents: number, sellerName?: string | null | undefined, bookingEventSent: boolean, settlementDate?: DateOnly | null | undefined, lineItems: Array<{ __typename?: 'PropertySaleSettlementStatementLineItem', id: string, amountInCents: number, notes?: string | null | undefined, type: { __typename?: 'PropertySaleSettlementStatementLineItemTypeDetail', code: PropertySaleSettlementStatementLineItemType, name: string } }>, lotPartition: { __typename?: 'LotPartition', id: string, blueprintProjectId?: string | null | undefined, lot: { __typename?: 'Lot', id: string, legalEntityName?: string | null | undefined, lotInvestmentStatus: { __typename?: 'LotInvestmentStatusDetail', code: LotInvestmentStatus, name: string }, address?: { __typename?: 'Address', id: string, street1: string } | null | undefined } }, document: { __typename?: 'Document', id: string }, canSendForBooking: { __typename?: 'PotentialOperation', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined }> };

export const FundAllocationsPageLotFragmentDoc = gql`
    fragment FundAllocationsPageLot on Lot {
  id
  address {
    id
    street1
    city
  }
  fund {
    id
    name
  }
  legalEntityName
  underContractDate
  lotInvestmentStatus {
    name
    code
  }
  canEditFund {
    allowed
    disabledReasons {
      message
    }
  }
  fundOwnerEntity {
    id
    name
  }
  canSendCustomerInformationToBlueprint {
    allowed
    disabledReasons {
      message
    }
  }
}
    `;
export const FundAllocationsPageFundFragmentDoc = gql`
    fragment FundAllocationsPageFund on Fund {
  id
  name
  ownerEntities {
    id
    name
  }
}
    `;
export const FundsPageFundFragmentDoc = gql`
    fragment FundsPageFund on Fund {
  id
  name
}
    `;
export const CheckoutControls_LotPartitionFragmentDoc = gql`
    fragment CheckoutControls_LotPartition on LotPartition {
  id
  blueprintProjectId
  basePriceInCents
  proposedBasePriceInCents
  underwrittenSalesPriceWithoutAppreciationInCents
  listPriceInCents
  salesforceHomeListingId
  salesPriceAtValuationDateInCents
  valuationReportId
  showInCheckout
  lotPartitionSalesStatus {
    name
    code
  }
  lot {
    id
    dpid
    clearToCloseUwReportId
    address {
      id
      street1
    }
  }
}
    `;
export const MetrosPageMetroFragmentDoc = gql`
    fragment MetrosPageMetro on Metro {
  id
  name
  code
  listToCloseRatioBasisPoints
  deliveryToSalesReadyInDays
  preListPremiumBasisPoints
}
    `;
export const UnderwritingOverviewPageUnderwritingConfigMetroFragmentDoc = gql`
    fragment UnderwritingOverviewPageUnderwritingConfigMetro on UnderwritingConfigMetro {
  id
  targetInvestorMarginBasisPoints
  buildMarginBasisPoints
  siteAcquisitionMarkupBasisPoints
  weightedFinancingRate
  financingRate
  percentDebtFinancedBasisPoints
  preConMonths
  constructionMonths
  salesPeriodMonths
  exitRealtorFeeBasisPoints
  acquisitionClosingCostsBasisPoints
  metro {
    id
    code
    name
  }
}
    `;
export const UnderwritingOverviewPageUnderwritingConfigFragmentDoc = gql`
    fragment UnderwritingOverviewPageUnderwritingConfig on UnderwritingConfig {
  id
  targetInvestorMarginBasisPoints
  debtFacilityBaseRateBasisPoints
  debtFacilitySpreadBasisPoints
  buildMarginBasisPoints
  siteAcquisitionMarkupBasisPoints
  weightedFinancingRate
  financingRate
  percentDebtFinancedBasisPoints
  preConMonths
  constructionMonths
  salesPeriodMonths
  exitRealtorFeeBasisPoints
  acquisitionClosingCostsBasisPoints
  metros {
    ...UnderwritingOverviewPageUnderwritingConfigMetro
  }
}
    ${UnderwritingOverviewPageUnderwritingConfigMetroFragmentDoc}`;
export const LotsPageLotFragmentDoc = gql`
    fragment LotsPageLot on Lot {
  id
  address {
    id
    street1
  }
  legalEntityName
  underwrittenInvestorMarginBasisPoints
  investorMarginBasisPoints
  salesforceOpportunityId
  dpid
  lotInvestmentStatus {
    code
    name
  }
  fund {
    id
    name
  }
}
    `;
export const DrawOverviewPageLotPartitionDrawFragmentDoc = gql`
    fragment DrawOverviewPageLotPartitionDraw on LotPartitionDraw {
  id
  amountInCents
  lotPartition {
    id
    blueprintProjectId
    lot {
      id
      address {
        id
        street1
      }
    }
  }
}
    `;
export const DrawOverviewPageDrawFragmentDoc = gql`
    fragment DrawOverviewPageDraw on CreditFacilityDraw {
  id
  lotPartitionDraws {
    ...DrawOverviewPageLotPartitionDraw
  }
  fund {
    id
    name
    creditFacilityInterestType {
      code
    }
  }
  drawDate
  fixedRateThousandthsBasisPoints
  canDelete {
    allowed
    disabledReasons {
      message
    }
  }
}
    ${DrawOverviewPageLotPartitionDrawFragmentDoc}`;
export const InvoiceOverPageLotPartitionDrawFragmentDoc = gql`
    fragment InvoiceOverPageLotPartitionDraw on LotPartitionDraw {
  id
  amountInCents
  creditFacilityDraw {
    id
    drawDate
  }
  lotPartition {
    id
    blueprintProjectId
    lot {
      id
      address {
        id
        street1
      }
    }
  }
}
    `;
export const InvoiceOverviewPageDrawInterestFragmentDoc = gql`
    fragment InvoiceOverviewPageDrawInterest on CreditFacilityInvoiceDrawInterest {
  id
  amountInCents
  drawAmountInCents
  interestDate
  lotPartitionDraw {
    ...InvoiceOverPageLotPartitionDraw
  }
}
    ${InvoiceOverPageLotPartitionDrawFragmentDoc}`;
export const InvoiceOverviewPageGroupedDrawInterestFragmentDoc = gql`
    fragment InvoiceOverviewPageGroupedDrawInterest on CreditFacilityInvoiceDrawInterestByLotPartitionDraw {
  amountInCents
  lotPartitionDraw {
    ...InvoiceOverPageLotPartitionDraw
  }
}
    ${InvoiceOverPageLotPartitionDrawFragmentDoc}`;
export const InvoiceOverviewPageInvoiceFragmentDoc = gql`
    fragment InvoiceOverviewPageInvoice on CreditFacilityInvoice {
  id
  fund {
    id
    name
  }
  invoiceDate
  amountInCents
  allocatedAmountInCents
  drawInterests {
    ...InvoiceOverviewPageDrawInterest
  }
  canDelete {
    allowed
    disabledReasons {
      message
    }
  }
  drawInterestsByLotPartitionDraw {
    ...InvoiceOverviewPageGroupedDrawInterest
  }
}
    ${InvoiceOverviewPageDrawInterestFragmentDoc}
${InvoiceOverviewPageGroupedDrawInterestFragmentDoc}`;
export const DrawRequestOverviewPageGoldmanDrawModelFragmentDoc = gql`
    fragment DrawRequestOverviewPageGoldmanDrawModel on GoldmanDrawModel {
  id
  isEligibleForGoldmanDraw
  isTargetBuy
  isExpandedBuy
  isFinishedProperty
  currentAppraisalValueInCents
  advanceRateBasisPoints
  adjustedCollateralValueInCents
  adjustedAdvanceRateBasisPoints
  realizedConstructionExpensesInCents
  isBlueprintCostDataSet
  landCostsInCents
  homeboundPortionInCents
  isLotCostToUnderwrittenNetSalesPriceEligible
  isOwnedLessThan_721Days
  isAppraisalAgeAcceptable
  isInfillOrDeveloperCommunity
  isLandCostEligible
  isUnderwrittenHardCostEligible
  isLandCostAndConstructionExpensesEligible
  isUnderwrittenMarginEligible
  isBedroomsEligible
  isSqftEligible
  isBathroomsEligible
  isLandCostTargetEligible
  isLotCostToUnderwrittenNetSalesPriceTargetEligible
  isConstructionExpensesTargetEligible
  isLandCostAndConstructionExpensesTargetEligible
  advanceRatePreconBasisPoints
  underwrittenSalesPriceMarginBasisPoints
  isVictoryOverride
}
    `;
export const DrawRequestOverviewPageAnchorMultilotDrawModelFragmentDoc = gql`
    fragment DrawRequestOverviewPageAnchorMultilotDrawModel on AnchorMultilotDrawModel {
  id
  realizedSoftCostsInCents
  realizedIndirectCostsInCents
  realizedDirectCostsInCents
  realizedBuilderFeeInCents
  realizedConstructionExpensesInCents
  isBlueprintCostDataSet
}
    `;
export const DrawRequestOverviewPageAnchorFloatingDrawModelFragmentDoc = gql`
    fragment DrawRequestOverviewPageAnchorFloatingDrawModel on AnchorFloatingDrawModel {
  id
  completedSoftCostsInCents
  completedIndirectCostsInCents
  completedDirectCostsInCents
  completedBuilderFeeInCents
  completedConstructionExpensesInCents
  isBlueprintCostDataSet
}
    `;
export const DrawRequestOverviewPageLotPartitionDrawRequestFragmentDoc = gql`
    fragment DrawRequestOverviewPageLotPartitionDrawRequest on LotPartitionDrawRequest {
  id
  amountInCents
  modeledIndividualAmountToBorrowInCents
  modeledCollectiveAmountToBorrowInCents
  lotPartition {
    id
    blueprintProjectId
    borrowedAmountInCents
    lot {
      id
      address {
        id
        street1
      }
    }
  }
  goldmanDrawModel {
    ...DrawRequestOverviewPageGoldmanDrawModel
  }
  anchorMultilotDrawModel {
    ...DrawRequestOverviewPageAnchorMultilotDrawModel
  }
  anchorFloatingDrawModel {
    ...DrawRequestOverviewPageAnchorFloatingDrawModel
  }
}
    ${DrawRequestOverviewPageGoldmanDrawModelFragmentDoc}
${DrawRequestOverviewPageAnchorMultilotDrawModelFragmentDoc}
${DrawRequestOverviewPageAnchorFloatingDrawModelFragmentDoc}`;
export const DrawRequestOverviewPageDrawRequestFragmentDoc = gql`
    fragment DrawRequestOverviewPageDrawRequest on CreditFacilityDrawRequest {
  id
  lotPartitionDrawRequests {
    ...DrawRequestOverviewPageLotPartitionDrawRequest
  }
  fund {
    id
    name
    creditFacilityInterestType {
      code
    }
    creditFacilityDrawModel {
      code
    }
  }
  preparationDate
  canEdit {
    allowed
    disabledReasons {
      message
    }
  }
}
    ${DrawRequestOverviewPageLotPartitionDrawRequestFragmentDoc}`;
export const FundOverviewPageLotPartitionFragmentDoc = gql`
    fragment FundOverviewPageLotPartition on LotPartition {
  id
  blueprintProjectId
  draws {
    id
    amountInCents
    remainingAmountInCents
    payments {
      id
      amountInCents
      creditFacilityPayment {
        id
        paymentDate
      }
    }
    creditFacilityDraw {
      id
      drawDate
    }
    invoices {
      id
      interestAmountInCents
    }
  }
  lot {
    id
    address {
      id
      street1
    }
    fundContributionDate
    purchasePriceInCents
    opcoSiteAcquisitionMarkupInCents
    underwrittenPurchasePriceInCents
    underwrittenUnleveredInternalRateOfReturnBasisPoints
    underwrittenUnleveredMultipleOnInvestedCapital
    underwrittenUnleveredReturnOnCostBasisPoints
    underwrittenLeveredReturnOnCostBasisPoints
  }
  payments {
    id
    amountInCents
    paymentDate
  }
  equityFinancingCosts {
    id
    interestAmountInCents
    interestDate
  }
  softCostInCents
  indirectHardCostInCents
  directHardCostInCents
  opcoMarkupInCents
  netSalesPriceInCents
  saleDate
  realizedUnleveredInternalRateOfReturnBasisPoints
  realizedUnleveredMultipleOnInvestedCapital
  realizedLeveredInternalRateOfReturnBasisPoints
  realizedLeveredMultipleOnInvestedCapital
  underwrittenLotOwnershipBasisPoints
  lotPartitionSalesStatus {
    name
    code
  }
  underwrittenSoftCostInCents
  underwrittenIndirectHardCostInCents
  underwrittenDirectHardCostInCents
  underwrittenOpcoMarkupInCents
  underwrittenNetSalesPriceInCents
  underwrittenDirectMarginBasisPoints
  directMarginBasisPoints
  expectedSaleDate
  manualExpectedSaleDate
  unleveredReturnOnCostBasisPoints
}
    `;
export const FundOverviewPageLotFragmentDoc = gql`
    fragment FundOverviewPageLot on Lot {
  id
  address {
    id
    street1
  }
  partitions {
    ...FundOverviewPageLotPartition
  }
  acquisitionDate
  purchasePriceInCents
  opcoSiteAcquisitionMarkupInCents
  equityFinancingCosts {
    id
    interestAmountInCents
    interestDate
  }
}
    ${FundOverviewPageLotPartitionFragmentDoc}`;
export const FundOverviewPageDrawFragmentDoc = gql`
    fragment FundOverviewPageDraw on CreditFacilityDraw {
  id
  amountInCents
  drawDate
}
    `;
export const FundOverviewPagePaymentFragmentDoc = gql`
    fragment FundOverviewPagePayment on CreditFacilityPayment {
  id
  amountInCents
  allocatedAmountInCents
  paymentDate
}
    `;
export const FundOverviewPageFundMetroFragmentDoc = gql`
    fragment FundOverviewPageFundMetro on FundMetro {
  id
  targetInvestorMarginBasisPoints
  metro {
    id
    code
    name
  }
}
    `;
export const FundOverviewPageDrawRequestFragmentDoc = gql`
    fragment FundOverviewPageDrawRequest on CreditFacilityDrawRequest {
  id
  amountInCents
  preparationDate
  creditFacilityDraw {
    id
  }
}
    `;
export const FundOverviewPageFundFragmentDoc = gql`
    fragment FundOverviewPageFund on Fund {
  id
  name
  targetInvestorMarginBasisPoints
  opcoDirectHardCostMarkupBasisPoints
  opcoIndirectHardCostMarkupBasisPoints
  opcoSoftCostMarkupBasisPoints
  opcoSiteAcquisitionMarkupBasisPoints
  creditFacilityFixedRateBasisPoints
  creditFacilityCanBorrowDirectCosts
  creditFacilityCanBorrowIndirectCosts
  creditFacilityCanBorrowSoftCosts
  equityFinancingBasisPoints
  lots {
    ...FundOverviewPageLot
  }
  creditFacilityDraws {
    ...FundOverviewPageDraw
  }
  creditFacilityPayments {
    ...FundOverviewPagePayment
  }
  metros {
    ...FundOverviewPageFundMetro
  }
  creditFacilityDrawRequests {
    ...FundOverviewPageDrawRequest
  }
}
    ${FundOverviewPageLotFragmentDoc}
${FundOverviewPageDrawFragmentDoc}
${FundOverviewPagePaymentFragmentDoc}
${FundOverviewPageFundMetroFragmentDoc}
${FundOverviewPageDrawRequestFragmentDoc}`;
export const FundOverviewPageExpectedSaleDateLotPartitionFragmentDoc = gql`
    fragment FundOverviewPageExpectedSaleDateLotPartition on LotPartition {
  id
  blueprintProjectId
  saleDate
  expectedSaleDate
  manualExpectedSaleDate
  lot {
    id
    address {
      id
      street1
    }
  }
}
    `;
export const FundOverviewPageExpectedSaleDateFundFragmentDoc = gql`
    fragment FundOverviewPageExpectedSaleDateFund on Fund {
  id
  name
  lots {
    id
    partitions {
      ...FundOverviewPageExpectedSaleDateLotPartition
    }
  }
}
    ${FundOverviewPageExpectedSaleDateLotPartitionFragmentDoc}`;
export const FundOverviewPageInvoiceFragmentDoc = gql`
    fragment FundOverviewPageInvoice on CreditFacilityInvoice {
  id
  invoiceDate
  amountInCents
  allocatedAmountInCents
}
    `;
export const PaymentOverviewPageLotPartitionDrawPaymentFragmentDoc = gql`
    fragment PaymentOverviewPageLotPartitionDrawPayment on LotPartitionDrawPayment {
  id
  amountInCents
  lotPartitionDraw {
    id
    amountInCents
    remainingAmountInCents
    creditFacilityDraw {
      id
      drawDate
    }
    lotPartition {
      id
      blueprintProjectId
      lot {
        id
        address {
          id
          street1
        }
      }
    }
  }
}
    `;
export const PaymentOverviewPageLotFragmentDoc = gql`
    fragment PaymentOverviewPageLot on Lot {
  id
  address {
    id
    street1
  }
  partitions {
    id
    blueprintProjectId
  }
}
    `;
export const PaymentOverviewPagePaymentFragmentDoc = gql`
    fragment PaymentOverviewPagePayment on CreditFacilityPayment {
  id
  lotPartitionDrawPayments {
    ...PaymentOverviewPageLotPartitionDrawPayment
  }
  fund {
    id
    name
    lots {
      ...PaymentOverviewPageLot
    }
  }
  paymentDate
  canDelete {
    allowed
    disabledReasons {
      message
    }
  }
  allocatedAmountInCents
  amountInCents
}
    ${PaymentOverviewPageLotPartitionDrawPaymentFragmentDoc}
${PaymentOverviewPageLotFragmentDoc}`;
export const FundLoanManagementPageDrawRequestFragmentDoc = gql`
    fragment FundLoanManagementPageDrawRequest on CreditFacilityDrawRequest {
  id
  amountInCents
  preparationDate
  canDelete {
    allowed
  }
  creditFacilityDraw {
    id
  }
}
    `;
export const FundLoanManagementPageFundDrawRequestsFragmentDoc = gql`
    fragment FundLoanManagementPageFundDrawRequests on Fund {
  id
  name
  creditFacilityDrawRequests {
    ...FundLoanManagementPageDrawRequest
  }
}
    ${FundLoanManagementPageDrawRequestFragmentDoc}`;
export const FundLoanManagementPageLotPartitionFragmentDoc = gql`
    fragment FundLoanManagementPageLotPartition on LotPartition {
  id
  blueprintProjectId
  appraisalDate
  appraisalValueInCents
  draws {
    id
    amountInCents
    remainingAmountInCents
    payments {
      id
      amountInCents
      creditFacilityPayment {
        id
        paymentDate
      }
    }
    creditFacilityDraw {
      id
      drawDate
    }
    invoices {
      id
      interestAmountInCents
      creditFacilityInvoice {
        id
        invoiceDate
      }
    }
  }
  lot {
    id
    address {
      id
      street1
    }
  }
  payments {
    id
    amountInCents
    paymentDate
  }
  equityFinancingCosts {
    id
    interestAmountInCents
    interestDate
  }
}
    `;
export const FundLoanManagementPageLotFragmentDoc = gql`
    fragment FundLoanManagementPageLot on Lot {
  id
  address {
    id
    street1
  }
  partitions {
    ...FundLoanManagementPageLotPartition
  }
  acquisitionDate
  purchasePriceInCents
  opcoSiteAcquisitionMarkupInCents
  equityFinancingCosts {
    id
    interestAmountInCents
    interestDate
  }
}
    ${FundLoanManagementPageLotPartitionFragmentDoc}`;
export const FundLoanManagementPageDrawFragmentDoc = gql`
    fragment FundLoanManagementPageDraw on CreditFacilityDraw {
  id
  fixedRateThousandthsBasisPoints
  amountInCents
  drawDate
}
    `;
export const FundLoanManagementPagePaymentFragmentDoc = gql`
    fragment FundLoanManagementPagePayment on CreditFacilityPayment {
  id
  amountInCents
  allocatedAmountInCents
  paymentDate
}
    `;
export const FundLoanManagementPageInvoiceFragmentDoc = gql`
    fragment FundLoanManagementPageInvoice on CreditFacilityInvoice {
  id
  invoiceDate
  amountInCents
  allocatedAmountInCents
}
    `;
export const FundLoanManagementPageFundFragmentDoc = gql`
    fragment FundLoanManagementPageFund on Fund {
  id
  name
  creditFacilityFixedRateBasisPoints
  creditFacilityCanBorrowDirectCosts
  creditFacilityCanBorrowIndirectCosts
  creditFacilityCanBorrowSoftCosts
  equityFinancingBasisPoints
  lots {
    ...FundLoanManagementPageLot
  }
  creditFacilityDraws {
    ...FundLoanManagementPageDraw
  }
  creditFacilityPayments {
    ...FundLoanManagementPagePayment
  }
  creditFacilityInvoices {
    ...FundLoanManagementPageInvoice
  }
  creditFacilityInterestType {
    code
  }
}
    ${FundLoanManagementPageLotFragmentDoc}
${FundLoanManagementPageDrawFragmentDoc}
${FundLoanManagementPagePaymentFragmentDoc}
${FundLoanManagementPageInvoiceFragmentDoc}`;
export const LotAcqLotFragmentDoc = gql`
    fragment LotAcqLot on Lot {
  id
  address {
    id
    street1
  }
  legalEntityName
  lotInvestmentStatus {
    code
    name
  }
}
    `;
export const LotAcqLotAcqPurchaseAgreementFragmentDoc = gql`
    fragment LotAcqLotAcqPurchaseAgreement on LotAcqPurchaseAgreement {
  id
  purchasePriceInCents
  earnestMoneyInCents
  optionFeeInCents
  lot {
    ...LotAcqLot
  }
  document {
    id
  }
}
    ${LotAcqLotFragmentDoc}`;
export const LotAcqLotAcqSettlementStatementLineItemFragmentDoc = gql`
    fragment LotAcqLotAcqSettlementStatementLineItem on LotAcqSettlementStatementLineItem {
  id
  amountInCents
  notes
  type {
    code
    name
  }
}
    `;
export const LotAcqLotAcqSettlementStatementFragmentDoc = gql`
    fragment LotAcqLotAcqSettlementStatement on LotAcqSettlementStatement {
  id
  lineItems {
    ...LotAcqLotAcqSettlementStatementLineItem
  }
  lot {
    ...LotAcqLot
  }
  document {
    id
  }
  totalCreditsInCents
  totalDebitsInCents
  canSendForBooking {
    allowed
    disabledReasons {
      message
    }
  }
  buyerName
  bookingEventSent
  settlementDate
}
    ${LotAcqLotAcqSettlementStatementLineItemFragmentDoc}
${LotAcqLotFragmentDoc}`;
export const AssetInfoFragmentDoc = gql`
    fragment AssetInfo on Asset {
  id
  version
  contentType
  downloadUrl
  attachmentUrl
  fileName
  createdAt
  previewUrl(resizing: {width: 250, height: 250, region: FULL})
}
    `;
export const LotPartitionDocuments_DocumentFragmentDoc = gql`
    fragment LotPartitionDocuments_Document on Document {
  id
  canCreatePropertySaleSettlementStatement {
    allowed
    disabledReasons {
      message
    }
  }
  canViewPropertySaleSettlementStatement {
    allowed
  }
  asset {
    id
    fileName
    downloadUrl
  }
  documentType {
    code
    name
  }
}
    `;
export const LotPartitionDocuments_LotPartitionFragmentDoc = gql`
    fragment LotPartitionDocuments_LotPartition on LotPartition {
  id
  lot {
    id
    address {
      id
      street1
    }
  }
}
    `;
export const LotPartitionFragmentDoc = gql`
    fragment LotPartition on LotPartition {
  id
  moveInDate
  blueprintProjectId
  underwrittenSalesPriceInCents
  expectedSalePriceInCents
  underwrittenOpcoTotalCostInCents
  underwrittenLotOwnershipBasisPoints
  opcoTotalCostInCents
  isLegacyUwRevenue
  lotPartitionSalesStatus {
    code
    name
  }
  expectedCompletionDate
  salesPriceAtValuationDateInCents
  valuationDate
  valuationReportId
  appreciationMultiplier
  lot {
    id
    dpid
    clearToCloseUwReportId
  }
  saleDate
  lotOwnershipBasisPoints
  salesforceOpportunityId
  salePriceInCents
  realizedNetSalesPriceInCents
  salesforceHomeListingId
  underContractPriceInCents
  underContractNetSalesPriceInCents
  listPriceInCents
  listedNetSalesPriceInCents
  netSalesPriceInCents
  notes
  appraisalDate
  appraisalValueInCents
  directUnderwritingSoftCostsInCents
  directUnderwritingHardCostsInCents
  directUnderwritingHardCostMarkupBasisPoints
  underwrittenSalesCommissionBasisPoints
  basePriceInCents
  proposedBasePriceInCents
  documents {
    id
  }
}
    `;
export const LotInvestorMarginFragmentDoc = gql`
    fragment LotInvestorMargin on Lot {
  id
  purchasePriceInCents
  opcoSiteAcquisitionMarkupInCents
  softCostInCents
  indirectHardCostInCents
  directHardCostInCents
  opcoMarkupInCents
  financingCostInCents
  totalCostInCents
  totalSaleValueInCents
  totalNetSaleRevenueInCents
  investorMarginBasisPoints
  underwrittenSoftCostInCents
  underwrittenIndirectHardCostInCents
  underwrittenDirectHardCostInCents
  underwrittenOpcoMarkupInCents
  underwrittenOpcoTotalCostInCents
  underwrittenSiteAcquisitionMarkupBasisPoints
  underwrittenFinancingCostInCents
  underwrittenTotalSaleValueInCents
  underwrittenTotalNetSaleRevenueInCents
  underwrittenTotalCostInCents
  underwrittenInvestorMarginBasisPoints
  underwrittenPurchasePriceInCents
  underwrittenClosingCostsInCents
  underwrittenTotalLotAcquisitionCostsInCents
}
    `;
export const LotOverviewPageLotFragmentDoc = gql`
    fragment LotOverviewPageLot on Lot {
  id
  salesforceOpportunityId
  purchasePriceInCents
  address {
    id
    street1
  }
  lotInvestmentStatus {
    code
  }
  partitions {
    ...LotPartition
  }
  ...LotInvestorMargin
  canContractDirectUnderwriting {
    allowed
    disabledReasons {
      message
    }
  }
  isSuburban
}
    ${LotPartitionFragmentDoc}
${LotInvestorMarginFragmentDoc}`;
export const LotOverviewPageLotDocumentFragmentDoc = gql`
    fragment LotOverviewPageLotDocument on Document {
  id
  asset {
    id
    fileName
    downloadUrl
  }
  canViewLotAcqSettlementStatement {
    allowed
  }
  canCreateLotAcqSettlementStatement {
    allowed
  }
  canViewLotAcqPurchaseAgreement {
    allowed
  }
  canCreateLotAcqPurchaseAgreement {
    allowed
  }
  documentType {
    code
    name
  }
}
    `;
export const LotOverviewPageLotDocumentsLotFragmentDoc = gql`
    fragment LotOverviewPageLotDocumentsLot on Lot {
  id
  documents {
    ...LotOverviewPageLotDocument
  }
}
    ${LotOverviewPageLotDocumentFragmentDoc}`;
export const PropertySaleSettlementStatementLineItemFragmentDoc = gql`
    fragment PropertySaleSettlementStatementLineItem on PropertySaleSettlementStatementLineItem {
  id
  amountInCents
  notes
  type {
    code
    name
  }
}
    `;
export const PropertySaleSettlementStatement_LotPartitionFragmentDoc = gql`
    fragment PropertySaleSettlementStatement_LotPartition on LotPartition {
  id
  blueprintProjectId
  lot {
    id
    legalEntityName
    lotInvestmentStatus {
      code
      name
    }
    address {
      id
      street1
    }
  }
}
    `;
export const PropertySaleSettlementStatementFragmentDoc = gql`
    fragment PropertySaleSettlementStatement on PropertySaleSettlementStatement {
  id
  lineItems {
    ...PropertySaleSettlementStatementLineItem
  }
  lotPartition {
    ...PropertySaleSettlementStatement_LotPartition
  }
  document {
    id
  }
  totalCreditsInCents
  totalDebitsInCents
  canSendForBooking {
    allowed
    disabledReasons {
      message
    }
  }
  sellerName
  bookingEventSent
  settlementDate
}
    ${PropertySaleSettlementStatementLineItemFragmentDoc}
${PropertySaleSettlementStatement_LotPartitionFragmentDoc}`;
export const FundAllocationsPageLotsDocument = gql`
    query FundAllocationsPageLots {
  lots {
    ...FundAllocationsPageLot
  }
}
    ${FundAllocationsPageLotFragmentDoc}`;

/**
 * __useFundAllocationsPageLotsQuery__
 *
 * To run a query within a React component, call `useFundAllocationsPageLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundAllocationsPageLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundAllocationsPageLotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundAllocationsPageLotsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundAllocationsPageLotsQuery, FundAllocationsPageLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundAllocationsPageLotsQuery, FundAllocationsPageLotsQueryVariables>(FundAllocationsPageLotsDocument, options);
      }
export function useFundAllocationsPageLotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundAllocationsPageLotsQuery, FundAllocationsPageLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundAllocationsPageLotsQuery, FundAllocationsPageLotsQueryVariables>(FundAllocationsPageLotsDocument, options);
        }
export type FundAllocationsPageLotsQueryHookResult = ReturnType<typeof useFundAllocationsPageLotsQuery>;
export type FundAllocationsPageLotsLazyQueryHookResult = ReturnType<typeof useFundAllocationsPageLotsLazyQuery>;
export type FundAllocationsPageLotsQueryResult = Apollo.QueryResult<FundAllocationsPageLotsQuery, FundAllocationsPageLotsQueryVariables>;
export const FundAllocationsPageFundsDocument = gql`
    query FundAllocationsPageFunds {
  funds {
    ...FundAllocationsPageFund
  }
}
    ${FundAllocationsPageFundFragmentDoc}`;

/**
 * __useFundAllocationsPageFundsQuery__
 *
 * To run a query within a React component, call `useFundAllocationsPageFundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundAllocationsPageFundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundAllocationsPageFundsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundAllocationsPageFundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundAllocationsPageFundsQuery, FundAllocationsPageFundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundAllocationsPageFundsQuery, FundAllocationsPageFundsQueryVariables>(FundAllocationsPageFundsDocument, options);
      }
export function useFundAllocationsPageFundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundAllocationsPageFundsQuery, FundAllocationsPageFundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundAllocationsPageFundsQuery, FundAllocationsPageFundsQueryVariables>(FundAllocationsPageFundsDocument, options);
        }
export type FundAllocationsPageFundsQueryHookResult = ReturnType<typeof useFundAllocationsPageFundsQuery>;
export type FundAllocationsPageFundsLazyQueryHookResult = ReturnType<typeof useFundAllocationsPageFundsLazyQuery>;
export type FundAllocationsPageFundsQueryResult = Apollo.QueryResult<FundAllocationsPageFundsQuery, FundAllocationsPageFundsQueryVariables>;
export const SaveLotsDocument = gql`
    mutation SaveLots($input: SaveLotsInput!) {
  saveLots(input: $input) {
    lots {
      ...FundAllocationsPageLot
    }
  }
}
    ${FundAllocationsPageLotFragmentDoc}`;
export type SaveLotsMutationFn = Apollo.MutationFunction<SaveLotsMutation, SaveLotsMutationVariables>;

/**
 * __useSaveLotsMutation__
 *
 * To run a mutation, you first call `useSaveLotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotsMutation, { data, loading, error }] = useSaveLotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotsMutation, SaveLotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotsMutation, SaveLotsMutationVariables>(SaveLotsDocument, options);
      }
export type SaveLotsMutationHookResult = ReturnType<typeof useSaveLotsMutation>;
export type SaveLotsMutationResult = Apollo.MutationResult<SaveLotsMutation>;
export type SaveLotsMutationOptions = Apollo.BaseMutationOptions<SaveLotsMutation, SaveLotsMutationVariables>;
export const SendCustomerInformationToBlueprintDocument = gql`
    mutation SendCustomerInformationToBlueprint($input: SendCustomerInformationToBlueprintInput!) {
  sendCustomerInformationToBlueprint(input: $input) {
    lot {
      ...FundAllocationsPageLot
    }
  }
}
    ${FundAllocationsPageLotFragmentDoc}`;
export type SendCustomerInformationToBlueprintMutationFn = Apollo.MutationFunction<SendCustomerInformationToBlueprintMutation, SendCustomerInformationToBlueprintMutationVariables>;

/**
 * __useSendCustomerInformationToBlueprintMutation__
 *
 * To run a mutation, you first call `useSendCustomerInformationToBlueprintMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendCustomerInformationToBlueprintMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendCustomerInformationToBlueprintMutation, { data, loading, error }] = useSendCustomerInformationToBlueprintMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendCustomerInformationToBlueprintMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendCustomerInformationToBlueprintMutation, SendCustomerInformationToBlueprintMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendCustomerInformationToBlueprintMutation, SendCustomerInformationToBlueprintMutationVariables>(SendCustomerInformationToBlueprintDocument, options);
      }
export type SendCustomerInformationToBlueprintMutationHookResult = ReturnType<typeof useSendCustomerInformationToBlueprintMutation>;
export type SendCustomerInformationToBlueprintMutationResult = Apollo.MutationResult<SendCustomerInformationToBlueprintMutation>;
export type SendCustomerInformationToBlueprintMutationOptions = Apollo.BaseMutationOptions<SendCustomerInformationToBlueprintMutation, SendCustomerInformationToBlueprintMutationVariables>;
export const CreateAssetUploadUrlDocument = gql`
    mutation CreateAssetUploadUrl($input: CreateAssetUploadUrlInput!) {
  createAssetUploadUrl(input: $input) {
    s3Key
    uploadUrl
    downloadUrl
    previewUrl
  }
}
    `;
export type CreateAssetUploadUrlMutationFn = Apollo.MutationFunction<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>;

/**
 * __useCreateAssetUploadUrlMutation__
 *
 * To run a mutation, you first call `useCreateAssetUploadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAssetUploadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAssetUploadUrlMutation, { data, loading, error }] = useCreateAssetUploadUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAssetUploadUrlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>(CreateAssetUploadUrlDocument, options);
      }
export type CreateAssetUploadUrlMutationHookResult = ReturnType<typeof useCreateAssetUploadUrlMutation>;
export type CreateAssetUploadUrlMutationResult = Apollo.MutationResult<CreateAssetUploadUrlMutation>;
export type CreateAssetUploadUrlMutationOptions = Apollo.BaseMutationOptions<CreateAssetUploadUrlMutation, CreateAssetUploadUrlMutationVariables>;
export const FundsPageFundsDocument = gql`
    query FundsPageFunds {
  funds {
    ...FundsPageFund
  }
}
    ${FundsPageFundFragmentDoc}`;

/**
 * __useFundsPageFundsQuery__
 *
 * To run a query within a React component, call `useFundsPageFundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundsPageFundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundsPageFundsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFundsPageFundsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FundsPageFundsQuery, FundsPageFundsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundsPageFundsQuery, FundsPageFundsQueryVariables>(FundsPageFundsDocument, options);
      }
export function useFundsPageFundsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundsPageFundsQuery, FundsPageFundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundsPageFundsQuery, FundsPageFundsQueryVariables>(FundsPageFundsDocument, options);
        }
export type FundsPageFundsQueryHookResult = ReturnType<typeof useFundsPageFundsQuery>;
export type FundsPageFundsLazyQueryHookResult = ReturnType<typeof useFundsPageFundsLazyQuery>;
export type FundsPageFundsQueryResult = Apollo.QueryResult<FundsPageFundsQuery, FundsPageFundsQueryVariables>;
export const CheckoutControlsDocument = gql`
    query CheckoutControls {
  lotPartitions(
    filter: {lotPartitionSalesStatus: [PRE_FOR_SALE, FOR_SALE, RESERVED], lotInvestmentStatus: [ACTIVE]}
  ) {
    ...CheckoutControls_LotPartition
  }
}
    ${CheckoutControls_LotPartitionFragmentDoc}`;

/**
 * __useCheckoutControlsQuery__
 *
 * To run a query within a React component, call `useCheckoutControlsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckoutControlsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckoutControlsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCheckoutControlsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CheckoutControlsQuery, CheckoutControlsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CheckoutControlsQuery, CheckoutControlsQueryVariables>(CheckoutControlsDocument, options);
      }
export function useCheckoutControlsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CheckoutControlsQuery, CheckoutControlsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CheckoutControlsQuery, CheckoutControlsQueryVariables>(CheckoutControlsDocument, options);
        }
export type CheckoutControlsQueryHookResult = ReturnType<typeof useCheckoutControlsQuery>;
export type CheckoutControlsLazyQueryHookResult = ReturnType<typeof useCheckoutControlsLazyQuery>;
export type CheckoutControlsQueryResult = Apollo.QueryResult<CheckoutControlsQuery, CheckoutControlsQueryVariables>;
export const MetrosPageMetrosDocument = gql`
    query MetrosPageMetros {
  metros {
    ...MetrosPageMetro
  }
}
    ${MetrosPageMetroFragmentDoc}`;

/**
 * __useMetrosPageMetrosQuery__
 *
 * To run a query within a React component, call `useMetrosPageMetrosQuery` and pass it any options that fit your needs.
 * When your component renders, `useMetrosPageMetrosQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMetrosPageMetrosQuery({
 *   variables: {
 *   },
 * });
 */
export function useMetrosPageMetrosQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MetrosPageMetrosQuery, MetrosPageMetrosQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MetrosPageMetrosQuery, MetrosPageMetrosQueryVariables>(MetrosPageMetrosDocument, options);
      }
export function useMetrosPageMetrosLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MetrosPageMetrosQuery, MetrosPageMetrosQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MetrosPageMetrosQuery, MetrosPageMetrosQueryVariables>(MetrosPageMetrosDocument, options);
        }
export type MetrosPageMetrosQueryHookResult = ReturnType<typeof useMetrosPageMetrosQuery>;
export type MetrosPageMetrosLazyQueryHookResult = ReturnType<typeof useMetrosPageMetrosLazyQuery>;
export type MetrosPageMetrosQueryResult = Apollo.QueryResult<MetrosPageMetrosQuery, MetrosPageMetrosQueryVariables>;
export const SaveMetroDocument = gql`
    mutation SaveMetro($input: SaveMetroInput!) {
  saveMetro(input: $input) {
    metro {
      ...MetrosPageMetro
    }
  }
}
    ${MetrosPageMetroFragmentDoc}`;
export type SaveMetroMutationFn = Apollo.MutationFunction<SaveMetroMutation, SaveMetroMutationVariables>;

/**
 * __useSaveMetroMutation__
 *
 * To run a mutation, you first call `useSaveMetroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveMetroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveMetroMutation, { data, loading, error }] = useSaveMetroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveMetroMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveMetroMutation, SaveMetroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveMetroMutation, SaveMetroMutationVariables>(SaveMetroDocument, options);
      }
export type SaveMetroMutationHookResult = ReturnType<typeof useSaveMetroMutation>;
export type SaveMetroMutationResult = Apollo.MutationResult<SaveMetroMutation>;
export type SaveMetroMutationOptions = Apollo.BaseMutationOptions<SaveMetroMutation, SaveMetroMutationVariables>;
export const UnderwritingOverviewUnderwritingConfigDocument = gql`
    query UnderwritingOverviewUnderwritingConfig($underwritingConfigId: ID!) {
  underwritingConfigs(filter: {id: [$underwritingConfigId]}) {
    ...UnderwritingOverviewPageUnderwritingConfig
  }
}
    ${UnderwritingOverviewPageUnderwritingConfigFragmentDoc}`;

/**
 * __useUnderwritingOverviewUnderwritingConfigQuery__
 *
 * To run a query within a React component, call `useUnderwritingOverviewUnderwritingConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnderwritingOverviewUnderwritingConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnderwritingOverviewUnderwritingConfigQuery({
 *   variables: {
 *      underwritingConfigId: // value for 'underwritingConfigId'
 *   },
 * });
 */
export function useUnderwritingOverviewUnderwritingConfigQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UnderwritingOverviewUnderwritingConfigQuery, UnderwritingOverviewUnderwritingConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UnderwritingOverviewUnderwritingConfigQuery, UnderwritingOverviewUnderwritingConfigQueryVariables>(UnderwritingOverviewUnderwritingConfigDocument, options);
      }
export function useUnderwritingOverviewUnderwritingConfigLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UnderwritingOverviewUnderwritingConfigQuery, UnderwritingOverviewUnderwritingConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UnderwritingOverviewUnderwritingConfigQuery, UnderwritingOverviewUnderwritingConfigQueryVariables>(UnderwritingOverviewUnderwritingConfigDocument, options);
        }
export type UnderwritingOverviewUnderwritingConfigQueryHookResult = ReturnType<typeof useUnderwritingOverviewUnderwritingConfigQuery>;
export type UnderwritingOverviewUnderwritingConfigLazyQueryHookResult = ReturnType<typeof useUnderwritingOverviewUnderwritingConfigLazyQuery>;
export type UnderwritingOverviewUnderwritingConfigQueryResult = Apollo.QueryResult<UnderwritingOverviewUnderwritingConfigQuery, UnderwritingOverviewUnderwritingConfigQueryVariables>;
export const SaveUnderwritingConfigDocument = gql`
    mutation SaveUnderwritingConfig($input: SaveUnderwritingConfigInput!) {
  saveUnderwritingConfig(input: $input) {
    underwritingConfig {
      ...UnderwritingOverviewPageUnderwritingConfig
    }
  }
}
    ${UnderwritingOverviewPageUnderwritingConfigFragmentDoc}`;
export type SaveUnderwritingConfigMutationFn = Apollo.MutationFunction<SaveUnderwritingConfigMutation, SaveUnderwritingConfigMutationVariables>;

/**
 * __useSaveUnderwritingConfigMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingConfigMutation, { data, loading, error }] = useSaveUnderwritingConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUnderwritingConfigMutation, SaveUnderwritingConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUnderwritingConfigMutation, SaveUnderwritingConfigMutationVariables>(SaveUnderwritingConfigDocument, options);
      }
export type SaveUnderwritingConfigMutationHookResult = ReturnType<typeof useSaveUnderwritingConfigMutation>;
export type SaveUnderwritingConfigMutationResult = Apollo.MutationResult<SaveUnderwritingConfigMutation>;
export type SaveUnderwritingConfigMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingConfigMutation, SaveUnderwritingConfigMutationVariables>;
export const SaveUnderwritingConfigMetroDocument = gql`
    mutation SaveUnderwritingConfigMetro($input: SaveUnderwritingConfigMetroInput!) {
  saveUnderwritingConfigMetro(input: $input) {
    underwritingConfigMetro {
      ...UnderwritingOverviewPageUnderwritingConfigMetro
    }
  }
}
    ${UnderwritingOverviewPageUnderwritingConfigMetroFragmentDoc}`;
export type SaveUnderwritingConfigMetroMutationFn = Apollo.MutationFunction<SaveUnderwritingConfigMetroMutation, SaveUnderwritingConfigMetroMutationVariables>;

/**
 * __useSaveUnderwritingConfigMetroMutation__
 *
 * To run a mutation, you first call `useSaveUnderwritingConfigMetroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveUnderwritingConfigMetroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveUnderwritingConfigMetroMutation, { data, loading, error }] = useSaveUnderwritingConfigMetroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveUnderwritingConfigMetroMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveUnderwritingConfigMetroMutation, SaveUnderwritingConfigMetroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveUnderwritingConfigMetroMutation, SaveUnderwritingConfigMetroMutationVariables>(SaveUnderwritingConfigMetroDocument, options);
      }
export type SaveUnderwritingConfigMetroMutationHookResult = ReturnType<typeof useSaveUnderwritingConfigMetroMutation>;
export type SaveUnderwritingConfigMetroMutationResult = Apollo.MutationResult<SaveUnderwritingConfigMetroMutation>;
export type SaveUnderwritingConfigMetroMutationOptions = Apollo.BaseMutationOptions<SaveUnderwritingConfigMetroMutation, SaveUnderwritingConfigMetroMutationVariables>;
export const LotsPageLotsDocument = gql`
    query LotsPageLots {
  lots {
    ...LotsPageLot
  }
}
    ${LotsPageLotFragmentDoc}`;

/**
 * __useLotsPageLotsQuery__
 *
 * To run a query within a React component, call `useLotsPageLotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotsPageLotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotsPageLotsQuery({
 *   variables: {
 *   },
 * });
 */
export function useLotsPageLotsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<LotsPageLotsQuery, LotsPageLotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotsPageLotsQuery, LotsPageLotsQueryVariables>(LotsPageLotsDocument, options);
      }
export function useLotsPageLotsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotsPageLotsQuery, LotsPageLotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotsPageLotsQuery, LotsPageLotsQueryVariables>(LotsPageLotsDocument, options);
        }
export type LotsPageLotsQueryHookResult = ReturnType<typeof useLotsPageLotsQuery>;
export type LotsPageLotsLazyQueryHookResult = ReturnType<typeof useLotsPageLotsLazyQuery>;
export type LotsPageLotsQueryResult = Apollo.QueryResult<LotsPageLotsQuery, LotsPageLotsQueryVariables>;
export const DrawOverviewDrawDocument = gql`
    query DrawOverviewDraw($drawId: ID!) {
  creditFacilityDraws(filter: {id: [$drawId]}) {
    ...DrawOverviewPageDraw
  }
}
    ${DrawOverviewPageDrawFragmentDoc}`;

/**
 * __useDrawOverviewDrawQuery__
 *
 * To run a query within a React component, call `useDrawOverviewDrawQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawOverviewDrawQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawOverviewDrawQuery({
 *   variables: {
 *      drawId: // value for 'drawId'
 *   },
 * });
 */
export function useDrawOverviewDrawQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DrawOverviewDrawQuery, DrawOverviewDrawQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DrawOverviewDrawQuery, DrawOverviewDrawQueryVariables>(DrawOverviewDrawDocument, options);
      }
export function useDrawOverviewDrawLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DrawOverviewDrawQuery, DrawOverviewDrawQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DrawOverviewDrawQuery, DrawOverviewDrawQueryVariables>(DrawOverviewDrawDocument, options);
        }
export type DrawOverviewDrawQueryHookResult = ReturnType<typeof useDrawOverviewDrawQuery>;
export type DrawOverviewDrawLazyQueryHookResult = ReturnType<typeof useDrawOverviewDrawLazyQuery>;
export type DrawOverviewDrawQueryResult = Apollo.QueryResult<DrawOverviewDrawQuery, DrawOverviewDrawQueryVariables>;
export const SaveLotPartitionDrawDocument = gql`
    mutation SaveLotPartitionDraw($input: SaveLotPartitionDrawInput!) {
  saveLotPartitionDraw(input: $input) {
    lotPartitionDraw {
      ...DrawOverviewPageLotPartitionDraw
    }
  }
}
    ${DrawOverviewPageLotPartitionDrawFragmentDoc}`;
export type SaveLotPartitionDrawMutationFn = Apollo.MutationFunction<SaveLotPartitionDrawMutation, SaveLotPartitionDrawMutationVariables>;

/**
 * __useSaveLotPartitionDrawMutation__
 *
 * To run a mutation, you first call `useSaveLotPartitionDrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotPartitionDrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotPartitionDrawMutation, { data, loading, error }] = useSaveLotPartitionDrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotPartitionDrawMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotPartitionDrawMutation, SaveLotPartitionDrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotPartitionDrawMutation, SaveLotPartitionDrawMutationVariables>(SaveLotPartitionDrawDocument, options);
      }
export type SaveLotPartitionDrawMutationHookResult = ReturnType<typeof useSaveLotPartitionDrawMutation>;
export type SaveLotPartitionDrawMutationResult = Apollo.MutationResult<SaveLotPartitionDrawMutation>;
export type SaveLotPartitionDrawMutationOptions = Apollo.BaseMutationOptions<SaveLotPartitionDrawMutation, SaveLotPartitionDrawMutationVariables>;
export const SaveCreditFacilityDrawDocument = gql`
    mutation SaveCreditFacilityDraw($input: SaveCreditFacilityDrawInput!) {
  saveCreditFacilityDraw(input: $input) {
    creditFacilityDraw {
      ...DrawOverviewPageDraw
    }
  }
}
    ${DrawOverviewPageDrawFragmentDoc}`;
export type SaveCreditFacilityDrawMutationFn = Apollo.MutationFunction<SaveCreditFacilityDrawMutation, SaveCreditFacilityDrawMutationVariables>;

/**
 * __useSaveCreditFacilityDrawMutation__
 *
 * To run a mutation, you first call `useSaveCreditFacilityDrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCreditFacilityDrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCreditFacilityDrawMutation, { data, loading, error }] = useSaveCreditFacilityDrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCreditFacilityDrawMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCreditFacilityDrawMutation, SaveCreditFacilityDrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCreditFacilityDrawMutation, SaveCreditFacilityDrawMutationVariables>(SaveCreditFacilityDrawDocument, options);
      }
export type SaveCreditFacilityDrawMutationHookResult = ReturnType<typeof useSaveCreditFacilityDrawMutation>;
export type SaveCreditFacilityDrawMutationResult = Apollo.MutationResult<SaveCreditFacilityDrawMutation>;
export type SaveCreditFacilityDrawMutationOptions = Apollo.BaseMutationOptions<SaveCreditFacilityDrawMutation, SaveCreditFacilityDrawMutationVariables>;
export const DeleteDrawDocument = gql`
    mutation DeleteDraw($input: DeleteEntityInput!) {
  deleteCreditFacilityDraw(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteDrawMutationFn = Apollo.MutationFunction<DeleteDrawMutation, DeleteDrawMutationVariables>;

/**
 * __useDeleteDrawMutation__
 *
 * To run a mutation, you first call `useDeleteDrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDrawMutation, { data, loading, error }] = useDeleteDrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDrawMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteDrawMutation, DeleteDrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteDrawMutation, DeleteDrawMutationVariables>(DeleteDrawDocument, options);
      }
export type DeleteDrawMutationHookResult = ReturnType<typeof useDeleteDrawMutation>;
export type DeleteDrawMutationResult = Apollo.MutationResult<DeleteDrawMutation>;
export type DeleteDrawMutationOptions = Apollo.BaseMutationOptions<DeleteDrawMutation, DeleteDrawMutationVariables>;
export const ExportBillsForDrawDocument = gql`
    mutation ExportBillsForDraw($input: ExportBillsForDrawInput!) {
  exportBillsForDraw(input: $input) {
    googleDriveFolderId
  }
}
    `;
export type ExportBillsForDrawMutationFn = Apollo.MutationFunction<ExportBillsForDrawMutation, ExportBillsForDrawMutationVariables>;

/**
 * __useExportBillsForDrawMutation__
 *
 * To run a mutation, you first call `useExportBillsForDrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportBillsForDrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportBillsForDrawMutation, { data, loading, error }] = useExportBillsForDrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportBillsForDrawMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ExportBillsForDrawMutation, ExportBillsForDrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ExportBillsForDrawMutation, ExportBillsForDrawMutationVariables>(ExportBillsForDrawDocument, options);
      }
export type ExportBillsForDrawMutationHookResult = ReturnType<typeof useExportBillsForDrawMutation>;
export type ExportBillsForDrawMutationResult = Apollo.MutationResult<ExportBillsForDrawMutation>;
export type ExportBillsForDrawMutationOptions = Apollo.BaseMutationOptions<ExportBillsForDrawMutation, ExportBillsForDrawMutationVariables>;
export const CreateCreditFacilityDrawDocument = gql`
    mutation CreateCreditFacilityDraw($input: SaveCreditFacilityDrawInput!) {
  saveCreditFacilityDraw(input: $input) {
    creditFacilityDraw {
      id
    }
  }
}
    `;
export type CreateCreditFacilityDrawMutationFn = Apollo.MutationFunction<CreateCreditFacilityDrawMutation, CreateCreditFacilityDrawMutationVariables>;

/**
 * __useCreateCreditFacilityDrawMutation__
 *
 * To run a mutation, you first call `useCreateCreditFacilityDrawMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditFacilityDrawMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditFacilityDrawMutation, { data, loading, error }] = useCreateCreditFacilityDrawMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditFacilityDrawMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreditFacilityDrawMutation, CreateCreditFacilityDrawMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreditFacilityDrawMutation, CreateCreditFacilityDrawMutationVariables>(CreateCreditFacilityDrawDocument, options);
      }
export type CreateCreditFacilityDrawMutationHookResult = ReturnType<typeof useCreateCreditFacilityDrawMutation>;
export type CreateCreditFacilityDrawMutationResult = Apollo.MutationResult<CreateCreditFacilityDrawMutation>;
export type CreateCreditFacilityDrawMutationOptions = Apollo.BaseMutationOptions<CreateCreditFacilityDrawMutation, CreateCreditFacilityDrawMutationVariables>;
export const InvoiceOverviewInvoiceDocument = gql`
    query InvoiceOverviewInvoice($invoiceId: ID!) {
  creditFacilityInvoices(filter: {id: [$invoiceId]}) {
    ...InvoiceOverviewPageInvoice
  }
}
    ${InvoiceOverviewPageInvoiceFragmentDoc}`;

/**
 * __useInvoiceOverviewInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceOverviewInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceOverviewInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceOverviewInvoiceQuery({
 *   variables: {
 *      invoiceId: // value for 'invoiceId'
 *   },
 * });
 */
export function useInvoiceOverviewInvoiceQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InvoiceOverviewInvoiceQuery, InvoiceOverviewInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InvoiceOverviewInvoiceQuery, InvoiceOverviewInvoiceQueryVariables>(InvoiceOverviewInvoiceDocument, options);
      }
export function useInvoiceOverviewInvoiceLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InvoiceOverviewInvoiceQuery, InvoiceOverviewInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InvoiceOverviewInvoiceQuery, InvoiceOverviewInvoiceQueryVariables>(InvoiceOverviewInvoiceDocument, options);
        }
export type InvoiceOverviewInvoiceQueryHookResult = ReturnType<typeof useInvoiceOverviewInvoiceQuery>;
export type InvoiceOverviewInvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceOverviewInvoiceLazyQuery>;
export type InvoiceOverviewInvoiceQueryResult = Apollo.QueryResult<InvoiceOverviewInvoiceQuery, InvoiceOverviewInvoiceQueryVariables>;
export const SaveDrawInterestDocument = gql`
    mutation SaveDrawInterest($input: SaveCreditFacilityInvoiceDrawInterestInput!) {
  saveCreditFacilityInvoiceDrawInterest(input: $input) {
    creditFacilityInvoiceDrawInterest {
      ...InvoiceOverviewPageDrawInterest
    }
  }
}
    ${InvoiceOverviewPageDrawInterestFragmentDoc}`;
export type SaveDrawInterestMutationFn = Apollo.MutationFunction<SaveDrawInterestMutation, SaveDrawInterestMutationVariables>;

/**
 * __useSaveDrawInterestMutation__
 *
 * To run a mutation, you first call `useSaveDrawInterestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDrawInterestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDrawInterestMutation, { data, loading, error }] = useSaveDrawInterestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDrawInterestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDrawInterestMutation, SaveDrawInterestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDrawInterestMutation, SaveDrawInterestMutationVariables>(SaveDrawInterestDocument, options);
      }
export type SaveDrawInterestMutationHookResult = ReturnType<typeof useSaveDrawInterestMutation>;
export type SaveDrawInterestMutationResult = Apollo.MutationResult<SaveDrawInterestMutation>;
export type SaveDrawInterestMutationOptions = Apollo.BaseMutationOptions<SaveDrawInterestMutation, SaveDrawInterestMutationVariables>;
export const DeleteInvoiceDocument = gql`
    mutation DeleteInvoice($input: DeleteEntityInput!) {
  deleteCreditFacilityInvoice(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteInvoiceMutationFn = Apollo.MutationFunction<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;

/**
 * __useDeleteInvoiceMutation__
 *
 * To run a mutation, you first call `useDeleteInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInvoiceMutation, { data, loading, error }] = useDeleteInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>(DeleteInvoiceDocument, options);
      }
export type DeleteInvoiceMutationHookResult = ReturnType<typeof useDeleteInvoiceMutation>;
export type DeleteInvoiceMutationResult = Apollo.MutationResult<DeleteInvoiceMutation>;
export type DeleteInvoiceMutationOptions = Apollo.BaseMutationOptions<DeleteInvoiceMutation, DeleteInvoiceMutationVariables>;
export const DrawRequestOverviewDrawRequestDocument = gql`
    query DrawRequestOverviewDrawRequest($drawRequestId: ID!) {
  creditFacilityDrawRequests(filter: {id: [$drawRequestId]}) {
    ...DrawRequestOverviewPageDrawRequest
  }
}
    ${DrawRequestOverviewPageDrawRequestFragmentDoc}`;

/**
 * __useDrawRequestOverviewDrawRequestQuery__
 *
 * To run a query within a React component, call `useDrawRequestOverviewDrawRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useDrawRequestOverviewDrawRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDrawRequestOverviewDrawRequestQuery({
 *   variables: {
 *      drawRequestId: // value for 'drawRequestId'
 *   },
 * });
 */
export function useDrawRequestOverviewDrawRequestQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DrawRequestOverviewDrawRequestQuery, DrawRequestOverviewDrawRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DrawRequestOverviewDrawRequestQuery, DrawRequestOverviewDrawRequestQueryVariables>(DrawRequestOverviewDrawRequestDocument, options);
      }
export function useDrawRequestOverviewDrawRequestLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DrawRequestOverviewDrawRequestQuery, DrawRequestOverviewDrawRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DrawRequestOverviewDrawRequestQuery, DrawRequestOverviewDrawRequestQueryVariables>(DrawRequestOverviewDrawRequestDocument, options);
        }
export type DrawRequestOverviewDrawRequestQueryHookResult = ReturnType<typeof useDrawRequestOverviewDrawRequestQuery>;
export type DrawRequestOverviewDrawRequestLazyQueryHookResult = ReturnType<typeof useDrawRequestOverviewDrawRequestLazyQuery>;
export type DrawRequestOverviewDrawRequestQueryResult = Apollo.QueryResult<DrawRequestOverviewDrawRequestQuery, DrawRequestOverviewDrawRequestQueryVariables>;
export const SaveLotPartitionDrawRequestsDocument = gql`
    mutation SaveLotPartitionDrawRequests($input: SaveLotPartitionDrawRequestsInput!) {
  saveLotPartitionDrawRequests(input: $input) {
    lotPartitionDrawRequests {
      ...DrawRequestOverviewPageLotPartitionDrawRequest
    }
  }
}
    ${DrawRequestOverviewPageLotPartitionDrawRequestFragmentDoc}`;
export type SaveLotPartitionDrawRequestsMutationFn = Apollo.MutationFunction<SaveLotPartitionDrawRequestsMutation, SaveLotPartitionDrawRequestsMutationVariables>;

/**
 * __useSaveLotPartitionDrawRequestsMutation__
 *
 * To run a mutation, you first call `useSaveLotPartitionDrawRequestsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotPartitionDrawRequestsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotPartitionDrawRequestsMutation, { data, loading, error }] = useSaveLotPartitionDrawRequestsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotPartitionDrawRequestsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotPartitionDrawRequestsMutation, SaveLotPartitionDrawRequestsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotPartitionDrawRequestsMutation, SaveLotPartitionDrawRequestsMutationVariables>(SaveLotPartitionDrawRequestsDocument, options);
      }
export type SaveLotPartitionDrawRequestsMutationHookResult = ReturnType<typeof useSaveLotPartitionDrawRequestsMutation>;
export type SaveLotPartitionDrawRequestsMutationResult = Apollo.MutationResult<SaveLotPartitionDrawRequestsMutation>;
export type SaveLotPartitionDrawRequestsMutationOptions = Apollo.BaseMutationOptions<SaveLotPartitionDrawRequestsMutation, SaveLotPartitionDrawRequestsMutationVariables>;
export const SaveCreditFacilityDrawRequestDocument = gql`
    mutation SaveCreditFacilityDrawRequest($input: SaveCreditFacilityDrawRequestInput!) {
  saveCreditFacilityDrawRequest(input: $input) {
    creditFacilityDrawRequest {
      ...DrawRequestOverviewPageDrawRequest
    }
  }
}
    ${DrawRequestOverviewPageDrawRequestFragmentDoc}`;
export type SaveCreditFacilityDrawRequestMutationFn = Apollo.MutationFunction<SaveCreditFacilityDrawRequestMutation, SaveCreditFacilityDrawRequestMutationVariables>;

/**
 * __useSaveCreditFacilityDrawRequestMutation__
 *
 * To run a mutation, you first call `useSaveCreditFacilityDrawRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCreditFacilityDrawRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCreditFacilityDrawRequestMutation, { data, loading, error }] = useSaveCreditFacilityDrawRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCreditFacilityDrawRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCreditFacilityDrawRequestMutation, SaveCreditFacilityDrawRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCreditFacilityDrawRequestMutation, SaveCreditFacilityDrawRequestMutationVariables>(SaveCreditFacilityDrawRequestDocument, options);
      }
export type SaveCreditFacilityDrawRequestMutationHookResult = ReturnType<typeof useSaveCreditFacilityDrawRequestMutation>;
export type SaveCreditFacilityDrawRequestMutationResult = Apollo.MutationResult<SaveCreditFacilityDrawRequestMutation>;
export type SaveCreditFacilityDrawRequestMutationOptions = Apollo.BaseMutationOptions<SaveCreditFacilityDrawRequestMutation, SaveCreditFacilityDrawRequestMutationVariables>;
export const RefreshDrawModelBlueprintDataDocument = gql`
    mutation RefreshDrawModelBlueprintData($input: RefreshDrawModelBlueprintDataInput!) {
  refreshDrawModelBlueprintData(input: $input) {
    emptyResult
  }
}
    `;
export type RefreshDrawModelBlueprintDataMutationFn = Apollo.MutationFunction<RefreshDrawModelBlueprintDataMutation, RefreshDrawModelBlueprintDataMutationVariables>;

/**
 * __useRefreshDrawModelBlueprintDataMutation__
 *
 * To run a mutation, you first call `useRefreshDrawModelBlueprintDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshDrawModelBlueprintDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshDrawModelBlueprintDataMutation, { data, loading, error }] = useRefreshDrawModelBlueprintDataMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshDrawModelBlueprintDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RefreshDrawModelBlueprintDataMutation, RefreshDrawModelBlueprintDataMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RefreshDrawModelBlueprintDataMutation, RefreshDrawModelBlueprintDataMutationVariables>(RefreshDrawModelBlueprintDataDocument, options);
      }
export type RefreshDrawModelBlueprintDataMutationHookResult = ReturnType<typeof useRefreshDrawModelBlueprintDataMutation>;
export type RefreshDrawModelBlueprintDataMutationResult = Apollo.MutationResult<RefreshDrawModelBlueprintDataMutation>;
export type RefreshDrawModelBlueprintDataMutationOptions = Apollo.BaseMutationOptions<RefreshDrawModelBlueprintDataMutation, RefreshDrawModelBlueprintDataMutationVariables>;
export const FundOverviewFundDocument = gql`
    query FundOverviewFund($fundId: ID!) {
  funds(filter: {id: [$fundId]}) {
    ...FundOverviewPageFund
  }
}
    ${FundOverviewPageFundFragmentDoc}`;

/**
 * __useFundOverviewFundQuery__
 *
 * To run a query within a React component, call `useFundOverviewFundQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundOverviewFundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundOverviewFundQuery({
 *   variables: {
 *      fundId: // value for 'fundId'
 *   },
 * });
 */
export function useFundOverviewFundQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FundOverviewFundQuery, FundOverviewFundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundOverviewFundQuery, FundOverviewFundQueryVariables>(FundOverviewFundDocument, options);
      }
export function useFundOverviewFundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundOverviewFundQuery, FundOverviewFundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundOverviewFundQuery, FundOverviewFundQueryVariables>(FundOverviewFundDocument, options);
        }
export type FundOverviewFundQueryHookResult = ReturnType<typeof useFundOverviewFundQuery>;
export type FundOverviewFundLazyQueryHookResult = ReturnType<typeof useFundOverviewFundLazyQuery>;
export type FundOverviewFundQueryResult = Apollo.QueryResult<FundOverviewFundQuery, FundOverviewFundQueryVariables>;
export const FundOverviewExpectedSaleDateFundDocument = gql`
    query FundOverviewExpectedSaleDateFund($fundId: ID!) {
  funds(filter: {id: [$fundId]}) {
    ...FundOverviewPageExpectedSaleDateFund
  }
}
    ${FundOverviewPageExpectedSaleDateFundFragmentDoc}`;

/**
 * __useFundOverviewExpectedSaleDateFundQuery__
 *
 * To run a query within a React component, call `useFundOverviewExpectedSaleDateFundQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundOverviewExpectedSaleDateFundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundOverviewExpectedSaleDateFundQuery({
 *   variables: {
 *      fundId: // value for 'fundId'
 *   },
 * });
 */
export function useFundOverviewExpectedSaleDateFundQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FundOverviewExpectedSaleDateFundQuery, FundOverviewExpectedSaleDateFundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundOverviewExpectedSaleDateFundQuery, FundOverviewExpectedSaleDateFundQueryVariables>(FundOverviewExpectedSaleDateFundDocument, options);
      }
export function useFundOverviewExpectedSaleDateFundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundOverviewExpectedSaleDateFundQuery, FundOverviewExpectedSaleDateFundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundOverviewExpectedSaleDateFundQuery, FundOverviewExpectedSaleDateFundQueryVariables>(FundOverviewExpectedSaleDateFundDocument, options);
        }
export type FundOverviewExpectedSaleDateFundQueryHookResult = ReturnType<typeof useFundOverviewExpectedSaleDateFundQuery>;
export type FundOverviewExpectedSaleDateFundLazyQueryHookResult = ReturnType<typeof useFundOverviewExpectedSaleDateFundLazyQuery>;
export type FundOverviewExpectedSaleDateFundQueryResult = Apollo.QueryResult<FundOverviewExpectedSaleDateFundQuery, FundOverviewExpectedSaleDateFundQueryVariables>;
export const SaveFundDocument = gql`
    mutation SaveFund($input: SaveFundInput!) {
  saveFund(input: $input) {
    fund {
      ...FundOverviewPageFund
    }
  }
}
    ${FundOverviewPageFundFragmentDoc}`;
export type SaveFundMutationFn = Apollo.MutationFunction<SaveFundMutation, SaveFundMutationVariables>;

/**
 * __useSaveFundMutation__
 *
 * To run a mutation, you first call `useSaveFundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFundMutation, { data, loading, error }] = useSaveFundMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFundMutation, SaveFundMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFundMutation, SaveFundMutationVariables>(SaveFundDocument, options);
      }
export type SaveFundMutationHookResult = ReturnType<typeof useSaveFundMutation>;
export type SaveFundMutationResult = Apollo.MutationResult<SaveFundMutation>;
export type SaveFundMutationOptions = Apollo.BaseMutationOptions<SaveFundMutation, SaveFundMutationVariables>;
export const SaveFundMetroDocument = gql`
    mutation SaveFundMetro($input: SaveFundMetroInput!) {
  saveFundMetro(input: $input) {
    fundMetro {
      ...FundOverviewPageFundMetro
    }
  }
}
    ${FundOverviewPageFundMetroFragmentDoc}`;
export type SaveFundMetroMutationFn = Apollo.MutationFunction<SaveFundMetroMutation, SaveFundMetroMutationVariables>;

/**
 * __useSaveFundMetroMutation__
 *
 * To run a mutation, you first call `useSaveFundMetroMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveFundMetroMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveFundMetroMutation, { data, loading, error }] = useSaveFundMetroMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveFundMetroMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveFundMetroMutation, SaveFundMetroMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveFundMetroMutation, SaveFundMetroMutationVariables>(SaveFundMetroDocument, options);
      }
export type SaveFundMetroMutationHookResult = ReturnType<typeof useSaveFundMetroMutation>;
export type SaveFundMetroMutationResult = Apollo.MutationResult<SaveFundMetroMutation>;
export type SaveFundMetroMutationOptions = Apollo.BaseMutationOptions<SaveFundMetroMutation, SaveFundMetroMutationVariables>;
export const CreateCreditFacilityPaymentDocument = gql`
    mutation CreateCreditFacilityPayment($input: SaveCreditFacilityPaymentInput!) {
  saveCreditFacilityPayment(input: $input) {
    creditFacilityPayment {
      id
    }
  }
}
    `;
export type CreateCreditFacilityPaymentMutationFn = Apollo.MutationFunction<CreateCreditFacilityPaymentMutation, CreateCreditFacilityPaymentMutationVariables>;

/**
 * __useCreateCreditFacilityPaymentMutation__
 *
 * To run a mutation, you first call `useCreateCreditFacilityPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCreditFacilityPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCreditFacilityPaymentMutation, { data, loading, error }] = useCreateCreditFacilityPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCreditFacilityPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateCreditFacilityPaymentMutation, CreateCreditFacilityPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateCreditFacilityPaymentMutation, CreateCreditFacilityPaymentMutationVariables>(CreateCreditFacilityPaymentDocument, options);
      }
export type CreateCreditFacilityPaymentMutationHookResult = ReturnType<typeof useCreateCreditFacilityPaymentMutation>;
export type CreateCreditFacilityPaymentMutationResult = Apollo.MutationResult<CreateCreditFacilityPaymentMutation>;
export type CreateCreditFacilityPaymentMutationOptions = Apollo.BaseMutationOptions<CreateCreditFacilityPaymentMutation, CreateCreditFacilityPaymentMutationVariables>;
export const PaymentOverviewPaymentDocument = gql`
    query PaymentOverviewPayment($paymentId: ID!) {
  creditFacilityPayments(filter: {id: [$paymentId]}) {
    ...PaymentOverviewPagePayment
  }
}
    ${PaymentOverviewPagePaymentFragmentDoc}`;

/**
 * __usePaymentOverviewPaymentQuery__
 *
 * To run a query within a React component, call `usePaymentOverviewPaymentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePaymentOverviewPaymentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePaymentOverviewPaymentQuery({
 *   variables: {
 *      paymentId: // value for 'paymentId'
 *   },
 * });
 */
export function usePaymentOverviewPaymentQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PaymentOverviewPaymentQuery, PaymentOverviewPaymentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PaymentOverviewPaymentQuery, PaymentOverviewPaymentQueryVariables>(PaymentOverviewPaymentDocument, options);
      }
export function usePaymentOverviewPaymentLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PaymentOverviewPaymentQuery, PaymentOverviewPaymentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PaymentOverviewPaymentQuery, PaymentOverviewPaymentQueryVariables>(PaymentOverviewPaymentDocument, options);
        }
export type PaymentOverviewPaymentQueryHookResult = ReturnType<typeof usePaymentOverviewPaymentQuery>;
export type PaymentOverviewPaymentLazyQueryHookResult = ReturnType<typeof usePaymentOverviewPaymentLazyQuery>;
export type PaymentOverviewPaymentQueryResult = Apollo.QueryResult<PaymentOverviewPaymentQuery, PaymentOverviewPaymentQueryVariables>;
export const SaveLotPartitionDrawPaymentDocument = gql`
    mutation SaveLotPartitionDrawPayment($input: SaveLotPartitionDrawPaymentInput!) {
  saveLotPartitionDrawPayment(input: $input) {
    lotPartitionDrawPayment {
      ...PaymentOverviewPageLotPartitionDrawPayment
    }
  }
}
    ${PaymentOverviewPageLotPartitionDrawPaymentFragmentDoc}`;
export type SaveLotPartitionDrawPaymentMutationFn = Apollo.MutationFunction<SaveLotPartitionDrawPaymentMutation, SaveLotPartitionDrawPaymentMutationVariables>;

/**
 * __useSaveLotPartitionDrawPaymentMutation__
 *
 * To run a mutation, you first call `useSaveLotPartitionDrawPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotPartitionDrawPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotPartitionDrawPaymentMutation, { data, loading, error }] = useSaveLotPartitionDrawPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotPartitionDrawPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotPartitionDrawPaymentMutation, SaveLotPartitionDrawPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotPartitionDrawPaymentMutation, SaveLotPartitionDrawPaymentMutationVariables>(SaveLotPartitionDrawPaymentDocument, options);
      }
export type SaveLotPartitionDrawPaymentMutationHookResult = ReturnType<typeof useSaveLotPartitionDrawPaymentMutation>;
export type SaveLotPartitionDrawPaymentMutationResult = Apollo.MutationResult<SaveLotPartitionDrawPaymentMutation>;
export type SaveLotPartitionDrawPaymentMutationOptions = Apollo.BaseMutationOptions<SaveLotPartitionDrawPaymentMutation, SaveLotPartitionDrawPaymentMutationVariables>;
export const SaveCreditFacilityPaymentDocument = gql`
    mutation SaveCreditFacilityPayment($input: SaveCreditFacilityPaymentInput!) {
  saveCreditFacilityPayment(input: $input) {
    creditFacilityPayment {
      ...PaymentOverviewPagePayment
    }
  }
}
    ${PaymentOverviewPagePaymentFragmentDoc}`;
export type SaveCreditFacilityPaymentMutationFn = Apollo.MutationFunction<SaveCreditFacilityPaymentMutation, SaveCreditFacilityPaymentMutationVariables>;

/**
 * __useSaveCreditFacilityPaymentMutation__
 *
 * To run a mutation, you first call `useSaveCreditFacilityPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCreditFacilityPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCreditFacilityPaymentMutation, { data, loading, error }] = useSaveCreditFacilityPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCreditFacilityPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCreditFacilityPaymentMutation, SaveCreditFacilityPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCreditFacilityPaymentMutation, SaveCreditFacilityPaymentMutationVariables>(SaveCreditFacilityPaymentDocument, options);
      }
export type SaveCreditFacilityPaymentMutationHookResult = ReturnType<typeof useSaveCreditFacilityPaymentMutation>;
export type SaveCreditFacilityPaymentMutationResult = Apollo.MutationResult<SaveCreditFacilityPaymentMutation>;
export type SaveCreditFacilityPaymentMutationOptions = Apollo.BaseMutationOptions<SaveCreditFacilityPaymentMutation, SaveCreditFacilityPaymentMutationVariables>;
export const DeletePaymentDocument = gql`
    mutation DeletePayment($input: DeleteEntityInput!) {
  deleteCreditFacilityPayment(input: $input) {
    emptyResult
  }
}
    `;
export type DeletePaymentMutationFn = Apollo.MutationFunction<DeletePaymentMutation, DeletePaymentMutationVariables>;

/**
 * __useDeletePaymentMutation__
 *
 * To run a mutation, you first call `useDeletePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePaymentMutation, { data, loading, error }] = useDeletePaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePaymentMutation, DeletePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePaymentMutation, DeletePaymentMutationVariables>(DeletePaymentDocument, options);
      }
export type DeletePaymentMutationHookResult = ReturnType<typeof useDeletePaymentMutation>;
export type DeletePaymentMutationResult = Apollo.MutationResult<DeletePaymentMutation>;
export type DeletePaymentMutationOptions = Apollo.BaseMutationOptions<DeletePaymentMutation, DeletePaymentMutationVariables>;
export const SaveCreditFacilityInvoiceDocument = gql`
    mutation SaveCreditFacilityInvoice($input: SaveCreditFacilityInvoiceInput!) {
  saveCreditFacilityInvoice(input: $input) {
    creditFacilityInvoice {
      id
    }
  }
}
    `;
export type SaveCreditFacilityInvoiceMutationFn = Apollo.MutationFunction<SaveCreditFacilityInvoiceMutation, SaveCreditFacilityInvoiceMutationVariables>;

/**
 * __useSaveCreditFacilityInvoiceMutation__
 *
 * To run a mutation, you first call `useSaveCreditFacilityInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCreditFacilityInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCreditFacilityInvoiceMutation, { data, loading, error }] = useSaveCreditFacilityInvoiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveCreditFacilityInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveCreditFacilityInvoiceMutation, SaveCreditFacilityInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveCreditFacilityInvoiceMutation, SaveCreditFacilityInvoiceMutationVariables>(SaveCreditFacilityInvoiceDocument, options);
      }
export type SaveCreditFacilityInvoiceMutationHookResult = ReturnType<typeof useSaveCreditFacilityInvoiceMutation>;
export type SaveCreditFacilityInvoiceMutationResult = Apollo.MutationResult<SaveCreditFacilityInvoiceMutation>;
export type SaveCreditFacilityInvoiceMutationOptions = Apollo.BaseMutationOptions<SaveCreditFacilityInvoiceMutation, SaveCreditFacilityInvoiceMutationVariables>;
export const CreditFacilityInvoicePopulatedDocument = gql`
    query CreditFacilityInvoicePopulated($filter: CreditFacilityInvoiceFilter!) {
  creditFacilityInvoices(filter: $filter) {
    id
    isInterestPopulated
  }
}
    `;

/**
 * __useCreditFacilityInvoicePopulatedQuery__
 *
 * To run a query within a React component, call `useCreditFacilityInvoicePopulatedQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditFacilityInvoicePopulatedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditFacilityInvoicePopulatedQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useCreditFacilityInvoicePopulatedQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreditFacilityInvoicePopulatedQuery, CreditFacilityInvoicePopulatedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditFacilityInvoicePopulatedQuery, CreditFacilityInvoicePopulatedQueryVariables>(CreditFacilityInvoicePopulatedDocument, options);
      }
export function useCreditFacilityInvoicePopulatedLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditFacilityInvoicePopulatedQuery, CreditFacilityInvoicePopulatedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditFacilityInvoicePopulatedQuery, CreditFacilityInvoicePopulatedQueryVariables>(CreditFacilityInvoicePopulatedDocument, options);
        }
export type CreditFacilityInvoicePopulatedQueryHookResult = ReturnType<typeof useCreditFacilityInvoicePopulatedQuery>;
export type CreditFacilityInvoicePopulatedLazyQueryHookResult = ReturnType<typeof useCreditFacilityInvoicePopulatedLazyQuery>;
export type CreditFacilityInvoicePopulatedQueryResult = Apollo.QueryResult<CreditFacilityInvoicePopulatedQuery, CreditFacilityInvoicePopulatedQueryVariables>;
export const FundLoanManagementFundDocument = gql`
    query FundLoanManagementFund($fundId: ID!) {
  funds(filter: {id: [$fundId]}) {
    ...FundLoanManagementPageFund
  }
}
    ${FundLoanManagementPageFundFragmentDoc}`;

/**
 * __useFundLoanManagementFundQuery__
 *
 * To run a query within a React component, call `useFundLoanManagementFundQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundLoanManagementFundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundLoanManagementFundQuery({
 *   variables: {
 *      fundId: // value for 'fundId'
 *   },
 * });
 */
export function useFundLoanManagementFundQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FundLoanManagementFundQuery, FundLoanManagementFundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundLoanManagementFundQuery, FundLoanManagementFundQueryVariables>(FundLoanManagementFundDocument, options);
      }
export function useFundLoanManagementFundLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundLoanManagementFundQuery, FundLoanManagementFundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundLoanManagementFundQuery, FundLoanManagementFundQueryVariables>(FundLoanManagementFundDocument, options);
        }
export type FundLoanManagementFundQueryHookResult = ReturnType<typeof useFundLoanManagementFundQuery>;
export type FundLoanManagementFundLazyQueryHookResult = ReturnType<typeof useFundLoanManagementFundLazyQuery>;
export type FundLoanManagementFundQueryResult = Apollo.QueryResult<FundLoanManagementFundQuery, FundLoanManagementFundQueryVariables>;
export const FundLoanManagementFundDrawRequestsDocument = gql`
    query FundLoanManagementFundDrawRequests($fundId: ID!) {
  funds(filter: {id: [$fundId]}) {
    ...FundLoanManagementPageFundDrawRequests
  }
}
    ${FundLoanManagementPageFundDrawRequestsFragmentDoc}`;

/**
 * __useFundLoanManagementFundDrawRequestsQuery__
 *
 * To run a query within a React component, call `useFundLoanManagementFundDrawRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFundLoanManagementFundDrawRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFundLoanManagementFundDrawRequestsQuery({
 *   variables: {
 *      fundId: // value for 'fundId'
 *   },
 * });
 */
export function useFundLoanManagementFundDrawRequestsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FundLoanManagementFundDrawRequestsQuery, FundLoanManagementFundDrawRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FundLoanManagementFundDrawRequestsQuery, FundLoanManagementFundDrawRequestsQueryVariables>(FundLoanManagementFundDrawRequestsDocument, options);
      }
export function useFundLoanManagementFundDrawRequestsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FundLoanManagementFundDrawRequestsQuery, FundLoanManagementFundDrawRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FundLoanManagementFundDrawRequestsQuery, FundLoanManagementFundDrawRequestsQueryVariables>(FundLoanManagementFundDrawRequestsDocument, options);
        }
export type FundLoanManagementFundDrawRequestsQueryHookResult = ReturnType<typeof useFundLoanManagementFundDrawRequestsQuery>;
export type FundLoanManagementFundDrawRequestsLazyQueryHookResult = ReturnType<typeof useFundLoanManagementFundDrawRequestsLazyQuery>;
export type FundLoanManagementFundDrawRequestsQueryResult = Apollo.QueryResult<FundLoanManagementFundDrawRequestsQuery, FundLoanManagementFundDrawRequestsQueryVariables>;
export const DeleteCreditFacilityDrawRequestDocument = gql`
    mutation DeleteCreditFacilityDrawRequest($input: DeleteEntityInput!) {
  deleteCreditFacilityDrawRequest(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteCreditFacilityDrawRequestMutationFn = Apollo.MutationFunction<DeleteCreditFacilityDrawRequestMutation, DeleteCreditFacilityDrawRequestMutationVariables>;

/**
 * __useDeleteCreditFacilityDrawRequestMutation__
 *
 * To run a mutation, you first call `useDeleteCreditFacilityDrawRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCreditFacilityDrawRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCreditFacilityDrawRequestMutation, { data, loading, error }] = useDeleteCreditFacilityDrawRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteCreditFacilityDrawRequestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteCreditFacilityDrawRequestMutation, DeleteCreditFacilityDrawRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteCreditFacilityDrawRequestMutation, DeleteCreditFacilityDrawRequestMutationVariables>(DeleteCreditFacilityDrawRequestDocument, options);
      }
export type DeleteCreditFacilityDrawRequestMutationHookResult = ReturnType<typeof useDeleteCreditFacilityDrawRequestMutation>;
export type DeleteCreditFacilityDrawRequestMutationResult = Apollo.MutationResult<DeleteCreditFacilityDrawRequestMutation>;
export type DeleteCreditFacilityDrawRequestMutationOptions = Apollo.BaseMutationOptions<DeleteCreditFacilityDrawRequestMutation, DeleteCreditFacilityDrawRequestMutationVariables>;
export const QueueJobsDocument = gql`
    mutation QueueJobs($input: AddJobsInput!) {
  addJobs(input: $input) {
    emptyResult
  }
}
    `;
export type QueueJobsMutationFn = Apollo.MutationFunction<QueueJobsMutation, QueueJobsMutationVariables>;

/**
 * __useQueueJobsMutation__
 *
 * To run a mutation, you first call `useQueueJobsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useQueueJobsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [queueJobsMutation, { data, loading, error }] = useQueueJobsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useQueueJobsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<QueueJobsMutation, QueueJobsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<QueueJobsMutation, QueueJobsMutationVariables>(QueueJobsDocument, options);
      }
export type QueueJobsMutationHookResult = ReturnType<typeof useQueueJobsMutation>;
export type QueueJobsMutationResult = Apollo.MutationResult<QueueJobsMutation>;
export type QueueJobsMutationOptions = Apollo.BaseMutationOptions<QueueJobsMutation, QueueJobsMutationVariables>;
export const CreditFacilityDrawRequestCreatePollingDocument = gql`
    query CreditFacilityDrawRequestCreatePolling($fundId: ID!) {
  creditFacilityDrawRequests(filter: {fund: [$fundId], isDrawn: false}) {
    id
  }
}
    `;

/**
 * __useCreditFacilityDrawRequestCreatePollingQuery__
 *
 * To run a query within a React component, call `useCreditFacilityDrawRequestCreatePollingQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditFacilityDrawRequestCreatePollingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditFacilityDrawRequestCreatePollingQuery({
 *   variables: {
 *      fundId: // value for 'fundId'
 *   },
 * });
 */
export function useCreditFacilityDrawRequestCreatePollingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreditFacilityDrawRequestCreatePollingQuery, CreditFacilityDrawRequestCreatePollingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditFacilityDrawRequestCreatePollingQuery, CreditFacilityDrawRequestCreatePollingQueryVariables>(CreditFacilityDrawRequestCreatePollingDocument, options);
      }
export function useCreditFacilityDrawRequestCreatePollingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditFacilityDrawRequestCreatePollingQuery, CreditFacilityDrawRequestCreatePollingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditFacilityDrawRequestCreatePollingQuery, CreditFacilityDrawRequestCreatePollingQueryVariables>(CreditFacilityDrawRequestCreatePollingDocument, options);
        }
export type CreditFacilityDrawRequestCreatePollingQueryHookResult = ReturnType<typeof useCreditFacilityDrawRequestCreatePollingQuery>;
export type CreditFacilityDrawRequestCreatePollingLazyQueryHookResult = ReturnType<typeof useCreditFacilityDrawRequestCreatePollingLazyQuery>;
export type CreditFacilityDrawRequestCreatePollingQueryResult = Apollo.QueryResult<CreditFacilityDrawRequestCreatePollingQuery, CreditFacilityDrawRequestCreatePollingQueryVariables>;
export const AddDrawsToPaymentDocument = gql`
    mutation AddDrawsToPayment($input: AddOpenDrawsToCreditFacilityPaymentInput!) {
  addOpenDrawsToCreditFacilityPayment(input: $input) {
    creditFacilityPayment {
      id
    }
  }
}
    `;
export type AddDrawsToPaymentMutationFn = Apollo.MutationFunction<AddDrawsToPaymentMutation, AddDrawsToPaymentMutationVariables>;

/**
 * __useAddDrawsToPaymentMutation__
 *
 * To run a mutation, you first call `useAddDrawsToPaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddDrawsToPaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addDrawsToPaymentMutation, { data, loading, error }] = useAddDrawsToPaymentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddDrawsToPaymentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddDrawsToPaymentMutation, AddDrawsToPaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddDrawsToPaymentMutation, AddDrawsToPaymentMutationVariables>(AddDrawsToPaymentDocument, options);
      }
export type AddDrawsToPaymentMutationHookResult = ReturnType<typeof useAddDrawsToPaymentMutation>;
export type AddDrawsToPaymentMutationResult = Apollo.MutationResult<AddDrawsToPaymentMutation>;
export type AddDrawsToPaymentMutationOptions = Apollo.BaseMutationOptions<AddDrawsToPaymentMutation, AddDrawsToPaymentMutationVariables>;
export const SaveLotAcqPurchaseAgreementDocument = gql`
    mutation SaveLotAcqPurchaseAgreement($input: SaveLotAcqPurchaseAgreementInput!) {
  saveLotAcqPurchaseAgreement(input: $input) {
    lotAcqPurchaseAgreement {
      ...LotAcqLotAcqPurchaseAgreement
    }
  }
}
    ${LotAcqLotAcqPurchaseAgreementFragmentDoc}`;
export type SaveLotAcqPurchaseAgreementMutationFn = Apollo.MutationFunction<SaveLotAcqPurchaseAgreementMutation, SaveLotAcqPurchaseAgreementMutationVariables>;

/**
 * __useSaveLotAcqPurchaseAgreementMutation__
 *
 * To run a mutation, you first call `useSaveLotAcqPurchaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotAcqPurchaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotAcqPurchaseAgreementMutation, { data, loading, error }] = useSaveLotAcqPurchaseAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotAcqPurchaseAgreementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotAcqPurchaseAgreementMutation, SaveLotAcqPurchaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotAcqPurchaseAgreementMutation, SaveLotAcqPurchaseAgreementMutationVariables>(SaveLotAcqPurchaseAgreementDocument, options);
      }
export type SaveLotAcqPurchaseAgreementMutationHookResult = ReturnType<typeof useSaveLotAcqPurchaseAgreementMutation>;
export type SaveLotAcqPurchaseAgreementMutationResult = Apollo.MutationResult<SaveLotAcqPurchaseAgreementMutation>;
export type SaveLotAcqPurchaseAgreementMutationOptions = Apollo.BaseMutationOptions<SaveLotAcqPurchaseAgreementMutation, SaveLotAcqPurchaseAgreementMutationVariables>;
export const DeleteLotAcqPurchaseAgreementDocument = gql`
    mutation DeleteLotAcqPurchaseAgreement($input: DeleteEntityInput!) {
  deleteLotAcqPurchaseAgreement(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteLotAcqPurchaseAgreementMutationFn = Apollo.MutationFunction<DeleteLotAcqPurchaseAgreementMutation, DeleteLotAcqPurchaseAgreementMutationVariables>;

/**
 * __useDeleteLotAcqPurchaseAgreementMutation__
 *
 * To run a mutation, you first call `useDeleteLotAcqPurchaseAgreementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLotAcqPurchaseAgreementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLotAcqPurchaseAgreementMutation, { data, loading, error }] = useDeleteLotAcqPurchaseAgreementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLotAcqPurchaseAgreementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLotAcqPurchaseAgreementMutation, DeleteLotAcqPurchaseAgreementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLotAcqPurchaseAgreementMutation, DeleteLotAcqPurchaseAgreementMutationVariables>(DeleteLotAcqPurchaseAgreementDocument, options);
      }
export type DeleteLotAcqPurchaseAgreementMutationHookResult = ReturnType<typeof useDeleteLotAcqPurchaseAgreementMutation>;
export type DeleteLotAcqPurchaseAgreementMutationResult = Apollo.MutationResult<DeleteLotAcqPurchaseAgreementMutation>;
export type DeleteLotAcqPurchaseAgreementMutationOptions = Apollo.BaseMutationOptions<DeleteLotAcqPurchaseAgreementMutation, DeleteLotAcqPurchaseAgreementMutationVariables>;
export const LotAcqPurchaseAgreementDocumentsDocument = gql`
    query LotAcqPurchaseAgreementDocuments($documentIds: [ID!]!) {
  documents(filter: {id: $documentIds}) {
    id
    parent {
      ... on Lot {
        ...LotAcqLot
      }
    }
    asset {
      ...AssetInfo
    }
    lotAcqPurchaseAgreement {
      ...LotAcqLotAcqPurchaseAgreement
    }
  }
}
    ${LotAcqLotFragmentDoc}
${AssetInfoFragmentDoc}
${LotAcqLotAcqPurchaseAgreementFragmentDoc}`;

/**
 * __useLotAcqPurchaseAgreementDocumentsQuery__
 *
 * To run a query within a React component, call `useLotAcqPurchaseAgreementDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotAcqPurchaseAgreementDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotAcqPurchaseAgreementDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useLotAcqPurchaseAgreementDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotAcqPurchaseAgreementDocumentsQuery, LotAcqPurchaseAgreementDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotAcqPurchaseAgreementDocumentsQuery, LotAcqPurchaseAgreementDocumentsQueryVariables>(LotAcqPurchaseAgreementDocumentsDocument, options);
      }
export function useLotAcqPurchaseAgreementDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotAcqPurchaseAgreementDocumentsQuery, LotAcqPurchaseAgreementDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotAcqPurchaseAgreementDocumentsQuery, LotAcqPurchaseAgreementDocumentsQueryVariables>(LotAcqPurchaseAgreementDocumentsDocument, options);
        }
export type LotAcqPurchaseAgreementDocumentsQueryHookResult = ReturnType<typeof useLotAcqPurchaseAgreementDocumentsQuery>;
export type LotAcqPurchaseAgreementDocumentsLazyQueryHookResult = ReturnType<typeof useLotAcqPurchaseAgreementDocumentsLazyQuery>;
export type LotAcqPurchaseAgreementDocumentsQueryResult = Apollo.QueryResult<LotAcqPurchaseAgreementDocumentsQuery, LotAcqPurchaseAgreementDocumentsQueryVariables>;
export const SaveLotAcqSettlementStatementDocument = gql`
    mutation SaveLotAcqSettlementStatement($input: SaveLotAcqSettlementStatementInput!) {
  saveLotAcqSettlementStatement(input: $input) {
    lotAcqSettlementStatement {
      ...LotAcqLotAcqSettlementStatement
    }
  }
}
    ${LotAcqLotAcqSettlementStatementFragmentDoc}`;
export type SaveLotAcqSettlementStatementMutationFn = Apollo.MutationFunction<SaveLotAcqSettlementStatementMutation, SaveLotAcqSettlementStatementMutationVariables>;

/**
 * __useSaveLotAcqSettlementStatementMutation__
 *
 * To run a mutation, you first call `useSaveLotAcqSettlementStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotAcqSettlementStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotAcqSettlementStatementMutation, { data, loading, error }] = useSaveLotAcqSettlementStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotAcqSettlementStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotAcqSettlementStatementMutation, SaveLotAcqSettlementStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotAcqSettlementStatementMutation, SaveLotAcqSettlementStatementMutationVariables>(SaveLotAcqSettlementStatementDocument, options);
      }
export type SaveLotAcqSettlementStatementMutationHookResult = ReturnType<typeof useSaveLotAcqSettlementStatementMutation>;
export type SaveLotAcqSettlementStatementMutationResult = Apollo.MutationResult<SaveLotAcqSettlementStatementMutation>;
export type SaveLotAcqSettlementStatementMutationOptions = Apollo.BaseMutationOptions<SaveLotAcqSettlementStatementMutation, SaveLotAcqSettlementStatementMutationVariables>;
export const DeleteLotAcqSettlementStatementDocument = gql`
    mutation DeleteLotAcqSettlementStatement($input: DeleteEntityInput!) {
  deleteLotAcqSettlementStatement(input: $input) {
    emptyResult
  }
}
    `;
export type DeleteLotAcqSettlementStatementMutationFn = Apollo.MutationFunction<DeleteLotAcqSettlementStatementMutation, DeleteLotAcqSettlementStatementMutationVariables>;

/**
 * __useDeleteLotAcqSettlementStatementMutation__
 *
 * To run a mutation, you first call `useDeleteLotAcqSettlementStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLotAcqSettlementStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLotAcqSettlementStatementMutation, { data, loading, error }] = useDeleteLotAcqSettlementStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteLotAcqSettlementStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteLotAcqSettlementStatementMutation, DeleteLotAcqSettlementStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteLotAcqSettlementStatementMutation, DeleteLotAcqSettlementStatementMutationVariables>(DeleteLotAcqSettlementStatementDocument, options);
      }
export type DeleteLotAcqSettlementStatementMutationHookResult = ReturnType<typeof useDeleteLotAcqSettlementStatementMutation>;
export type DeleteLotAcqSettlementStatementMutationResult = Apollo.MutationResult<DeleteLotAcqSettlementStatementMutation>;
export type DeleteLotAcqSettlementStatementMutationOptions = Apollo.BaseMutationOptions<DeleteLotAcqSettlementStatementMutation, DeleteLotAcqSettlementStatementMutationVariables>;
export const SendLotAcqSettlementStatementForBookingDocument = gql`
    mutation SendLotAcqSettlementStatementForBooking($input: SendLotAcqSettlementStatementForBookingInput!) {
  sendLotAcqSettlementStatementForBooking(input: $input) {
    ...LotAcqLotAcqSettlementStatement
  }
}
    ${LotAcqLotAcqSettlementStatementFragmentDoc}`;
export type SendLotAcqSettlementStatementForBookingMutationFn = Apollo.MutationFunction<SendLotAcqSettlementStatementForBookingMutation, SendLotAcqSettlementStatementForBookingMutationVariables>;

/**
 * __useSendLotAcqSettlementStatementForBookingMutation__
 *
 * To run a mutation, you first call `useSendLotAcqSettlementStatementForBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendLotAcqSettlementStatementForBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendLotAcqSettlementStatementForBookingMutation, { data, loading, error }] = useSendLotAcqSettlementStatementForBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendLotAcqSettlementStatementForBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendLotAcqSettlementStatementForBookingMutation, SendLotAcqSettlementStatementForBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendLotAcqSettlementStatementForBookingMutation, SendLotAcqSettlementStatementForBookingMutationVariables>(SendLotAcqSettlementStatementForBookingDocument, options);
      }
export type SendLotAcqSettlementStatementForBookingMutationHookResult = ReturnType<typeof useSendLotAcqSettlementStatementForBookingMutation>;
export type SendLotAcqSettlementStatementForBookingMutationResult = Apollo.MutationResult<SendLotAcqSettlementStatementForBookingMutation>;
export type SendLotAcqSettlementStatementForBookingMutationOptions = Apollo.BaseMutationOptions<SendLotAcqSettlementStatementForBookingMutation, SendLotAcqSettlementStatementForBookingMutationVariables>;
export const ProcessLotAcqSettlementStatementOcrDocument = gql`
    mutation ProcessLotAcqSettlementStatementOcr($input: ProcessLotAcqSettlementStatementOcrInput!) {
  processLotAcqSettlementStatementOcr(input: $input) {
    ...LotAcqLotAcqSettlementStatement
  }
}
    ${LotAcqLotAcqSettlementStatementFragmentDoc}`;
export type ProcessLotAcqSettlementStatementOcrMutationFn = Apollo.MutationFunction<ProcessLotAcqSettlementStatementOcrMutation, ProcessLotAcqSettlementStatementOcrMutationVariables>;

/**
 * __useProcessLotAcqSettlementStatementOcrMutation__
 *
 * To run a mutation, you first call `useProcessLotAcqSettlementStatementOcrMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProcessLotAcqSettlementStatementOcrMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [processLotAcqSettlementStatementOcrMutation, { data, loading, error }] = useProcessLotAcqSettlementStatementOcrMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProcessLotAcqSettlementStatementOcrMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProcessLotAcqSettlementStatementOcrMutation, ProcessLotAcqSettlementStatementOcrMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProcessLotAcqSettlementStatementOcrMutation, ProcessLotAcqSettlementStatementOcrMutationVariables>(ProcessLotAcqSettlementStatementOcrDocument, options);
      }
export type ProcessLotAcqSettlementStatementOcrMutationHookResult = ReturnType<typeof useProcessLotAcqSettlementStatementOcrMutation>;
export type ProcessLotAcqSettlementStatementOcrMutationResult = Apollo.MutationResult<ProcessLotAcqSettlementStatementOcrMutation>;
export type ProcessLotAcqSettlementStatementOcrMutationOptions = Apollo.BaseMutationOptions<ProcessLotAcqSettlementStatementOcrMutation, ProcessLotAcqSettlementStatementOcrMutationVariables>;
export const LotAcqSettlementStatementDocumentsDocument = gql`
    query LotAcqSettlementStatementDocuments($documentIds: [ID!]!) {
  documents(filter: {id: $documentIds}) {
    id
    parent {
      ... on Lot {
        ...LotAcqLot
      }
    }
    asset {
      ...AssetInfo
    }
    lotAcqSettlementStatement {
      ...LotAcqLotAcqSettlementStatement
    }
  }
}
    ${LotAcqLotFragmentDoc}
${AssetInfoFragmentDoc}
${LotAcqLotAcqSettlementStatementFragmentDoc}`;

/**
 * __useLotAcqSettlementStatementDocumentsQuery__
 *
 * To run a query within a React component, call `useLotAcqSettlementStatementDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotAcqSettlementStatementDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotAcqSettlementStatementDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function useLotAcqSettlementStatementDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotAcqSettlementStatementDocumentsQuery, LotAcqSettlementStatementDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotAcqSettlementStatementDocumentsQuery, LotAcqSettlementStatementDocumentsQueryVariables>(LotAcqSettlementStatementDocumentsDocument, options);
      }
export function useLotAcqSettlementStatementDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotAcqSettlementStatementDocumentsQuery, LotAcqSettlementStatementDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotAcqSettlementStatementDocumentsQuery, LotAcqSettlementStatementDocumentsQueryVariables>(LotAcqSettlementStatementDocumentsDocument, options);
        }
export type LotAcqSettlementStatementDocumentsQueryHookResult = ReturnType<typeof useLotAcqSettlementStatementDocumentsQuery>;
export type LotAcqSettlementStatementDocumentsLazyQueryHookResult = ReturnType<typeof useLotAcqSettlementStatementDocumentsLazyQuery>;
export type LotAcqSettlementStatementDocumentsQueryResult = Apollo.QueryResult<LotAcqSettlementStatementDocumentsQuery, LotAcqSettlementStatementDocumentsQueryVariables>;
export const LotPartitionDocumentsDocument = gql`
    query LotPartitionDocuments($lotPartitionId: ID!) {
  documents(filter: {parentIds: [$lotPartitionId]}) {
    ...LotPartitionDocuments_Document
  }
  lotPartitions(filter: {id: [$lotPartitionId]}) {
    ...LotPartitionDocuments_LotPartition
  }
}
    ${LotPartitionDocuments_DocumentFragmentDoc}
${LotPartitionDocuments_LotPartitionFragmentDoc}`;

/**
 * __useLotPartitionDocumentsQuery__
 *
 * To run a query within a React component, call `useLotPartitionDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotPartitionDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotPartitionDocumentsQuery({
 *   variables: {
 *      lotPartitionId: // value for 'lotPartitionId'
 *   },
 * });
 */
export function useLotPartitionDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotPartitionDocumentsQuery, LotPartitionDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotPartitionDocumentsQuery, LotPartitionDocumentsQueryVariables>(LotPartitionDocumentsDocument, options);
      }
export function useLotPartitionDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotPartitionDocumentsQuery, LotPartitionDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotPartitionDocumentsQuery, LotPartitionDocumentsQueryVariables>(LotPartitionDocumentsDocument, options);
        }
export type LotPartitionDocumentsQueryHookResult = ReturnType<typeof useLotPartitionDocumentsQuery>;
export type LotPartitionDocumentsLazyQueryHookResult = ReturnType<typeof useLotPartitionDocumentsLazyQuery>;
export type LotPartitionDocumentsQueryResult = Apollo.QueryResult<LotPartitionDocumentsQuery, LotPartitionDocumentsQueryVariables>;
export const SaveLotPartitionDocumentsDocument = gql`
    mutation SaveLotPartitionDocuments($input: SaveDocumentsInput!) {
  saveDocuments(input: $input) {
    documents {
      ...LotPartitionDocuments_Document
    }
  }
}
    ${LotPartitionDocuments_DocumentFragmentDoc}`;
export type SaveLotPartitionDocumentsMutationFn = Apollo.MutationFunction<SaveLotPartitionDocumentsMutation, SaveLotPartitionDocumentsMutationVariables>;

/**
 * __useSaveLotPartitionDocumentsMutation__
 *
 * To run a mutation, you first call `useSaveLotPartitionDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotPartitionDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotPartitionDocumentsMutation, { data, loading, error }] = useSaveLotPartitionDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotPartitionDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotPartitionDocumentsMutation, SaveLotPartitionDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotPartitionDocumentsMutation, SaveLotPartitionDocumentsMutationVariables>(SaveLotPartitionDocumentsDocument, options);
      }
export type SaveLotPartitionDocumentsMutationHookResult = ReturnType<typeof useSaveLotPartitionDocumentsMutation>;
export type SaveLotPartitionDocumentsMutationResult = Apollo.MutationResult<SaveLotPartitionDocumentsMutation>;
export type SaveLotPartitionDocumentsMutationOptions = Apollo.BaseMutationOptions<SaveLotPartitionDocumentsMutation, SaveLotPartitionDocumentsMutationVariables>;
export const SavePropertySaleSettlementStatementDocument = gql`
    mutation SavePropertySaleSettlementStatement($input: SavePropertySaleSettlementStatementInput!) {
  savePropertySaleSettlementStatement(input: $input) {
    propertySaleSettlementStatement {
      id
    }
  }
}
    `;
export type SavePropertySaleSettlementStatementMutationFn = Apollo.MutationFunction<SavePropertySaleSettlementStatementMutation, SavePropertySaleSettlementStatementMutationVariables>;

/**
 * __useSavePropertySaleSettlementStatementMutation__
 *
 * To run a mutation, you first call `useSavePropertySaleSettlementStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePropertySaleSettlementStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePropertySaleSettlementStatementMutation, { data, loading, error }] = useSavePropertySaleSettlementStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePropertySaleSettlementStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePropertySaleSettlementStatementMutation, SavePropertySaleSettlementStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePropertySaleSettlementStatementMutation, SavePropertySaleSettlementStatementMutationVariables>(SavePropertySaleSettlementStatementDocument, options);
      }
export type SavePropertySaleSettlementStatementMutationHookResult = ReturnType<typeof useSavePropertySaleSettlementStatementMutation>;
export type SavePropertySaleSettlementStatementMutationResult = Apollo.MutationResult<SavePropertySaleSettlementStatementMutation>;
export type SavePropertySaleSettlementStatementMutationOptions = Apollo.BaseMutationOptions<SavePropertySaleSettlementStatementMutation, SavePropertySaleSettlementStatementMutationVariables>;
export const LotOverviewLotDocument = gql`
    query LotOverviewLot($lotId: ID!) {
  lots(filter: {id: $lotId}) {
    ...LotOverviewPageLot
  }
}
    ${LotOverviewPageLotFragmentDoc}`;

/**
 * __useLotOverviewLotQuery__
 *
 * To run a query within a React component, call `useLotOverviewLotQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotOverviewLotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotOverviewLotQuery({
 *   variables: {
 *      lotId: // value for 'lotId'
 *   },
 * });
 */
export function useLotOverviewLotQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotOverviewLotQuery, LotOverviewLotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotOverviewLotQuery, LotOverviewLotQueryVariables>(LotOverviewLotDocument, options);
      }
export function useLotOverviewLotLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotOverviewLotQuery, LotOverviewLotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotOverviewLotQuery, LotOverviewLotQueryVariables>(LotOverviewLotDocument, options);
        }
export type LotOverviewLotQueryHookResult = ReturnType<typeof useLotOverviewLotQuery>;
export type LotOverviewLotLazyQueryHookResult = ReturnType<typeof useLotOverviewLotLazyQuery>;
export type LotOverviewLotQueryResult = Apollo.QueryResult<LotOverviewLotQuery, LotOverviewLotQueryVariables>;
export const SaveLotPartitionsDocument = gql`
    mutation SaveLotPartitions($input: SaveLotPartitionsInput!) {
  saveLotPartitions(input: $input) {
    lotPartitions {
      ...LotPartition
    }
  }
}
    ${LotPartitionFragmentDoc}`;
export type SaveLotPartitionsMutationFn = Apollo.MutationFunction<SaveLotPartitionsMutation, SaveLotPartitionsMutationVariables>;

/**
 * __useSaveLotPartitionsMutation__
 *
 * To run a mutation, you first call `useSaveLotPartitionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveLotPartitionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveLotPartitionsMutation, { data, loading, error }] = useSaveLotPartitionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveLotPartitionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveLotPartitionsMutation, SaveLotPartitionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveLotPartitionsMutation, SaveLotPartitionsMutationVariables>(SaveLotPartitionsDocument, options);
      }
export type SaveLotPartitionsMutationHookResult = ReturnType<typeof useSaveLotPartitionsMutation>;
export type SaveLotPartitionsMutationResult = Apollo.MutationResult<SaveLotPartitionsMutation>;
export type SaveLotPartitionsMutationOptions = Apollo.BaseMutationOptions<SaveLotPartitionsMutation, SaveLotPartitionsMutationVariables>;
export const SaveDocumentsDocument = gql`
    mutation SaveDocuments($input: SaveDocumentsInput!) {
  saveDocuments(input: $input) {
    documents {
      ...LotOverviewPageLotDocument
    }
  }
}
    ${LotOverviewPageLotDocumentFragmentDoc}`;
export type SaveDocumentsMutationFn = Apollo.MutationFunction<SaveDocumentsMutation, SaveDocumentsMutationVariables>;

/**
 * __useSaveDocumentsMutation__
 *
 * To run a mutation, you first call `useSaveDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDocumentsMutation, { data, loading, error }] = useSaveDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDocumentsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDocumentsMutation, SaveDocumentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDocumentsMutation, SaveDocumentsMutationVariables>(SaveDocumentsDocument, options);
      }
export type SaveDocumentsMutationHookResult = ReturnType<typeof useSaveDocumentsMutation>;
export type SaveDocumentsMutationResult = Apollo.MutationResult<SaveDocumentsMutation>;
export type SaveDocumentsMutationOptions = Apollo.BaseMutationOptions<SaveDocumentsMutation, SaveDocumentsMutationVariables>;
export const LotDocumentsDocument = gql`
    query LotDocuments($lotId: ID!) {
  lots(filter: {id: $lotId}) {
    ...LotOverviewPageLotDocumentsLot
  }
}
    ${LotOverviewPageLotDocumentsLotFragmentDoc}`;

/**
 * __useLotDocumentsQuery__
 *
 * To run a query within a React component, call `useLotDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useLotDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLotDocumentsQuery({
 *   variables: {
 *      lotId: // value for 'lotId'
 *   },
 * });
 */
export function useLotDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<LotDocumentsQuery, LotDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<LotDocumentsQuery, LotDocumentsQueryVariables>(LotDocumentsDocument, options);
      }
export function useLotDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<LotDocumentsQuery, LotDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<LotDocumentsQuery, LotDocumentsQueryVariables>(LotDocumentsDocument, options);
        }
export type LotDocumentsQueryHookResult = ReturnType<typeof useLotDocumentsQuery>;
export type LotDocumentsLazyQueryHookResult = ReturnType<typeof useLotDocumentsLazyQuery>;
export type LotDocumentsQueryResult = Apollo.QueryResult<LotDocumentsQuery, LotDocumentsQueryVariables>;
export const CreateDirectUnderwritingContractsDocument = gql`
    mutation CreateDirectUnderwritingContracts($input: CreateDirectUnderwritingContractsInput!) {
  createDirectUnderwritingContracts(input: $input) {
    lot {
      ...LotOverviewPageLot
    }
  }
}
    ${LotOverviewPageLotFragmentDoc}`;
export type CreateDirectUnderwritingContractsMutationFn = Apollo.MutationFunction<CreateDirectUnderwritingContractsMutation, CreateDirectUnderwritingContractsMutationVariables>;

/**
 * __useCreateDirectUnderwritingContractsMutation__
 *
 * To run a mutation, you first call `useCreateDirectUnderwritingContractsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDirectUnderwritingContractsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDirectUnderwritingContractsMutation, { data, loading, error }] = useCreateDirectUnderwritingContractsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDirectUnderwritingContractsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateDirectUnderwritingContractsMutation, CreateDirectUnderwritingContractsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateDirectUnderwritingContractsMutation, CreateDirectUnderwritingContractsMutationVariables>(CreateDirectUnderwritingContractsDocument, options);
      }
export type CreateDirectUnderwritingContractsMutationHookResult = ReturnType<typeof useCreateDirectUnderwritingContractsMutation>;
export type CreateDirectUnderwritingContractsMutationResult = Apollo.MutationResult<CreateDirectUnderwritingContractsMutation>;
export type CreateDirectUnderwritingContractsMutationOptions = Apollo.BaseMutationOptions<CreateDirectUnderwritingContractsMutation, CreateDirectUnderwritingContractsMutationVariables>;
export const SavePropertySaleSettlementStatementEditorDocument = gql`
    mutation SavePropertySaleSettlementStatementEditor($input: SavePropertySaleSettlementStatementInput!) {
  savePropertySaleSettlementStatement(input: $input) {
    propertySaleSettlementStatement {
      ...PropertySaleSettlementStatement
    }
  }
}
    ${PropertySaleSettlementStatementFragmentDoc}`;
export type SavePropertySaleSettlementStatementEditorMutationFn = Apollo.MutationFunction<SavePropertySaleSettlementStatementEditorMutation, SavePropertySaleSettlementStatementEditorMutationVariables>;

/**
 * __useSavePropertySaleSettlementStatementEditorMutation__
 *
 * To run a mutation, you first call `useSavePropertySaleSettlementStatementEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePropertySaleSettlementStatementEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePropertySaleSettlementStatementEditorMutation, { data, loading, error }] = useSavePropertySaleSettlementStatementEditorMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSavePropertySaleSettlementStatementEditorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SavePropertySaleSettlementStatementEditorMutation, SavePropertySaleSettlementStatementEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SavePropertySaleSettlementStatementEditorMutation, SavePropertySaleSettlementStatementEditorMutationVariables>(SavePropertySaleSettlementStatementEditorDocument, options);
      }
export type SavePropertySaleSettlementStatementEditorMutationHookResult = ReturnType<typeof useSavePropertySaleSettlementStatementEditorMutation>;
export type SavePropertySaleSettlementStatementEditorMutationResult = Apollo.MutationResult<SavePropertySaleSettlementStatementEditorMutation>;
export type SavePropertySaleSettlementStatementEditorMutationOptions = Apollo.BaseMutationOptions<SavePropertySaleSettlementStatementEditorMutation, SavePropertySaleSettlementStatementEditorMutationVariables>;
export const DeletePropertySaleSettlementStatementDocument = gql`
    mutation DeletePropertySaleSettlementStatement($input: DeleteEntityInput!) {
  deletePropertySaleSettlementStatement(input: $input) {
    emptyResult
  }
}
    `;
export type DeletePropertySaleSettlementStatementMutationFn = Apollo.MutationFunction<DeletePropertySaleSettlementStatementMutation, DeletePropertySaleSettlementStatementMutationVariables>;

/**
 * __useDeletePropertySaleSettlementStatementMutation__
 *
 * To run a mutation, you first call `useDeletePropertySaleSettlementStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertySaleSettlementStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertySaleSettlementStatementMutation, { data, loading, error }] = useDeletePropertySaleSettlementStatementMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePropertySaleSettlementStatementMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeletePropertySaleSettlementStatementMutation, DeletePropertySaleSettlementStatementMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeletePropertySaleSettlementStatementMutation, DeletePropertySaleSettlementStatementMutationVariables>(DeletePropertySaleSettlementStatementDocument, options);
      }
export type DeletePropertySaleSettlementStatementMutationHookResult = ReturnType<typeof useDeletePropertySaleSettlementStatementMutation>;
export type DeletePropertySaleSettlementStatementMutationResult = Apollo.MutationResult<DeletePropertySaleSettlementStatementMutation>;
export type DeletePropertySaleSettlementStatementMutationOptions = Apollo.BaseMutationOptions<DeletePropertySaleSettlementStatementMutation, DeletePropertySaleSettlementStatementMutationVariables>;
export const SendPropertySaleSettlementStatementForBookingDocument = gql`
    mutation SendPropertySaleSettlementStatementForBooking($input: SendPropertySaleSettlementStatementForBookingInput!) {
  sendPropertySaleSettlementStatementForBooking(input: $input) {
    ...PropertySaleSettlementStatement
  }
}
    ${PropertySaleSettlementStatementFragmentDoc}`;
export type SendPropertySaleSettlementStatementForBookingMutationFn = Apollo.MutationFunction<SendPropertySaleSettlementStatementForBookingMutation, SendPropertySaleSettlementStatementForBookingMutationVariables>;

/**
 * __useSendPropertySaleSettlementStatementForBookingMutation__
 *
 * To run a mutation, you first call `useSendPropertySaleSettlementStatementForBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPropertySaleSettlementStatementForBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPropertySaleSettlementStatementForBookingMutation, { data, loading, error }] = useSendPropertySaleSettlementStatementForBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendPropertySaleSettlementStatementForBookingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SendPropertySaleSettlementStatementForBookingMutation, SendPropertySaleSettlementStatementForBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SendPropertySaleSettlementStatementForBookingMutation, SendPropertySaleSettlementStatementForBookingMutationVariables>(SendPropertySaleSettlementStatementForBookingDocument, options);
      }
export type SendPropertySaleSettlementStatementForBookingMutationHookResult = ReturnType<typeof useSendPropertySaleSettlementStatementForBookingMutation>;
export type SendPropertySaleSettlementStatementForBookingMutationResult = Apollo.MutationResult<SendPropertySaleSettlementStatementForBookingMutation>;
export type SendPropertySaleSettlementStatementForBookingMutationOptions = Apollo.BaseMutationOptions<SendPropertySaleSettlementStatementForBookingMutation, SendPropertySaleSettlementStatementForBookingMutationVariables>;
export const PropertySaleSettlementStatementDocumentsDocument = gql`
    query PropertySaleSettlementStatementDocuments($documentIds: [ID!]!) {
  documents(filter: {id: $documentIds}) {
    id
    parent {
      ... on LotPartition {
        ...PropertySaleSettlementStatement_LotPartition
      }
    }
    asset {
      ...AssetInfo
    }
    propertySaleSettlementStatement {
      ...PropertySaleSettlementStatement
    }
  }
}
    ${PropertySaleSettlementStatement_LotPartitionFragmentDoc}
${AssetInfoFragmentDoc}
${PropertySaleSettlementStatementFragmentDoc}`;

/**
 * __usePropertySaleSettlementStatementDocumentsQuery__
 *
 * To run a query within a React component, call `usePropertySaleSettlementStatementDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertySaleSettlementStatementDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertySaleSettlementStatementDocumentsQuery({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *   },
 * });
 */
export function usePropertySaleSettlementStatementDocumentsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PropertySaleSettlementStatementDocumentsQuery, PropertySaleSettlementStatementDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PropertySaleSettlementStatementDocumentsQuery, PropertySaleSettlementStatementDocumentsQueryVariables>(PropertySaleSettlementStatementDocumentsDocument, options);
      }
export function usePropertySaleSettlementStatementDocumentsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PropertySaleSettlementStatementDocumentsQuery, PropertySaleSettlementStatementDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PropertySaleSettlementStatementDocumentsQuery, PropertySaleSettlementStatementDocumentsQueryVariables>(PropertySaleSettlementStatementDocumentsDocument, options);
        }
export type PropertySaleSettlementStatementDocumentsQueryHookResult = ReturnType<typeof usePropertySaleSettlementStatementDocumentsQuery>;
export type PropertySaleSettlementStatementDocumentsLazyQueryHookResult = ReturnType<typeof usePropertySaleSettlementStatementDocumentsLazyQuery>;
export type PropertySaleSettlementStatementDocumentsQueryResult = Apollo.QueryResult<PropertySaleSettlementStatementDocumentsQuery, PropertySaleSettlementStatementDocumentsQueryVariables>;
import { newDate, newDateTime } from "src/utils/tests/testDates";

const factories: Record<string, Function> = {};
export interface AddressOptions {
  __typename?: "Address";
  id?: Address["id"];
  street1?: Address["street1"];
  street2?: Address["street2"];
  city?: Address["city"];
  state?: Address["state"];
  postalCode?: Address["postalCode"];
  country?: Address["country"];
  createdAt?: Address["createdAt"];
  updatedAt?: Address["updatedAt"];
}

export function newAddress(options: AddressOptions = {}, cache: Record<string, any> = {}): Address {
  const o = (options.__typename ? options : cache["Address"] = {}) as Address;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Address";
  o.id = options.id ?? nextFactoryId("Address");
  o.street1 = options.street1 ?? "street1";
  o.street2 = options.street2 ?? null;
  o.city = options.city ?? "city";
  o.state = options.state ?? "state";
  o.postalCode = options.postalCode ?? "postalCode";
  o.country = options.country ?? "country";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["Address"] = newAddress;

export interface SaveAddressResultOptions {
  __typename?: "SaveAddressResult";
  address?: AddressOptions;
}

export function newSaveAddressResult(
  options: SaveAddressResultOptions = {},
  cache: Record<string, any> = {},
): SaveAddressResult {
  const o = (options.__typename ? options : cache["SaveAddressResult"] = {}) as SaveAddressResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAddressResult";
  o.address = maybeNew("Address", options.address, cache, options.hasOwnProperty("address"));
  return o;
}

factories["SaveAddressResult"] = newSaveAddressResult;

export interface AnchorFloatingDrawModelOptions {
  __typename?: "AnchorFloatingDrawModel";
  id?: AnchorFloatingDrawModel["id"];
  asOfDate?: AnchorFloatingDrawModel["asOfDate"];
  isBlueprintCostDataSet?: AnchorFloatingDrawModel["isBlueprintCostDataSet"];
  lotPartition?: LotPartitionOptions;
  lotPartitionDrawRequest?: LotPartitionDrawRequestOptions | null;
  costItems?: Array<AnchorFloatingDrawModelCostItemOptions>;
  completedSoftCostsInCents?: AnchorFloatingDrawModel["completedSoftCostsInCents"];
  completedIndirectCostsInCents?: AnchorFloatingDrawModel["completedIndirectCostsInCents"];
  completedDirectCostsInCents?: AnchorFloatingDrawModel["completedDirectCostsInCents"];
  completedBuilderFeeInCents?: AnchorFloatingDrawModel["completedBuilderFeeInCents"];
  completedConstructionExpensesInCents?: AnchorFloatingDrawModel["completedConstructionExpensesInCents"];
}

export function newAnchorFloatingDrawModel(
  options: AnchorFloatingDrawModelOptions = {},
  cache: Record<string, any> = {},
): AnchorFloatingDrawModel {
  const o = (options.__typename ? options : cache["AnchorFloatingDrawModel"] = {}) as AnchorFloatingDrawModel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnchorFloatingDrawModel";
  o.id = options.id ?? nextFactoryId("AnchorFloatingDrawModel");
  o.asOfDate = options.asOfDate ?? newDate();
  o.isBlueprintCostDataSet = options.isBlueprintCostDataSet ?? null;
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.lotPartitionDrawRequest = maybeNewOrNull("LotPartitionDrawRequest", options.lotPartitionDrawRequest, cache);
  o.costItems = (options.costItems ?? []).map((i) =>
    maybeNew("AnchorFloatingDrawModelCostItem", i, cache, options.hasOwnProperty("costItems"))
  );
  o.completedSoftCostsInCents = options.completedSoftCostsInCents ?? 0;
  o.completedIndirectCostsInCents = options.completedIndirectCostsInCents ?? 0;
  o.completedDirectCostsInCents = options.completedDirectCostsInCents ?? 0;
  o.completedBuilderFeeInCents = options.completedBuilderFeeInCents ?? 0;
  o.completedConstructionExpensesInCents = options.completedConstructionExpensesInCents ?? 0;
  return o;
}

factories["AnchorFloatingDrawModel"] = newAnchorFloatingDrawModel;

export interface SaveAnchorFloatingDrawModelResultOptions {
  __typename?: "SaveAnchorFloatingDrawModelResult";
  anchorFloatingDrawModel?: AnchorFloatingDrawModelOptions;
}

export function newSaveAnchorFloatingDrawModelResult(
  options: SaveAnchorFloatingDrawModelResultOptions = {},
  cache: Record<string, any> = {},
): SaveAnchorFloatingDrawModelResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveAnchorFloatingDrawModelResult"] = {}) as SaveAnchorFloatingDrawModelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAnchorFloatingDrawModelResult";
  o.anchorFloatingDrawModel = maybeNew(
    "AnchorFloatingDrawModel",
    options.anchorFloatingDrawModel,
    cache,
    options.hasOwnProperty("anchorFloatingDrawModel"),
  );
  return o;
}

factories["SaveAnchorFloatingDrawModelResult"] = newSaveAnchorFloatingDrawModelResult;

export interface AnchorFloatingDrawModelCostItemOptions {
  __typename?: "AnchorFloatingDrawModelCostItem";
  id?: AnchorFloatingDrawModelCostItem["id"];
  amountInCents?: AnchorFloatingDrawModelCostItem["amountInCents"];
  builderFeeInCents?: AnchorFloatingDrawModelCostItem["builderFeeInCents"];
  fullCostCodeNumber?: AnchorFloatingDrawModelCostItem["fullCostCodeNumber"];
  costType?: CostTypeDetailOptions | CostType;
  anchorFloatingDrawModel?: AnchorFloatingDrawModelOptions;
  date?: AnchorFloatingDrawModelCostItem["date"];
}

export function newAnchorFloatingDrawModelCostItem(
  options: AnchorFloatingDrawModelCostItemOptions = {},
  cache: Record<string, any> = {},
): AnchorFloatingDrawModelCostItem {
  const o =
    (options.__typename ? options : cache["AnchorFloatingDrawModelCostItem"] = {}) as AnchorFloatingDrawModelCostItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnchorFloatingDrawModelCostItem";
  o.id = options.id ?? nextFactoryId("AnchorFloatingDrawModelCostItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.builderFeeInCents = options.builderFeeInCents ?? 0;
  o.fullCostCodeNumber = options.fullCostCodeNumber ?? "fullCostCodeNumber";
  o.costType = enumOrDetailOfCostType(options.costType);
  o.anchorFloatingDrawModel = maybeNew(
    "AnchorFloatingDrawModel",
    options.anchorFloatingDrawModel,
    cache,
    options.hasOwnProperty("anchorFloatingDrawModel"),
  );
  o.date = options.date ?? newDate();
  return o;
}

factories["AnchorFloatingDrawModelCostItem"] = newAnchorFloatingDrawModelCostItem;

export interface SaveAnchorFloatingDrawModelCostItemResultOptions {
  __typename?: "SaveAnchorFloatingDrawModelCostItemResult";
  anchorFloatingDrawModelCostItem?: AnchorFloatingDrawModelCostItemOptions;
}

export function newSaveAnchorFloatingDrawModelCostItemResult(
  options: SaveAnchorFloatingDrawModelCostItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveAnchorFloatingDrawModelCostItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveAnchorFloatingDrawModelCostItemResult"] = {}) as SaveAnchorFloatingDrawModelCostItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAnchorFloatingDrawModelCostItemResult";
  o.anchorFloatingDrawModelCostItem = maybeNew(
    "AnchorFloatingDrawModelCostItem",
    options.anchorFloatingDrawModelCostItem,
    cache,
    options.hasOwnProperty("anchorFloatingDrawModelCostItem"),
  );
  return o;
}

factories["SaveAnchorFloatingDrawModelCostItemResult"] = newSaveAnchorFloatingDrawModelCostItemResult;

export interface AnchorMultilotDrawModelOptions {
  __typename?: "AnchorMultilotDrawModel";
  id?: AnchorMultilotDrawModel["id"];
  realizedSoftCostsInCents?: AnchorMultilotDrawModel["realizedSoftCostsInCents"];
  realizedIndirectCostsInCents?: AnchorMultilotDrawModel["realizedIndirectCostsInCents"];
  realizedDirectCostsInCents?: AnchorMultilotDrawModel["realizedDirectCostsInCents"];
  realizedBuilderFeeInCents?: AnchorMultilotDrawModel["realizedBuilderFeeInCents"];
  realizedConstructionExpensesInCents?: AnchorMultilotDrawModel["realizedConstructionExpensesInCents"];
  lotPartition?: LotPartitionOptions;
  costItems?: Array<AnchorMultilotDrawModelCostItemOptions>;
  asOfDate?: AnchorMultilotDrawModel["asOfDate"];
  isBlueprintCostDataSet?: AnchorMultilotDrawModel["isBlueprintCostDataSet"];
  lotPartitionDrawRequest?: LotPartitionDrawRequestOptions | null;
}

export function newAnchorMultilotDrawModel(
  options: AnchorMultilotDrawModelOptions = {},
  cache: Record<string, any> = {},
): AnchorMultilotDrawModel {
  const o = (options.__typename ? options : cache["AnchorMultilotDrawModel"] = {}) as AnchorMultilotDrawModel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnchorMultilotDrawModel";
  o.id = options.id ?? nextFactoryId("AnchorMultilotDrawModel");
  o.realizedSoftCostsInCents = options.realizedSoftCostsInCents ?? 0;
  o.realizedIndirectCostsInCents = options.realizedIndirectCostsInCents ?? 0;
  o.realizedDirectCostsInCents = options.realizedDirectCostsInCents ?? 0;
  o.realizedBuilderFeeInCents = options.realizedBuilderFeeInCents ?? 0;
  o.realizedConstructionExpensesInCents = options.realizedConstructionExpensesInCents ?? 0;
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.costItems = (options.costItems ?? []).map((i) =>
    maybeNew("AnchorMultilotDrawModelCostItem", i, cache, options.hasOwnProperty("costItems"))
  );
  o.asOfDate = options.asOfDate ?? newDate();
  o.isBlueprintCostDataSet = options.isBlueprintCostDataSet ?? null;
  o.lotPartitionDrawRequest = maybeNewOrNull("LotPartitionDrawRequest", options.lotPartitionDrawRequest, cache);
  return o;
}

factories["AnchorMultilotDrawModel"] = newAnchorMultilotDrawModel;

export interface SaveAnchorMultilotDrawModelResultOptions {
  __typename?: "SaveAnchorMultilotDrawModelResult";
  anchorMultilotDrawModel?: AnchorMultilotDrawModelOptions;
}

export function newSaveAnchorMultilotDrawModelResult(
  options: SaveAnchorMultilotDrawModelResultOptions = {},
  cache: Record<string, any> = {},
): SaveAnchorMultilotDrawModelResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveAnchorMultilotDrawModelResult"] = {}) as SaveAnchorMultilotDrawModelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAnchorMultilotDrawModelResult";
  o.anchorMultilotDrawModel = maybeNew(
    "AnchorMultilotDrawModel",
    options.anchorMultilotDrawModel,
    cache,
    options.hasOwnProperty("anchorMultilotDrawModel"),
  );
  return o;
}

factories["SaveAnchorMultilotDrawModelResult"] = newSaveAnchorMultilotDrawModelResult;

export interface AnchorMultilotDrawModelCostItemOptions {
  __typename?: "AnchorMultilotDrawModelCostItem";
  id?: AnchorMultilotDrawModelCostItem["id"];
  amountInCents?: AnchorMultilotDrawModelCostItem["amountInCents"];
  fullCostCodeNumber?: AnchorMultilotDrawModelCostItem["fullCostCodeNumber"];
  costType?: CostTypeDetailOptions | CostType;
  anchorMultilotDrawModel?: AnchorMultilotDrawModelOptions;
  builderFeeInCents?: AnchorMultilotDrawModelCostItem["builderFeeInCents"];
  date?: AnchorMultilotDrawModelCostItem["date"];
  billNumber?: AnchorMultilotDrawModelCostItem["billNumber"];
}

export function newAnchorMultilotDrawModelCostItem(
  options: AnchorMultilotDrawModelCostItemOptions = {},
  cache: Record<string, any> = {},
): AnchorMultilotDrawModelCostItem {
  const o =
    (options.__typename ? options : cache["AnchorMultilotDrawModelCostItem"] = {}) as AnchorMultilotDrawModelCostItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AnchorMultilotDrawModelCostItem";
  o.id = options.id ?? nextFactoryId("AnchorMultilotDrawModelCostItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.fullCostCodeNumber = options.fullCostCodeNumber ?? "fullCostCodeNumber";
  o.costType = enumOrDetailOfCostType(options.costType);
  o.anchorMultilotDrawModel = maybeNew(
    "AnchorMultilotDrawModel",
    options.anchorMultilotDrawModel,
    cache,
    options.hasOwnProperty("anchorMultilotDrawModel"),
  );
  o.builderFeeInCents = options.builderFeeInCents ?? 0;
  o.date = options.date ?? newDate();
  o.billNumber = options.billNumber ?? null;
  return o;
}

factories["AnchorMultilotDrawModelCostItem"] = newAnchorMultilotDrawModelCostItem;

export interface SaveAnchorMultilotDrawModelCostItemResultOptions {
  __typename?: "SaveAnchorMultilotDrawModelCostItemResult";
  anchorMultilotDrawModelCostItem?: AnchorMultilotDrawModelCostItemOptions;
}

export function newSaveAnchorMultilotDrawModelCostItemResult(
  options: SaveAnchorMultilotDrawModelCostItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveAnchorMultilotDrawModelCostItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveAnchorMultilotDrawModelCostItemResult"] = {}) as SaveAnchorMultilotDrawModelCostItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveAnchorMultilotDrawModelCostItemResult";
  o.anchorMultilotDrawModelCostItem = maybeNew(
    "AnchorMultilotDrawModelCostItem",
    options.anchorMultilotDrawModelCostItem,
    cache,
    options.hasOwnProperty("anchorMultilotDrawModelCostItem"),
  );
  return o;
}

factories["SaveAnchorMultilotDrawModelCostItemResult"] = newSaveAnchorMultilotDrawModelCostItemResult;

export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
  document?: DocumentOptions | null;
}

export function newAsset(options: AssetOptions = {}, cache: Record<string, any> = {}): Asset {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Asset";
  o.id = options.id ?? nextFactoryId("Asset");
  o.contentType = options.contentType ?? "contentType";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  o.url = options.url ?? "url";
  o.fileName = options.fileName ?? null;
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.version = options.version ?? "version";
  o.document = maybeNewOrNull("Document", options.document, cache);
  return o;
}

factories["Asset"] = newAsset;

export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetUploadUrlResult {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetUploadUrlResult";
  o.s3Key = options.s3Key ?? "s3Key";
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  return o;
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

export interface ConfigurationOptions {
  __typename?: "Configuration";
  id?: Configuration["id"];
  airtableId?: Configuration["airtableId"];
  code?: Configuration["code"];
  name?: Configuration["name"];
  email?: Configuration["email"];
  createdAt?: Configuration["createdAt"];
  updatedAt?: Configuration["updatedAt"];
  elevation?: ElevationOptions;
  elevationStyle?: ElevationStyleOptions;
  plan?: PlanOptions;
  specLevel?: SpecLevelOptions;
  specLevelStyle?: SpecLevelStyleOptions;
  toOptions?: Array<ConfigurationToOptionOptions>;
  completedDate?: Configuration["completedDate"];
  address?: Configuration["address"];
  phoneNumber?: Configuration["phoneNumber"];
}

export function newConfiguration(options: ConfigurationOptions = {}, cache: Record<string, any> = {}): Configuration {
  const o = (options.__typename ? options : cache["Configuration"] = {}) as Configuration;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Configuration";
  o.id = options.id ?? nextFactoryId("Configuration");
  o.airtableId = options.airtableId ?? "airtableId";
  o.code = options.code ?? "code";
  o.name = options.name ?? null;
  o.email = options.email ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNew("Elevation", options.elevation, cache, options.hasOwnProperty("elevation"));
  o.elevationStyle = maybeNew(
    "ElevationStyle",
    options.elevationStyle,
    cache,
    options.hasOwnProperty("elevationStyle"),
  );
  o.plan = maybeNew("Plan", options.plan, cache, options.hasOwnProperty("plan"));
  o.specLevel = maybeNew("SpecLevel", options.specLevel, cache, options.hasOwnProperty("specLevel"));
  o.specLevelStyle = maybeNew(
    "SpecLevelStyle",
    options.specLevelStyle,
    cache,
    options.hasOwnProperty("specLevelStyle"),
  );
  o.toOptions = (options.toOptions ?? []).map((i) =>
    maybeNew("ConfigurationToOption", i, cache, options.hasOwnProperty("toOptions"))
  );
  o.completedDate = options.completedDate ?? null;
  o.address = options.address ?? null;
  o.phoneNumber = options.phoneNumber ?? null;
  return o;
}

factories["Configuration"] = newConfiguration;

export interface SaveConfigurationResultOptions {
  __typename?: "SaveConfigurationResult";
  configuration?: ConfigurationOptions;
}

export function newSaveConfigurationResult(
  options: SaveConfigurationResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationResult {
  const o = (options.__typename ? options : cache["SaveConfigurationResult"] = {}) as SaveConfigurationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationResult";
  o.configuration = maybeNew("Configuration", options.configuration, cache, options.hasOwnProperty("configuration"));
  return o;
}

factories["SaveConfigurationResult"] = newSaveConfigurationResult;

export interface ConfigurationToOptionOptions {
  __typename?: "ConfigurationToOption";
  id?: ConfigurationToOption["id"];
  createdAt?: ConfigurationToOption["createdAt"];
  airtableId?: ConfigurationToOption["airtableId"];
  updatedAt?: ConfigurationToOption["updatedAt"];
  configuration?: ConfigurationOptions;
  option?: OptionOptions;
}

export function newConfigurationToOption(
  options: ConfigurationToOptionOptions = {},
  cache: Record<string, any> = {},
): ConfigurationToOption {
  const o = (options.__typename ? options : cache["ConfigurationToOption"] = {}) as ConfigurationToOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConfigurationToOption";
  o.id = options.id ?? nextFactoryId("ConfigurationToOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.airtableId = options.airtableId ?? "airtableId";
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.configuration = maybeNew("Configuration", options.configuration, cache, options.hasOwnProperty("configuration"));
  o.option = maybeNew("Option", options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["ConfigurationToOption"] = newConfigurationToOption;

export interface SaveConfigurationToOptionResultOptions {
  __typename?: "SaveConfigurationToOptionResult";
  configurationToOption?: ConfigurationToOptionOptions;
}

export function newSaveConfigurationToOptionResult(
  options: SaveConfigurationToOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationToOptionResult {
  const o =
    (options.__typename ? options : cache["SaveConfigurationToOptionResult"] = {}) as SaveConfigurationToOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationToOptionResult";
  o.configurationToOption = maybeNew(
    "ConfigurationToOption",
    options.configurationToOption,
    cache,
    options.hasOwnProperty("configurationToOption"),
  );
  return o;
}

factories["SaveConfigurationToOptionResult"] = newSaveConfigurationToOptionResult;

export interface SaveConfigurationToOptionsResultOptions {
  __typename?: "SaveConfigurationToOptionsResult";
  configurationToOptions?: Array<ConfigurationToOptionOptions>;
}

export function newSaveConfigurationToOptionsResult(
  options: SaveConfigurationToOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationToOptionsResult {
  const o =
    (options.__typename ? options : cache["SaveConfigurationToOptionsResult"] = {}) as SaveConfigurationToOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationToOptionsResult";
  o.configurationToOptions = (options.configurationToOptions ?? []).map((i) =>
    maybeNew("ConfigurationToOption", i, cache, options.hasOwnProperty("configurationToOptions"))
  );
  return o;
}

factories["SaveConfigurationToOptionsResult"] = newSaveConfigurationToOptionsResult;

export interface CreditFacilityDrawOptions {
  __typename?: "CreditFacilityDraw";
  id?: CreditFacilityDraw["id"];
  drawDate?: CreditFacilityDraw["drawDate"];
  amountInCents?: CreditFacilityDraw["amountInCents"];
  createdAt?: CreditFacilityDraw["createdAt"];
  updatedAt?: CreditFacilityDraw["updatedAt"];
  fund?: FundOptions;
  lotPartitionDraws?: Array<LotPartitionDrawOptions>;
  canDelete?: PotentialOperationOptions;
  fixedRateThousandthsBasisPoints?: CreditFacilityDraw["fixedRateThousandthsBasisPoints"];
  request?: CreditFacilityDrawRequestOptions | null;
}

export function newCreditFacilityDraw(
  options: CreditFacilityDrawOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityDraw {
  const o = (options.__typename ? options : cache["CreditFacilityDraw"] = {}) as CreditFacilityDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityDraw";
  o.id = options.id ?? nextFactoryId("CreditFacilityDraw");
  o.drawDate = options.drawDate ?? newDate();
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  o.lotPartitionDraws = (options.lotPartitionDraws ?? []).map((i) =>
    maybeNew("LotPartitionDraw", i, cache, options.hasOwnProperty("lotPartitionDraws"))
  );
  o.canDelete = maybeNew("PotentialOperation", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.fixedRateThousandthsBasisPoints = options.fixedRateThousandthsBasisPoints ?? null;
  o.request = maybeNewOrNull("CreditFacilityDrawRequest", options.request, cache);
  return o;
}

factories["CreditFacilityDraw"] = newCreditFacilityDraw;

export interface SaveCreditFacilityDrawResultOptions {
  __typename?: "SaveCreditFacilityDrawResult";
  creditFacilityDraw?: CreditFacilityDrawOptions;
}

export function newSaveCreditFacilityDrawResult(
  options: SaveCreditFacilityDrawResultOptions = {},
  cache: Record<string, any> = {},
): SaveCreditFacilityDrawResult {
  const o = (options.__typename ? options : cache["SaveCreditFacilityDrawResult"] = {}) as SaveCreditFacilityDrawResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCreditFacilityDrawResult";
  o.creditFacilityDraw = maybeNew(
    "CreditFacilityDraw",
    options.creditFacilityDraw,
    cache,
    options.hasOwnProperty("creditFacilityDraw"),
  );
  return o;
}

factories["SaveCreditFacilityDrawResult"] = newSaveCreditFacilityDrawResult;

export interface CreateOffsettingPaymentForCreditFacilityDrawResultOptions {
  __typename?: "CreateOffsettingPaymentForCreditFacilityDrawResult";
  creditFacilityPayment?: CreditFacilityPaymentOptions;
}

export function newCreateOffsettingPaymentForCreditFacilityDrawResult(
  options: CreateOffsettingPaymentForCreditFacilityDrawResultOptions = {},
  cache: Record<string, any> = {},
): CreateOffsettingPaymentForCreditFacilityDrawResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateOffsettingPaymentForCreditFacilityDrawResult"] =
        {}) as CreateOffsettingPaymentForCreditFacilityDrawResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateOffsettingPaymentForCreditFacilityDrawResult";
  o.creditFacilityPayment = maybeNew(
    "CreditFacilityPayment",
    options.creditFacilityPayment,
    cache,
    options.hasOwnProperty("creditFacilityPayment"),
  );
  return o;
}

factories["CreateOffsettingPaymentForCreditFacilityDrawResult"] = newCreateOffsettingPaymentForCreditFacilityDrawResult;

export interface CreditFacilityDrawRequestOptions {
  __typename?: "CreditFacilityDrawRequest";
  id?: CreditFacilityDrawRequest["id"];
  preparationDate?: CreditFacilityDrawRequest["preparationDate"];
  createdAt?: CreditFacilityDrawRequest["createdAt"];
  updatedAt?: CreditFacilityDrawRequest["updatedAt"];
  fund?: FundOptions;
  lotPartitionDrawRequests?: Array<LotPartitionDrawRequestOptions>;
  amountInCents?: CreditFacilityDrawRequest["amountInCents"];
  canEdit?: PotentialOperationOptions;
  creditFacilityDraw?: CreditFacilityDrawOptions | null;
  canDelete?: PotentialOperationOptions;
}

export function newCreditFacilityDrawRequest(
  options: CreditFacilityDrawRequestOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityDrawRequest {
  const o = (options.__typename ? options : cache["CreditFacilityDrawRequest"] = {}) as CreditFacilityDrawRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityDrawRequest";
  o.id = options.id ?? nextFactoryId("CreditFacilityDrawRequest");
  o.preparationDate = options.preparationDate ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  o.lotPartitionDrawRequests = (options.lotPartitionDrawRequests ?? []).map((i) =>
    maybeNew("LotPartitionDrawRequest", i, cache, options.hasOwnProperty("lotPartitionDrawRequests"))
  );
  o.amountInCents = options.amountInCents ?? 0;
  o.canEdit = maybeNew("PotentialOperation", options.canEdit, cache, options.hasOwnProperty("canEdit"));
  o.creditFacilityDraw = maybeNewOrNull("CreditFacilityDraw", options.creditFacilityDraw, cache);
  o.canDelete = maybeNew("PotentialOperation", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["CreditFacilityDrawRequest"] = newCreditFacilityDrawRequest;

export interface SaveCreditFacilityDrawRequestResultOptions {
  __typename?: "SaveCreditFacilityDrawRequestResult";
  creditFacilityDrawRequest?: CreditFacilityDrawRequestOptions;
}

export function newSaveCreditFacilityDrawRequestResult(
  options: SaveCreditFacilityDrawRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveCreditFacilityDrawRequestResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveCreditFacilityDrawRequestResult"] = {}) as SaveCreditFacilityDrawRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCreditFacilityDrawRequestResult";
  o.creditFacilityDrawRequest = maybeNew(
    "CreditFacilityDrawRequest",
    options.creditFacilityDrawRequest,
    cache,
    options.hasOwnProperty("creditFacilityDrawRequest"),
  );
  return o;
}

factories["SaveCreditFacilityDrawRequestResult"] = newSaveCreditFacilityDrawRequestResult;

export interface CreditFacilityInvoiceOptions {
  __typename?: "CreditFacilityInvoice";
  id?: CreditFacilityInvoice["id"];
  invoiceDate?: CreditFacilityInvoice["invoiceDate"];
  amountInCents?: CreditFacilityInvoice["amountInCents"];
  allocatedAmountInCents?: CreditFacilityInvoice["allocatedAmountInCents"];
  createdAt?: CreditFacilityInvoice["createdAt"];
  updatedAt?: CreditFacilityInvoice["updatedAt"];
  fund?: FundOptions;
  drawInterests?: Array<CreditFacilityInvoiceDrawInterestOptions>;
  canDelete?: PotentialOperationOptions;
  drawInterestsByLotPartitionDraw?: Array<CreditFacilityInvoiceDrawInterestByLotPartitionDrawOptions>;
  lotPartitionDrawInvoices?: Array<LotPartitionDrawInvoiceOptions>;
  isInterestPopulated?: CreditFacilityInvoice["isInterestPopulated"];
  baseRateThousandthsBasisPoints?: CreditFacilityInvoice["baseRateThousandthsBasisPoints"];
}

export function newCreditFacilityInvoice(
  options: CreditFacilityInvoiceOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityInvoice {
  const o = (options.__typename ? options : cache["CreditFacilityInvoice"] = {}) as CreditFacilityInvoice;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityInvoice";
  o.id = options.id ?? nextFactoryId("CreditFacilityInvoice");
  o.invoiceDate = options.invoiceDate ?? newDate();
  o.amountInCents = options.amountInCents ?? 0;
  o.allocatedAmountInCents = options.allocatedAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  o.drawInterests = (options.drawInterests ?? []).map((i) =>
    maybeNew("CreditFacilityInvoiceDrawInterest", i, cache, options.hasOwnProperty("drawInterests"))
  );
  o.canDelete = maybeNew("PotentialOperation", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  o.drawInterestsByLotPartitionDraw = (options.drawInterestsByLotPartitionDraw ?? []).map((i) =>
    maybeNew(
      "CreditFacilityInvoiceDrawInterestByLotPartitionDraw",
      i,
      cache,
      options.hasOwnProperty("drawInterestsByLotPartitionDraw"),
    )
  );
  o.lotPartitionDrawInvoices = (options.lotPartitionDrawInvoices ?? []).map((i) =>
    maybeNew("LotPartitionDrawInvoice", i, cache, options.hasOwnProperty("lotPartitionDrawInvoices"))
  );
  o.isInterestPopulated = options.isInterestPopulated ?? false;
  o.baseRateThousandthsBasisPoints = options.baseRateThousandthsBasisPoints ?? null;
  return o;
}

factories["CreditFacilityInvoice"] = newCreditFacilityInvoice;

export interface SaveCreditFacilityInvoiceResultOptions {
  __typename?: "SaveCreditFacilityInvoiceResult";
  creditFacilityInvoice?: CreditFacilityInvoiceOptions;
}

export function newSaveCreditFacilityInvoiceResult(
  options: SaveCreditFacilityInvoiceResultOptions = {},
  cache: Record<string, any> = {},
): SaveCreditFacilityInvoiceResult {
  const o =
    (options.__typename ? options : cache["SaveCreditFacilityInvoiceResult"] = {}) as SaveCreditFacilityInvoiceResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCreditFacilityInvoiceResult";
  o.creditFacilityInvoice = maybeNew(
    "CreditFacilityInvoice",
    options.creditFacilityInvoice,
    cache,
    options.hasOwnProperty("creditFacilityInvoice"),
  );
  return o;
}

factories["SaveCreditFacilityInvoiceResult"] = newSaveCreditFacilityInvoiceResult;

export interface CreditFacilityInvoiceDrawInterestByLotPartitionDrawOptions {
  __typename?: "CreditFacilityInvoiceDrawInterestByLotPartitionDraw";
  lotPartitionDraw?: LotPartitionDrawOptions;
  amountInCents?: CreditFacilityInvoiceDrawInterestByLotPartitionDraw["amountInCents"];
  drawInterests?: Array<CreditFacilityInvoiceDrawInterestOptions>;
}

export function newCreditFacilityInvoiceDrawInterestByLotPartitionDraw(
  options: CreditFacilityInvoiceDrawInterestByLotPartitionDrawOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityInvoiceDrawInterestByLotPartitionDraw {
  const o =
    (options.__typename
      ? options
      : cache["CreditFacilityInvoiceDrawInterestByLotPartitionDraw"] =
        {}) as CreditFacilityInvoiceDrawInterestByLotPartitionDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityInvoiceDrawInterestByLotPartitionDraw";
  o.lotPartitionDraw = maybeNew(
    "LotPartitionDraw",
    options.lotPartitionDraw,
    cache,
    options.hasOwnProperty("lotPartitionDraw"),
  );
  o.amountInCents = options.amountInCents ?? 0;
  o.drawInterests = (options.drawInterests ?? []).map((i) =>
    maybeNew("CreditFacilityInvoiceDrawInterest", i, cache, options.hasOwnProperty("drawInterests"))
  );
  return o;
}

factories["CreditFacilityInvoiceDrawInterestByLotPartitionDraw"] =
  newCreditFacilityInvoiceDrawInterestByLotPartitionDraw;

export interface CreditFacilityInvoiceDrawInterestOptions {
  __typename?: "CreditFacilityInvoiceDrawInterest";
  id?: CreditFacilityInvoiceDrawInterest["id"];
  interestDate?: CreditFacilityInvoiceDrawInterest["interestDate"];
  amountInCents?: CreditFacilityInvoiceDrawInterest["amountInCents"];
  createdAt?: CreditFacilityInvoiceDrawInterest["createdAt"];
  updatedAt?: CreditFacilityInvoiceDrawInterest["updatedAt"];
  creditFacilityInvoice?: CreditFacilityInvoiceOptions;
  lotPartitionDraw?: LotPartitionDrawOptions;
  drawAmountInCents?: CreditFacilityInvoiceDrawInterest["drawAmountInCents"];
  lotPartitionDrawInvoice?: LotPartitionDrawInvoiceOptions | null;
}

export function newCreditFacilityInvoiceDrawInterest(
  options: CreditFacilityInvoiceDrawInterestOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityInvoiceDrawInterest {
  const o =
    (options.__typename
      ? options
      : cache["CreditFacilityInvoiceDrawInterest"] = {}) as CreditFacilityInvoiceDrawInterest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityInvoiceDrawInterest";
  o.id = options.id ?? nextFactoryId("CreditFacilityInvoiceDrawInterest");
  o.interestDate = options.interestDate ?? newDate();
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.creditFacilityInvoice = maybeNew(
    "CreditFacilityInvoice",
    options.creditFacilityInvoice,
    cache,
    options.hasOwnProperty("creditFacilityInvoice"),
  );
  o.lotPartitionDraw = maybeNew(
    "LotPartitionDraw",
    options.lotPartitionDraw,
    cache,
    options.hasOwnProperty("lotPartitionDraw"),
  );
  o.drawAmountInCents = options.drawAmountInCents ?? 0;
  o.lotPartitionDrawInvoice = maybeNewOrNull("LotPartitionDrawInvoice", options.lotPartitionDrawInvoice, cache);
  return o;
}

factories["CreditFacilityInvoiceDrawInterest"] = newCreditFacilityInvoiceDrawInterest;

export interface SaveCreditFacilityInvoiceDrawInterestResultOptions {
  __typename?: "SaveCreditFacilityInvoiceDrawInterestResult";
  creditFacilityInvoiceDrawInterest?: CreditFacilityInvoiceDrawInterestOptions;
}

export function newSaveCreditFacilityInvoiceDrawInterestResult(
  options: SaveCreditFacilityInvoiceDrawInterestResultOptions = {},
  cache: Record<string, any> = {},
): SaveCreditFacilityInvoiceDrawInterestResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveCreditFacilityInvoiceDrawInterestResult"] = {}) as SaveCreditFacilityInvoiceDrawInterestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCreditFacilityInvoiceDrawInterestResult";
  o.creditFacilityInvoiceDrawInterest = maybeNew(
    "CreditFacilityInvoiceDrawInterest",
    options.creditFacilityInvoiceDrawInterest,
    cache,
    options.hasOwnProperty("creditFacilityInvoiceDrawInterest"),
  );
  return o;
}

factories["SaveCreditFacilityInvoiceDrawInterestResult"] = newSaveCreditFacilityInvoiceDrawInterestResult;

export interface CreditFacilityPaymentOptions {
  __typename?: "CreditFacilityPayment";
  id?: CreditFacilityPayment["id"];
  paymentDate?: CreditFacilityPayment["paymentDate"];
  amountInCents?: CreditFacilityPayment["amountInCents"];
  allocatedAmountInCents?: CreditFacilityPayment["allocatedAmountInCents"];
  createdAt?: CreditFacilityPayment["createdAt"];
  updatedAt?: CreditFacilityPayment["updatedAt"];
  fund?: FundOptions;
  lotPartitionDrawPayments?: Array<LotPartitionDrawPaymentOptions>;
  canDelete?: PotentialOperationOptions;
}

export function newCreditFacilityPayment(
  options: CreditFacilityPaymentOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityPayment {
  const o = (options.__typename ? options : cache["CreditFacilityPayment"] = {}) as CreditFacilityPayment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityPayment";
  o.id = options.id ?? nextFactoryId("CreditFacilityPayment");
  o.paymentDate = options.paymentDate ?? newDate();
  o.amountInCents = options.amountInCents ?? 0;
  o.allocatedAmountInCents = options.allocatedAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  o.lotPartitionDrawPayments = (options.lotPartitionDrawPayments ?? []).map((i) =>
    maybeNew("LotPartitionDrawPayment", i, cache, options.hasOwnProperty("lotPartitionDrawPayments"))
  );
  o.canDelete = maybeNew("PotentialOperation", options.canDelete, cache, options.hasOwnProperty("canDelete"));
  return o;
}

factories["CreditFacilityPayment"] = newCreditFacilityPayment;

export interface SaveCreditFacilityPaymentResultOptions {
  __typename?: "SaveCreditFacilityPaymentResult";
  creditFacilityPayment?: CreditFacilityPaymentOptions;
}

export function newSaveCreditFacilityPaymentResult(
  options: SaveCreditFacilityPaymentResultOptions = {},
  cache: Record<string, any> = {},
): SaveCreditFacilityPaymentResult {
  const o =
    (options.__typename ? options : cache["SaveCreditFacilityPaymentResult"] = {}) as SaveCreditFacilityPaymentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveCreditFacilityPaymentResult";
  o.creditFacilityPayment = maybeNew(
    "CreditFacilityPayment",
    options.creditFacilityPayment,
    cache,
    options.hasOwnProperty("creditFacilityPayment"),
  );
  return o;
}

factories["SaveCreditFacilityPaymentResult"] = newSaveCreditFacilityPaymentResult;

export interface AddOpenDrawsToCreditFacilityPaymentResultOptions {
  __typename?: "AddOpenDrawsToCreditFacilityPaymentResult";
  creditFacilityPayment?: CreditFacilityPaymentOptions;
}

export function newAddOpenDrawsToCreditFacilityPaymentResult(
  options: AddOpenDrawsToCreditFacilityPaymentResultOptions = {},
  cache: Record<string, any> = {},
): AddOpenDrawsToCreditFacilityPaymentResult {
  const o =
    (options.__typename
      ? options
      : cache["AddOpenDrawsToCreditFacilityPaymentResult"] = {}) as AddOpenDrawsToCreditFacilityPaymentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AddOpenDrawsToCreditFacilityPaymentResult";
  o.creditFacilityPayment = maybeNew(
    "CreditFacilityPayment",
    options.creditFacilityPayment,
    cache,
    options.hasOwnProperty("creditFacilityPayment"),
  );
  return o;
}

factories["AddOpenDrawsToCreditFacilityPaymentResult"] = newAddOpenDrawsToCreditFacilityPaymentResult;

export interface DocumentOptions {
  __typename?: "Document";
  id?: Document["id"];
  asset?: AssetOptions;
  blueprintDocumentId?: Document["blueprintDocumentId"];
  documentType?: DocumentTypeDetailOptions | DocumentType;
  parent?: Document["parent"];
  lotAcqSettlementStatement?: LotAcqSettlementStatementOptions | null;
  canCreateLotAcqSettlementStatement?: PotentialOperationOptions;
  canViewLotAcqSettlementStatement?: PotentialOperationOptions;
  lotAcqPurchaseAgreement?: LotAcqPurchaseAgreementOptions | null;
  canCreateLotAcqPurchaseAgreement?: PotentialOperationOptions;
  canViewLotAcqPurchaseAgreement?: PotentialOperationOptions;
  propertySaleSettlementStatement?: PropertySaleSettlementStatementOptions | null;
  canCreatePropertySaleSettlementStatement?: PotentialOperationOptions;
  canViewPropertySaleSettlementStatement?: PotentialOperationOptions;
}

export function newDocument(options: DocumentOptions = {}, cache: Record<string, any> = {}): Document {
  const o = (options.__typename ? options : cache["Document"] = {}) as Document;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Document";
  o.id = options.id ?? nextFactoryId("Document");
  o.asset = maybeNew("Asset", options.asset, cache, options.hasOwnProperty("asset"));
  o.blueprintDocumentId = options.blueprintDocumentId ?? null;
  o.documentType = enumOrDetailOfDocumentType(options.documentType);
  o.parent = options.parent ?? undefined as any;
  o.lotAcqSettlementStatement = maybeNewOrNull("LotAcqSettlementStatement", options.lotAcqSettlementStatement, cache);
  o.canCreateLotAcqSettlementStatement = maybeNew(
    "PotentialOperation",
    options.canCreateLotAcqSettlementStatement,
    cache,
    options.hasOwnProperty("canCreateLotAcqSettlementStatement"),
  );
  o.canViewLotAcqSettlementStatement = maybeNew(
    "PotentialOperation",
    options.canViewLotAcqSettlementStatement,
    cache,
    options.hasOwnProperty("canViewLotAcqSettlementStatement"),
  );
  o.lotAcqPurchaseAgreement = maybeNewOrNull("LotAcqPurchaseAgreement", options.lotAcqPurchaseAgreement, cache);
  o.canCreateLotAcqPurchaseAgreement = maybeNew(
    "PotentialOperation",
    options.canCreateLotAcqPurchaseAgreement,
    cache,
    options.hasOwnProperty("canCreateLotAcqPurchaseAgreement"),
  );
  o.canViewLotAcqPurchaseAgreement = maybeNew(
    "PotentialOperation",
    options.canViewLotAcqPurchaseAgreement,
    cache,
    options.hasOwnProperty("canViewLotAcqPurchaseAgreement"),
  );
  o.propertySaleSettlementStatement = maybeNewOrNull(
    "PropertySaleSettlementStatement",
    options.propertySaleSettlementStatement,
    cache,
  );
  o.canCreatePropertySaleSettlementStatement = maybeNew(
    "PotentialOperation",
    options.canCreatePropertySaleSettlementStatement,
    cache,
    options.hasOwnProperty("canCreatePropertySaleSettlementStatement"),
  );
  o.canViewPropertySaleSettlementStatement = maybeNew(
    "PotentialOperation",
    options.canViewPropertySaleSettlementStatement,
    cache,
    options.hasOwnProperty("canViewPropertySaleSettlementStatement"),
  );
  return o;
}

factories["Document"] = newDocument;

export interface SaveDocumentsResultOptions {
  __typename?: "SaveDocumentsResult";
  documents?: Array<DocumentOptions>;
}

export function newSaveDocumentsResult(
  options: SaveDocumentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveDocumentsResult {
  const o = (options.__typename ? options : cache["SaveDocumentsResult"] = {}) as SaveDocumentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveDocumentsResult";
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  return o;
}

factories["SaveDocumentsResult"] = newSaveDocumentsResult;

export interface ElevationOptions {
  __typename?: "Elevation";
  id?: Elevation["id"];
  airtableId?: Elevation["airtableId"];
  name?: Elevation["name"];
  priceInCents?: Elevation["priceInCents"];
  createdAt?: Elevation["createdAt"];
  updatedAt?: Elevation["updatedAt"];
  plan?: PlanOptions;
  configurations?: Array<ConfigurationOptions>;
  styles?: Array<ElevationStyleOptions>;
  specLevels?: Array<SpecLevelOptions>;
}

export function newElevation(options: ElevationOptions = {}, cache: Record<string, any> = {}): Elevation {
  const o = (options.__typename ? options : cache["Elevation"] = {}) as Elevation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Elevation";
  o.id = options.id ?? nextFactoryId("Elevation");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNew("Plan", options.plan, cache, options.hasOwnProperty("plan"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNew("Configuration", i, cache, options.hasOwnProperty("configurations"))
  );
  o.styles = (options.styles ?? []).map((i) => maybeNew("ElevationStyle", i, cache, options.hasOwnProperty("styles")));
  o.specLevels = (options.specLevels ?? []).map((i) =>
    maybeNew("SpecLevel", i, cache, options.hasOwnProperty("specLevels"))
  );
  return o;
}

factories["Elevation"] = newElevation;

export interface SaveElevationResultOptions {
  __typename?: "SaveElevationResult";
  elevation?: ElevationOptions;
}

export function newSaveElevationResult(
  options: SaveElevationResultOptions = {},
  cache: Record<string, any> = {},
): SaveElevationResult {
  const o = (options.__typename ? options : cache["SaveElevationResult"] = {}) as SaveElevationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveElevationResult";
  o.elevation = maybeNew("Elevation", options.elevation, cache, options.hasOwnProperty("elevation"));
  return o;
}

factories["SaveElevationResult"] = newSaveElevationResult;

export interface ElevationStyleOptions {
  __typename?: "ElevationStyle";
  id?: ElevationStyle["id"];
  airtableId?: ElevationStyle["airtableId"];
  name?: ElevationStyle["name"];
  priceInCents?: ElevationStyle["priceInCents"];
  image?: ElevationStyle["image"];
  createdAt?: ElevationStyle["createdAt"];
  updatedAt?: ElevationStyle["updatedAt"];
  elevation?: ElevationOptions;
  configurations?: Array<ConfigurationOptions>;
  exteriorImages?: Array<ExteriorImageOptions>;
  sortOrder?: ElevationStyle["sortOrder"];
}

export function newElevationStyle(
  options: ElevationStyleOptions = {},
  cache: Record<string, any> = {},
): ElevationStyle {
  const o = (options.__typename ? options : cache["ElevationStyle"] = {}) as ElevationStyle;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ElevationStyle";
  o.id = options.id ?? nextFactoryId("ElevationStyle");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNew("Elevation", options.elevation, cache, options.hasOwnProperty("elevation"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNew("Configuration", i, cache, options.hasOwnProperty("configurations"))
  );
  o.exteriorImages = (options.exteriorImages ?? []).map((i) =>
    maybeNew("ExteriorImage", i, cache, options.hasOwnProperty("exteriorImages"))
  );
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["ElevationStyle"] = newElevationStyle;

export interface SaveElevationStyleResultOptions {
  __typename?: "SaveElevationStyleResult";
  elevationStyle?: ElevationStyleOptions;
}

export function newSaveElevationStyleResult(
  options: SaveElevationStyleResultOptions = {},
  cache: Record<string, any> = {},
): SaveElevationStyleResult {
  const o = (options.__typename ? options : cache["SaveElevationStyleResult"] = {}) as SaveElevationStyleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveElevationStyleResult";
  o.elevationStyle = maybeNew(
    "ElevationStyle",
    options.elevationStyle,
    cache,
    options.hasOwnProperty("elevationStyle"),
  );
  return o;
}

factories["SaveElevationStyleResult"] = newSaveElevationStyleResult;

export interface CostTypeDetailOptions {
  __typename?: "CostTypeDetail";
  code?: CostTypeDetail["code"];
  name?: CostTypeDetail["name"];
}

export function newCostTypeDetail(
  options: CostTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CostTypeDetail {
  const o = (options.__typename ? options : cache["CostTypeDetail"] = {}) as CostTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CostTypeDetail";
  o.code = options.code ?? CostType.Soft;
  o.name = options.name ?? "Soft";
  return o;
}

factories["CostTypeDetail"] = newCostTypeDetail;

export interface CreditFacilityInterestTypeDetailOptions {
  __typename?: "CreditFacilityInterestTypeDetail";
  code?: CreditFacilityInterestTypeDetail["code"];
  name?: CreditFacilityInterestTypeDetail["name"];
}

export function newCreditFacilityInterestTypeDetail(
  options: CreditFacilityInterestTypeDetailOptions = {},
  cache: Record<string, any> = {},
): CreditFacilityInterestTypeDetail {
  const o =
    (options.__typename ? options : cache["CreditFacilityInterestTypeDetail"] = {}) as CreditFacilityInterestTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreditFacilityInterestTypeDetail";
  o.code = options.code ?? CreditFacilityInterestType.FixedAtDraw;
  o.name = options.name ?? "Fixed at draw";
  return o;
}

factories["CreditFacilityInterestTypeDetail"] = newCreditFacilityInterestTypeDetail;

export interface DocumentTypeDetailOptions {
  __typename?: "DocumentTypeDetail";
  code?: DocumentTypeDetail["code"];
  name?: DocumentTypeDetail["name"];
}

export function newDocumentTypeDetail(
  options: DocumentTypeDetailOptions = {},
  cache: Record<string, any> = {},
): DocumentTypeDetail {
  const o = (options.__typename ? options : cache["DocumentTypeDetail"] = {}) as DocumentTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DocumentTypeDetail";
  o.code = options.code ?? DocumentType.General;
  o.name = options.name ?? "General";
  return o;
}

factories["DocumentTypeDetail"] = newDocumentTypeDetail;

export interface FundCreditFacilityDrawModelDetailOptions {
  __typename?: "FundCreditFacilityDrawModelDetail";
  code?: FundCreditFacilityDrawModelDetail["code"];
  name?: FundCreditFacilityDrawModelDetail["name"];
}

export function newFundCreditFacilityDrawModelDetail(
  options: FundCreditFacilityDrawModelDetailOptions = {},
  cache: Record<string, any> = {},
): FundCreditFacilityDrawModelDetail {
  const o =
    (options.__typename
      ? options
      : cache["FundCreditFacilityDrawModelDetail"] = {}) as FundCreditFacilityDrawModelDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FundCreditFacilityDrawModelDetail";
  o.code = options.code ?? FundCreditFacilityDrawModel.None;
  o.name = options.name ?? "None";
  return o;
}

factories["FundCreditFacilityDrawModelDetail"] = newFundCreditFacilityDrawModelDetail;

export interface LotAcqSettlementStatementLineItemTypeDetailOptions {
  __typename?: "LotAcqSettlementStatementLineItemTypeDetail";
  code?: LotAcqSettlementStatementLineItemTypeDetail["code"];
  name?: LotAcqSettlementStatementLineItemTypeDetail["name"];
}

export function newLotAcqSettlementStatementLineItemTypeDetail(
  options: LotAcqSettlementStatementLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LotAcqSettlementStatementLineItemTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["LotAcqSettlementStatementLineItemTypeDetail"] = {}) as LotAcqSettlementStatementLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotAcqSettlementStatementLineItemTypeDetail";
  o.code = options.code ?? LotAcqSettlementStatementLineItemType.Other;
  o.name = options.name ?? "Other";
  return o;
}

factories["LotAcqSettlementStatementLineItemTypeDetail"] = newLotAcqSettlementStatementLineItemTypeDetail;

export interface LotInvestmentStatusDetailOptions {
  __typename?: "LotInvestmentStatusDetail";
  code?: LotInvestmentStatusDetail["code"];
  name?: LotInvestmentStatusDetail["name"];
}

export function newLotInvestmentStatusDetail(
  options: LotInvestmentStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LotInvestmentStatusDetail {
  const o = (options.__typename ? options : cache["LotInvestmentStatusDetail"] = {}) as LotInvestmentStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotInvestmentStatusDetail";
  o.code = options.code ?? LotInvestmentStatus.Pending;
  o.name = options.name ?? "Pending";
  return o;
}

factories["LotInvestmentStatusDetail"] = newLotInvestmentStatusDetail;

export interface LotPartitionEstimateStatusDetailOptions {
  __typename?: "LotPartitionEstimateStatusDetail";
  code?: LotPartitionEstimateStatusDetail["code"];
  name?: LotPartitionEstimateStatusDetail["name"];
}

export function newLotPartitionEstimateStatusDetail(
  options: LotPartitionEstimateStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LotPartitionEstimateStatusDetail {
  const o =
    (options.__typename ? options : cache["LotPartitionEstimateStatusDetail"] = {}) as LotPartitionEstimateStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionEstimateStatusDetail";
  o.code = options.code ?? LotPartitionEstimateStatus.Rejected;
  o.name = options.name ?? "Rejected";
  return o;
}

factories["LotPartitionEstimateStatusDetail"] = newLotPartitionEstimateStatusDetail;

export interface LotPartitionEstimateTypeDetailOptions {
  __typename?: "LotPartitionEstimateTypeDetail";
  code?: LotPartitionEstimateTypeDetail["code"];
  name?: LotPartitionEstimateTypeDetail["name"];
}

export function newLotPartitionEstimateTypeDetail(
  options: LotPartitionEstimateTypeDetailOptions = {},
  cache: Record<string, any> = {},
): LotPartitionEstimateTypeDetail {
  const o =
    (options.__typename ? options : cache["LotPartitionEstimateTypeDetail"] = {}) as LotPartitionEstimateTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionEstimateTypeDetail";
  o.code = options.code ?? LotPartitionEstimateType.Prime;
  o.name = options.name ?? "Prime";
  return o;
}

factories["LotPartitionEstimateTypeDetail"] = newLotPartitionEstimateTypeDetail;

export interface LotPartitionSalesStatusDetailOptions {
  __typename?: "LotPartitionSalesStatusDetail";
  code?: LotPartitionSalesStatusDetail["code"];
  name?: LotPartitionSalesStatusDetail["name"];
}

export function newLotPartitionSalesStatusDetail(
  options: LotPartitionSalesStatusDetailOptions = {},
  cache: Record<string, any> = {},
): LotPartitionSalesStatusDetail {
  const o =
    (options.__typename ? options : cache["LotPartitionSalesStatusDetail"] = {}) as LotPartitionSalesStatusDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionSalesStatusDetail";
  o.code = options.code ?? LotPartitionSalesStatus.PreForSale;
  o.name = options.name ?? "Pre for sale";
  return o;
}

factories["LotPartitionSalesStatusDetail"] = newLotPartitionSalesStatusDetail;

export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
}

export function newLotTypeDetail(options: LotTypeDetailOptions = {}, cache: Record<string, any> = {}): LotTypeDetail {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotTypeDetail";
  o.code = options.code ?? LotType.Boyl;
  o.name = options.name ?? "Boyl";
  return o;
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface PropertySaleSettlementStatementLineItemTypeDetailOptions {
  __typename?: "PropertySaleSettlementStatementLineItemTypeDetail";
  code?: PropertySaleSettlementStatementLineItemTypeDetail["code"];
  name?: PropertySaleSettlementStatementLineItemTypeDetail["name"];
}

export function newPropertySaleSettlementStatementLineItemTypeDetail(
  options: PropertySaleSettlementStatementLineItemTypeDetailOptions = {},
  cache: Record<string, any> = {},
): PropertySaleSettlementStatementLineItemTypeDetail {
  const o =
    (options.__typename
      ? options
      : cache["PropertySaleSettlementStatementLineItemTypeDetail"] =
        {}) as PropertySaleSettlementStatementLineItemTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertySaleSettlementStatementLineItemTypeDetail";
  o.code = options.code ?? PropertySaleSettlementStatementLineItemType.GrossSalePrice;
  o.name = options.name ?? "Gross sale price";
  return o;
}

factories["PropertySaleSettlementStatementLineItemTypeDetail"] = newPropertySaleSettlementStatementLineItemTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserTypeDetail {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserTypeDetail";
  o.code = options.code ?? UserType.Anonymous;
  o.name = options.name ?? "Anonymous";
  return o;
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface AllEnumDetailsOptions {
  __typename?: "AllEnumDetails";
  costType?: Array<CostTypeDetailOptions>;
  creditFacilityInterestType?: Array<CreditFacilityInterestTypeDetailOptions>;
  documentType?: Array<DocumentTypeDetailOptions>;
  fundCreditFacilityDrawModel?: Array<FundCreditFacilityDrawModelDetailOptions>;
  lotAcqSettlementStatementLineItemType?: Array<LotAcqSettlementStatementLineItemTypeDetailOptions>;
  lotInvestmentStatus?: Array<LotInvestmentStatusDetailOptions>;
  lotPartitionEstimateStatus?: Array<LotPartitionEstimateStatusDetailOptions>;
  lotPartitionEstimateType?: Array<LotPartitionEstimateTypeDetailOptions>;
  lotPartitionSalesStatus?: Array<LotPartitionSalesStatusDetailOptions>;
  lotType?: Array<LotTypeDetailOptions>;
  propertySaleSettlementStatementLineItemType?: Array<PropertySaleSettlementStatementLineItemTypeDetailOptions>;
  userType?: Array<UserTypeDetailOptions>;
}

export function newAllEnumDetails(
  options: AllEnumDetailsOptions = {},
  cache: Record<string, any> = {},
): AllEnumDetails {
  const o = (options.__typename ? options : cache["AllEnumDetails"] = {}) as AllEnumDetails;
  (cache.all ??= new Set()).add(o);
  o.__typename = "AllEnumDetails";
  o.costType = (options.costType ?? []).map((i) => enumOrDetailOfCostType(i));
  o.creditFacilityInterestType = (options.creditFacilityInterestType ?? []).map((i) =>
    enumOrDetailOfCreditFacilityInterestType(i)
  );
  o.documentType = (options.documentType ?? []).map((i) => enumOrDetailOfDocumentType(i));
  o.fundCreditFacilityDrawModel = (options.fundCreditFacilityDrawModel ?? []).map((i) =>
    enumOrDetailOfFundCreditFacilityDrawModel(i)
  );
  o.lotAcqSettlementStatementLineItemType = (options.lotAcqSettlementStatementLineItemType ?? []).map((i) =>
    enumOrDetailOfLotAcqSettlementStatementLineItemType(i)
  );
  o.lotInvestmentStatus = (options.lotInvestmentStatus ?? []).map((i) => enumOrDetailOfLotInvestmentStatus(i));
  o.lotPartitionEstimateStatus = (options.lotPartitionEstimateStatus ?? []).map((i) =>
    enumOrDetailOfLotPartitionEstimateStatus(i)
  );
  o.lotPartitionEstimateType = (options.lotPartitionEstimateType ?? []).map((i) =>
    enumOrDetailOfLotPartitionEstimateType(i)
  );
  o.lotPartitionSalesStatus = (options.lotPartitionSalesStatus ?? []).map((i) =>
    enumOrDetailOfLotPartitionSalesStatus(i)
  );
  o.lotType = (options.lotType ?? []).map((i) => enumOrDetailOfLotType(i));
  o.propertySaleSettlementStatementLineItemType = (options.propertySaleSettlementStatementLineItemType ?? []).map((i) =>
    enumOrDetailOfPropertySaleSettlementStatementLineItemType(i)
  );
  o.userType = (options.userType ?? []).map((i) => enumOrDetailOfUserType(i));
  return o;
}

factories["AllEnumDetails"] = newAllEnumDetails;

export interface EquityFinancingCostOptions {
  __typename?: "EquityFinancingCost";
  id?: EquityFinancingCost["id"];
  interestDate?: EquityFinancingCost["interestDate"];
  interestAmountInCents?: EquityFinancingCost["interestAmountInCents"];
  equityAmountInCents?: EquityFinancingCost["equityAmountInCents"];
  createdAt?: EquityFinancingCost["createdAt"];
  updatedAt?: EquityFinancingCost["updatedAt"];
  lot?: LotOptions | null;
  lotPartition?: LotPartitionOptions | null;
}

export function newEquityFinancingCost(
  options: EquityFinancingCostOptions = {},
  cache: Record<string, any> = {},
): EquityFinancingCost {
  const o = (options.__typename ? options : cache["EquityFinancingCost"] = {}) as EquityFinancingCost;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EquityFinancingCost";
  o.id = options.id ?? nextFactoryId("EquityFinancingCost");
  o.interestDate = options.interestDate ?? newDate();
  o.interestAmountInCents = options.interestAmountInCents ?? 0;
  o.equityAmountInCents = options.equityAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lot = maybeNewOrNull("Lot", options.lot, cache);
  o.lotPartition = maybeNewOrNull("LotPartition", options.lotPartition, cache);
  return o;
}

factories["EquityFinancingCost"] = newEquityFinancingCost;

export interface SaveEquityFinancingCostResultOptions {
  __typename?: "SaveEquityFinancingCostResult";
  equityFinancingCost?: EquityFinancingCostOptions;
}

export function newSaveEquityFinancingCostResult(
  options: SaveEquityFinancingCostResultOptions = {},
  cache: Record<string, any> = {},
): SaveEquityFinancingCostResult {
  const o =
    (options.__typename ? options : cache["SaveEquityFinancingCostResult"] = {}) as SaveEquityFinancingCostResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveEquityFinancingCostResult";
  o.equityFinancingCost = maybeNew(
    "EquityFinancingCost",
    options.equityFinancingCost,
    cache,
    options.hasOwnProperty("equityFinancingCost"),
  );
  return o;
}

factories["SaveEquityFinancingCostResult"] = newSaveEquityFinancingCostResult;

export interface RegenerateAllMonthlyEquityFinanceValuesResultOptions {
  __typename?: "RegenerateAllMonthlyEquityFinanceValuesResult";
  lots?: Array<LotOptions>;
  lotPartitions?: Array<LotPartitionOptions>;
}

export function newRegenerateAllMonthlyEquityFinanceValuesResult(
  options: RegenerateAllMonthlyEquityFinanceValuesResultOptions = {},
  cache: Record<string, any> = {},
): RegenerateAllMonthlyEquityFinanceValuesResult {
  const o =
    (options.__typename
      ? options
      : cache["RegenerateAllMonthlyEquityFinanceValuesResult"] = {}) as RegenerateAllMonthlyEquityFinanceValuesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RegenerateAllMonthlyEquityFinanceValuesResult";
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  o.lotPartitions = (options.lotPartitions ?? []).map((i) =>
    maybeNew("LotPartition", i, cache, options.hasOwnProperty("lotPartitions"))
  );
  return o;
}

factories["RegenerateAllMonthlyEquityFinanceValuesResult"] = newRegenerateAllMonthlyEquityFinanceValuesResult;

export interface ExteriorImageOptions {
  __typename?: "ExteriorImage";
  id?: ExteriorImage["id"];
  airtableId?: ExteriorImage["airtableId"];
  image?: ExteriorImage["image"];
  createdAt?: ExteriorImage["createdAt"];
  updatedAt?: ExteriorImage["updatedAt"];
  elevationStyle?: ElevationStyleOptions;
  sortOrder?: ExteriorImage["sortOrder"];
}

export function newExteriorImage(options: ExteriorImageOptions = {}, cache: Record<string, any> = {}): ExteriorImage {
  const o = (options.__typename ? options : cache["ExteriorImage"] = {}) as ExteriorImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExteriorImage";
  o.id = options.id ?? nextFactoryId("ExteriorImage");
  o.airtableId = options.airtableId ?? "airtableId";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevationStyle = maybeNew(
    "ElevationStyle",
    options.elevationStyle,
    cache,
    options.hasOwnProperty("elevationStyle"),
  );
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["ExteriorImage"] = newExteriorImage;

export interface SaveExteriorImageResultOptions {
  __typename?: "SaveExteriorImageResult";
  exteriorImage?: ExteriorImageOptions;
}

export function newSaveExteriorImageResult(
  options: SaveExteriorImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveExteriorImageResult {
  const o = (options.__typename ? options : cache["SaveExteriorImageResult"] = {}) as SaveExteriorImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExteriorImageResult";
  o.exteriorImage = maybeNew("ExteriorImage", options.exteriorImage, cache, options.hasOwnProperty("exteriorImage"));
  return o;
}

factories["SaveExteriorImageResult"] = newSaveExteriorImageResult;

export interface FloorOptions {
  __typename?: "Floor";
  id?: Floor["id"];
  airtableId?: Floor["airtableId"];
  name?: Floor["name"];
  image?: Floor["image"];
  createdAt?: Floor["createdAt"];
  updatedAt?: Floor["updatedAt"];
  plan?: PlanOptions;
  options?: Array<OptionOptions>;
}

export function newFloor(options: FloorOptions = {}, cache: Record<string, any> = {}): Floor {
  const o = (options.__typename ? options : cache["Floor"] = {}) as Floor;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Floor";
  o.id = options.id ?? nextFactoryId("Floor");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNew("Plan", options.plan, cache, options.hasOwnProperty("plan"));
  o.options = (options.options ?? []).map((i) => maybeNew("Option", i, cache, options.hasOwnProperty("options")));
  return o;
}

factories["Floor"] = newFloor;

export interface SaveFloorResultOptions {
  __typename?: "SaveFloorResult";
  floor?: FloorOptions;
}

export function newSaveFloorResult(
  options: SaveFloorResultOptions = {},
  cache: Record<string, any> = {},
): SaveFloorResult {
  const o = (options.__typename ? options : cache["SaveFloorResult"] = {}) as SaveFloorResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFloorResult";
  o.floor = maybeNew("Floor", options.floor, cache, options.hasOwnProperty("floor"));
  return o;
}

factories["SaveFloorResult"] = newSaveFloorResult;

export interface FundOptions {
  __typename?: "Fund";
  id?: Fund["id"];
  name?: Fund["name"];
  createdAt?: Fund["createdAt"];
  updatedAt?: Fund["updatedAt"];
  lots?: Array<LotOptions>;
  targetInvestorMarginBasisPoints?: Fund["targetInvestorMarginBasisPoints"];
  opcoDirectHardCostMarkupBasisPoints?: Fund["opcoDirectHardCostMarkupBasisPoints"];
  opcoIndirectHardCostMarkupBasisPoints?: Fund["opcoIndirectHardCostMarkupBasisPoints"];
  opcoSoftCostMarkupBasisPoints?: Fund["opcoSoftCostMarkupBasisPoints"];
  creditFacilityFixedRateBasisPoints?: Fund["creditFacilityFixedRateBasisPoints"];
  opcoSiteAcquisitionMarkupBasisPoints?: Fund["opcoSiteAcquisitionMarkupBasisPoints"];
  creditFacilityCanBorrowDirectCosts?: Fund["creditFacilityCanBorrowDirectCosts"];
  creditFacilityCanBorrowIndirectCosts?: Fund["creditFacilityCanBorrowIndirectCosts"];
  creditFacilityCanBorrowSoftCosts?: Fund["creditFacilityCanBorrowSoftCosts"];
  creditFacilityDraws?: Array<CreditFacilityDrawOptions>;
  creditFacilityPayments?: Array<CreditFacilityPaymentOptions>;
  creditFacilityInvoices?: Array<CreditFacilityInvoiceOptions>;
  metros?: Array<FundMetroOptions>;
  equityFinancingBasisPoints?: Fund["equityFinancingBasisPoints"];
  salesforceName?: Fund["salesforceName"];
  closedBooksDate?: Fund["closedBooksDate"];
  blueprintCustomerId?: Fund["blueprintCustomerId"];
  creditFacilityDrawModel?: FundCreditFacilityDrawModelDetailOptions | FundCreditFacilityDrawModel | null;
  creditFacilityDrawRequests?: Array<CreditFacilityDrawRequestOptions>;
  ownerEntities?: Array<FundOwnerEntityOptions>;
  creditFacilityInterestType?: CreditFacilityInterestTypeDetailOptions | CreditFacilityInterestType;
}

export function newFund(options: FundOptions = {}, cache: Record<string, any> = {}): Fund {
  const o = (options.__typename ? options : cache["Fund"] = {}) as Fund;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Fund";
  o.id = options.id ?? nextFactoryId("Fund");
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  o.targetInvestorMarginBasisPoints = options.targetInvestorMarginBasisPoints ?? 0;
  o.opcoDirectHardCostMarkupBasisPoints = options.opcoDirectHardCostMarkupBasisPoints ?? 0;
  o.opcoIndirectHardCostMarkupBasisPoints = options.opcoIndirectHardCostMarkupBasisPoints ?? 0;
  o.opcoSoftCostMarkupBasisPoints = options.opcoSoftCostMarkupBasisPoints ?? 0;
  o.creditFacilityFixedRateBasisPoints = options.creditFacilityFixedRateBasisPoints ?? 0;
  o.opcoSiteAcquisitionMarkupBasisPoints = options.opcoSiteAcquisitionMarkupBasisPoints ?? 0;
  o.creditFacilityCanBorrowDirectCosts = options.creditFacilityCanBorrowDirectCosts ?? false;
  o.creditFacilityCanBorrowIndirectCosts = options.creditFacilityCanBorrowIndirectCosts ?? false;
  o.creditFacilityCanBorrowSoftCosts = options.creditFacilityCanBorrowSoftCosts ?? false;
  o.creditFacilityDraws = (options.creditFacilityDraws ?? []).map((i) =>
    maybeNew("CreditFacilityDraw", i, cache, options.hasOwnProperty("creditFacilityDraws"))
  );
  o.creditFacilityPayments = (options.creditFacilityPayments ?? []).map((i) =>
    maybeNew("CreditFacilityPayment", i, cache, options.hasOwnProperty("creditFacilityPayments"))
  );
  o.creditFacilityInvoices = (options.creditFacilityInvoices ?? []).map((i) =>
    maybeNew("CreditFacilityInvoice", i, cache, options.hasOwnProperty("creditFacilityInvoices"))
  );
  o.metros = (options.metros ?? []).map((i) => maybeNew("FundMetro", i, cache, options.hasOwnProperty("metros")));
  o.equityFinancingBasisPoints = options.equityFinancingBasisPoints ?? 0;
  o.salesforceName = options.salesforceName ?? null;
  o.closedBooksDate = options.closedBooksDate ?? null;
  o.blueprintCustomerId = options.blueprintCustomerId ?? null;
  o.creditFacilityDrawModel = enumOrDetailOrNullOfFundCreditFacilityDrawModel(options.creditFacilityDrawModel);
  o.creditFacilityDrawRequests = (options.creditFacilityDrawRequests ?? []).map((i) =>
    maybeNew("CreditFacilityDrawRequest", i, cache, options.hasOwnProperty("creditFacilityDrawRequests"))
  );
  o.ownerEntities = (options.ownerEntities ?? []).map((i) =>
    maybeNew("FundOwnerEntity", i, cache, options.hasOwnProperty("ownerEntities"))
  );
  o.creditFacilityInterestType = enumOrDetailOfCreditFacilityInterestType(options.creditFacilityInterestType);
  return o;
}

factories["Fund"] = newFund;

export interface SaveFundResultOptions {
  __typename?: "SaveFundResult";
  fund?: FundOptions;
}

export function newSaveFundResult(
  options: SaveFundResultOptions = {},
  cache: Record<string, any> = {},
): SaveFundResult {
  const o = (options.__typename ? options : cache["SaveFundResult"] = {}) as SaveFundResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFundResult";
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  return o;
}

factories["SaveFundResult"] = newSaveFundResult;

export interface ExportBillsForDrawResultOptions {
  __typename?: "ExportBillsForDrawResult";
  googleDriveFolderId?: ExportBillsForDrawResult["googleDriveFolderId"];
}

export function newExportBillsForDrawResult(
  options: ExportBillsForDrawResultOptions = {},
  cache: Record<string, any> = {},
): ExportBillsForDrawResult {
  const o = (options.__typename ? options : cache["ExportBillsForDrawResult"] = {}) as ExportBillsForDrawResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExportBillsForDrawResult";
  o.googleDriveFolderId = options.googleDriveFolderId ?? "googleDriveFolderId";
  return o;
}

factories["ExportBillsForDrawResult"] = newExportBillsForDrawResult;

export interface FundMetroOptions {
  __typename?: "FundMetro";
  id?: FundMetro["id"];
  targetInvestorMarginBasisPoints?: FundMetro["targetInvestorMarginBasisPoints"];
  createdAt?: FundMetro["createdAt"];
  updatedAt?: FundMetro["updatedAt"];
  fund?: FundOptions;
  metro?: MetroOptions;
}

export function newFundMetro(options: FundMetroOptions = {}, cache: Record<string, any> = {}): FundMetro {
  const o = (options.__typename ? options : cache["FundMetro"] = {}) as FundMetro;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FundMetro";
  o.id = options.id ?? nextFactoryId("FundMetro");
  o.targetInvestorMarginBasisPoints = options.targetInvestorMarginBasisPoints ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fund = maybeNew("Fund", options.fund, cache, options.hasOwnProperty("fund"));
  o.metro = maybeNew("Metro", options.metro, cache, options.hasOwnProperty("metro"));
  return o;
}

factories["FundMetro"] = newFundMetro;

export interface SaveFundMetroResultOptions {
  __typename?: "SaveFundMetroResult";
  fundMetro?: FundMetroOptions;
}

export function newSaveFundMetroResult(
  options: SaveFundMetroResultOptions = {},
  cache: Record<string, any> = {},
): SaveFundMetroResult {
  const o = (options.__typename ? options : cache["SaveFundMetroResult"] = {}) as SaveFundMetroResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFundMetroResult";
  o.fundMetro = maybeNew("FundMetro", options.fundMetro, cache, options.hasOwnProperty("fundMetro"));
  return o;
}

factories["SaveFundMetroResult"] = newSaveFundMetroResult;

export interface EnsureAllFundMetrosResultOptions {
  __typename?: "EnsureAllFundMetrosResult";
  fundMetros?: Array<FundMetroOptions>;
}

export function newEnsureAllFundMetrosResult(
  options: EnsureAllFundMetrosResultOptions = {},
  cache: Record<string, any> = {},
): EnsureAllFundMetrosResult {
  const o = (options.__typename ? options : cache["EnsureAllFundMetrosResult"] = {}) as EnsureAllFundMetrosResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EnsureAllFundMetrosResult";
  o.fundMetros = (options.fundMetros ?? []).map((i) =>
    maybeNew("FundMetro", i, cache, options.hasOwnProperty("fundMetros"))
  );
  return o;
}

factories["EnsureAllFundMetrosResult"] = newEnsureAllFundMetrosResult;

export interface FundOwnerEntityOptions {
  __typename?: "FundOwnerEntity";
  id?: FundOwnerEntity["id"];
  name?: FundOwnerEntity["name"];
  fund?: FundOptions | null;
  lots?: Array<LotOptions>;
}

export function newFundOwnerEntity(
  options: FundOwnerEntityOptions = {},
  cache: Record<string, any> = {},
): FundOwnerEntity {
  const o = (options.__typename ? options : cache["FundOwnerEntity"] = {}) as FundOwnerEntity;
  (cache.all ??= new Set()).add(o);
  o.__typename = "FundOwnerEntity";
  o.id = options.id ?? nextFactoryId("FundOwnerEntity");
  o.name = options.name ?? "name";
  o.fund = maybeNewOrNull("Fund", options.fund, cache);
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  return o;
}

factories["FundOwnerEntity"] = newFundOwnerEntity;

export interface SaveFundOwnerEntityResultOptions {
  __typename?: "SaveFundOwnerEntityResult";
  fundOwnerEntity?: FundOwnerEntityOptions;
}

export function newSaveFundOwnerEntityResult(
  options: SaveFundOwnerEntityResultOptions = {},
  cache: Record<string, any> = {},
): SaveFundOwnerEntityResult {
  const o = (options.__typename ? options : cache["SaveFundOwnerEntityResult"] = {}) as SaveFundOwnerEntityResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFundOwnerEntityResult";
  o.fundOwnerEntity = maybeNew(
    "FundOwnerEntity",
    options.fundOwnerEntity,
    cache,
    options.hasOwnProperty("fundOwnerEntity"),
  );
  return o;
}

factories["SaveFundOwnerEntityResult"] = newSaveFundOwnerEntityResult;

export interface GoldmanDrawModelOptions {
  __typename?: "GoldmanDrawModel";
  id?: GoldmanDrawModel["id"];
  borrowingBaseInCents?: GoldmanDrawModel["borrowingBaseInCents"];
  realizedConstructionExpensesInCents?: GoldmanDrawModel["realizedConstructionExpensesInCents"];
  isFinishedProperty?: GoldmanDrawModel["isFinishedProperty"];
  isPropertySold?: GoldmanDrawModel["isPropertySold"];
  currentAppraisalValueInCents?: GoldmanDrawModel["currentAppraisalValueInCents"];
  advanceRateBasisPoints?: GoldmanDrawModel["advanceRateBasisPoints"];
  adjustedAdvanceRateBasisPoints?: GoldmanDrawModel["adjustedAdvanceRateBasisPoints"];
  landCostsInCents?: GoldmanDrawModel["landCostsInCents"];
  adjustedCollateralValueInCents?: GoldmanDrawModel["adjustedCollateralValueInCents"];
  createdAt?: GoldmanDrawModel["createdAt"];
  updatedAt?: GoldmanDrawModel["updatedAt"];
  lotPartition?: LotPartitionOptions;
  asOfDate?: GoldmanDrawModel["asOfDate"];
  realizedSoftCostsInCents?: GoldmanDrawModel["realizedSoftCostsInCents"];
  realizedIndirectCostsInCents?: GoldmanDrawModel["realizedIndirectCostsInCents"];
  realizedDirectCostsInCents?: GoldmanDrawModel["realizedDirectCostsInCents"];
  realizedBuilderFeeInCents?: GoldmanDrawModel["realizedBuilderFeeInCents"];
  homeboundPortionInCents?: GoldmanDrawModel["homeboundPortionInCents"];
  adjustedConstructionExpensesInCents?: GoldmanDrawModel["adjustedConstructionExpensesInCents"];
  lotCostToUnderwrittenNetSalesPriceBasisPoints?: GoldmanDrawModel["lotCostToUnderwrittenNetSalesPriceBasisPoints"];
  isEligibleForGoldmanDraw?: GoldmanDrawModel["isEligibleForGoldmanDraw"];
  isLotCostToUnderwrittenNetSalesPriceEligible?: GoldmanDrawModel["isLotCostToUnderwrittenNetSalesPriceEligible"];
  isOwnedLessThan_721Days?: GoldmanDrawModel["isOwnedLessThan_721Days"];
  isHorizontalComplete?: GoldmanDrawModel["isHorizontalComplete"];
  isAppraisalAgeAcceptable?: GoldmanDrawModel["isAppraisalAgeAcceptable"];
  isInfillOrDeveloperCommunity?: GoldmanDrawModel["isInfillOrDeveloperCommunity"];
  isLandCostEligible?: GoldmanDrawModel["isLandCostEligible"];
  isUnderwrittenHardCostEligible?: GoldmanDrawModel["isUnderwrittenHardCostEligible"];
  isLandCostAndConstructionExpensesEligible?: GoldmanDrawModel["isLandCostAndConstructionExpensesEligible"];
  isUnderwrittenMarginEligible?: GoldmanDrawModel["isUnderwrittenMarginEligible"];
  isBedroomsEligible?: GoldmanDrawModel["isBedroomsEligible"];
  isSqftEligible?: GoldmanDrawModel["isSqftEligible"];
  isBathroomsEligible?: GoldmanDrawModel["isBathroomsEligible"];
  isExpandedBuy?: GoldmanDrawModel["isExpandedBuy"];
  isTargetBuy?: GoldmanDrawModel["isTargetBuy"];
  isLandCostTargetEligible?: GoldmanDrawModel["isLandCostTargetEligible"];
  isLotCostToUnderwrittenNetSalesPriceTargetEligible?:
    GoldmanDrawModel["isLotCostToUnderwrittenNetSalesPriceTargetEligible"];
  isConstructionExpensesTargetEligible?: GoldmanDrawModel["isConstructionExpensesTargetEligible"];
  isLandCostAndConstructionExpensesTargetEligible?: GoldmanDrawModel["isLandCostAndConstructionExpensesTargetEligible"];
  lotPartitionDrawRequest?: LotPartitionDrawRequestOptions | null;
  borrowingBaseWithExcessConcentrationLimitInCents?:
    GoldmanDrawModel["borrowingBaseWithExcessConcentrationLimitInCents"];
  advanceRatePreconBasisPoints?: GoldmanDrawModel["advanceRatePreconBasisPoints"];
  isBlueprintCostDataSet?: GoldmanDrawModel["isBlueprintCostDataSet"];
  costItems?: Array<GoldmanDrawModelCostItemOptions>;
  isVictoryOverride?: GoldmanDrawModel["isVictoryOverride"];
  isVerticalComplete?: GoldmanDrawModel["isVerticalComplete"];
  underwrittenSalesPriceMarginBasisPoints?: GoldmanDrawModel["underwrittenSalesPriceMarginBasisPoints"];
}

export function newGoldmanDrawModel(
  options: GoldmanDrawModelOptions = {},
  cache: Record<string, any> = {},
): GoldmanDrawModel {
  const o = (options.__typename ? options : cache["GoldmanDrawModel"] = {}) as GoldmanDrawModel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GoldmanDrawModel";
  o.id = options.id ?? nextFactoryId("GoldmanDrawModel");
  o.borrowingBaseInCents = options.borrowingBaseInCents ?? 0;
  o.realizedConstructionExpensesInCents = options.realizedConstructionExpensesInCents ?? 0;
  o.isFinishedProperty = options.isFinishedProperty ?? false;
  o.isPropertySold = options.isPropertySold ?? false;
  o.currentAppraisalValueInCents = options.currentAppraisalValueInCents ?? null;
  o.advanceRateBasisPoints = options.advanceRateBasisPoints ?? 0;
  o.adjustedAdvanceRateBasisPoints = options.adjustedAdvanceRateBasisPoints ?? 0;
  o.landCostsInCents = options.landCostsInCents ?? 0;
  o.adjustedCollateralValueInCents = options.adjustedCollateralValueInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.asOfDate = options.asOfDate ?? newDate();
  o.realizedSoftCostsInCents = options.realizedSoftCostsInCents ?? 0;
  o.realizedIndirectCostsInCents = options.realizedIndirectCostsInCents ?? 0;
  o.realizedDirectCostsInCents = options.realizedDirectCostsInCents ?? 0;
  o.realizedBuilderFeeInCents = options.realizedBuilderFeeInCents ?? 0;
  o.homeboundPortionInCents = options.homeboundPortionInCents ?? 0;
  o.adjustedConstructionExpensesInCents = options.adjustedConstructionExpensesInCents ?? 0;
  o.lotCostToUnderwrittenNetSalesPriceBasisPoints = options.lotCostToUnderwrittenNetSalesPriceBasisPoints ?? 0;
  o.isEligibleForGoldmanDraw = options.isEligibleForGoldmanDraw ?? false;
  o.isLotCostToUnderwrittenNetSalesPriceEligible = options.isLotCostToUnderwrittenNetSalesPriceEligible ?? false;
  o.isOwnedLessThan_721Days = options.isOwnedLessThan_721Days ?? false;
  o.isHorizontalComplete = options.isHorizontalComplete ?? false;
  o.isAppraisalAgeAcceptable = options.isAppraisalAgeAcceptable ?? false;
  o.isInfillOrDeveloperCommunity = options.isInfillOrDeveloperCommunity ?? false;
  o.isLandCostEligible = options.isLandCostEligible ?? false;
  o.isUnderwrittenHardCostEligible = options.isUnderwrittenHardCostEligible ?? false;
  o.isLandCostAndConstructionExpensesEligible = options.isLandCostAndConstructionExpensesEligible ?? false;
  o.isUnderwrittenMarginEligible = options.isUnderwrittenMarginEligible ?? false;
  o.isBedroomsEligible = options.isBedroomsEligible ?? false;
  o.isSqftEligible = options.isSqftEligible ?? false;
  o.isBathroomsEligible = options.isBathroomsEligible ?? false;
  o.isExpandedBuy = options.isExpandedBuy ?? false;
  o.isTargetBuy = options.isTargetBuy ?? false;
  o.isLandCostTargetEligible = options.isLandCostTargetEligible ?? false;
  o.isLotCostToUnderwrittenNetSalesPriceTargetEligible = options.isLotCostToUnderwrittenNetSalesPriceTargetEligible ??
    false;
  o.isConstructionExpensesTargetEligible = options.isConstructionExpensesTargetEligible ?? false;
  o.isLandCostAndConstructionExpensesTargetEligible = options.isLandCostAndConstructionExpensesTargetEligible ?? false;
  o.lotPartitionDrawRequest = maybeNewOrNull("LotPartitionDrawRequest", options.lotPartitionDrawRequest, cache);
  o.borrowingBaseWithExcessConcentrationLimitInCents = options.borrowingBaseWithExcessConcentrationLimitInCents ?? 0;
  o.advanceRatePreconBasisPoints = options.advanceRatePreconBasisPoints ?? 0;
  o.isBlueprintCostDataSet = options.isBlueprintCostDataSet ?? null;
  o.costItems = (options.costItems ?? []).map((i) =>
    maybeNew("GoldmanDrawModelCostItem", i, cache, options.hasOwnProperty("costItems"))
  );
  o.isVictoryOverride = options.isVictoryOverride ?? null;
  o.isVerticalComplete = options.isVerticalComplete ?? false;
  o.underwrittenSalesPriceMarginBasisPoints = options.underwrittenSalesPriceMarginBasisPoints ?? 0;
  return o;
}

factories["GoldmanDrawModel"] = newGoldmanDrawModel;

export interface SaveGoldmanDrawModelsResultOptions {
  __typename?: "SaveGoldmanDrawModelsResult";
  goldmanDrawModels?: Array<GoldmanDrawModelOptions>;
}

export function newSaveGoldmanDrawModelsResult(
  options: SaveGoldmanDrawModelsResultOptions = {},
  cache: Record<string, any> = {},
): SaveGoldmanDrawModelsResult {
  const o = (options.__typename ? options : cache["SaveGoldmanDrawModelsResult"] = {}) as SaveGoldmanDrawModelsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGoldmanDrawModelsResult";
  o.goldmanDrawModels = (options.goldmanDrawModels ?? []).map((i) =>
    maybeNew("GoldmanDrawModel", i, cache, options.hasOwnProperty("goldmanDrawModels"))
  );
  return o;
}

factories["SaveGoldmanDrawModelsResult"] = newSaveGoldmanDrawModelsResult;

export interface GoldmanDrawModelCostItemOptions {
  __typename?: "GoldmanDrawModelCostItem";
  id?: GoldmanDrawModelCostItem["id"];
  amountInCents?: GoldmanDrawModelCostItem["amountInCents"];
  costCodeNumber?: GoldmanDrawModelCostItem["costCodeNumber"];
  goldmanDrawModel?: GoldmanDrawModelOptions;
  costType?: CostTypeDetailOptions | CostType;
  date?: GoldmanDrawModelCostItem["date"];
  billNumber?: GoldmanDrawModelCostItem["billNumber"];
}

export function newGoldmanDrawModelCostItem(
  options: GoldmanDrawModelCostItemOptions = {},
  cache: Record<string, any> = {},
): GoldmanDrawModelCostItem {
  const o = (options.__typename ? options : cache["GoldmanDrawModelCostItem"] = {}) as GoldmanDrawModelCostItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GoldmanDrawModelCostItem";
  o.id = options.id ?? nextFactoryId("GoldmanDrawModelCostItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.costCodeNumber = options.costCodeNumber ?? "costCodeNumber";
  o.goldmanDrawModel = maybeNew(
    "GoldmanDrawModel",
    options.goldmanDrawModel,
    cache,
    options.hasOwnProperty("goldmanDrawModel"),
  );
  o.costType = enumOrDetailOfCostType(options.costType);
  o.date = options.date ?? newDate();
  o.billNumber = options.billNumber ?? null;
  return o;
}

factories["GoldmanDrawModelCostItem"] = newGoldmanDrawModelCostItem;

export interface SaveGoldmanDrawModelCostItemResultOptions {
  __typename?: "SaveGoldmanDrawModelCostItemResult";
  goldmanDrawModelCostItem?: GoldmanDrawModelCostItemOptions;
}

export function newSaveGoldmanDrawModelCostItemResult(
  options: SaveGoldmanDrawModelCostItemResultOptions = {},
  cache: Record<string, any> = {},
): SaveGoldmanDrawModelCostItemResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveGoldmanDrawModelCostItemResult"] = {}) as SaveGoldmanDrawModelCostItemResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveGoldmanDrawModelCostItemResult";
  o.goldmanDrawModelCostItem = maybeNew(
    "GoldmanDrawModelCostItem",
    options.goldmanDrawModelCostItem,
    cache,
    options.hasOwnProperty("goldmanDrawModelCostItem"),
  );
  return o;
}

factories["SaveGoldmanDrawModelCostItemResult"] = newSaveGoldmanDrawModelCostItemResult;

export interface HelloWorldOptions {
  __typename?: "HelloWorld";
  id?: HelloWorld["id"];
  name?: HelloWorld["name"];
  description?: HelloWorld["description"];
  priceInCents?: HelloWorld["priceInCents"];
  createdAt?: HelloWorld["createdAt"];
  updatedAt?: HelloWorld["updatedAt"];
  isActive?: HelloWorld["isActive"];
}

export function newHelloWorld(options: HelloWorldOptions = {}, cache: Record<string, any> = {}): HelloWorld {
  const o = (options.__typename ? options : cache["HelloWorld"] = {}) as HelloWorld;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HelloWorld";
  o.id = options.id ?? nextFactoryId("HelloWorld");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isActive = options.isActive ?? null;
  return o;
}

factories["HelloWorld"] = newHelloWorld;

export interface SaveHelloWorldResultOptions {
  __typename?: "SaveHelloWorldResult";
  helloWorld?: HelloWorldOptions;
}

export function newSaveHelloWorldResult(
  options: SaveHelloWorldResultOptions = {},
  cache: Record<string, any> = {},
): SaveHelloWorldResult {
  const o = (options.__typename ? options : cache["SaveHelloWorldResult"] = {}) as SaveHelloWorldResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHelloWorldResult";
  o.helloWorld = maybeNew("HelloWorld", options.helloWorld, cache, options.hasOwnProperty("helloWorld"));
  return o;
}

factories["SaveHelloWorldResult"] = newSaveHelloWorldResult;

export interface HomePriceAppreciationMonthlyMultiplierOptions {
  __typename?: "HomePriceAppreciationMonthlyMultiplier";
  id?: HomePriceAppreciationMonthlyMultiplier["id"];
  valuationDate?: HomePriceAppreciationMonthlyMultiplier["valuationDate"];
  createdAt?: HomePriceAppreciationMonthlyMultiplier["createdAt"];
  updatedAt?: HomePriceAppreciationMonthlyMultiplier["updatedAt"];
  percentile_10?: HomePriceAppreciationMonthlyMultiplier["percentile_10"];
  percentile_20?: HomePriceAppreciationMonthlyMultiplier["percentile_20"];
  percentile_50?: HomePriceAppreciationMonthlyMultiplier["percentile_50"];
  percentile_80?: HomePriceAppreciationMonthlyMultiplier["percentile_80"];
  percentile_90?: HomePriceAppreciationMonthlyMultiplier["percentile_90"];
  postalCode?: HomePriceAppreciationMonthlyMultiplier["postalCode"];
}

export function newHomePriceAppreciationMonthlyMultiplier(
  options: HomePriceAppreciationMonthlyMultiplierOptions = {},
  cache: Record<string, any> = {},
): HomePriceAppreciationMonthlyMultiplier {
  const o =
    (options.__typename
      ? options
      : cache["HomePriceAppreciationMonthlyMultiplier"] = {}) as HomePriceAppreciationMonthlyMultiplier;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HomePriceAppreciationMonthlyMultiplier";
  o.id = options.id ?? nextFactoryId("HomePriceAppreciationMonthlyMultiplier");
  o.valuationDate = options.valuationDate ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.percentile_10 = options.percentile_10 ?? "" as any;
  o.percentile_20 = options.percentile_20 ?? "" as any;
  o.percentile_50 = options.percentile_50 ?? "" as any;
  o.percentile_80 = options.percentile_80 ?? "" as any;
  o.percentile_90 = options.percentile_90 ?? "" as any;
  o.postalCode = options.postalCode ?? "postalCode";
  return o;
}

factories["HomePriceAppreciationMonthlyMultiplier"] = newHomePriceAppreciationMonthlyMultiplier;

export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  createdAt?: Homeowner["createdAt"];
  updatedAt?: Homeowner["updatedAt"];
  user?: UserOptions;
  lastActive?: Homeowner["lastActive"];
}

export function newHomeowner(options: HomeownerOptions = {}, cache: Record<string, any> = {}): Homeowner {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Homeowner";
  o.id = options.id ?? nextFactoryId("Homeowner");
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  o.lastActive = options.lastActive ?? null;
  return o;
}

factories["Homeowner"] = newHomeowner;

export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: HomeownerOptions;
}

export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerResult {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerResult";
  o.homeowner = maybeNew("Homeowner", options.homeowner, cache, options.hasOwnProperty("homeowner"));
  return o;
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

export interface InteriorImageOptions {
  __typename?: "InteriorImage";
  id?: InteriorImage["id"];
  airtableId?: InteriorImage["airtableId"];
  name?: InteriorImage["name"];
  image?: InteriorImage["image"];
  createdAt?: InteriorImage["createdAt"];
  updatedAt?: InteriorImage["updatedAt"];
  specLevelStyle?: SpecLevelStyleOptions;
  sortOrder?: InteriorImage["sortOrder"];
}

export function newInteriorImage(options: InteriorImageOptions = {}, cache: Record<string, any> = {}): InteriorImage {
  const o = (options.__typename ? options : cache["InteriorImage"] = {}) as InteriorImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InteriorImage";
  o.id = options.id ?? nextFactoryId("InteriorImage");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specLevelStyle = maybeNew(
    "SpecLevelStyle",
    options.specLevelStyle,
    cache,
    options.hasOwnProperty("specLevelStyle"),
  );
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["InteriorImage"] = newInteriorImage;

export interface SaveInteriorImageResultOptions {
  __typename?: "SaveInteriorImageResult";
  interiorImage?: InteriorImageOptions;
}

export function newSaveInteriorImageResult(
  options: SaveInteriorImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveInteriorImageResult {
  const o = (options.__typename ? options : cache["SaveInteriorImageResult"] = {}) as SaveInteriorImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInteriorImageResult";
  o.interiorImage = maybeNew("InteriorImage", options.interiorImage, cache, options.hasOwnProperty("interiorImage"));
  return o;
}

factories["SaveInteriorImageResult"] = newSaveInteriorImageResult;

export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  avatarUrl?: InternalUser["avatarUrl"];
  createdAt?: InternalUser["createdAt"];
  updatedAt?: InternalUser["updatedAt"];
  user?: UserOptions;
}

export function newInternalUser(options: InternalUserOptions = {}, cache: Record<string, any> = {}): InternalUser {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalUser";
  o.id = options.id ?? nextFactoryId("InternalUser");
  o.name = options.name ?? "name";
  o.avatarUrl = options.avatarUrl ?? "avatarUrl";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNew("User", options.user, cache, options.hasOwnProperty("user"));
  return o;
}

factories["InternalUser"] = newInternalUser;

export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: InternalUserOptions;
}

export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveInternalUserResult {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInternalUserResult";
  o.internalUser = maybeNew("InternalUser", options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

export interface LotOptions {
  __typename?: "Lot";
  id?: Lot["id"];
  purchasePriceInCents?: Lot["purchasePriceInCents"];
  createdAt?: Lot["createdAt"];
  updatedAt?: Lot["updatedAt"];
  lotInvestmentStatus?: LotInvestmentStatusDetailOptions | LotInvestmentStatus;
  partitions?: Array<LotPartitionOptions>;
  salesforceOpportunityId?: Lot["salesforceOpportunityId"];
  dpid?: Lot["dpid"];
  originalUwReportId?: Lot["originalUwReportId"];
  primeEstimateSoftCostInCents?: Lot["primeEstimateSoftCostInCents"];
  primeEstimateHardCostInCents?: Lot["primeEstimateHardCostInCents"];
  primeEstimateDirectHardCostInCents?: Lot["primeEstimateDirectHardCostInCents"];
  primeEstimateIndirectHardCostInCents?: Lot["primeEstimateIndirectHardCostInCents"];
  primeEstimateOpcoMarkupInCents?: Lot["primeEstimateOpcoMarkupInCents"];
  primeEstimateReadyForClearToCloseReport?: Lot["primeEstimateReadyForClearToCloseReport"];
  primeEstimateBlueprintIds?: Lot["primeEstimateBlueprintIds"];
  primeEstimateContingencyPriceInCents?: Lot["primeEstimateContingencyPriceInCents"];
  underwrittenSoftCostInCents?: Lot["underwrittenSoftCostInCents"];
  underwrittenIndirectHardCostInCents?: Lot["underwrittenIndirectHardCostInCents"];
  underwrittenDirectHardCostInCents?: Lot["underwrittenDirectHardCostInCents"];
  underwrittenOpcoMarkupInCents?: Lot["underwrittenOpcoMarkupInCents"];
  softCostInCents?: Lot["softCostInCents"];
  indirectHardCostInCents?: Lot["indirectHardCostInCents"];
  directHardCostInCents?: Lot["directHardCostInCents"];
  opcoMarkupInCents?: Lot["opcoMarkupInCents"];
  opcoTotalCostInCents?: Lot["opcoTotalCostInCents"];
  underwrittenOpcoTotalCostInCents?: Lot["underwrittenOpcoTotalCostInCents"];
  underwrittenInterestRateBasisPoints?: Lot["underwrittenInterestRateBasisPoints"];
  underwrittenProjectedLoanDurationInDays?: Lot["underwrittenProjectedLoanDurationInDays"];
  underwrittenSiteAcquisitionMarkupBasisPoints?: Lot["underwrittenSiteAcquisitionMarkupBasisPoints"];
  underwrittenLoanToCostBasisPoints?: Lot["underwrittenLoanToCostBasisPoints"];
  weightedDurationOfDrawBasisPoints?: Lot["weightedDurationOfDrawBasisPoints"];
  address?: AddressOptions | null;
  underwrittenTotalSaleValueInCents?: Lot["underwrittenTotalSaleValueInCents"];
  underwrittenTotalNetSaleRevenueInCents?: Lot["underwrittenTotalNetSaleRevenueInCents"];
  investorMarginBasisPoints?: Lot["investorMarginBasisPoints"];
  underwrittenFinancingCostInCents?: Lot["underwrittenFinancingCostInCents"];
  underwrittenTotalCostInCents?: Lot["underwrittenTotalCostInCents"];
  underwrittenInvestorMarginBasisPoints?: Lot["underwrittenInvestorMarginBasisPoints"];
  totalCostInCents?: Lot["totalCostInCents"];
  financingCostInCents?: Lot["financingCostInCents"];
  opcoSiteAcquisitionMarkupInCents?: Lot["opcoSiteAcquisitionMarkupInCents"];
  clearToCloseUwReportId?: Lot["clearToCloseUwReportId"];
  underwrittenDate?: Lot["underwrittenDate"];
  totalSaleValueInCents?: Lot["totalSaleValueInCents"];
  totalNetSaleRevenueInCents?: Lot["totalNetSaleRevenueInCents"];
  fund?: FundOptions | null;
  underwrittenPurchasePriceInCents?: Lot["underwrittenPurchasePriceInCents"];
  underwrittenClosingCostsInCents?: Lot["underwrittenClosingCostsInCents"];
  underwrittenTotalLotAcquisitionCostsInCents?: Lot["underwrittenTotalLotAcquisitionCostsInCents"];
  isLegacyUwPurchasePrice?: Lot["isLegacyUwPurchasePrice"];
  isLegacyUwFinancingCosts?: Lot["isLegacyUwFinancingCosts"];
  acquisitionDate?: Lot["acquisitionDate"];
  equityFinancingCostInCents?: Lot["equityFinancingCostInCents"];
  equityFinancingCosts?: Array<EquityFinancingCostOptions>;
  totalEquityFinancingCostInCents?: Lot["totalEquityFinancingCostInCents"];
  legalEntityName?: Lot["legalEntityName"];
  fundContributionDate?: Lot["fundContributionDate"];
  metro?: MetroOptions | null;
  origin?: Lot["origin"];
  underContractAmountInCents?: Lot["underContractAmountInCents"];
  underContractDate?: Lot["underContractDate"];
  contingencyExpirationDate?: Lot["contingencyExpirationDate"];
  expectedCloseDate?: Lot["expectedCloseDate"];
  underwrittenPreconDurationInMonths?: Lot["underwrittenPreconDurationInMonths"];
  underwrittenConstructionDurationInMonths?: Lot["underwrittenConstructionDurationInMonths"];
  underwrittenSalesDurationInMonths?: Lot["underwrittenSalesDurationInMonths"];
  underwrittenDebtInterestRateThousandthsBasisPoints?: Lot["underwrittenDebtInterestRateThousandthsBasisPoints"];
  underwrittenUnleveredInternalRateOfReturnBasisPoints?: Lot["underwrittenUnleveredInternalRateOfReturnBasisPoints"];
  underwrittenUnleveredMultipleOnInvestedCapital?: Lot["underwrittenUnleveredMultipleOnInvestedCapital"];
  underwrittenLeveredInternalRateOfReturnBasisPoints?: Lot["underwrittenLeveredInternalRateOfReturnBasisPoints"];
  underwrittenLeveredMultipleOnInvestedCapital?: Lot["underwrittenLeveredMultipleOnInvestedCapital"];
  realizedPreconDurationInMonths?: Lot["realizedPreconDurationInMonths"];
  realizedConstructionDurationInMonths?: Lot["realizedConstructionDurationInMonths"];
  realizedSalesDurationInMonths?: Lot["realizedSalesDurationInMonths"];
  realizedUnleveredInternalRateOfReturnBasisPoints?: Lot["realizedUnleveredInternalRateOfReturnBasisPoints"];
  realizedUnleveredMultipleOnInvestedCapital?: Lot["realizedUnleveredMultipleOnInvestedCapital"];
  realizedLeveredMultipleOnInvestedCapital?: Lot["realizedLeveredMultipleOnInvestedCapital"];
  realizedLeveredInternalRateOfReturnBasisPoints?: Lot["realizedLeveredInternalRateOfReturnBasisPoints"];
  realizedDeltaBetweenOpcoContractedAndInvoicedInCents?: Lot["realizedDeltaBetweenOpcoContractedAndInvoicedInCents"];
  realizedUwUnleveredInternalRateOfReturnBasisPoints?: Lot["realizedUwUnleveredInternalRateOfReturnBasisPoints"];
  realizedUwUnleveredMultipleOnInvestedCapital?: Lot["realizedUwUnleveredMultipleOnInvestedCapital"];
  realizedUwLeveredInternalRateOfReturnBasisPoints?: Lot["realizedUwLeveredInternalRateOfReturnBasisPoints"];
  realizedUwLeveredMultipleOnInvestedCapital?: Lot["realizedUwLeveredMultipleOnInvestedCapital"];
  realizedExpUnleveredInternalRateOfReturnBasisPoints?: Lot["realizedExpUnleveredInternalRateOfReturnBasisPoints"];
  realizedExpUnleveredMultipleOnInvestedCapital?: Lot["realizedExpUnleveredMultipleOnInvestedCapital"];
  realizedExpLeveredMultipleOnInvestedCapital?: Lot["realizedExpLeveredMultipleOnInvestedCapital"];
  realizedExpLeveredInternalRateOfReturnBasisPoints?: Lot["realizedExpLeveredInternalRateOfReturnBasisPoints"];
  documents?: Array<DocumentOptions>;
  underwrittenUnleveredReturnOnCostBasisPoints?: Lot["underwrittenUnleveredReturnOnCostBasisPoints"];
  underwrittenLeveredReturnOnCostBasisPoints?: Lot["underwrittenLeveredReturnOnCostBasisPoints"];
  underwrittenSeniorDebtInterestAmountInCents?: Lot["underwrittenSeniorDebtInterestAmountInCents"];
  lotAcqSettlementStatement?: LotAcqSettlementStatementOptions | null;
  lotAcqPurchaseAgreement?: LotAcqPurchaseAgreementOptions | null;
  canEditFund?: PotentialOperationOptions;
  fundOwnerEntity?: FundOwnerEntityOptions | null;
  canSendCustomerInformationToBlueprint?: PotentialOperationOptions;
  isLegacyIrr?: Lot["isLegacyIrr"];
  ownerEntitySentToBlueprint?: Lot["ownerEntitySentToBlueprint"];
  canContractDirectUnderwriting?: PotentialOperationOptions;
  isSuburban?: Lot["isSuburban"];
}

export function newLot(options: LotOptions = {}, cache: Record<string, any> = {}): Lot {
  const o = (options.__typename ? options : cache["Lot"] = {}) as Lot;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Lot";
  o.id = options.id ?? nextFactoryId("Lot");
  o.purchasePriceInCents = options.purchasePriceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lotInvestmentStatus = enumOrDetailOfLotInvestmentStatus(options.lotInvestmentStatus);
  o.partitions = (options.partitions ?? []).map((i) =>
    maybeNew("LotPartition", i, cache, options.hasOwnProperty("partitions"))
  );
  o.salesforceOpportunityId = options.salesforceOpportunityId ?? null;
  o.dpid = options.dpid ?? null;
  o.originalUwReportId = options.originalUwReportId ?? null;
  o.primeEstimateSoftCostInCents = options.primeEstimateSoftCostInCents ?? 0;
  o.primeEstimateHardCostInCents = options.primeEstimateHardCostInCents ?? 0;
  o.primeEstimateDirectHardCostInCents = options.primeEstimateDirectHardCostInCents ?? 0;
  o.primeEstimateIndirectHardCostInCents = options.primeEstimateIndirectHardCostInCents ?? 0;
  o.primeEstimateOpcoMarkupInCents = options.primeEstimateOpcoMarkupInCents ?? 0;
  o.primeEstimateReadyForClearToCloseReport = options.primeEstimateReadyForClearToCloseReport ?? false;
  o.primeEstimateBlueprintIds = options.primeEstimateBlueprintIds ?? [];
  o.primeEstimateContingencyPriceInCents = options.primeEstimateContingencyPriceInCents ?? 0;
  o.underwrittenSoftCostInCents = options.underwrittenSoftCostInCents ?? "" as any;
  o.underwrittenIndirectHardCostInCents = options.underwrittenIndirectHardCostInCents ?? "" as any;
  o.underwrittenDirectHardCostInCents = options.underwrittenDirectHardCostInCents ?? "" as any;
  o.underwrittenOpcoMarkupInCents = options.underwrittenOpcoMarkupInCents ?? "" as any;
  o.softCostInCents = options.softCostInCents ?? "" as any;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? "" as any;
  o.directHardCostInCents = options.directHardCostInCents ?? "" as any;
  o.opcoMarkupInCents = options.opcoMarkupInCents ?? "" as any;
  o.opcoTotalCostInCents = options.opcoTotalCostInCents ?? "" as any;
  o.underwrittenOpcoTotalCostInCents = options.underwrittenOpcoTotalCostInCents ?? "" as any;
  o.underwrittenInterestRateBasisPoints = options.underwrittenInterestRateBasisPoints ?? 0;
  o.underwrittenProjectedLoanDurationInDays = options.underwrittenProjectedLoanDurationInDays ?? 0;
  o.underwrittenSiteAcquisitionMarkupBasisPoints = options.underwrittenSiteAcquisitionMarkupBasisPoints ?? 0;
  o.underwrittenLoanToCostBasisPoints = options.underwrittenLoanToCostBasisPoints ?? 0;
  o.weightedDurationOfDrawBasisPoints = options.weightedDurationOfDrawBasisPoints ?? 0;
  o.address = maybeNewOrNull("Address", options.address, cache);
  o.underwrittenTotalSaleValueInCents = options.underwrittenTotalSaleValueInCents ?? "" as any;
  o.underwrittenTotalNetSaleRevenueInCents = options.underwrittenTotalNetSaleRevenueInCents ?? "" as any;
  o.investorMarginBasisPoints = options.investorMarginBasisPoints ?? 0;
  o.underwrittenFinancingCostInCents = options.underwrittenFinancingCostInCents ?? 0;
  o.underwrittenTotalCostInCents = options.underwrittenTotalCostInCents ?? "" as any;
  o.underwrittenInvestorMarginBasisPoints = options.underwrittenInvestorMarginBasisPoints ?? 0;
  o.totalCostInCents = options.totalCostInCents ?? "" as any;
  o.financingCostInCents = options.financingCostInCents ?? 0;
  o.opcoSiteAcquisitionMarkupInCents = options.opcoSiteAcquisitionMarkupInCents ?? 0;
  o.clearToCloseUwReportId = options.clearToCloseUwReportId ?? null;
  o.underwrittenDate = options.underwrittenDate ?? null;
  o.totalSaleValueInCents = options.totalSaleValueInCents ?? "" as any;
  o.totalNetSaleRevenueInCents = options.totalNetSaleRevenueInCents ?? "" as any;
  o.fund = maybeNewOrNull("Fund", options.fund, cache);
  o.underwrittenPurchasePriceInCents = options.underwrittenPurchasePriceInCents ?? 0;
  o.underwrittenClosingCostsInCents = options.underwrittenClosingCostsInCents ?? 0;
  o.underwrittenTotalLotAcquisitionCostsInCents = options.underwrittenTotalLotAcquisitionCostsInCents ?? 0;
  o.isLegacyUwPurchasePrice = options.isLegacyUwPurchasePrice ?? null;
  o.isLegacyUwFinancingCosts = options.isLegacyUwFinancingCosts ?? null;
  o.acquisitionDate = options.acquisitionDate ?? null;
  o.equityFinancingCostInCents = options.equityFinancingCostInCents ?? 0;
  o.equityFinancingCosts = (options.equityFinancingCosts ?? []).map((i) =>
    maybeNew("EquityFinancingCost", i, cache, options.hasOwnProperty("equityFinancingCosts"))
  );
  o.totalEquityFinancingCostInCents = options.totalEquityFinancingCostInCents ?? 0;
  o.legalEntityName = options.legalEntityName ?? null;
  o.fundContributionDate = options.fundContributionDate ?? null;
  o.metro = maybeNewOrNull("Metro", options.metro, cache);
  o.origin = options.origin ?? null;
  o.underContractAmountInCents = options.underContractAmountInCents ?? 0;
  o.underContractDate = options.underContractDate ?? null;
  o.contingencyExpirationDate = options.contingencyExpirationDate ?? null;
  o.expectedCloseDate = options.expectedCloseDate ?? null;
  o.underwrittenPreconDurationInMonths = options.underwrittenPreconDurationInMonths ?? null;
  o.underwrittenConstructionDurationInMonths = options.underwrittenConstructionDurationInMonths ?? null;
  o.underwrittenSalesDurationInMonths = options.underwrittenSalesDurationInMonths ?? null;
  o.underwrittenDebtInterestRateThousandthsBasisPoints = options.underwrittenDebtInterestRateThousandthsBasisPoints ??
    null;
  o.underwrittenUnleveredInternalRateOfReturnBasisPoints =
    options.underwrittenUnleveredInternalRateOfReturnBasisPoints ?? null;
  o.underwrittenUnleveredMultipleOnInvestedCapital = options.underwrittenUnleveredMultipleOnInvestedCapital ?? null;
  o.underwrittenLeveredInternalRateOfReturnBasisPoints = options.underwrittenLeveredInternalRateOfReturnBasisPoints ??
    null;
  o.underwrittenLeveredMultipleOnInvestedCapital = options.underwrittenLeveredMultipleOnInvestedCapital ?? null;
  o.realizedPreconDurationInMonths = options.realizedPreconDurationInMonths ?? null;
  o.realizedConstructionDurationInMonths = options.realizedConstructionDurationInMonths ?? null;
  o.realizedSalesDurationInMonths = options.realizedSalesDurationInMonths ?? null;
  o.realizedUnleveredInternalRateOfReturnBasisPoints = options.realizedUnleveredInternalRateOfReturnBasisPoints ?? null;
  o.realizedUnleveredMultipleOnInvestedCapital = options.realizedUnleveredMultipleOnInvestedCapital ?? null;
  o.realizedLeveredMultipleOnInvestedCapital = options.realizedLeveredMultipleOnInvestedCapital ?? null;
  o.realizedLeveredInternalRateOfReturnBasisPoints = options.realizedLeveredInternalRateOfReturnBasisPoints ?? null;
  o.realizedDeltaBetweenOpcoContractedAndInvoicedInCents =
    options.realizedDeltaBetweenOpcoContractedAndInvoicedInCents ?? null;
  o.realizedUwUnleveredInternalRateOfReturnBasisPoints = options.realizedUwUnleveredInternalRateOfReturnBasisPoints ??
    null;
  o.realizedUwUnleveredMultipleOnInvestedCapital = options.realizedUwUnleveredMultipleOnInvestedCapital ?? null;
  o.realizedUwLeveredInternalRateOfReturnBasisPoints = options.realizedUwLeveredInternalRateOfReturnBasisPoints ?? null;
  o.realizedUwLeveredMultipleOnInvestedCapital = options.realizedUwLeveredMultipleOnInvestedCapital ?? null;
  o.realizedExpUnleveredInternalRateOfReturnBasisPoints = options.realizedExpUnleveredInternalRateOfReturnBasisPoints ??
    null;
  o.realizedExpUnleveredMultipleOnInvestedCapital = options.realizedExpUnleveredMultipleOnInvestedCapital ?? null;
  o.realizedExpLeveredMultipleOnInvestedCapital = options.realizedExpLeveredMultipleOnInvestedCapital ?? null;
  o.realizedExpLeveredInternalRateOfReturnBasisPoints = options.realizedExpLeveredInternalRateOfReturnBasisPoints ??
    null;
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.underwrittenUnleveredReturnOnCostBasisPoints = options.underwrittenUnleveredReturnOnCostBasisPoints ?? null;
  o.underwrittenLeveredReturnOnCostBasisPoints = options.underwrittenLeveredReturnOnCostBasisPoints ?? null;
  o.underwrittenSeniorDebtInterestAmountInCents = options.underwrittenSeniorDebtInterestAmountInCents ?? null;
  o.lotAcqSettlementStatement = maybeNewOrNull("LotAcqSettlementStatement", options.lotAcqSettlementStatement, cache);
  o.lotAcqPurchaseAgreement = maybeNewOrNull("LotAcqPurchaseAgreement", options.lotAcqPurchaseAgreement, cache);
  o.canEditFund = maybeNew("PotentialOperation", options.canEditFund, cache, options.hasOwnProperty("canEditFund"));
  o.fundOwnerEntity = maybeNewOrNull("FundOwnerEntity", options.fundOwnerEntity, cache);
  o.canSendCustomerInformationToBlueprint = maybeNew(
    "PotentialOperation",
    options.canSendCustomerInformationToBlueprint,
    cache,
    options.hasOwnProperty("canSendCustomerInformationToBlueprint"),
  );
  o.isLegacyIrr = options.isLegacyIrr ?? false;
  o.ownerEntitySentToBlueprint = options.ownerEntitySentToBlueprint ?? false;
  o.canContractDirectUnderwriting = maybeNew(
    "PotentialOperation",
    options.canContractDirectUnderwriting,
    cache,
    options.hasOwnProperty("canContractDirectUnderwriting"),
  );
  o.isSuburban = options.isSuburban ?? false;
  return o;
}

factories["Lot"] = newLot;

export interface SaveLotResultOptions {
  __typename?: "SaveLotResult";
  lot?: LotOptions;
}

export function newSaveLotResult(options: SaveLotResultOptions = {}, cache: Record<string, any> = {}): SaveLotResult {
  const o = (options.__typename ? options : cache["SaveLotResult"] = {}) as SaveLotResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotResult";
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["SaveLotResult"] = newSaveLotResult;

export interface SaveLotsResultOptions {
  __typename?: "SaveLotsResult";
  lots?: Array<LotOptions>;
}

export function newSaveLotsResult(
  options: SaveLotsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotsResult {
  const o = (options.__typename ? options : cache["SaveLotsResult"] = {}) as SaveLotsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotsResult";
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  return o;
}

factories["SaveLotsResult"] = newSaveLotsResult;

export interface BackfillUnderwrittenReturnMetricsResultOptions {
  __typename?: "BackfillUnderwrittenReturnMetricsResult";
  lots?: Array<LotOptions>;
}

export function newBackfillUnderwrittenReturnMetricsResult(
  options: BackfillUnderwrittenReturnMetricsResultOptions = {},
  cache: Record<string, any> = {},
): BackfillUnderwrittenReturnMetricsResult {
  const o =
    (options.__typename
      ? options
      : cache["BackfillUnderwrittenReturnMetricsResult"] = {}) as BackfillUnderwrittenReturnMetricsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BackfillUnderwrittenReturnMetricsResult";
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  return o;
}

factories["BackfillUnderwrittenReturnMetricsResult"] = newBackfillUnderwrittenReturnMetricsResult;

export interface SendCustomerInformationToBlueprintResultOptions {
  __typename?: "SendCustomerInformationToBlueprintResult";
  lot?: LotOptions;
}

export function newSendCustomerInformationToBlueprintResult(
  options: SendCustomerInformationToBlueprintResultOptions = {},
  cache: Record<string, any> = {},
): SendCustomerInformationToBlueprintResult {
  const o =
    (options.__typename
      ? options
      : cache["SendCustomerInformationToBlueprintResult"] = {}) as SendCustomerInformationToBlueprintResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SendCustomerInformationToBlueprintResult";
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["SendCustomerInformationToBlueprintResult"] = newSendCustomerInformationToBlueprintResult;

export interface CreateDirectUnderwritingContractsResultOptions {
  __typename?: "CreateDirectUnderwritingContractsResult";
  lot?: LotOptions;
}

export function newCreateDirectUnderwritingContractsResult(
  options: CreateDirectUnderwritingContractsResultOptions = {},
  cache: Record<string, any> = {},
): CreateDirectUnderwritingContractsResult {
  const o =
    (options.__typename
      ? options
      : cache["CreateDirectUnderwritingContractsResult"] = {}) as CreateDirectUnderwritingContractsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateDirectUnderwritingContractsResult";
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["CreateDirectUnderwritingContractsResult"] = newCreateDirectUnderwritingContractsResult;

export interface LotAcqPurchaseAgreementOptions {
  __typename?: "LotAcqPurchaseAgreement";
  id?: LotAcqPurchaseAgreement["id"];
  purchasePriceInCents?: LotAcqPurchaseAgreement["purchasePriceInCents"];
  earnestMoneyInCents?: LotAcqPurchaseAgreement["earnestMoneyInCents"];
  optionFeeInCents?: LotAcqPurchaseAgreement["optionFeeInCents"];
  document?: DocumentOptions;
  lot?: LotOptions;
}

export function newLotAcqPurchaseAgreement(
  options: LotAcqPurchaseAgreementOptions = {},
  cache: Record<string, any> = {},
): LotAcqPurchaseAgreement {
  const o = (options.__typename ? options : cache["LotAcqPurchaseAgreement"] = {}) as LotAcqPurchaseAgreement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotAcqPurchaseAgreement";
  o.id = options.id ?? nextFactoryId("LotAcqPurchaseAgreement");
  o.purchasePriceInCents = options.purchasePriceInCents ?? 0;
  o.earnestMoneyInCents = options.earnestMoneyInCents ?? 0;
  o.optionFeeInCents = options.optionFeeInCents ?? 0;
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  return o;
}

factories["LotAcqPurchaseAgreement"] = newLotAcqPurchaseAgreement;

export interface SaveLotAcqPurchaseAgreementResultOptions {
  __typename?: "SaveLotAcqPurchaseAgreementResult";
  lotAcqPurchaseAgreement?: LotAcqPurchaseAgreementOptions;
}

export function newSaveLotAcqPurchaseAgreementResult(
  options: SaveLotAcqPurchaseAgreementResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotAcqPurchaseAgreementResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveLotAcqPurchaseAgreementResult"] = {}) as SaveLotAcqPurchaseAgreementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotAcqPurchaseAgreementResult";
  o.lotAcqPurchaseAgreement = maybeNew(
    "LotAcqPurchaseAgreement",
    options.lotAcqPurchaseAgreement,
    cache,
    options.hasOwnProperty("lotAcqPurchaseAgreement"),
  );
  return o;
}

factories["SaveLotAcqPurchaseAgreementResult"] = newSaveLotAcqPurchaseAgreementResult;

export interface LotAcqSettlementStatementOptions {
  __typename?: "LotAcqSettlementStatement";
  id?: LotAcqSettlementStatement["id"];
  document?: DocumentOptions;
  lot?: LotOptions;
  lineItems?: Array<LotAcqSettlementStatementLineItemOptions>;
  totalDebitsInCents?: LotAcqSettlementStatement["totalDebitsInCents"];
  totalCreditsInCents?: LotAcqSettlementStatement["totalCreditsInCents"];
  ocrRawJson?: LotAcqSettlementStatement["ocrRawJson"];
  bookingEventRawJson?: LotAcqSettlementStatement["bookingEventRawJson"];
  bookingEventSent?: LotAcqSettlementStatement["bookingEventSent"];
  canSendForBooking?: PotentialOperationOptions;
  buyerName?: LotAcqSettlementStatement["buyerName"];
  settlementDate?: LotAcqSettlementStatement["settlementDate"];
}

export function newLotAcqSettlementStatement(
  options: LotAcqSettlementStatementOptions = {},
  cache: Record<string, any> = {},
): LotAcqSettlementStatement {
  const o = (options.__typename ? options : cache["LotAcqSettlementStatement"] = {}) as LotAcqSettlementStatement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotAcqSettlementStatement";
  o.id = options.id ?? nextFactoryId("LotAcqSettlementStatement");
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("LotAcqSettlementStatementLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.totalDebitsInCents = options.totalDebitsInCents ?? 0;
  o.totalCreditsInCents = options.totalCreditsInCents ?? 0;
  o.ocrRawJson = options.ocrRawJson ?? null;
  o.bookingEventRawJson = options.bookingEventRawJson ?? null;
  o.bookingEventSent = options.bookingEventSent ?? false;
  o.canSendForBooking = maybeNew(
    "PotentialOperation",
    options.canSendForBooking,
    cache,
    options.hasOwnProperty("canSendForBooking"),
  );
  o.buyerName = options.buyerName ?? null;
  o.settlementDate = options.settlementDate ?? null;
  return o;
}

factories["LotAcqSettlementStatement"] = newLotAcqSettlementStatement;

export interface SaveLotAcqSettlementStatementResultOptions {
  __typename?: "SaveLotAcqSettlementStatementResult";
  lotAcqSettlementStatement?: LotAcqSettlementStatementOptions;
}

export function newSaveLotAcqSettlementStatementResult(
  options: SaveLotAcqSettlementStatementResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotAcqSettlementStatementResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveLotAcqSettlementStatementResult"] = {}) as SaveLotAcqSettlementStatementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotAcqSettlementStatementResult";
  o.lotAcqSettlementStatement = maybeNew(
    "LotAcqSettlementStatement",
    options.lotAcqSettlementStatement,
    cache,
    options.hasOwnProperty("lotAcqSettlementStatement"),
  );
  return o;
}

factories["SaveLotAcqSettlementStatementResult"] = newSaveLotAcqSettlementStatementResult;

export interface LotAcqSettlementStatementLineItemOptions {
  __typename?: "LotAcqSettlementStatementLineItem";
  id?: LotAcqSettlementStatementLineItem["id"];
  amountInCents?: LotAcqSettlementStatementLineItem["amountInCents"];
  type?: LotAcqSettlementStatementLineItemTypeDetailOptions | LotAcqSettlementStatementLineItemType;
  lotAcqSettlementStatement?: LotAcqSettlementStatementOptions;
  notes?: LotAcqSettlementStatementLineItem["notes"];
}

export function newLotAcqSettlementStatementLineItem(
  options: LotAcqSettlementStatementLineItemOptions = {},
  cache: Record<string, any> = {},
): LotAcqSettlementStatementLineItem {
  const o =
    (options.__typename
      ? options
      : cache["LotAcqSettlementStatementLineItem"] = {}) as LotAcqSettlementStatementLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotAcqSettlementStatementLineItem";
  o.id = options.id ?? nextFactoryId("LotAcqSettlementStatementLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.type = enumOrDetailOfLotAcqSettlementStatementLineItemType(options.type);
  o.lotAcqSettlementStatement = maybeNew(
    "LotAcqSettlementStatement",
    options.lotAcqSettlementStatement,
    cache,
    options.hasOwnProperty("lotAcqSettlementStatement"),
  );
  o.notes = options.notes ?? null;
  return o;
}

factories["LotAcqSettlementStatementLineItem"] = newLotAcqSettlementStatementLineItem;

export interface LotPartitionOptions {
  __typename?: "LotPartition";
  id?: LotPartition["id"];
  basePriceInCents?: LotPartition["basePriceInCents"];
  listPriceInCents?: LotPartition["listPriceInCents"];
  salePriceInCents?: LotPartition["salePriceInCents"];
  moveInDate?: LotPartition["moveInDate"];
  createdAt?: LotPartition["createdAt"];
  updatedAt?: LotPartition["updatedAt"];
  lot?: LotOptions;
  blueprintProjectId?: LotPartition["blueprintProjectId"];
  lotPartitionSalesStatus?: LotPartitionSalesStatusDetailOptions | LotPartitionSalesStatus;
  estimates?: Array<LotPartitionEstimateOptions>;
  underwrittenSoftCostInCents?: LotPartition["underwrittenSoftCostInCents"];
  underwrittenIndirectHardCostInCents?: LotPartition["underwrittenIndirectHardCostInCents"];
  underwrittenDirectHardCostInCents?: LotPartition["underwrittenDirectHardCostInCents"];
  underwrittenOpcoMarkupInCents?: LotPartition["underwrittenOpcoMarkupInCents"];
  underwrittenOpcoTotalCostInCents?: LotPartition["underwrittenOpcoTotalCostInCents"];
  softCostInCents?: LotPartition["softCostInCents"];
  indirectHardCostInCents?: LotPartition["indirectHardCostInCents"];
  directHardCostInCents?: LotPartition["directHardCostInCents"];
  opcoMarkupInCents?: LotPartition["opcoMarkupInCents"];
  opcoTotalCostInCents?: LotPartition["opcoTotalCostInCents"];
  contracts?: Array<LotPartitionContractOptions>;
  underwrittenSalesPriceInCents?: LotPartition["underwrittenSalesPriceInCents"];
  underwrittenSalesCommissionBasisPoints?: LotPartition["underwrittenSalesCommissionBasisPoints"];
  valuations?: Array<LotPartitionValuationOptions>;
  salesPriceAtValuationDateInCents?: LotPartition["salesPriceAtValuationDateInCents"];
  valuationDate?: LotPartition["valuationDate"];
  expectedCompletionDate?: LotPartition["expectedCompletionDate"];
  expectedSalePriceInCents?: LotPartition["expectedSalePriceInCents"];
  appreciationMultiplier?: LotPartition["appreciationMultiplier"];
  draws?: Array<LotPartitionDrawOptions>;
  underwrittenSalesPriceWithoutAppreciationInCents?: LotPartition["underwrittenSalesPriceWithoutAppreciationInCents"];
  valuationReportId?: LotPartition["valuationReportId"];
  underwrittenReadyPlanId?: LotPartition["underwrittenReadyPlanId"];
  underwrittenReadyPlanOptionIds?: LotPartition["underwrittenReadyPlanOptionIds"];
  listDate?: LotPartition["listDate"];
  isLegacyUwRevenue?: LotPartition["isLegacyUwRevenue"];
  underwrittenNetSalesPriceInCents?: LotPartition["underwrittenNetSalesPriceInCents"];
  payments?: Array<LotPartitionPaymentOptions>;
  equityFinancingCostInCents?: LotPartition["equityFinancingCostInCents"];
  equityFinancingCosts?: Array<EquityFinancingCostOptions>;
  saleDate?: LotPartition["saleDate"];
  lotOwnershipBasisPoints?: LotPartition["lotOwnershipBasisPoints"];
  salesforceOpportunityId?: LotPartition["salesforceOpportunityId"];
  underContractPriceInCents?: LotPartition["underContractPriceInCents"];
  commissionBuyerBasisPoints?: LotPartition["commissionBuyerBasisPoints"];
  commissionSellerBasisPoints?: LotPartition["commissionSellerBasisPoints"];
  saleIncentiveAmountInCents?: LotPartition["saleIncentiveAmountInCents"];
  assumedSaleIncentiveAmountInCents?: LotPartition["assumedSaleIncentiveAmountInCents"];
  assumedCommissionBuyerBasisPoints?: LotPartition["assumedCommissionBuyerBasisPoints"];
  assumedCommissionSellerBasisPoints?: LotPartition["assumedCommissionSellerBasisPoints"];
  salesforceHomeListingId?: LotPartition["salesforceHomeListingId"];
  underwrittenNetSalesPriceWithoutAppreciationInCents?:
    LotPartition["underwrittenNetSalesPriceWithoutAppreciationInCents"];
  netSalesPriceInCents?: LotPartition["netSalesPriceInCents"];
  realizedNetSalesPriceInCents?: LotPartition["realizedNetSalesPriceInCents"];
  underContractNetSalesPriceInCents?: LotPartition["underContractNetSalesPriceInCents"];
  listedNetSalesPriceInCents?: LotPartition["listedNetSalesPriceInCents"];
  estimateNetSalesPriceInCents?: LotPartition["estimateNetSalesPriceInCents"];
  grossSalesPriceInCents?: LotPartition["grossSalesPriceInCents"];
  notes?: LotPartition["notes"];
  underwrittenLotOwnershipBasisPoints?: LotPartition["underwrittenLotOwnershipBasisPoints"];
  underwrittenTotalCostInCents?: LotPartition["underwrittenTotalCostInCents"];
  underwrittenInvestorMarginBasisPoints?: LotPartition["underwrittenInvestorMarginBasisPoints"];
  salesReadyDate?: LotPartition["salesReadyDate"];
  preListDate?: LotPartition["preListDate"];
  valuationAtSalesReadyDateInCents?: LotPartition["valuationAtSalesReadyDateInCents"];
  valuationAtPreListDateInCents?: LotPartition["valuationAtPreListDateInCents"];
  salesReadyAppreciationMultiplier?: LotPartition["salesReadyAppreciationMultiplier"];
  preListAppreciationMultiplier?: LotPartition["preListAppreciationMultiplier"];
  seasonalityMultiplier?: LotPartition["seasonalityMultiplier"];
  expectedSalePriceSeasonalityOnlyInCents?: LotPartition["expectedSalePriceSeasonalityOnlyInCents"];
  salesReadySeasonalityMultiplier?: LotPartition["salesReadySeasonalityMultiplier"];
  valuationAtSalesReadyDateSeasonalityOnlyInCents?: LotPartition["valuationAtSalesReadyDateSeasonalityOnlyInCents"];
  preListSeasonalityMultiplier?: LotPartition["preListSeasonalityMultiplier"];
  valuationAtPreListDateSeasonalityOnlyInCents?: LotPartition["valuationAtPreListDateSeasonalityOnlyInCents"];
  underwrittenOpcoMarkupBasisPoints?: LotPartition["underwrittenOpcoMarkupBasisPoints"];
  opcoMarkupBasisPoints?: LotPartition["opcoMarkupBasisPoints"];
  expectedListSeasonalityMultiplier?: LotPartition["expectedListSeasonalityMultiplier"];
  valuationAtExpectedListDateSeasonalityOnlyInCents?: LotPartition["valuationAtExpectedListDateSeasonalityOnlyInCents"];
  grossSalesPriceLessIncentivesInCents?: LotPartition["grossSalesPriceLessIncentivesInCents"];
  closingCostsInCents?: LotPartition["closingCostsInCents"];
  assumedClosingCostsInCents?: LotPartition["assumedClosingCostsInCents"];
  assumedCommissionEstimateBuyerInCents?: LotPartition["assumedCommissionEstimateBuyerInCents"];
  assumedCommissionEstimateSellerInCents?: LotPartition["assumedCommissionEstimateSellerInCents"];
  assumedCommissionListBuyerInCents?: LotPartition["assumedCommissionListBuyerInCents"];
  assumedCommissionListSellerInCents?: LotPartition["assumedCommissionListSellerInCents"];
  commissionUnderContractBuyerInCents?: LotPartition["commissionUnderContractBuyerInCents"];
  commissionUnderContractSellerInCents?: LotPartition["commissionUnderContractSellerInCents"];
  commissionRealizedBuyerInCents?: LotPartition["commissionRealizedBuyerInCents"];
  commissionRealizedSellerInCents?: LotPartition["commissionRealizedSellerInCents"];
  appliedSeasonalityMultiplier?: LotPartition["appliedSeasonalityMultiplier"];
  appliedListToCloseRatioBasisPoints?: LotPartition["appliedListToCloseRatioBasisPoints"];
  appliedClosingCostsInCents?: LotPartition["appliedClosingCostsInCents"];
  permitSubmittedDate?: LotPartition["permitSubmittedDate"];
  permitApprovedDate?: LotPartition["permitApprovedDate"];
  verticalBuildStartDate?: LotPartition["verticalBuildStartDate"];
  underContractDate?: LotPartition["underContractDate"];
  goldmanDrawModel?: GoldmanDrawModelOptions | null;
  isVerticalConstructionComplete?: LotPartition["isVerticalConstructionComplete"];
  isVerticalConstructionStarted?: LotPartition["isVerticalConstructionStarted"];
  drawRequests?: Array<LotPartitionDrawRequestOptions>;
  borrowedAmountInCents?: LotPartition["borrowedAmountInCents"];
  modeledAmountToBorrowInCents?: LotPartition["modeledAmountToBorrowInCents"];
  goldmanDrawModels?: Array<GoldmanDrawModelOptions>;
  appraisalValueInCents?: LotPartition["appraisalValueInCents"];
  appraisalDate?: LotPartition["appraisalDate"];
  invoices?: Array<LotPartitionInvoiceOptions>;
  realizedUnleveredInternalRateOfReturnBasisPoints?: LotPartition["realizedUnleveredInternalRateOfReturnBasisPoints"];
  realizedUnleveredMultipleOnInvestedCapital?: LotPartition["realizedUnleveredMultipleOnInvestedCapital"];
  realizedLeveredMultipleOnInvestedCapital?: LotPartition["realizedLeveredMultipleOnInvestedCapital"];
  realizedLeveredInternalRateOfReturnBasisPoints?: LotPartition["realizedLeveredInternalRateOfReturnBasisPoints"];
  realizedDeltaBetweenOpcoContractedAndInvoicedInCents?:
    LotPartition["realizedDeltaBetweenOpcoContractedAndInvoicedInCents"];
  underContractPersonalizationPriceInCents?: LotPartition["underContractPersonalizationPriceInCents"];
  underContractGrossSalesPriceInCents?: LotPartition["underContractGrossSalesPriceInCents"];
  commissionBuyerFixedAmountInCents?: LotPartition["commissionBuyerFixedAmountInCents"];
  commissionSellerFixedAmountInCents?: LotPartition["commissionSellerFixedAmountInCents"];
  blueprintRemediationProjectId?: LotPartition["blueprintRemediationProjectId"];
  remediationExpectedCompletionDate?: LotPartition["remediationExpectedCompletionDate"];
  isRemediationVerticalConstructionComplete?: LotPartition["isRemediationVerticalConstructionComplete"];
  underwrittenDirectMarginBasisPoints?: LotPartition["underwrittenDirectMarginBasisPoints"];
  directMarginBasisPoints?: LotPartition["directMarginBasisPoints"];
  manualExpectedSaleDate?: LotPartition["manualExpectedSaleDate"];
  expectedSaleDate?: LotPartition["expectedSaleDate"];
  anchorMultilotBaseDrawModel?: AnchorMultilotDrawModelOptions | null;
  anchorMultilotDrawModels?: Array<AnchorMultilotDrawModelOptions>;
  readyPlanId?: LotPartition["readyPlanId"];
  readyPlanOptionIds?: LotPartition["readyPlanOptionIds"];
  unleveredReturnOnCostBasisPoints?: LotPartition["unleveredReturnOnCostBasisPoints"];
  purchasePriceInCents?: LotPartition["purchasePriceInCents"];
  closingCostsForDirectMarginInCents?: LotPartition["closingCostsForDirectMarginInCents"];
  directUnderwritingSoftCostsInCents?: LotPartition["directUnderwritingSoftCostsInCents"];
  directUnderwritingHardCostsInCents?: LotPartition["directUnderwritingHardCostsInCents"];
  directUnderwritingHardCostMarkupBasisPoints?: LotPartition["directUnderwritingHardCostMarkupBasisPoints"];
  anchorFloatingBaseDrawModel?: AnchorFloatingDrawModelOptions | null;
  anchorFloatingDrawModels?: Array<AnchorFloatingDrawModelOptions>;
  documents?: Array<DocumentOptions>;
  propertySaleSettlementStatement?: PropertySaleSettlementStatementOptions | null;
  proposedBasePriceInCents?: LotPartition["proposedBasePriceInCents"];
  showInCheckout?: LotPartition["showInCheckout"];
}

export function newLotPartition(options: LotPartitionOptions = {}, cache: Record<string, any> = {}): LotPartition {
  const o = (options.__typename ? options : cache["LotPartition"] = {}) as LotPartition;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartition";
  o.id = options.id ?? nextFactoryId("LotPartition");
  o.basePriceInCents = options.basePriceInCents ?? null;
  o.listPriceInCents = options.listPriceInCents ?? null;
  o.salePriceInCents = options.salePriceInCents ?? null;
  o.moveInDate = options.moveInDate ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lot = maybeNew("Lot", options.lot, cache, options.hasOwnProperty("lot"));
  o.blueprintProjectId = options.blueprintProjectId ?? null;
  o.lotPartitionSalesStatus = enumOrDetailOfLotPartitionSalesStatus(options.lotPartitionSalesStatus);
  o.estimates = (options.estimates ?? []).map((i) =>
    maybeNew("LotPartitionEstimate", i, cache, options.hasOwnProperty("estimates"))
  );
  o.underwrittenSoftCostInCents = options.underwrittenSoftCostInCents ?? 0;
  o.underwrittenIndirectHardCostInCents = options.underwrittenIndirectHardCostInCents ?? 0;
  o.underwrittenDirectHardCostInCents = options.underwrittenDirectHardCostInCents ?? 0;
  o.underwrittenOpcoMarkupInCents = options.underwrittenOpcoMarkupInCents ?? 0;
  o.underwrittenOpcoTotalCostInCents = options.underwrittenOpcoTotalCostInCents ?? 0;
  o.softCostInCents = options.softCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.opcoMarkupInCents = options.opcoMarkupInCents ?? 0;
  o.opcoTotalCostInCents = options.opcoTotalCostInCents ?? 0;
  o.contracts = (options.contracts ?? []).map((i) =>
    maybeNew("LotPartitionContract", i, cache, options.hasOwnProperty("contracts"))
  );
  o.underwrittenSalesPriceInCents = options.underwrittenSalesPriceInCents ?? 0;
  o.underwrittenSalesCommissionBasisPoints = options.underwrittenSalesCommissionBasisPoints ?? 0;
  o.valuations = (options.valuations ?? []).map((i) =>
    maybeNew("LotPartitionValuation", i, cache, options.hasOwnProperty("valuations"))
  );
  o.salesPriceAtValuationDateInCents = options.salesPriceAtValuationDateInCents ?? 0;
  o.valuationDate = options.valuationDate ?? newDate();
  o.expectedCompletionDate = options.expectedCompletionDate ?? null;
  o.expectedSalePriceInCents = options.expectedSalePriceInCents ?? 0;
  o.appreciationMultiplier = options.appreciationMultiplier ?? "" as any;
  o.draws = (options.draws ?? []).map((i) => maybeNew("LotPartitionDraw", i, cache, options.hasOwnProperty("draws")));
  o.underwrittenSalesPriceWithoutAppreciationInCents = options.underwrittenSalesPriceWithoutAppreciationInCents ?? 0;
  o.valuationReportId = options.valuationReportId ?? null;
  o.underwrittenReadyPlanId = options.underwrittenReadyPlanId ?? null;
  o.underwrittenReadyPlanOptionIds = options.underwrittenReadyPlanOptionIds ?? null;
  o.listDate = options.listDate ?? null;
  o.isLegacyUwRevenue = options.isLegacyUwRevenue ?? null;
  o.underwrittenNetSalesPriceInCents = options.underwrittenNetSalesPriceInCents ?? 0;
  o.payments = (options.payments ?? []).map((i) =>
    maybeNew("LotPartitionPayment", i, cache, options.hasOwnProperty("payments"))
  );
  o.equityFinancingCostInCents = options.equityFinancingCostInCents ?? 0;
  o.equityFinancingCosts = (options.equityFinancingCosts ?? []).map((i) =>
    maybeNew("EquityFinancingCost", i, cache, options.hasOwnProperty("equityFinancingCosts"))
  );
  o.saleDate = options.saleDate ?? null;
  o.lotOwnershipBasisPoints = options.lotOwnershipBasisPoints ?? 0;
  o.salesforceOpportunityId = options.salesforceOpportunityId ?? null;
  o.underContractPriceInCents = options.underContractPriceInCents ?? null;
  o.commissionBuyerBasisPoints = options.commissionBuyerBasisPoints ?? null;
  o.commissionSellerBasisPoints = options.commissionSellerBasisPoints ?? null;
  o.saleIncentiveAmountInCents = options.saleIncentiveAmountInCents ?? null;
  o.assumedSaleIncentiveAmountInCents = options.assumedSaleIncentiveAmountInCents ?? null;
  o.assumedCommissionBuyerBasisPoints = options.assumedCommissionBuyerBasisPoints ?? null;
  o.assumedCommissionSellerBasisPoints = options.assumedCommissionSellerBasisPoints ?? null;
  o.salesforceHomeListingId = options.salesforceHomeListingId ?? null;
  o.underwrittenNetSalesPriceWithoutAppreciationInCents = options.underwrittenNetSalesPriceWithoutAppreciationInCents ??
    0;
  o.netSalesPriceInCents = options.netSalesPriceInCents ?? 0;
  o.realizedNetSalesPriceInCents = options.realizedNetSalesPriceInCents ?? null;
  o.underContractNetSalesPriceInCents = options.underContractNetSalesPriceInCents ?? null;
  o.listedNetSalesPriceInCents = options.listedNetSalesPriceInCents ?? null;
  o.estimateNetSalesPriceInCents = options.estimateNetSalesPriceInCents ?? 0;
  o.grossSalesPriceInCents = options.grossSalesPriceInCents ?? 0;
  o.notes = options.notes ?? null;
  o.underwrittenLotOwnershipBasisPoints = options.underwrittenLotOwnershipBasisPoints ?? 0;
  o.underwrittenTotalCostInCents = options.underwrittenTotalCostInCents ?? 0;
  o.underwrittenInvestorMarginBasisPoints = options.underwrittenInvestorMarginBasisPoints ?? 0;
  o.salesReadyDate = options.salesReadyDate ?? null;
  o.preListDate = options.preListDate ?? null;
  o.valuationAtSalesReadyDateInCents = options.valuationAtSalesReadyDateInCents ?? null;
  o.valuationAtPreListDateInCents = options.valuationAtPreListDateInCents ?? null;
  o.salesReadyAppreciationMultiplier = options.salesReadyAppreciationMultiplier ?? "" as any;
  o.preListAppreciationMultiplier = options.preListAppreciationMultiplier ?? "" as any;
  o.seasonalityMultiplier = options.seasonalityMultiplier ?? "" as any;
  o.expectedSalePriceSeasonalityOnlyInCents = options.expectedSalePriceSeasonalityOnlyInCents ?? 0;
  o.salesReadySeasonalityMultiplier = options.salesReadySeasonalityMultiplier ?? "" as any;
  o.valuationAtSalesReadyDateSeasonalityOnlyInCents = options.valuationAtSalesReadyDateSeasonalityOnlyInCents ?? null;
  o.preListSeasonalityMultiplier = options.preListSeasonalityMultiplier ?? "" as any;
  o.valuationAtPreListDateSeasonalityOnlyInCents = options.valuationAtPreListDateSeasonalityOnlyInCents ?? null;
  o.underwrittenOpcoMarkupBasisPoints = options.underwrittenOpcoMarkupBasisPoints ?? 0;
  o.opcoMarkupBasisPoints = options.opcoMarkupBasisPoints ?? 0;
  o.expectedListSeasonalityMultiplier = options.expectedListSeasonalityMultiplier ?? 0;
  o.valuationAtExpectedListDateSeasonalityOnlyInCents = options.valuationAtExpectedListDateSeasonalityOnlyInCents ??
    null;
  o.grossSalesPriceLessIncentivesInCents = options.grossSalesPriceLessIncentivesInCents ?? 0;
  o.closingCostsInCents = options.closingCostsInCents ?? 0;
  o.assumedClosingCostsInCents = options.assumedClosingCostsInCents ?? 0;
  o.assumedCommissionEstimateBuyerInCents = options.assumedCommissionEstimateBuyerInCents ?? 0;
  o.assumedCommissionEstimateSellerInCents = options.assumedCommissionEstimateSellerInCents ?? 0;
  o.assumedCommissionListBuyerInCents = options.assumedCommissionListBuyerInCents ?? 0;
  o.assumedCommissionListSellerInCents = options.assumedCommissionListSellerInCents ?? 0;
  o.commissionUnderContractBuyerInCents = options.commissionUnderContractBuyerInCents ?? 0;
  o.commissionUnderContractSellerInCents = options.commissionUnderContractSellerInCents ?? 0;
  o.commissionRealizedBuyerInCents = options.commissionRealizedBuyerInCents ?? 0;
  o.commissionRealizedSellerInCents = options.commissionRealizedSellerInCents ?? 0;
  o.appliedSeasonalityMultiplier = options.appliedSeasonalityMultiplier ?? "" as any;
  o.appliedListToCloseRatioBasisPoints = options.appliedListToCloseRatioBasisPoints ?? null;
  o.appliedClosingCostsInCents = options.appliedClosingCostsInCents ?? 0;
  o.permitSubmittedDate = options.permitSubmittedDate ?? null;
  o.permitApprovedDate = options.permitApprovedDate ?? null;
  o.verticalBuildStartDate = options.verticalBuildStartDate ?? null;
  o.underContractDate = options.underContractDate ?? null;
  o.goldmanDrawModel = maybeNewOrNull("GoldmanDrawModel", options.goldmanDrawModel, cache);
  o.isVerticalConstructionComplete = options.isVerticalConstructionComplete ?? false;
  o.isVerticalConstructionStarted = options.isVerticalConstructionStarted ?? false;
  o.drawRequests = (options.drawRequests ?? []).map((i) =>
    maybeNew("LotPartitionDrawRequest", i, cache, options.hasOwnProperty("drawRequests"))
  );
  o.borrowedAmountInCents = options.borrowedAmountInCents ?? 0;
  o.modeledAmountToBorrowInCents = options.modeledAmountToBorrowInCents ?? 0;
  o.goldmanDrawModels = (options.goldmanDrawModels ?? []).map((i) =>
    maybeNew("GoldmanDrawModel", i, cache, options.hasOwnProperty("goldmanDrawModels"))
  );
  o.appraisalValueInCents = options.appraisalValueInCents ?? null;
  o.appraisalDate = options.appraisalDate ?? null;
  o.invoices = (options.invoices ?? []).map((i) =>
    maybeNew("LotPartitionInvoice", i, cache, options.hasOwnProperty("invoices"))
  );
  o.realizedUnleveredInternalRateOfReturnBasisPoints = options.realizedUnleveredInternalRateOfReturnBasisPoints ?? null;
  o.realizedUnleveredMultipleOnInvestedCapital = options.realizedUnleveredMultipleOnInvestedCapital ?? null;
  o.realizedLeveredMultipleOnInvestedCapital = options.realizedLeveredMultipleOnInvestedCapital ?? null;
  o.realizedLeveredInternalRateOfReturnBasisPoints = options.realizedLeveredInternalRateOfReturnBasisPoints ?? null;
  o.realizedDeltaBetweenOpcoContractedAndInvoicedInCents =
    options.realizedDeltaBetweenOpcoContractedAndInvoicedInCents ?? null;
  o.underContractPersonalizationPriceInCents = options.underContractPersonalizationPriceInCents ?? 0;
  o.underContractGrossSalesPriceInCents = options.underContractGrossSalesPriceInCents ?? null;
  o.commissionBuyerFixedAmountInCents = options.commissionBuyerFixedAmountInCents ?? null;
  o.commissionSellerFixedAmountInCents = options.commissionSellerFixedAmountInCents ?? null;
  o.blueprintRemediationProjectId = options.blueprintRemediationProjectId ?? null;
  o.remediationExpectedCompletionDate = options.remediationExpectedCompletionDate ?? null;
  o.isRemediationVerticalConstructionComplete = options.isRemediationVerticalConstructionComplete ?? false;
  o.underwrittenDirectMarginBasisPoints = options.underwrittenDirectMarginBasisPoints ?? 0;
  o.directMarginBasisPoints = options.directMarginBasisPoints ?? 0;
  o.manualExpectedSaleDate = options.manualExpectedSaleDate ?? null;
  o.expectedSaleDate = options.expectedSaleDate ?? null;
  o.anchorMultilotBaseDrawModel = maybeNewOrNull("AnchorMultilotDrawModel", options.anchorMultilotBaseDrawModel, cache);
  o.anchorMultilotDrawModels = (options.anchorMultilotDrawModels ?? []).map((i) =>
    maybeNew("AnchorMultilotDrawModel", i, cache, options.hasOwnProperty("anchorMultilotDrawModels"))
  );
  o.readyPlanId = options.readyPlanId ?? null;
  o.readyPlanOptionIds = options.readyPlanOptionIds ?? null;
  o.unleveredReturnOnCostBasisPoints = options.unleveredReturnOnCostBasisPoints ?? 0;
  o.purchasePriceInCents = options.purchasePriceInCents ?? null;
  o.closingCostsForDirectMarginInCents = options.closingCostsForDirectMarginInCents ?? 0;
  o.directUnderwritingSoftCostsInCents = options.directUnderwritingSoftCostsInCents ?? null;
  o.directUnderwritingHardCostsInCents = options.directUnderwritingHardCostsInCents ?? null;
  o.directUnderwritingHardCostMarkupBasisPoints = options.directUnderwritingHardCostMarkupBasisPoints ?? null;
  o.anchorFloatingBaseDrawModel = maybeNewOrNull("AnchorFloatingDrawModel", options.anchorFloatingBaseDrawModel, cache);
  o.anchorFloatingDrawModels = (options.anchorFloatingDrawModels ?? []).map((i) =>
    maybeNew("AnchorFloatingDrawModel", i, cache, options.hasOwnProperty("anchorFloatingDrawModels"))
  );
  o.documents = (options.documents ?? []).map((i) =>
    maybeNew("Document", i, cache, options.hasOwnProperty("documents"))
  );
  o.propertySaleSettlementStatement = maybeNewOrNull(
    "PropertySaleSettlementStatement",
    options.propertySaleSettlementStatement,
    cache,
  );
  o.proposedBasePriceInCents = options.proposedBasePriceInCents ?? null;
  o.showInCheckout = options.showInCheckout ?? false;
  return o;
}

factories["LotPartition"] = newLotPartition;

export interface SaveLotPartitionResultOptions {
  __typename?: "SaveLotPartitionResult";
  lotPartition?: LotPartitionOptions;
}

export function newSaveLotPartitionResult(
  options: SaveLotPartitionResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionResult {
  const o = (options.__typename ? options : cache["SaveLotPartitionResult"] = {}) as SaveLotPartitionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionResult";
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  return o;
}

factories["SaveLotPartitionResult"] = newSaveLotPartitionResult;

export interface SaveLotPartitionsResultOptions {
  __typename?: "SaveLotPartitionsResult";
  lotPartitions?: Array<LotPartitionOptions>;
}

export function newSaveLotPartitionsResult(
  options: SaveLotPartitionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionsResult {
  const o = (options.__typename ? options : cache["SaveLotPartitionsResult"] = {}) as SaveLotPartitionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionsResult";
  o.lotPartitions = (options.lotPartitions ?? []).map((i) =>
    maybeNew("LotPartition", i, cache, options.hasOwnProperty("lotPartitions"))
  );
  return o;
}

factories["SaveLotPartitionsResult"] = newSaveLotPartitionsResult;

export interface BackfillLotPartitionUnderwrittenCostsResultOptions {
  __typename?: "BackfillLotPartitionUnderwrittenCostsResult";
  lotPartitions?: Array<LotPartitionOptions>;
}

export function newBackfillLotPartitionUnderwrittenCostsResult(
  options: BackfillLotPartitionUnderwrittenCostsResultOptions = {},
  cache: Record<string, any> = {},
): BackfillLotPartitionUnderwrittenCostsResult {
  const o =
    (options.__typename
      ? options
      : cache["BackfillLotPartitionUnderwrittenCostsResult"] = {}) as BackfillLotPartitionUnderwrittenCostsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "BackfillLotPartitionUnderwrittenCostsResult";
  o.lotPartitions = (options.lotPartitions ?? []).map((i) =>
    maybeNew("LotPartition", i, cache, options.hasOwnProperty("lotPartitions"))
  );
  return o;
}

factories["BackfillLotPartitionUnderwrittenCostsResult"] = newBackfillLotPartitionUnderwrittenCostsResult;

export interface EstimateDirectMarginImpactToLotPartitionResultOptions {
  __typename?: "EstimateDirectMarginImpactToLotPartitionResult";
  lotPartition?: LotPartitionOptions;
  estimatedDirectMarginBasisPoints?: EstimateDirectMarginImpactToLotPartitionResult["estimatedDirectMarginBasisPoints"];
}

export function newEstimateDirectMarginImpactToLotPartitionResult(
  options: EstimateDirectMarginImpactToLotPartitionResultOptions = {},
  cache: Record<string, any> = {},
): EstimateDirectMarginImpactToLotPartitionResult {
  const o =
    (options.__typename
      ? options
      : cache["EstimateDirectMarginImpactToLotPartitionResult"] = {}) as EstimateDirectMarginImpactToLotPartitionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EstimateDirectMarginImpactToLotPartitionResult";
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.estimatedDirectMarginBasisPoints = options.estimatedDirectMarginBasisPoints ?? 0;
  return o;
}

factories["EstimateDirectMarginImpactToLotPartitionResult"] = newEstimateDirectMarginImpactToLotPartitionResult;

export interface LotPartitionContractOptions {
  __typename?: "LotPartitionContract";
  id?: LotPartitionContract["id"];
  softCostInCents?: LotPartitionContract["softCostInCents"];
  indirectHardCostInCents?: LotPartitionContract["indirectHardCostInCents"];
  directHardCostInCents?: LotPartitionContract["directHardCostInCents"];
  opcoMarkupInCents?: LotPartitionContract["opcoMarkupInCents"];
  blueprintContractId?: LotPartitionContract["blueprintContractId"];
  blueprintChangeOrderId?: LotPartitionContract["blueprintChangeOrderId"];
  createdAt?: LotPartitionContract["createdAt"];
  updatedAt?: LotPartitionContract["updatedAt"];
  lotPartition?: LotPartitionOptions;
  opcoTotalCostInCents?: LotPartitionContract["opcoTotalCostInCents"];
}

export function newLotPartitionContract(
  options: LotPartitionContractOptions = {},
  cache: Record<string, any> = {},
): LotPartitionContract {
  const o = (options.__typename ? options : cache["LotPartitionContract"] = {}) as LotPartitionContract;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionContract";
  o.id = options.id ?? nextFactoryId("LotPartitionContract");
  o.softCostInCents = options.softCostInCents ?? 0;
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.opcoMarkupInCents = options.opcoMarkupInCents ?? 0;
  o.blueprintContractId = options.blueprintContractId ?? null;
  o.blueprintChangeOrderId = options.blueprintChangeOrderId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.opcoTotalCostInCents = options.opcoTotalCostInCents ?? 0;
  return o;
}

factories["LotPartitionContract"] = newLotPartitionContract;

export interface SaveLotPartitionContractResultOptions {
  __typename?: "SaveLotPartitionContractResult";
  lotPartitionContract?: LotPartitionContractOptions;
}

export function newSaveLotPartitionContractResult(
  options: SaveLotPartitionContractResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionContractResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionContractResult"] = {}) as SaveLotPartitionContractResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionContractResult";
  o.lotPartitionContract = maybeNew(
    "LotPartitionContract",
    options.lotPartitionContract,
    cache,
    options.hasOwnProperty("lotPartitionContract"),
  );
  return o;
}

factories["SaveLotPartitionContractResult"] = newSaveLotPartitionContractResult;

export interface SaveLotPartitionContractsResultOptions {
  __typename?: "SaveLotPartitionContractsResult";
  lotPartitionContracts?: Array<LotPartitionContractOptions>;
}

export function newSaveLotPartitionContractsResult(
  options: SaveLotPartitionContractsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionContractsResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionContractsResult"] = {}) as SaveLotPartitionContractsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionContractsResult";
  o.lotPartitionContracts = (options.lotPartitionContracts ?? []).map((i) =>
    maybeNew("LotPartitionContract", i, cache, options.hasOwnProperty("lotPartitionContracts"))
  );
  return o;
}

factories["SaveLotPartitionContractsResult"] = newSaveLotPartitionContractsResult;

export interface LotPartitionDrawOptions {
  __typename?: "LotPartitionDraw";
  id?: LotPartitionDraw["id"];
  amountInCents?: LotPartitionDraw["amountInCents"];
  remainingAmountInCents?: LotPartitionDraw["remainingAmountInCents"];
  createdAt?: LotPartitionDraw["createdAt"];
  updatedAt?: LotPartitionDraw["updatedAt"];
  creditFacilityDraw?: CreditFacilityDrawOptions;
  lotPartition?: LotPartitionOptions;
  payments?: Array<LotPartitionDrawPaymentOptions>;
  creditFacilityInvoiceDrawInterests?: Array<CreditFacilityInvoiceDrawInterestOptions>;
  invoices?: Array<LotPartitionDrawInvoiceOptions>;
}

export function newLotPartitionDraw(
  options: LotPartitionDrawOptions = {},
  cache: Record<string, any> = {},
): LotPartitionDraw {
  const o = (options.__typename ? options : cache["LotPartitionDraw"] = {}) as LotPartitionDraw;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionDraw";
  o.id = options.id ?? nextFactoryId("LotPartitionDraw");
  o.amountInCents = options.amountInCents ?? 0;
  o.remainingAmountInCents = options.remainingAmountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.creditFacilityDraw = maybeNew(
    "CreditFacilityDraw",
    options.creditFacilityDraw,
    cache,
    options.hasOwnProperty("creditFacilityDraw"),
  );
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.payments = (options.payments ?? []).map((i) =>
    maybeNew("LotPartitionDrawPayment", i, cache, options.hasOwnProperty("payments"))
  );
  o.creditFacilityInvoiceDrawInterests = (options.creditFacilityInvoiceDrawInterests ?? []).map((i) =>
    maybeNew(
      "CreditFacilityInvoiceDrawInterest",
      i,
      cache,
      options.hasOwnProperty("creditFacilityInvoiceDrawInterests"),
    )
  );
  o.invoices = (options.invoices ?? []).map((i) =>
    maybeNew("LotPartitionDrawInvoice", i, cache, options.hasOwnProperty("invoices"))
  );
  return o;
}

factories["LotPartitionDraw"] = newLotPartitionDraw;

export interface SaveLotPartitionDrawResultOptions {
  __typename?: "SaveLotPartitionDrawResult";
  lotPartitionDraw?: LotPartitionDrawOptions;
}

export function newSaveLotPartitionDrawResult(
  options: SaveLotPartitionDrawResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionDrawResult {
  const o = (options.__typename ? options : cache["SaveLotPartitionDrawResult"] = {}) as SaveLotPartitionDrawResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionDrawResult";
  o.lotPartitionDraw = maybeNew(
    "LotPartitionDraw",
    options.lotPartitionDraw,
    cache,
    options.hasOwnProperty("lotPartitionDraw"),
  );
  return o;
}

factories["SaveLotPartitionDrawResult"] = newSaveLotPartitionDrawResult;

export interface LotPartitionDrawInvoiceOptions {
  __typename?: "LotPartitionDrawInvoice";
  id?: LotPartitionDrawInvoice["id"];
  creditFacilityInvoice?: CreditFacilityInvoiceOptions;
  lotPartitionDraw?: LotPartitionDrawOptions;
  interestAmountInCents?: LotPartitionDrawInvoice["interestAmountInCents"];
  creditFacilityInvoiceDrawInterests?: Array<CreditFacilityInvoiceDrawInterestOptions>;
  isInterestPopulated?: LotPartitionDrawInvoice["isInterestPopulated"];
}

export function newLotPartitionDrawInvoice(
  options: LotPartitionDrawInvoiceOptions = {},
  cache: Record<string, any> = {},
): LotPartitionDrawInvoice {
  const o = (options.__typename ? options : cache["LotPartitionDrawInvoice"] = {}) as LotPartitionDrawInvoice;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionDrawInvoice";
  o.id = options.id ?? nextFactoryId("LotPartitionDrawInvoice");
  o.creditFacilityInvoice = maybeNew(
    "CreditFacilityInvoice",
    options.creditFacilityInvoice,
    cache,
    options.hasOwnProperty("creditFacilityInvoice"),
  );
  o.lotPartitionDraw = maybeNew(
    "LotPartitionDraw",
    options.lotPartitionDraw,
    cache,
    options.hasOwnProperty("lotPartitionDraw"),
  );
  o.interestAmountInCents = options.interestAmountInCents ?? 0;
  o.creditFacilityInvoiceDrawInterests = (options.creditFacilityInvoiceDrawInterests ?? []).map((i) =>
    maybeNew(
      "CreditFacilityInvoiceDrawInterest",
      i,
      cache,
      options.hasOwnProperty("creditFacilityInvoiceDrawInterests"),
    )
  );
  o.isInterestPopulated = options.isInterestPopulated ?? false;
  return o;
}

factories["LotPartitionDrawInvoice"] = newLotPartitionDrawInvoice;

export interface LotPartitionDrawPaymentOptions {
  __typename?: "LotPartitionDrawPayment";
  id?: LotPartitionDrawPayment["id"];
  amountInCents?: LotPartitionDrawPayment["amountInCents"];
  createdAt?: LotPartitionDrawPayment["createdAt"];
  updatedAt?: LotPartitionDrawPayment["updatedAt"];
  creditFacilityPayment?: CreditFacilityPaymentOptions;
  lotPartitionDraw?: LotPartitionDrawOptions;
}

export function newLotPartitionDrawPayment(
  options: LotPartitionDrawPaymentOptions = {},
  cache: Record<string, any> = {},
): LotPartitionDrawPayment {
  const o = (options.__typename ? options : cache["LotPartitionDrawPayment"] = {}) as LotPartitionDrawPayment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionDrawPayment";
  o.id = options.id ?? nextFactoryId("LotPartitionDrawPayment");
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.creditFacilityPayment = maybeNew(
    "CreditFacilityPayment",
    options.creditFacilityPayment,
    cache,
    options.hasOwnProperty("creditFacilityPayment"),
  );
  o.lotPartitionDraw = maybeNew(
    "LotPartitionDraw",
    options.lotPartitionDraw,
    cache,
    options.hasOwnProperty("lotPartitionDraw"),
  );
  return o;
}

factories["LotPartitionDrawPayment"] = newLotPartitionDrawPayment;

export interface SaveLotPartitionDrawPaymentResultOptions {
  __typename?: "SaveLotPartitionDrawPaymentResult";
  lotPartitionDrawPayment?: LotPartitionDrawPaymentOptions;
}

export function newSaveLotPartitionDrawPaymentResult(
  options: SaveLotPartitionDrawPaymentResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionDrawPaymentResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveLotPartitionDrawPaymentResult"] = {}) as SaveLotPartitionDrawPaymentResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionDrawPaymentResult";
  o.lotPartitionDrawPayment = maybeNew(
    "LotPartitionDrawPayment",
    options.lotPartitionDrawPayment,
    cache,
    options.hasOwnProperty("lotPartitionDrawPayment"),
  );
  return o;
}

factories["SaveLotPartitionDrawPaymentResult"] = newSaveLotPartitionDrawPaymentResult;

export interface LotPartitionDrawRequestOptions {
  __typename?: "LotPartitionDrawRequest";
  id?: LotPartitionDrawRequest["id"];
  amountInCents?: LotPartitionDrawRequest["amountInCents"];
  createdAt?: LotPartitionDrawRequest["createdAt"];
  updatedAt?: LotPartitionDrawRequest["updatedAt"];
  creditFacilityDrawRequest?: CreditFacilityDrawRequestOptions;
  lotPartition?: LotPartitionOptions;
  modeledIndividualAmountToBorrowInCents?: LotPartitionDrawRequest["modeledIndividualAmountToBorrowInCents"];
  modeledCollectiveAmountToBorrowInCents?: LotPartitionDrawRequest["modeledCollectiveAmountToBorrowInCents"];
  goldmanDrawModel?: GoldmanDrawModelOptions | null;
  anchorMultilotDrawModel?: AnchorMultilotDrawModelOptions | null;
  anchorFloatingDrawModel?: AnchorFloatingDrawModelOptions | null;
}

export function newLotPartitionDrawRequest(
  options: LotPartitionDrawRequestOptions = {},
  cache: Record<string, any> = {},
): LotPartitionDrawRequest {
  const o = (options.__typename ? options : cache["LotPartitionDrawRequest"] = {}) as LotPartitionDrawRequest;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionDrawRequest";
  o.id = options.id ?? nextFactoryId("LotPartitionDrawRequest");
  o.amountInCents = options.amountInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.creditFacilityDrawRequest = maybeNew(
    "CreditFacilityDrawRequest",
    options.creditFacilityDrawRequest,
    cache,
    options.hasOwnProperty("creditFacilityDrawRequest"),
  );
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.modeledIndividualAmountToBorrowInCents = options.modeledIndividualAmountToBorrowInCents ?? 0;
  o.modeledCollectiveAmountToBorrowInCents = options.modeledCollectiveAmountToBorrowInCents ?? 0;
  o.goldmanDrawModel = maybeNewOrNull("GoldmanDrawModel", options.goldmanDrawModel, cache);
  o.anchorMultilotDrawModel = maybeNewOrNull("AnchorMultilotDrawModel", options.anchorMultilotDrawModel, cache);
  o.anchorFloatingDrawModel = maybeNewOrNull("AnchorFloatingDrawModel", options.anchorFloatingDrawModel, cache);
  return o;
}

factories["LotPartitionDrawRequest"] = newLotPartitionDrawRequest;

export interface SaveLotPartitionDrawRequestResultOptions {
  __typename?: "SaveLotPartitionDrawRequestResult";
  lotPartitionDrawRequest?: LotPartitionDrawRequestOptions;
}

export function newSaveLotPartitionDrawRequestResult(
  options: SaveLotPartitionDrawRequestResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionDrawRequestResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveLotPartitionDrawRequestResult"] = {}) as SaveLotPartitionDrawRequestResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionDrawRequestResult";
  o.lotPartitionDrawRequest = maybeNew(
    "LotPartitionDrawRequest",
    options.lotPartitionDrawRequest,
    cache,
    options.hasOwnProperty("lotPartitionDrawRequest"),
  );
  return o;
}

factories["SaveLotPartitionDrawRequestResult"] = newSaveLotPartitionDrawRequestResult;

export interface SaveLotPartitionDrawRequestsResultOptions {
  __typename?: "SaveLotPartitionDrawRequestsResult";
  lotPartitionDrawRequests?: Array<LotPartitionDrawRequestOptions>;
}

export function newSaveLotPartitionDrawRequestsResult(
  options: SaveLotPartitionDrawRequestsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionDrawRequestsResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveLotPartitionDrawRequestsResult"] = {}) as SaveLotPartitionDrawRequestsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionDrawRequestsResult";
  o.lotPartitionDrawRequests = (options.lotPartitionDrawRequests ?? []).map((i) =>
    maybeNew("LotPartitionDrawRequest", i, cache, options.hasOwnProperty("lotPartitionDrawRequests"))
  );
  return o;
}

factories["SaveLotPartitionDrawRequestsResult"] = newSaveLotPartitionDrawRequestsResult;

export interface LotPartitionEstimateOptions {
  __typename?: "LotPartitionEstimate";
  id?: LotPartitionEstimate["id"];
  softCostInCents?: LotPartitionEstimate["softCostInCents"];
  hardCostInCents?: LotPartitionEstimate["hardCostInCents"];
  opcoMarkupInCents?: LotPartitionEstimate["opcoMarkupInCents"];
  blueprintEstimateId?: LotPartitionEstimate["blueprintEstimateId"];
  createdAt?: LotPartitionEstimate["createdAt"];
  updatedAt?: LotPartitionEstimate["updatedAt"];
  estimateStatus?: LotPartitionEstimateStatusDetailOptions | LotPartitionEstimateStatus;
  estimateType?: LotPartitionEstimateTypeDetailOptions | LotPartitionEstimateType;
  lotPartition?: LotPartitionOptions;
  indirectHardCostInCents?: LotPartitionEstimate["indirectHardCostInCents"];
  directHardCostInCents?: LotPartitionEstimate["directHardCostInCents"];
  contingencyPriceInCents?: LotPartitionEstimate["contingencyPriceInCents"];
}

export function newLotPartitionEstimate(
  options: LotPartitionEstimateOptions = {},
  cache: Record<string, any> = {},
): LotPartitionEstimate {
  const o = (options.__typename ? options : cache["LotPartitionEstimate"] = {}) as LotPartitionEstimate;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionEstimate";
  o.id = options.id ?? nextFactoryId("LotPartitionEstimate");
  o.softCostInCents = options.softCostInCents ?? 0;
  o.hardCostInCents = options.hardCostInCents ?? 0;
  o.opcoMarkupInCents = options.opcoMarkupInCents ?? 0;
  o.blueprintEstimateId = options.blueprintEstimateId ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.estimateStatus = enumOrDetailOfLotPartitionEstimateStatus(options.estimateStatus);
  o.estimateType = enumOrDetailOfLotPartitionEstimateType(options.estimateType);
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.indirectHardCostInCents = options.indirectHardCostInCents ?? 0;
  o.directHardCostInCents = options.directHardCostInCents ?? 0;
  o.contingencyPriceInCents = options.contingencyPriceInCents ?? 0;
  return o;
}

factories["LotPartitionEstimate"] = newLotPartitionEstimate;

export interface SaveLotPartitionEstimateResultOptions {
  __typename?: "SaveLotPartitionEstimateResult";
  lotPartitionEstimate?: LotPartitionEstimateOptions;
}

export function newSaveLotPartitionEstimateResult(
  options: SaveLotPartitionEstimateResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionEstimateResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionEstimateResult"] = {}) as SaveLotPartitionEstimateResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionEstimateResult";
  o.lotPartitionEstimate = maybeNew(
    "LotPartitionEstimate",
    options.lotPartitionEstimate,
    cache,
    options.hasOwnProperty("lotPartitionEstimate"),
  );
  return o;
}

factories["SaveLotPartitionEstimateResult"] = newSaveLotPartitionEstimateResult;

export interface LotPartitionInvoiceOptions {
  __typename?: "LotPartitionInvoice";
  id?: LotPartitionInvoice["id"];
  blueprintInvoiceId?: LotPartitionInvoice["blueprintInvoiceId"];
  amountInCents?: LotPartitionInvoice["amountInCents"];
  lotPartition?: LotPartitionOptions;
  invoiceDate?: LotPartitionInvoice["invoiceDate"];
  description?: LotPartitionInvoice["description"];
}

export function newLotPartitionInvoice(
  options: LotPartitionInvoiceOptions = {},
  cache: Record<string, any> = {},
): LotPartitionInvoice {
  const o = (options.__typename ? options : cache["LotPartitionInvoice"] = {}) as LotPartitionInvoice;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionInvoice";
  o.id = options.id ?? nextFactoryId("LotPartitionInvoice");
  o.blueprintInvoiceId = options.blueprintInvoiceId ?? null;
  o.amountInCents = options.amountInCents ?? 0;
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.invoiceDate = options.invoiceDate ?? newDate();
  o.description = options.description ?? null;
  return o;
}

factories["LotPartitionInvoice"] = newLotPartitionInvoice;

export interface SaveLotPartitionInvoicesResultOptions {
  __typename?: "SaveLotPartitionInvoicesResult";
  lotPartitionInvoices?: Array<LotPartitionInvoiceOptions>;
}

export function newSaveLotPartitionInvoicesResult(
  options: SaveLotPartitionInvoicesResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionInvoicesResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionInvoicesResult"] = {}) as SaveLotPartitionInvoicesResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionInvoicesResult";
  o.lotPartitionInvoices = (options.lotPartitionInvoices ?? []).map((i) =>
    maybeNew("LotPartitionInvoice", i, cache, options.hasOwnProperty("lotPartitionInvoices"))
  );
  return o;
}

factories["SaveLotPartitionInvoicesResult"] = newSaveLotPartitionInvoicesResult;

export interface LotPartitionPaymentOptions {
  __typename?: "LotPartitionPayment";
  id?: LotPartitionPayment["id"];
  amountInCents?: LotPartitionPayment["amountInCents"];
  paymentDate?: LotPartitionPayment["paymentDate"];
  createdAt?: LotPartitionPayment["createdAt"];
  updatedAt?: LotPartitionPayment["updatedAt"];
  lotPartition?: LotPartitionOptions;
}

export function newLotPartitionPayment(
  options: LotPartitionPaymentOptions = {},
  cache: Record<string, any> = {},
): LotPartitionPayment {
  const o = (options.__typename ? options : cache["LotPartitionPayment"] = {}) as LotPartitionPayment;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionPayment";
  o.id = options.id ?? nextFactoryId("LotPartitionPayment");
  o.amountInCents = options.amountInCents ?? 0;
  o.paymentDate = options.paymentDate ?? newDate();
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  return o;
}

factories["LotPartitionPayment"] = newLotPartitionPayment;

export interface SaveLotPartitionPaymentsResultOptions {
  __typename?: "SaveLotPartitionPaymentsResult";
  lotPartitionPayments?: Array<LotPartitionPaymentOptions>;
}

export function newSaveLotPartitionPaymentsResult(
  options: SaveLotPartitionPaymentsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionPaymentsResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionPaymentsResult"] = {}) as SaveLotPartitionPaymentsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionPaymentsResult";
  o.lotPartitionPayments = (options.lotPartitionPayments ?? []).map((i) =>
    maybeNew("LotPartitionPayment", i, cache, options.hasOwnProperty("lotPartitionPayments"))
  );
  return o;
}

factories["SaveLotPartitionPaymentsResult"] = newSaveLotPartitionPaymentsResult;

export interface LotPartitionValuationOptions {
  __typename?: "LotPartitionValuation";
  id?: LotPartitionValuation["id"];
  valuationReportId?: LotPartitionValuation["valuationReportId"];
  valuationDate?: LotPartitionValuation["valuationDate"];
  expectedSalesPriceInCents?: LotPartitionValuation["expectedSalesPriceInCents"];
  createdAt?: LotPartitionValuation["createdAt"];
  updatedAt?: LotPartitionValuation["updatedAt"];
  lotPartition?: LotPartitionOptions;
}

export function newLotPartitionValuation(
  options: LotPartitionValuationOptions = {},
  cache: Record<string, any> = {},
): LotPartitionValuation {
  const o = (options.__typename ? options : cache["LotPartitionValuation"] = {}) as LotPartitionValuation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotPartitionValuation";
  o.id = options.id ?? nextFactoryId("LotPartitionValuation");
  o.valuationReportId = options.valuationReportId ?? null;
  o.valuationDate = options.valuationDate ?? newDate();
  o.expectedSalesPriceInCents = options.expectedSalesPriceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  return o;
}

factories["LotPartitionValuation"] = newLotPartitionValuation;

export interface SaveLotPartitionValuationResultOptions {
  __typename?: "SaveLotPartitionValuationResult";
  lotPartitionValuation?: LotPartitionValuationOptions;
}

export function newSaveLotPartitionValuationResult(
  options: SaveLotPartitionValuationResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionValuationResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionValuationResult"] = {}) as SaveLotPartitionValuationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionValuationResult";
  o.lotPartitionValuation = maybeNew(
    "LotPartitionValuation",
    options.lotPartitionValuation,
    cache,
    options.hasOwnProperty("lotPartitionValuation"),
  );
  return o;
}

factories["SaveLotPartitionValuationResult"] = newSaveLotPartitionValuationResult;

export interface SaveLotPartitionValuationsResultOptions {
  __typename?: "SaveLotPartitionValuationsResult";
  lotPartitionValuations?: Array<LotPartitionValuationOptions>;
}

export function newSaveLotPartitionValuationsResult(
  options: SaveLotPartitionValuationsResultOptions = {},
  cache: Record<string, any> = {},
): SaveLotPartitionValuationsResult {
  const o =
    (options.__typename ? options : cache["SaveLotPartitionValuationsResult"] = {}) as SaveLotPartitionValuationsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveLotPartitionValuationsResult";
  o.lotPartitionValuations = (options.lotPartitionValuations ?? []).map((i) =>
    maybeNew("LotPartitionValuation", i, cache, options.hasOwnProperty("lotPartitionValuations"))
  );
  return o;
}

factories["SaveLotPartitionValuationsResult"] = newSaveLotPartitionValuationsResult;

export interface MetroOptions {
  __typename?: "Metro";
  id?: Metro["id"];
  code?: Metro["code"];
  name?: Metro["name"];
  createdAt?: Metro["createdAt"];
  updatedAt?: Metro["updatedAt"];
  fundMetros?: Array<FundMetroOptions>;
  listToCloseRatioBasisPoints?: Metro["listToCloseRatioBasisPoints"];
  lots?: Array<LotOptions>;
  deliveryToSalesReadyInDays?: Metro["deliveryToSalesReadyInDays"];
  underwritingConfigMetros?: Array<UnderwritingConfigMetroOptions>;
  preListPremiumBasisPoints?: Metro["preListPremiumBasisPoints"];
}

export function newMetro(options: MetroOptions = {}, cache: Record<string, any> = {}): Metro {
  const o = (options.__typename ? options : cache["Metro"] = {}) as Metro;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Metro";
  o.id = options.id ?? nextFactoryId("Metro");
  o.code = options.code ?? "code";
  o.name = options.name ?? "name";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.fundMetros = (options.fundMetros ?? []).map((i) =>
    maybeNew("FundMetro", i, cache, options.hasOwnProperty("fundMetros"))
  );
  o.listToCloseRatioBasisPoints = options.listToCloseRatioBasisPoints ?? 0;
  o.lots = (options.lots ?? []).map((i) => maybeNew("Lot", i, cache, options.hasOwnProperty("lots")));
  o.deliveryToSalesReadyInDays = options.deliveryToSalesReadyInDays ?? 0;
  o.underwritingConfigMetros = (options.underwritingConfigMetros ?? []).map((i) =>
    maybeNew("UnderwritingConfigMetro", i, cache, options.hasOwnProperty("underwritingConfigMetros"))
  );
  o.preListPremiumBasisPoints = options.preListPremiumBasisPoints ?? 0;
  return o;
}

factories["Metro"] = newMetro;

export interface SaveMetroResultOptions {
  __typename?: "SaveMetroResult";
  metro?: MetroOptions;
}

export function newSaveMetroResult(
  options: SaveMetroResultOptions = {},
  cache: Record<string, any> = {},
): SaveMetroResult {
  const o = (options.__typename ? options : cache["SaveMetroResult"] = {}) as SaveMetroResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveMetroResult";
  o.metro = maybeNew("Metro", options.metro, cache, options.hasOwnProperty("metro"));
  return o;
}

factories["SaveMetroResult"] = newSaveMetroResult;

export interface RecalculateSeasonalityForMetroResultOptions {
  __typename?: "RecalculateSeasonalityForMetroResult";
  metro?: MetroOptions;
  lotPartitions?: Array<LotPartitionOptions>;
}

export function newRecalculateSeasonalityForMetroResult(
  options: RecalculateSeasonalityForMetroResultOptions = {},
  cache: Record<string, any> = {},
): RecalculateSeasonalityForMetroResult {
  const o =
    (options.__typename
      ? options
      : cache["RecalculateSeasonalityForMetroResult"] = {}) as RecalculateSeasonalityForMetroResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "RecalculateSeasonalityForMetroResult";
  o.metro = maybeNew("Metro", options.metro, cache, options.hasOwnProperty("metro"));
  o.lotPartitions = (options.lotPartitions ?? []).map((i) =>
    maybeNew("LotPartition", i, cache, options.hasOwnProperty("lotPartitions"))
  );
  return o;
}

factories["RecalculateSeasonalityForMetroResult"] = newRecalculateSeasonalityForMetroResult;

export interface OptionOptions {
  __typename?: "Option";
  id?: Option["id"];
  airtableId?: Option["airtableId"];
  name?: Option["name"];
  description?: Option["description"];
  optionCode?: Option["optionCode"];
  bedrooms?: Option["bedrooms"];
  bathrooms?: Option["bathrooms"];
  garageParking?: Option["garageParking"];
  sqft?: Option["sqft"];
  image?: Option["image"];
  location?: Option["location"];
  createdAt?: Option["createdAt"];
  updatedAt?: Option["updatedAt"];
  floor?: FloorOptions | null;
  priceInCents?: Option["priceInCents"];
  group?: Option["group"];
  configurationTos?: Array<ConfigurationToOptionOptions>;
  conflictOptionToOptions?: Array<OptionToOptionOptions>;
  optionToOptions?: Array<OptionToOptionOptions>;
  toSpecLevels?: Array<OptionToSpecLevelOptions>;
  baseSqft?: Option["baseSqft"];
  floorPlanImage?: Option["floorPlanImage"];
  baseFullBathrooms?: Option["baseFullBathrooms"];
  baseHalfBathrooms?: Option["baseHalfBathrooms"];
  baseBedrooms?: Option["baseBedrooms"];
}

export function newOption(options: OptionOptions = {}, cache: Record<string, any> = {}): Option {
  const o = (options.__typename ? options : cache["Option"] = {}) as Option;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Option";
  o.id = options.id ?? nextFactoryId("Option");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.optionCode = options.optionCode ?? "optionCode";
  o.bedrooms = options.bedrooms ?? "bedrooms";
  o.bathrooms = options.bathrooms ?? "bathrooms";
  o.garageParking = options.garageParking ?? "garageParking";
  o.sqft = options.sqft ?? "sqft";
  o.image = options.image ?? null;
  o.location = options.location ?? "location";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.floor = maybeNewOrNull("Floor", options.floor, cache);
  o.priceInCents = options.priceInCents ?? 0;
  o.group = options.group ?? "group";
  o.configurationTos = (options.configurationTos ?? []).map((i) =>
    maybeNew("ConfigurationToOption", i, cache, options.hasOwnProperty("configurationTos"))
  );
  o.conflictOptionToOptions = (options.conflictOptionToOptions ?? []).map((i) =>
    maybeNew("OptionToOption", i, cache, options.hasOwnProperty("conflictOptionToOptions"))
  );
  o.optionToOptions = (options.optionToOptions ?? []).map((i) =>
    maybeNew("OptionToOption", i, cache, options.hasOwnProperty("optionToOptions"))
  );
  o.toSpecLevels = (options.toSpecLevels ?? []).map((i) =>
    maybeNew("OptionToSpecLevel", i, cache, options.hasOwnProperty("toSpecLevels"))
  );
  o.baseSqft = options.baseSqft ?? 0;
  o.floorPlanImage = options.floorPlanImage ?? null;
  o.baseFullBathrooms = options.baseFullBathrooms ?? 0;
  o.baseHalfBathrooms = options.baseHalfBathrooms ?? 0;
  o.baseBedrooms = options.baseBedrooms ?? 0;
  return o;
}

factories["Option"] = newOption;

export interface SaveOptionResultOptions {
  __typename?: "SaveOptionResult";
  option?: OptionOptions;
}

export function newSaveOptionResult(
  options: SaveOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionResult {
  const o = (options.__typename ? options : cache["SaveOptionResult"] = {}) as SaveOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionResult";
  o.option = maybeNew("Option", options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["SaveOptionResult"] = newSaveOptionResult;

export interface OptionToOptionOptions {
  __typename?: "OptionToOption";
  id?: OptionToOption["id"];
  airtableId?: OptionToOption["airtableId"];
  createdAt?: OptionToOption["createdAt"];
  updatedAt?: OptionToOption["updatedAt"];
  conflictOption?: OptionOptions;
  option?: OptionOptions;
}

export function newOptionToOption(
  options: OptionToOptionOptions = {},
  cache: Record<string, any> = {},
): OptionToOption {
  const o = (options.__typename ? options : cache["OptionToOption"] = {}) as OptionToOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToOption";
  o.id = options.id ?? nextFactoryId("OptionToOption");
  o.airtableId = options.airtableId ?? "airtableId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.conflictOption = maybeNew("Option", options.conflictOption, cache, options.hasOwnProperty("conflictOption"));
  o.option = maybeNew("Option", options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["OptionToOption"] = newOptionToOption;

export interface SaveOptionToOptionResultOptions {
  __typename?: "SaveOptionToOptionResult";
  optionToOption?: OptionToOptionOptions;
}

export function newSaveOptionToOptionResult(
  options: SaveOptionToOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionToOptionResult {
  const o = (options.__typename ? options : cache["SaveOptionToOptionResult"] = {}) as SaveOptionToOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionToOptionResult";
  o.optionToOption = maybeNew(
    "OptionToOption",
    options.optionToOption,
    cache,
    options.hasOwnProperty("optionToOption"),
  );
  return o;
}

factories["SaveOptionToOptionResult"] = newSaveOptionToOptionResult;

export interface OptionToSpecLevelOptions {
  __typename?: "OptionToSpecLevel";
  id?: OptionToSpecLevel["id"];
  createdAt?: OptionToSpecLevel["createdAt"];
  airtableId?: OptionToSpecLevel["airtableId"];
  priceInCents?: OptionToSpecLevel["priceInCents"];
  updatedAt?: OptionToSpecLevel["updatedAt"];
  option?: OptionOptions;
  specLevel?: SpecLevelOptions;
}

export function newOptionToSpecLevel(
  options: OptionToSpecLevelOptions = {},
  cache: Record<string, any> = {},
): OptionToSpecLevel {
  const o = (options.__typename ? options : cache["OptionToSpecLevel"] = {}) as OptionToSpecLevel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToSpecLevel";
  o.id = options.id ?? nextFactoryId("OptionToSpecLevel");
  o.createdAt = options.createdAt ?? newDateTime();
  o.airtableId = options.airtableId ?? "airtableId";
  o.priceInCents = options.priceInCents ?? 0;
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.option = maybeNew("Option", options.option, cache, options.hasOwnProperty("option"));
  o.specLevel = maybeNew("SpecLevel", options.specLevel, cache, options.hasOwnProperty("specLevel"));
  return o;
}

factories["OptionToSpecLevel"] = newOptionToSpecLevel;

export interface SaveOptionToSpecLevelResultOptions {
  __typename?: "SaveOptionToSpecLevelResult";
  optionToSpecLevel?: OptionToSpecLevelOptions;
}

export function newSaveOptionToSpecLevelResult(
  options: SaveOptionToSpecLevelResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionToSpecLevelResult {
  const o = (options.__typename ? options : cache["SaveOptionToSpecLevelResult"] = {}) as SaveOptionToSpecLevelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionToSpecLevelResult";
  o.optionToSpecLevel = maybeNew(
    "OptionToSpecLevel",
    options.optionToSpecLevel,
    cache,
    options.hasOwnProperty("optionToSpecLevel"),
  );
  return o;
}

factories["SaveOptionToSpecLevelResult"] = newSaveOptionToSpecLevelResult;

export interface PlanOptions {
  __typename?: "Plan";
  id?: Plan["id"];
  airtableId?: Plan["airtableId"];
  name?: Plan["name"];
  description?: Plan["description"];
  priceInCents?: Plan["priceInCents"];
  bedrooms?: Plan["bedrooms"];
  bathrooms?: Plan["bathrooms"];
  garageParking?: Plan["garageParking"];
  sqft?: Plan["sqft"];
  createdAt?: Plan["createdAt"];
  updatedAt?: Plan["updatedAt"];
  configurations?: Array<ConfigurationOptions>;
  elevations?: Array<ElevationOptions>;
  floors?: Array<FloorOptions>;
  baseSqft?: Plan["baseSqft"];
  baseFullBathrooms?: Plan["baseFullBathrooms"];
  baseHalfBathrooms?: Plan["baseHalfBathrooms"];
  baseBedrooms?: Plan["baseBedrooms"];
}

export function newPlan(options: PlanOptions = {}, cache: Record<string, any> = {}): Plan {
  const o = (options.__typename ? options : cache["Plan"] = {}) as Plan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Plan";
  o.id = options.id ?? nextFactoryId("Plan");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.bedrooms = options.bedrooms ?? null;
  o.bathrooms = options.bathrooms ?? null;
  o.garageParking = options.garageParking ?? null;
  o.sqft = options.sqft ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNew("Configuration", i, cache, options.hasOwnProperty("configurations"))
  );
  o.elevations = (options.elevations ?? []).map((i) =>
    maybeNew("Elevation", i, cache, options.hasOwnProperty("elevations"))
  );
  o.floors = (options.floors ?? []).map((i) => maybeNew("Floor", i, cache, options.hasOwnProperty("floors")));
  o.baseSqft = options.baseSqft ?? 0;
  o.baseFullBathrooms = options.baseFullBathrooms ?? 0;
  o.baseHalfBathrooms = options.baseHalfBathrooms ?? 0;
  o.baseBedrooms = options.baseBedrooms ?? 0;
  return o;
}

factories["Plan"] = newPlan;

export interface SavePlanResultOptions {
  __typename?: "SavePlanResult";
  plan?: PlanOptions;
}

export function newSavePlanResult(
  options: SavePlanResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanResult {
  const o = (options.__typename ? options : cache["SavePlanResult"] = {}) as SavePlanResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanResult";
  o.plan = maybeNew("Plan", options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["SavePlanResult"] = newSavePlanResult;

export interface PropertyOptions {
  __typename?: "Property";
  dpid?: Property["dpid"];
  fullStreetAddress?: Property["fullStreetAddress"];
  cityName?: Property["cityName"];
  state?: Property["state"];
  zipCode?: Property["zipCode"];
  latitude?: Property["latitude"];
  longitude?: Property["longitude"];
  unitNumber?: Property["unitNumber"];
  propertyTypeSimple?: Property["propertyTypeSimple"];
  lotSize?: Property["lotSize"];
  yearBuiltOrRenovated?: Property["yearBuiltOrRenovated"];
  finishedSqft?: Property["finishedSqft"];
  totalSqft?: Property["totalSqft"];
  numBedrooms?: Property["numBedrooms"];
  numBaths?: Property["numBaths"];
  numStories?: Property["numStories"];
  hasPool?: Property["hasPool"];
  garageNumCars?: Property["garageNumCars"];
  buildableSqft?: Property["buildableSqft"];
  lotFrontageFeet?: Property["lotFrontageFeet"];
  lotDepthFeet?: Property["lotDepthFeet"];
  zoning?: Property["zoning"];
}

export function newProperty(options: PropertyOptions = {}, cache: Record<string, any> = {}): Property {
  const o = (options.__typename ? options : cache["Property"] = {}) as Property;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Property";
  o.dpid = options.dpid ?? nextFactoryId("Property");
  o.fullStreetAddress = options.fullStreetAddress ?? "fullStreetAddress";
  o.cityName = options.cityName ?? "cityName";
  o.state = options.state ?? "state";
  o.zipCode = options.zipCode ?? "zipCode";
  o.latitude = options.latitude ?? "" as any;
  o.longitude = options.longitude ?? "" as any;
  o.unitNumber = options.unitNumber ?? null;
  o.propertyTypeSimple = options.propertyTypeSimple ?? null;
  o.lotSize = options.lotSize ?? null;
  o.yearBuiltOrRenovated = options.yearBuiltOrRenovated ?? null;
  o.finishedSqft = options.finishedSqft ?? null;
  o.totalSqft = options.totalSqft ?? null;
  o.numBedrooms = options.numBedrooms ?? null;
  o.numBaths = options.numBaths ?? null;
  o.numStories = options.numStories ?? null;
  o.hasPool = options.hasPool ?? null;
  o.garageNumCars = options.garageNumCars ?? null;
  o.buildableSqft = options.buildableSqft ?? null;
  o.lotFrontageFeet = options.lotFrontageFeet ?? null;
  o.lotDepthFeet = options.lotDepthFeet ?? null;
  o.zoning = options.zoning ?? null;
  return o;
}

factories["Property"] = newProperty;

export interface PropertySaleSettlementStatementOptions {
  __typename?: "PropertySaleSettlementStatement";
  id?: PropertySaleSettlementStatement["id"];
  totalDebitsInCents?: PropertySaleSettlementStatement["totalDebitsInCents"];
  totalCreditsInCents?: PropertySaleSettlementStatement["totalCreditsInCents"];
  sellerName?: PropertySaleSettlementStatement["sellerName"];
  settlementDate?: PropertySaleSettlementStatement["settlementDate"];
  document?: DocumentOptions;
  lotPartition?: LotPartitionOptions;
  lineItems?: Array<PropertySaleSettlementStatementLineItemOptions>;
  bookingEventRawJson?: PropertySaleSettlementStatement["bookingEventRawJson"];
  bookingEventSent?: PropertySaleSettlementStatement["bookingEventSent"];
  ocrRawJson?: PropertySaleSettlementStatement["ocrRawJson"];
  canSendForBooking?: PotentialOperationOptions;
}

export function newPropertySaleSettlementStatement(
  options: PropertySaleSettlementStatementOptions = {},
  cache: Record<string, any> = {},
): PropertySaleSettlementStatement {
  const o =
    (options.__typename ? options : cache["PropertySaleSettlementStatement"] = {}) as PropertySaleSettlementStatement;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertySaleSettlementStatement";
  o.id = options.id ?? nextFactoryId("PropertySaleSettlementStatement");
  o.totalDebitsInCents = options.totalDebitsInCents ?? 0;
  o.totalCreditsInCents = options.totalCreditsInCents ?? 0;
  o.sellerName = options.sellerName ?? null;
  o.settlementDate = options.settlementDate ?? null;
  o.document = maybeNew("Document", options.document, cache, options.hasOwnProperty("document"));
  o.lotPartition = maybeNew("LotPartition", options.lotPartition, cache, options.hasOwnProperty("lotPartition"));
  o.lineItems = (options.lineItems ?? []).map((i) =>
    maybeNew("PropertySaleSettlementStatementLineItem", i, cache, options.hasOwnProperty("lineItems"))
  );
  o.bookingEventRawJson = options.bookingEventRawJson ?? null;
  o.bookingEventSent = options.bookingEventSent ?? false;
  o.ocrRawJson = options.ocrRawJson ?? null;
  o.canSendForBooking = maybeNew(
    "PotentialOperation",
    options.canSendForBooking,
    cache,
    options.hasOwnProperty("canSendForBooking"),
  );
  return o;
}

factories["PropertySaleSettlementStatement"] = newPropertySaleSettlementStatement;

export interface SavePropertySaleSettlementStatementResultOptions {
  __typename?: "SavePropertySaleSettlementStatementResult";
  propertySaleSettlementStatement?: PropertySaleSettlementStatementOptions;
}

export function newSavePropertySaleSettlementStatementResult(
  options: SavePropertySaleSettlementStatementResultOptions = {},
  cache: Record<string, any> = {},
): SavePropertySaleSettlementStatementResult {
  const o =
    (options.__typename
      ? options
      : cache["SavePropertySaleSettlementStatementResult"] = {}) as SavePropertySaleSettlementStatementResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePropertySaleSettlementStatementResult";
  o.propertySaleSettlementStatement = maybeNew(
    "PropertySaleSettlementStatement",
    options.propertySaleSettlementStatement,
    cache,
    options.hasOwnProperty("propertySaleSettlementStatement"),
  );
  return o;
}

factories["SavePropertySaleSettlementStatementResult"] = newSavePropertySaleSettlementStatementResult;

export interface PropertySaleSettlementStatementLineItemOptions {
  __typename?: "PropertySaleSettlementStatementLineItem";
  id?: PropertySaleSettlementStatementLineItem["id"];
  amountInCents?: PropertySaleSettlementStatementLineItem["amountInCents"];
  notes?: PropertySaleSettlementStatementLineItem["notes"];
  type?: PropertySaleSettlementStatementLineItemTypeDetailOptions | PropertySaleSettlementStatementLineItemType;
  propertySaleSettlementStatement?: PropertySaleSettlementStatementOptions;
}

export function newPropertySaleSettlementStatementLineItem(
  options: PropertySaleSettlementStatementLineItemOptions = {},
  cache: Record<string, any> = {},
): PropertySaleSettlementStatementLineItem {
  const o =
    (options.__typename
      ? options
      : cache["PropertySaleSettlementStatementLineItem"] = {}) as PropertySaleSettlementStatementLineItem;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PropertySaleSettlementStatementLineItem";
  o.id = options.id ?? nextFactoryId("PropertySaleSettlementStatementLineItem");
  o.amountInCents = options.amountInCents ?? 0;
  o.notes = options.notes ?? null;
  o.type = enumOrDetailOfPropertySaleSettlementStatementLineItemType(options.type);
  o.propertySaleSettlementStatement = maybeNew(
    "PropertySaleSettlementStatement",
    options.propertySaleSettlementStatement,
    cache,
    options.hasOwnProperty("propertySaleSettlementStatement"),
  );
  return o;
}

factories["PropertySaleSettlementStatementLineItem"] = newPropertySaleSettlementStatementLineItem;

export interface UrlOptions {
  __typename?: "Url";
  path?: Url["path"];
  url?: Url["url"];
}

export function newUrl(options: UrlOptions = {}, cache: Record<string, any> = {}): Url {
  const o = (options.__typename ? options : cache["Url"] = {}) as Url;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Url";
  o.path = options.path ?? "path";
  o.url = options.url ?? "url";
  return o;
}

factories["Url"] = newUrl;

export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  allowed?: PotentialOperation["allowed"];
  disabledReasons?: Array<ReasonOptions>;
}

export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  cache: Record<string, any> = {},
): PotentialOperation {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation";
  o.allowed = options.allowed ?? false;
  o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
    maybeNew("Reason", i, cache, options.hasOwnProperty("disabledReasons"))
  );
  return o;
}

factories["PotentialOperation"] = newPotentialOperation;

export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
}

export function newReason(options: ReasonOptions = {}, cache: Record<string, any> = {}): Reason {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reason";
  o.message = options.message ?? "message";
  return o;
}

factories["Reason"] = newReason;

export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options: UserErrorOptions = {}, cache: Record<string, any> = {}): UserError {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserError";
  o.message = options.message ?? "message";
  return o;
}

factories["UserError"] = newUserError;

export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
}

export function newEmptyResult(options: EmptyResultOptions = {}, cache: Record<string, any> = {}): EmptyResult {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EmptyResult";
  o.emptyResult = options.emptyResult ?? null;
  return o;
}

factories["EmptyResult"] = newEmptyResult;

export interface PageInfoOptions {
  __typename?: "PageInfo";
  hasNextPage?: PageInfo["hasNextPage"];
}

export function newPageInfo(options: PageInfoOptions = {}, cache: Record<string, any> = {}): PageInfo {
  const o = (options.__typename ? options : cache["PageInfo"] = {}) as PageInfo;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PageInfo";
  o.hasNextPage = options.hasNextPage ?? false;
  return o;
}

factories["PageInfo"] = newPageInfo;

export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
}

export function newHistory(options: HistoryOptions = {}, cache: Record<string, any> = {}): History {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  o.__typename = "History";
  o.recordedAt = options.recordedAt ?? newDateTime();
  o.avatar = options.avatar ?? "avatar";
  o.title = options.title ?? "title";
  o.subtitle = options.subtitle ?? null;
  return o;
}

factories["History"] = newHistory;

export interface SeasonalityMonthlyMultiplierOptions {
  __typename?: "SeasonalityMonthlyMultiplier";
  id?: SeasonalityMonthlyMultiplier["id"];
  metroName?: SeasonalityMonthlyMultiplier["metroName"];
  month?: SeasonalityMonthlyMultiplier["month"];
  seasonalityValue?: SeasonalityMonthlyMultiplier["seasonalityValue"];
  createdAt?: SeasonalityMonthlyMultiplier["createdAt"];
  updatedAt?: SeasonalityMonthlyMultiplier["updatedAt"];
}

export function newSeasonalityMonthlyMultiplier(
  options: SeasonalityMonthlyMultiplierOptions = {},
  cache: Record<string, any> = {},
): SeasonalityMonthlyMultiplier {
  const o = (options.__typename ? options : cache["SeasonalityMonthlyMultiplier"] = {}) as SeasonalityMonthlyMultiplier;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SeasonalityMonthlyMultiplier";
  o.id = options.id ?? nextFactoryId("SeasonalityMonthlyMultiplier");
  o.metroName = options.metroName ?? "metroName";
  o.month = options.month ?? 0;
  o.seasonalityValue = options.seasonalityValue ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  return o;
}

factories["SeasonalityMonthlyMultiplier"] = newSeasonalityMonthlyMultiplier;

export interface SaveSeasonalityMonthlyMultiplierResultOptions {
  __typename?: "SaveSeasonalityMonthlyMultiplierResult";
  seasonalityMonthlyMultiplier?: SeasonalityMonthlyMultiplierOptions;
}

export function newSaveSeasonalityMonthlyMultiplierResult(
  options: SaveSeasonalityMonthlyMultiplierResultOptions = {},
  cache: Record<string, any> = {},
): SaveSeasonalityMonthlyMultiplierResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveSeasonalityMonthlyMultiplierResult"] = {}) as SaveSeasonalityMonthlyMultiplierResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSeasonalityMonthlyMultiplierResult";
  o.seasonalityMonthlyMultiplier = maybeNew(
    "SeasonalityMonthlyMultiplier",
    options.seasonalityMonthlyMultiplier,
    cache,
    options.hasOwnProperty("seasonalityMonthlyMultiplier"),
  );
  return o;
}

factories["SaveSeasonalityMonthlyMultiplierResult"] = newSaveSeasonalityMonthlyMultiplierResult;

export interface SpecLevelOptions {
  __typename?: "SpecLevel";
  id?: SpecLevel["id"];
  airtableId?: SpecLevel["airtableId"];
  name?: SpecLevel["name"];
  priceInCents?: SpecLevel["priceInCents"];
  createdAt?: SpecLevel["createdAt"];
  updatedAt?: SpecLevel["updatedAt"];
  elevation?: ElevationOptions;
  configurations?: Array<ConfigurationOptions>;
  optionTos?: Array<OptionToSpecLevelOptions>;
  styles?: Array<SpecLevelStyleOptions>;
}

export function newSpecLevel(options: SpecLevelOptions = {}, cache: Record<string, any> = {}): SpecLevel {
  const o = (options.__typename ? options : cache["SpecLevel"] = {}) as SpecLevel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SpecLevel";
  o.id = options.id ?? nextFactoryId("SpecLevel");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNew("Elevation", options.elevation, cache, options.hasOwnProperty("elevation"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNew("Configuration", i, cache, options.hasOwnProperty("configurations"))
  );
  o.optionTos = (options.optionTos ?? []).map((i) =>
    maybeNew("OptionToSpecLevel", i, cache, options.hasOwnProperty("optionTos"))
  );
  o.styles = (options.styles ?? []).map((i) => maybeNew("SpecLevelStyle", i, cache, options.hasOwnProperty("styles")));
  return o;
}

factories["SpecLevel"] = newSpecLevel;

export interface SaveSpecLevelResultOptions {
  __typename?: "SaveSpecLevelResult";
  specLevel?: SpecLevelOptions;
}

export function newSaveSpecLevelResult(
  options: SaveSpecLevelResultOptions = {},
  cache: Record<string, any> = {},
): SaveSpecLevelResult {
  const o = (options.__typename ? options : cache["SaveSpecLevelResult"] = {}) as SaveSpecLevelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSpecLevelResult";
  o.specLevel = maybeNew("SpecLevel", options.specLevel, cache, options.hasOwnProperty("specLevel"));
  return o;
}

factories["SaveSpecLevelResult"] = newSaveSpecLevelResult;

export interface SpecLevelStyleOptions {
  __typename?: "SpecLevelStyle";
  id?: SpecLevelStyle["id"];
  airtableId?: SpecLevelStyle["airtableId"];
  name?: SpecLevelStyle["name"];
  priceInCents?: SpecLevelStyle["priceInCents"];
  image?: SpecLevelStyle["image"];
  createdAt?: SpecLevelStyle["createdAt"];
  updatedAt?: SpecLevelStyle["updatedAt"];
  specLevel?: SpecLevelOptions;
  configurations?: Array<ConfigurationOptions>;
  interiorImages?: Array<InteriorImageOptions>;
}

export function newSpecLevelStyle(
  options: SpecLevelStyleOptions = {},
  cache: Record<string, any> = {},
): SpecLevelStyle {
  const o = (options.__typename ? options : cache["SpecLevelStyle"] = {}) as SpecLevelStyle;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SpecLevelStyle";
  o.id = options.id ?? nextFactoryId("SpecLevelStyle");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specLevel = maybeNew("SpecLevel", options.specLevel, cache, options.hasOwnProperty("specLevel"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNew("Configuration", i, cache, options.hasOwnProperty("configurations"))
  );
  o.interiorImages = (options.interiorImages ?? []).map((i) =>
    maybeNew("InteriorImage", i, cache, options.hasOwnProperty("interiorImages"))
  );
  return o;
}

factories["SpecLevelStyle"] = newSpecLevelStyle;

export interface SaveSpecLevelStyleResultOptions {
  __typename?: "SaveSpecLevelStyleResult";
  specLevelStyle?: SpecLevelStyleOptions;
}

export function newSaveSpecLevelStyleResult(
  options: SaveSpecLevelStyleResultOptions = {},
  cache: Record<string, any> = {},
): SaveSpecLevelStyleResult {
  const o = (options.__typename ? options : cache["SaveSpecLevelStyleResult"] = {}) as SaveSpecLevelStyleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSpecLevelStyleResult";
  o.specLevelStyle = maybeNew(
    "SpecLevelStyle",
    options.specLevelStyle,
    cache,
    options.hasOwnProperty("specLevelStyle"),
  );
  return o;
}

factories["SaveSpecLevelStyleResult"] = newSaveSpecLevelStyleResult;

export interface UnderwritingConfigOptions {
  __typename?: "UnderwritingConfig";
  id?: UnderwritingConfig["id"];
  targetInvestorMarginBasisPoints?: UnderwritingConfig["targetInvestorMarginBasisPoints"];
  debtFacilityBaseRateBasisPoints?: UnderwritingConfig["debtFacilityBaseRateBasisPoints"];
  debtFacilitySpreadBasisPoints?: UnderwritingConfig["debtFacilitySpreadBasisPoints"];
  metros?: Array<UnderwritingConfigMetroOptions>;
  buildMarginBasisPoints?: UnderwritingConfig["buildMarginBasisPoints"];
  siteAcquisitionMarkupBasisPoints?: UnderwritingConfig["siteAcquisitionMarkupBasisPoints"];
  weightedFinancingRate?: UnderwritingConfig["weightedFinancingRate"];
  financingRate?: UnderwritingConfig["financingRate"];
  percentDebtFinancedBasisPoints?: UnderwritingConfig["percentDebtFinancedBasisPoints"];
  preConMonths?: UnderwritingConfig["preConMonths"];
  constructionMonths?: UnderwritingConfig["constructionMonths"];
  salesPeriodMonths?: UnderwritingConfig["salesPeriodMonths"];
  exitRealtorFeeBasisPoints?: UnderwritingConfig["exitRealtorFeeBasisPoints"];
  acquisitionClosingCostsBasisPoints?: UnderwritingConfig["acquisitionClosingCostsBasisPoints"];
}

export function newUnderwritingConfig(
  options: UnderwritingConfigOptions = {},
  cache: Record<string, any> = {},
): UnderwritingConfig {
  const o = (options.__typename ? options : cache["UnderwritingConfig"] = {}) as UnderwritingConfig;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UnderwritingConfig";
  o.id = options.id ?? nextFactoryId("UnderwritingConfig");
  o.targetInvestorMarginBasisPoints = options.targetInvestorMarginBasisPoints ?? 0;
  o.debtFacilityBaseRateBasisPoints = options.debtFacilityBaseRateBasisPoints ?? 0;
  o.debtFacilitySpreadBasisPoints = options.debtFacilitySpreadBasisPoints ?? 0;
  o.metros = (options.metros ?? []).map((i) =>
    maybeNew("UnderwritingConfigMetro", i, cache, options.hasOwnProperty("metros"))
  );
  o.buildMarginBasisPoints = options.buildMarginBasisPoints ?? 0;
  o.siteAcquisitionMarkupBasisPoints = options.siteAcquisitionMarkupBasisPoints ?? 0;
  o.weightedFinancingRate = options.weightedFinancingRate ?? "" as any;
  o.financingRate = options.financingRate ?? "" as any;
  o.percentDebtFinancedBasisPoints = options.percentDebtFinancedBasisPoints ?? 0;
  o.preConMonths = options.preConMonths ?? "" as any;
  o.constructionMonths = options.constructionMonths ?? "" as any;
  o.salesPeriodMonths = options.salesPeriodMonths ?? "" as any;
  o.exitRealtorFeeBasisPoints = options.exitRealtorFeeBasisPoints ?? 0;
  o.acquisitionClosingCostsBasisPoints = options.acquisitionClosingCostsBasisPoints ?? 0;
  return o;
}

factories["UnderwritingConfig"] = newUnderwritingConfig;

export interface SaveUnderwritingConfigResultOptions {
  __typename?: "SaveUnderwritingConfigResult";
  underwritingConfig?: UnderwritingConfigOptions;
}

export function newSaveUnderwritingConfigResult(
  options: SaveUnderwritingConfigResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnderwritingConfigResult {
  const o = (options.__typename ? options : cache["SaveUnderwritingConfigResult"] = {}) as SaveUnderwritingConfigResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnderwritingConfigResult";
  o.underwritingConfig = maybeNew(
    "UnderwritingConfig",
    options.underwritingConfig,
    cache,
    options.hasOwnProperty("underwritingConfig"),
  );
  return o;
}

factories["SaveUnderwritingConfigResult"] = newSaveUnderwritingConfigResult;

export interface UnderwritingConfigMetroOptions {
  __typename?: "UnderwritingConfigMetro";
  id?: UnderwritingConfigMetro["id"];
  targetInvestorMarginBasisPoints?: UnderwritingConfigMetro["targetInvestorMarginBasisPoints"];
  metro?: MetroOptions;
  underwritingConfig?: UnderwritingConfigOptions;
  buildMarginBasisPoints?: UnderwritingConfigMetro["buildMarginBasisPoints"];
  siteAcquisitionMarkupBasisPoints?: UnderwritingConfigMetro["siteAcquisitionMarkupBasisPoints"];
  weightedFinancingRate?: UnderwritingConfigMetro["weightedFinancingRate"];
  financingRate?: UnderwritingConfigMetro["financingRate"];
  percentDebtFinancedBasisPoints?: UnderwritingConfigMetro["percentDebtFinancedBasisPoints"];
  preConMonths?: UnderwritingConfigMetro["preConMonths"];
  constructionMonths?: UnderwritingConfigMetro["constructionMonths"];
  salesPeriodMonths?: UnderwritingConfigMetro["salesPeriodMonths"];
  exitRealtorFeeBasisPoints?: UnderwritingConfigMetro["exitRealtorFeeBasisPoints"];
  acquisitionClosingCostsBasisPoints?: UnderwritingConfigMetro["acquisitionClosingCostsBasisPoints"];
}

export function newUnderwritingConfigMetro(
  options: UnderwritingConfigMetroOptions = {},
  cache: Record<string, any> = {},
): UnderwritingConfigMetro {
  const o = (options.__typename ? options : cache["UnderwritingConfigMetro"] = {}) as UnderwritingConfigMetro;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UnderwritingConfigMetro";
  o.id = options.id ?? nextFactoryId("UnderwritingConfigMetro");
  o.targetInvestorMarginBasisPoints = options.targetInvestorMarginBasisPoints ?? 0;
  o.metro = maybeNew("Metro", options.metro, cache, options.hasOwnProperty("metro"));
  o.underwritingConfig = maybeNew(
    "UnderwritingConfig",
    options.underwritingConfig,
    cache,
    options.hasOwnProperty("underwritingConfig"),
  );
  o.buildMarginBasisPoints = options.buildMarginBasisPoints ?? 0;
  o.siteAcquisitionMarkupBasisPoints = options.siteAcquisitionMarkupBasisPoints ?? 0;
  o.weightedFinancingRate = options.weightedFinancingRate ?? "" as any;
  o.financingRate = options.financingRate ?? "" as any;
  o.percentDebtFinancedBasisPoints = options.percentDebtFinancedBasisPoints ?? 0;
  o.preConMonths = options.preConMonths ?? "" as any;
  o.constructionMonths = options.constructionMonths ?? "" as any;
  o.salesPeriodMonths = options.salesPeriodMonths ?? "" as any;
  o.exitRealtorFeeBasisPoints = options.exitRealtorFeeBasisPoints ?? 0;
  o.acquisitionClosingCostsBasisPoints = options.acquisitionClosingCostsBasisPoints ?? 0;
  return o;
}

factories["UnderwritingConfigMetro"] = newUnderwritingConfigMetro;

export interface SaveUnderwritingConfigMetroResultOptions {
  __typename?: "SaveUnderwritingConfigMetroResult";
  underwritingConfigMetro?: UnderwritingConfigMetroOptions;
}

export function newSaveUnderwritingConfigMetroResult(
  options: SaveUnderwritingConfigMetroResultOptions = {},
  cache: Record<string, any> = {},
): SaveUnderwritingConfigMetroResult {
  const o =
    (options.__typename
      ? options
      : cache["SaveUnderwritingConfigMetroResult"] = {}) as SaveUnderwritingConfigMetroResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUnderwritingConfigMetroResult";
  o.underwritingConfigMetro = maybeNew(
    "UnderwritingConfigMetro",
    options.underwritingConfigMetro,
    cache,
    options.hasOwnProperty("underwritingConfigMetro"),
  );
  return o;
}

factories["SaveUnderwritingConfigMetroResult"] = newSaveUnderwritingConfigMetroResult;

export interface UnderwritingInternalRateOfReturnCalculatorResultOptions {
  __typename?: "UnderwritingInternalRateOfReturnCalculatorResult";
  leveredInternalRateOfReturnBasisPoints?:
    UnderwritingInternalRateOfReturnCalculatorResult["leveredInternalRateOfReturnBasisPoints"];
  leveredMultipleOnInvestedCapital?:
    UnderwritingInternalRateOfReturnCalculatorResult["leveredMultipleOnInvestedCapital"];
  leveredReturnOnCostBasisPoints?: UnderwritingInternalRateOfReturnCalculatorResult["leveredReturnOnCostBasisPoints"];
  unleveredInternalRateOfReturnBasisPoints?:
    UnderwritingInternalRateOfReturnCalculatorResult["unleveredInternalRateOfReturnBasisPoints"];
  unleveredMultipleOnInvestedCapital?:
    UnderwritingInternalRateOfReturnCalculatorResult["unleveredMultipleOnInvestedCapital"];
  unleveredReturnOnCostBasisPoints?:
    UnderwritingInternalRateOfReturnCalculatorResult["unleveredReturnOnCostBasisPoints"];
  seniorDebtInterestAmountInCents?: UnderwritingInternalRateOfReturnCalculatorResult["seniorDebtInterestAmountInCents"];
}

export function newUnderwritingInternalRateOfReturnCalculatorResult(
  options: UnderwritingInternalRateOfReturnCalculatorResultOptions = {},
  cache: Record<string, any> = {},
): UnderwritingInternalRateOfReturnCalculatorResult {
  const o =
    (options.__typename
      ? options
      : cache["UnderwritingInternalRateOfReturnCalculatorResult"] =
        {}) as UnderwritingInternalRateOfReturnCalculatorResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UnderwritingInternalRateOfReturnCalculatorResult";
  o.leveredInternalRateOfReturnBasisPoints = options.leveredInternalRateOfReturnBasisPoints ?? 0;
  o.leveredMultipleOnInvestedCapital = options.leveredMultipleOnInvestedCapital ?? "" as any;
  o.leveredReturnOnCostBasisPoints = options.leveredReturnOnCostBasisPoints ?? 0;
  o.unleveredInternalRateOfReturnBasisPoints = options.unleveredInternalRateOfReturnBasisPoints ?? 0;
  o.unleveredMultipleOnInvestedCapital = options.unleveredMultipleOnInvestedCapital ?? "" as any;
  o.unleveredReturnOnCostBasisPoints = options.unleveredReturnOnCostBasisPoints ?? 0;
  o.seniorDebtInterestAmountInCents = options.seniorDebtInterestAmountInCents ?? 0;
  return o;
}

factories["UnderwritingInternalRateOfReturnCalculatorResult"] = newUnderwritingInternalRateOfReturnCalculatorResult;

export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  email?: User["email"];
  deactivatedAt?: User["deactivatedAt"];
  gsuiteEmailAlias?: User["gsuiteEmailAlias"];
  createdAt?: User["createdAt"];
  updatedAt?: User["updatedAt"];
  type?: UserTypeDetailOptions | UserType;
  homeowner?: HomeownerOptions | null;
  internalUser?: InternalUserOptions | null;
  isActive?: User["isActive"];
}

export function newUser(options: UserOptions = {}, cache: Record<string, any> = {}): User {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  o.__typename = "User";
  o.id = options.id ?? null;
  o.email = options.email ?? "email";
  o.deactivatedAt = options.deactivatedAt ?? null;
  o.gsuiteEmailAlias = options.gsuiteEmailAlias ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfUserType(options.type);
  o.homeowner = maybeNewOrNull("Homeowner", options.homeowner, cache);
  o.internalUser = maybeNewOrNull("InternalUser", options.internalUser, cache);
  o.isActive = options.isActive ?? null;
  return o;
}

factories["User"] = newUser;

export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserResult {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveUserResult"] = newSaveUserResult;

export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUserResult {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUserResult {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNew("UserError", i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ActivateUserResult"] = newActivateUserResult;

const enumDetailNameOfCostType = { SOFT: "Soft", DIRECT: "Direct", INDIRECT: "Indirect" };

function enumOrDetailOfCostType(enumOrDetail: CostTypeDetailOptions | CostType | undefined): CostTypeDetail {
  if (enumOrDetail === undefined) {
    return newCostTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CostTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCostType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CostTypeDetail;
  } else {
    return newCostTypeDetail({
      code: enumOrDetail as CostType,
      name: enumDetailNameOfCostType[enumOrDetail as CostType],
    });
  }
}

function enumOrDetailOrNullOfCostType(
  enumOrDetail: CostTypeDetailOptions | CostType | undefined | null,
): CostTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCostType(enumOrDetail);
}

const enumDetailNameOfDocumentType = {
  GENERAL: "General",
  LOT_ACQ_SETTLEMENT_STATEMENT_FINAL: "Lot acq settlement statement final",
  LOT_ACQ_SETTLEMENT_STATEMENT_PRELIM: "Lot acq settlement statement prelim",
  PURCHASE_AGREEMENT: "Purchase agreement",
  PURCHASE_AGREEMENT_AMENDMENT: "Purchase agreement amendment",
  UNDERWRITING_PROFORMA: "Underwriting proforma",
  PROPERTY_SALE: "Property sale",
};

function enumOrDetailOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined,
): DocumentTypeDetail {
  if (enumOrDetail === undefined) {
    return newDocumentTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "DocumentTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfDocumentType[enumOrDetail.code!],
      ...enumOrDetail,
    } as DocumentTypeDetail;
  } else {
    return newDocumentTypeDetail({
      code: enumOrDetail as DocumentType,
      name: enumDetailNameOfDocumentType[enumOrDetail as DocumentType],
    });
  }
}

function enumOrDetailOrNullOfDocumentType(
  enumOrDetail: DocumentTypeDetailOptions | DocumentType | undefined | null,
): DocumentTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfDocumentType(enumOrDetail);
}

const enumDetailNameOfCreditFacilityInterestType = { FIXED_AT_DRAW: "Fixed at draw", FLOATING: "Floating" };

function enumOrDetailOfCreditFacilityInterestType(
  enumOrDetail: CreditFacilityInterestTypeDetailOptions | CreditFacilityInterestType | undefined,
): CreditFacilityInterestTypeDetail {
  if (enumOrDetail === undefined) {
    return newCreditFacilityInterestTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "CreditFacilityInterestTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfCreditFacilityInterestType[enumOrDetail.code!],
      ...enumOrDetail,
    } as CreditFacilityInterestTypeDetail;
  } else {
    return newCreditFacilityInterestTypeDetail({
      code: enumOrDetail as CreditFacilityInterestType,
      name: enumDetailNameOfCreditFacilityInterestType[enumOrDetail as CreditFacilityInterestType],
    });
  }
}

function enumOrDetailOrNullOfCreditFacilityInterestType(
  enumOrDetail: CreditFacilityInterestTypeDetailOptions | CreditFacilityInterestType | undefined | null,
): CreditFacilityInterestTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfCreditFacilityInterestType(enumOrDetail);
}

const enumDetailNameOfFundCreditFacilityDrawModel = {
  NONE: "None",
  GOLDMAN: "Goldman",
  ANCHOR_MULTILOT: "Anchor multilot",
  ANCHOR_FLOATING: "Anchor floating",
};

function enumOrDetailOfFundCreditFacilityDrawModel(
  enumOrDetail: FundCreditFacilityDrawModelDetailOptions | FundCreditFacilityDrawModel | undefined,
): FundCreditFacilityDrawModelDetail {
  if (enumOrDetail === undefined) {
    return newFundCreditFacilityDrawModelDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "FundCreditFacilityDrawModelDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfFundCreditFacilityDrawModel[enumOrDetail.code!],
      ...enumOrDetail,
    } as FundCreditFacilityDrawModelDetail;
  } else {
    return newFundCreditFacilityDrawModelDetail({
      code: enumOrDetail as FundCreditFacilityDrawModel,
      name: enumDetailNameOfFundCreditFacilityDrawModel[enumOrDetail as FundCreditFacilityDrawModel],
    });
  }
}

function enumOrDetailOrNullOfFundCreditFacilityDrawModel(
  enumOrDetail: FundCreditFacilityDrawModelDetailOptions | FundCreditFacilityDrawModel | undefined | null,
): FundCreditFacilityDrawModelDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfFundCreditFacilityDrawModel(enumOrDetail);
}

const enumDetailNameOfLotAcqSettlementStatementLineItemType = {
  OTHER: "Other",
  GROSS_PURCHASE_PRICE: "Gross purchase price",
  EARNEST_MONEY: "Earnest money",
  PROPERTY_TAXES: "Property taxes",
  PRORATIONS: "Prorations",
  LOAN_PROCEEDS: "Loan proceeds",
  ORIGINATION_FEE: "Origination fee",
  FINANCING_FEES: "Financing fees",
  ESCROW_FEES: "Escrow fees",
  LEGAL_FEES: "Legal fees",
  POLICY_GUARANTY_FEE: "Policy guaranty fee",
  TITLE_INSURANCE: "Title insurance",
  WARRANTY_DEED: "Warranty deed",
  MISC_TITLE_ESCROW_FEES: "Misc title escrow fees",
  SURVEY: "Survey",
  MISC_DISBURSEMENTS_PAID: "Misc disbursements paid",
  CASH_TO_CLOSE: "Cash to close",
};

function enumOrDetailOfLotAcqSettlementStatementLineItemType(
  enumOrDetail: LotAcqSettlementStatementLineItemTypeDetailOptions | LotAcqSettlementStatementLineItemType | undefined,
): LotAcqSettlementStatementLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotAcqSettlementStatementLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotAcqSettlementStatementLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotAcqSettlementStatementLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotAcqSettlementStatementLineItemTypeDetail;
  } else {
    return newLotAcqSettlementStatementLineItemTypeDetail({
      code: enumOrDetail as LotAcqSettlementStatementLineItemType,
      name:
        enumDetailNameOfLotAcqSettlementStatementLineItemType[enumOrDetail as LotAcqSettlementStatementLineItemType],
    });
  }
}

function enumOrDetailOrNullOfLotAcqSettlementStatementLineItemType(
  enumOrDetail:
    | LotAcqSettlementStatementLineItemTypeDetailOptions
    | LotAcqSettlementStatementLineItemType
    | undefined
    | null,
): LotAcqSettlementStatementLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotAcqSettlementStatementLineItemType(enumOrDetail);
}

const enumDetailNameOfLotInvestmentStatus = { PENDING: "Pending", ACTIVE: "Active", CLOSED: "Closed" };

function enumOrDetailOfLotInvestmentStatus(
  enumOrDetail: LotInvestmentStatusDetailOptions | LotInvestmentStatus | undefined,
): LotInvestmentStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotInvestmentStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotInvestmentStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotInvestmentStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotInvestmentStatusDetail;
  } else {
    return newLotInvestmentStatusDetail({
      code: enumOrDetail as LotInvestmentStatus,
      name: enumDetailNameOfLotInvestmentStatus[enumOrDetail as LotInvestmentStatus],
    });
  }
}

function enumOrDetailOrNullOfLotInvestmentStatus(
  enumOrDetail: LotInvestmentStatusDetailOptions | LotInvestmentStatus | undefined | null,
): LotInvestmentStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotInvestmentStatus(enumOrDetail);
}

const enumDetailNameOfLotPartitionEstimateStatus = {
  REJECTED: "Rejected",
  AWAITING_ACCEPTANCE: "Awaiting acceptance",
  ACCEPTED: "Accepted",
  CONTRACTED: "Contracted",
};

function enumOrDetailOfLotPartitionEstimateStatus(
  enumOrDetail: LotPartitionEstimateStatusDetailOptions | LotPartitionEstimateStatus | undefined,
): LotPartitionEstimateStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotPartitionEstimateStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotPartitionEstimateStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotPartitionEstimateStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotPartitionEstimateStatusDetail;
  } else {
    return newLotPartitionEstimateStatusDetail({
      code: enumOrDetail as LotPartitionEstimateStatus,
      name: enumDetailNameOfLotPartitionEstimateStatus[enumOrDetail as LotPartitionEstimateStatus],
    });
  }
}

function enumOrDetailOrNullOfLotPartitionEstimateStatus(
  enumOrDetail: LotPartitionEstimateStatusDetailOptions | LotPartitionEstimateStatus | undefined | null,
): LotPartitionEstimateStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotPartitionEstimateStatus(enumOrDetail);
}

const enumDetailNameOfLotPartitionEstimateType = { PRIME: "Prime", CHANGE_ORDER: "Change order" };

function enumOrDetailOfLotPartitionEstimateType(
  enumOrDetail: LotPartitionEstimateTypeDetailOptions | LotPartitionEstimateType | undefined,
): LotPartitionEstimateTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotPartitionEstimateTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotPartitionEstimateTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotPartitionEstimateType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotPartitionEstimateTypeDetail;
  } else {
    return newLotPartitionEstimateTypeDetail({
      code: enumOrDetail as LotPartitionEstimateType,
      name: enumDetailNameOfLotPartitionEstimateType[enumOrDetail as LotPartitionEstimateType],
    });
  }
}

function enumOrDetailOrNullOfLotPartitionEstimateType(
  enumOrDetail: LotPartitionEstimateTypeDetailOptions | LotPartitionEstimateType | undefined | null,
): LotPartitionEstimateTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotPartitionEstimateType(enumOrDetail);
}

const enumDetailNameOfLotPartitionSalesStatus = {
  PRE_FOR_SALE: "Pre for sale",
  FOR_SALE: "For sale",
  RESERVED: "Reserved",
  SOLD: "Sold",
};

function enumOrDetailOfLotPartitionSalesStatus(
  enumOrDetail: LotPartitionSalesStatusDetailOptions | LotPartitionSalesStatus | undefined,
): LotPartitionSalesStatusDetail {
  if (enumOrDetail === undefined) {
    return newLotPartitionSalesStatusDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotPartitionSalesStatusDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotPartitionSalesStatus[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotPartitionSalesStatusDetail;
  } else {
    return newLotPartitionSalesStatusDetail({
      code: enumOrDetail as LotPartitionSalesStatus,
      name: enumDetailNameOfLotPartitionSalesStatus[enumOrDetail as LotPartitionSalesStatus],
    });
  }
}

function enumOrDetailOrNullOfLotPartitionSalesStatus(
  enumOrDetail: LotPartitionSalesStatusDetailOptions | LotPartitionSalesStatus | undefined | null,
): LotPartitionSalesStatusDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotPartitionSalesStatus(enumOrDetail);
}

const enumDetailNameOfLotType = { BOYL: "Boyl", BOOL: "Bool" };

function enumOrDetailOfLotType(enumOrDetail: LotTypeDetailOptions | LotType | undefined): LotTypeDetail {
  if (enumOrDetail === undefined) {
    return newLotTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "LotTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfLotType[enumOrDetail.code!],
      ...enumOrDetail,
    } as LotTypeDetail;
  } else {
    return newLotTypeDetail({ code: enumOrDetail as LotType, name: enumDetailNameOfLotType[enumOrDetail as LotType] });
  }
}

function enumOrDetailOrNullOfLotType(
  enumOrDetail: LotTypeDetailOptions | LotType | undefined | null,
): LotTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfLotType(enumOrDetail);
}

const enumDetailNameOfPropertySaleSettlementStatementLineItemType = {
  GROSS_SALE_PRICE: "Gross sale price",
  DEPOSITS: "Deposits",
  SALES_INCENTIVE: "Sales incentive",
  PROPERTY_TAXES: "Property taxes",
  PRORATIONS: "Prorations",
  BROKERAGE_FEE_SELLER: "Brokerage fee seller",
  BROKERAGE_FEE_BUYER: "Brokerage fee buyer",
  BUYER_LOAN_PROCEEDS: "Buyer loan proceeds",
  LOAN_PAYOFF: "Loan payoff",
  INTEREST_EXPENSE: "Interest expense",
  FINANCING_FEES: "Financing fees",
  CLOSING_COSTS: "Closing costs",
  HOMEOWNER_INSURANCE: "Homeowner insurance",
  MISC_DISBURSEMENTS_PAID: "Misc disbursements paid",
  CASH_RECEIVED_AT_CLOSE: "Cash received at close",
  OTHER: "Other",
};

function enumOrDetailOfPropertySaleSettlementStatementLineItemType(
  enumOrDetail:
    | PropertySaleSettlementStatementLineItemTypeDetailOptions
    | PropertySaleSettlementStatementLineItemType
    | undefined,
): PropertySaleSettlementStatementLineItemTypeDetail {
  if (enumOrDetail === undefined) {
    return newPropertySaleSettlementStatementLineItemTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "PropertySaleSettlementStatementLineItemTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfPropertySaleSettlementStatementLineItemType[enumOrDetail.code!],
      ...enumOrDetail,
    } as PropertySaleSettlementStatementLineItemTypeDetail;
  } else {
    return newPropertySaleSettlementStatementLineItemTypeDetail({
      code: enumOrDetail as PropertySaleSettlementStatementLineItemType,
      name:
        enumDetailNameOfPropertySaleSettlementStatementLineItemType[
          enumOrDetail as PropertySaleSettlementStatementLineItemType
        ],
    });
  }
}

function enumOrDetailOrNullOfPropertySaleSettlementStatementLineItemType(
  enumOrDetail:
    | PropertySaleSettlementStatementLineItemTypeDetailOptions
    | PropertySaleSettlementStatementLineItemType
    | undefined
    | null,
): PropertySaleSettlementStatementLineItemTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfPropertySaleSettlementStatementLineItemType(enumOrDetail);
}

const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const taggedIds: Record<string, string> = {};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

function maybeNew(
  type: string,
  value: { __typename?: string } | object | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): any {
  if (value === undefined) {
    return isSet ? undefined : cache[type] || factories[type]({}, cache);
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

function maybeNewOrNull(
  type: string,
  value: { __typename?: string } | object | undefined | null,
  cache: Record<string, any>,
): any {
  if (!value) {
    return null;
  } else if ("__typename" in value && value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return factories[type](value, cache);
  }
}

export const possibleTypes = { DocumentParent: ["LotPartition", "Lot"] };

export const enumTypePolicies = {
  CostTypeDetail: { keyFields: ["code"] },

  CreditFacilityInterestTypeDetail: { keyFields: ["code"] },

  DocumentTypeDetail: { keyFields: ["code"] },

  FundCreditFacilityDrawModelDetail: { keyFields: ["code"] },

  LotAcqSettlementStatementLineItemTypeDetail: { keyFields: ["code"] },

  LotInvestmentStatusDetail: { keyFields: ["code"] },

  LotPartitionEstimateStatusDetail: { keyFields: ["code"] },

  LotPartitionEstimateTypeDetail: { keyFields: ["code"] },

  LotPartitionSalesStatusDetail: { keyFields: ["code"] },

  LotTypeDetail: { keyFields: ["code"] },

  PropertySaleSettlementStatementLineItemTypeDetail: { keyFields: ["code"] },

  UserTypeDetail: { keyFields: ["code"] },
};

interface FundAllocationsPageLotsDataOptions {
  lots?: LotOptions[];
}

export function newFundAllocationsPageLotsData(data: FundAllocationsPageLotsDataOptions): FundAllocationsPageLotsQuery {
  return { __typename: "Query" as const, lots: data["lots"]?.map((d) => newLot(d)) || [] } as any;
}

export function newFundAllocationsPageLotsResponse(
  data: FundAllocationsPageLotsDataOptions | Error,
): MockedResponse<FundAllocationsPageLotsQueryVariables, FundAllocationsPageLotsQuery> {
  return {
    request: { query: FundAllocationsPageLotsDocument },
    result: { data: data instanceof Error ? undefined : newFundAllocationsPageLotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundAllocationsPageFundsDataOptions {
  funds?: FundOptions[];
}

export function newFundAllocationsPageFundsData(
  data: FundAllocationsPageFundsDataOptions,
): FundAllocationsPageFundsQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundAllocationsPageFundsResponse(
  data: FundAllocationsPageFundsDataOptions | Error,
): MockedResponse<FundAllocationsPageFundsQueryVariables, FundAllocationsPageFundsQuery> {
  return {
    request: { query: FundAllocationsPageFundsDocument },
    result: { data: data instanceof Error ? undefined : newFundAllocationsPageFundsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotsDataOptions {
  saveLots?: SaveLotsResultOptions;
}

export function newSaveLotsData(data: SaveLotsDataOptions): SaveLotsMutation {
  return {
    __typename: "Mutation" as const,
    saveLots: maybeNew("SaveLotsResult", data["saveLots"] || undefined, {}),
  } as any;
}

export function newSaveLotsResponse(
  variables: SaveLotsMutationVariables,
  data: SaveLotsDataOptions | Error,
): MockedResponse<SaveLotsMutationVariables, SaveLotsMutation> {
  return {
    request: { query: SaveLotsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendCustomerInformationToBlueprintDataOptions {
  sendCustomerInformationToBlueprint?: SendCustomerInformationToBlueprintResultOptions;
}

export function newSendCustomerInformationToBlueprintData(
  data: SendCustomerInformationToBlueprintDataOptions,
): SendCustomerInformationToBlueprintMutation {
  return {
    __typename: "Mutation" as const,
    sendCustomerInformationToBlueprint: maybeNew(
      "SendCustomerInformationToBlueprintResult",
      data["sendCustomerInformationToBlueprint"] || undefined,
      {},
    ),
  } as any;
}

export function newSendCustomerInformationToBlueprintResponse(
  variables: SendCustomerInformationToBlueprintMutationVariables,
  data: SendCustomerInformationToBlueprintDataOptions | Error,
): MockedResponse<SendCustomerInformationToBlueprintMutationVariables, SendCustomerInformationToBlueprintMutation> {
  return {
    request: { query: SendCustomerInformationToBlueprintDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendCustomerInformationToBlueprintData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateAssetUploadUrlDataOptions {
  createAssetUploadUrl?: CreateAssetUploadUrlResultOptions;
}

export function newCreateAssetUploadUrlData(data: CreateAssetUploadUrlDataOptions): CreateAssetUploadUrlMutation {
  return {
    __typename: "Mutation" as const,
    createAssetUploadUrl: maybeNew("CreateAssetUploadUrlResult", data["createAssetUploadUrl"] || undefined, {}),
  } as any;
}

export function newCreateAssetUploadUrlResponse(
  variables: CreateAssetUploadUrlMutationVariables,
  data: CreateAssetUploadUrlDataOptions | Error,
): MockedResponse<CreateAssetUploadUrlMutationVariables, CreateAssetUploadUrlMutation> {
  return {
    request: { query: CreateAssetUploadUrlDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateAssetUploadUrlData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundsPageFundsDataOptions {
  funds?: FundOptions[];
}

export function newFundsPageFundsData(data: FundsPageFundsDataOptions): FundsPageFundsQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundsPageFundsResponse(
  data: FundsPageFundsDataOptions | Error,
): MockedResponse<FundsPageFundsQueryVariables, FundsPageFundsQuery> {
  return {
    request: { query: FundsPageFundsDocument },
    result: { data: data instanceof Error ? undefined : newFundsPageFundsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CheckoutControlsDataOptions {
  lotPartitions?: LotPartitionOptions[];
}

export function newCheckoutControlsData(data: CheckoutControlsDataOptions): CheckoutControlsQuery {
  return {
    __typename: "Query" as const,
    lotPartitions: data["lotPartitions"]?.map((d) => newLotPartition(d)) || [],
  } as any;
}

export function newCheckoutControlsResponse(
  data: CheckoutControlsDataOptions | Error,
): MockedResponse<CheckoutControlsQueryVariables, CheckoutControlsQuery> {
  return {
    request: { query: CheckoutControlsDocument },
    result: { data: data instanceof Error ? undefined : newCheckoutControlsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface MetrosPageMetrosDataOptions {
  metros?: MetroOptions[];
}

export function newMetrosPageMetrosData(data: MetrosPageMetrosDataOptions): MetrosPageMetrosQuery {
  return { __typename: "Query" as const, metros: data["metros"]?.map((d) => newMetro(d)) || [] } as any;
}

export function newMetrosPageMetrosResponse(
  data: MetrosPageMetrosDataOptions | Error,
): MockedResponse<MetrosPageMetrosQueryVariables, MetrosPageMetrosQuery> {
  return {
    request: { query: MetrosPageMetrosDocument },
    result: { data: data instanceof Error ? undefined : newMetrosPageMetrosData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveMetroDataOptions {
  saveMetro?: SaveMetroResultOptions;
}

export function newSaveMetroData(data: SaveMetroDataOptions): SaveMetroMutation {
  return {
    __typename: "Mutation" as const,
    saveMetro: maybeNew("SaveMetroResult", data["saveMetro"] || undefined, {}),
  } as any;
}

export function newSaveMetroResponse(
  variables: SaveMetroMutationVariables,
  data: SaveMetroDataOptions | Error,
): MockedResponse<SaveMetroMutationVariables, SaveMetroMutation> {
  return {
    request: { query: SaveMetroDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveMetroData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface UnderwritingOverviewUnderwritingConfigDataOptions {
  underwritingConfigs?: UnderwritingConfigOptions[];
}

export function newUnderwritingOverviewUnderwritingConfigData(
  data: UnderwritingOverviewUnderwritingConfigDataOptions,
): UnderwritingOverviewUnderwritingConfigQuery {
  return {
    __typename: "Query" as const,
    underwritingConfigs: data["underwritingConfigs"]?.map((d) => newUnderwritingConfig(d)) || [],
  } as any;
}

export function newUnderwritingOverviewUnderwritingConfigResponse(
  variables: UnderwritingOverviewUnderwritingConfigQueryVariables,
  data: UnderwritingOverviewUnderwritingConfigDataOptions | Error,
): MockedResponse<UnderwritingOverviewUnderwritingConfigQueryVariables, UnderwritingOverviewUnderwritingConfigQuery> {
  return {
    request: { query: UnderwritingOverviewUnderwritingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newUnderwritingOverviewUnderwritingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUnderwritingConfigDataOptions {
  saveUnderwritingConfig?: SaveUnderwritingConfigResultOptions;
}

export function newSaveUnderwritingConfigData(data: SaveUnderwritingConfigDataOptions): SaveUnderwritingConfigMutation {
  return {
    __typename: "Mutation" as const,
    saveUnderwritingConfig: maybeNew("SaveUnderwritingConfigResult", data["saveUnderwritingConfig"] || undefined, {}),
  } as any;
}

export function newSaveUnderwritingConfigResponse(
  variables: SaveUnderwritingConfigMutationVariables,
  data: SaveUnderwritingConfigDataOptions | Error,
): MockedResponse<SaveUnderwritingConfigMutationVariables, SaveUnderwritingConfigMutation> {
  return {
    request: { query: SaveUnderwritingConfigDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUnderwritingConfigData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveUnderwritingConfigMetroDataOptions {
  saveUnderwritingConfigMetro?: SaveUnderwritingConfigMetroResultOptions;
}

export function newSaveUnderwritingConfigMetroData(
  data: SaveUnderwritingConfigMetroDataOptions,
): SaveUnderwritingConfigMetroMutation {
  return {
    __typename: "Mutation" as const,
    saveUnderwritingConfigMetro: maybeNew(
      "SaveUnderwritingConfigMetroResult",
      data["saveUnderwritingConfigMetro"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveUnderwritingConfigMetroResponse(
  variables: SaveUnderwritingConfigMetroMutationVariables,
  data: SaveUnderwritingConfigMetroDataOptions | Error,
): MockedResponse<SaveUnderwritingConfigMetroMutationVariables, SaveUnderwritingConfigMetroMutation> {
  return {
    request: { query: SaveUnderwritingConfigMetroDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveUnderwritingConfigMetroData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotsPageLotsDataOptions {
  lots?: LotOptions[];
}

export function newLotsPageLotsData(data: LotsPageLotsDataOptions): LotsPageLotsQuery {
  return { __typename: "Query" as const, lots: data["lots"]?.map((d) => newLot(d)) || [] } as any;
}

export function newLotsPageLotsResponse(
  data: LotsPageLotsDataOptions | Error,
): MockedResponse<LotsPageLotsQueryVariables, LotsPageLotsQuery> {
  return {
    request: { query: LotsPageLotsDocument },
    result: { data: data instanceof Error ? undefined : newLotsPageLotsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DrawOverviewDrawDataOptions {
  creditFacilityDraws?: CreditFacilityDrawOptions[];
}

export function newDrawOverviewDrawData(data: DrawOverviewDrawDataOptions): DrawOverviewDrawQuery {
  return {
    __typename: "Query" as const,
    creditFacilityDraws: data["creditFacilityDraws"]?.map((d) => newCreditFacilityDraw(d)) || [],
  } as any;
}

export function newDrawOverviewDrawResponse(
  variables: DrawOverviewDrawQueryVariables,
  data: DrawOverviewDrawDataOptions | Error,
): MockedResponse<DrawOverviewDrawQueryVariables, DrawOverviewDrawQuery> {
  return {
    request: { query: DrawOverviewDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newDrawOverviewDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotPartitionDrawDataOptions {
  saveLotPartitionDraw?: SaveLotPartitionDrawResultOptions;
}

export function newSaveLotPartitionDrawData(data: SaveLotPartitionDrawDataOptions): SaveLotPartitionDrawMutation {
  return {
    __typename: "Mutation" as const,
    saveLotPartitionDraw: maybeNew("SaveLotPartitionDrawResult", data["saveLotPartitionDraw"] || undefined, {}),
  } as any;
}

export function newSaveLotPartitionDrawResponse(
  variables: SaveLotPartitionDrawMutationVariables,
  data: SaveLotPartitionDrawDataOptions | Error,
): MockedResponse<SaveLotPartitionDrawMutationVariables, SaveLotPartitionDrawMutation> {
  return {
    request: { query: SaveLotPartitionDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotPartitionDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCreditFacilityDrawDataOptions {
  saveCreditFacilityDraw?: SaveCreditFacilityDrawResultOptions;
}

export function newSaveCreditFacilityDrawData(data: SaveCreditFacilityDrawDataOptions): SaveCreditFacilityDrawMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityDraw: maybeNew("SaveCreditFacilityDrawResult", data["saveCreditFacilityDraw"] || undefined, {}),
  } as any;
}

export function newSaveCreditFacilityDrawResponse(
  variables: SaveCreditFacilityDrawMutationVariables,
  data: SaveCreditFacilityDrawDataOptions | Error,
): MockedResponse<SaveCreditFacilityDrawMutationVariables, SaveCreditFacilityDrawMutation> {
  return {
    request: { query: SaveCreditFacilityDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCreditFacilityDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteDrawDataOptions {
  deleteCreditFacilityDraw?: EmptyResultOptions;
}

export function newDeleteDrawData(data: DeleteDrawDataOptions): DeleteDrawMutation {
  return {
    __typename: "Mutation" as const,
    deleteCreditFacilityDraw: maybeNew("EmptyResult", data["deleteCreditFacilityDraw"] || undefined, {}),
  } as any;
}

export function newDeleteDrawResponse(
  variables: DeleteDrawMutationVariables,
  data: DeleteDrawDataOptions | Error,
): MockedResponse<DeleteDrawMutationVariables, DeleteDrawMutation> {
  return {
    request: { query: DeleteDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ExportBillsForDrawDataOptions {
  exportBillsForDraw?: ExportBillsForDrawResultOptions;
}

export function newExportBillsForDrawData(data: ExportBillsForDrawDataOptions): ExportBillsForDrawMutation {
  return {
    __typename: "Mutation" as const,
    exportBillsForDraw: maybeNew("ExportBillsForDrawResult", data["exportBillsForDraw"] || undefined, {}),
  } as any;
}

export function newExportBillsForDrawResponse(
  variables: ExportBillsForDrawMutationVariables,
  data: ExportBillsForDrawDataOptions | Error,
): MockedResponse<ExportBillsForDrawMutationVariables, ExportBillsForDrawMutation> {
  return {
    request: { query: ExportBillsForDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newExportBillsForDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCreditFacilityDrawDataOptions {
  saveCreditFacilityDraw?: SaveCreditFacilityDrawResultOptions;
}

export function newCreateCreditFacilityDrawData(
  data: CreateCreditFacilityDrawDataOptions,
): CreateCreditFacilityDrawMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityDraw: maybeNew("SaveCreditFacilityDrawResult", data["saveCreditFacilityDraw"] || undefined, {}),
  } as any;
}

export function newCreateCreditFacilityDrawResponse(
  variables: CreateCreditFacilityDrawMutationVariables,
  data: CreateCreditFacilityDrawDataOptions | Error,
): MockedResponse<CreateCreditFacilityDrawMutationVariables, CreateCreditFacilityDrawMutation> {
  return {
    request: { query: CreateCreditFacilityDrawDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCreditFacilityDrawData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface InvoiceOverviewInvoiceDataOptions {
  creditFacilityInvoices?: CreditFacilityInvoiceOptions[];
}

export function newInvoiceOverviewInvoiceData(data: InvoiceOverviewInvoiceDataOptions): InvoiceOverviewInvoiceQuery {
  return {
    __typename: "Query" as const,
    creditFacilityInvoices: data["creditFacilityInvoices"]?.map((d) => newCreditFacilityInvoice(d)) || [],
  } as any;
}

export function newInvoiceOverviewInvoiceResponse(
  variables: InvoiceOverviewInvoiceQueryVariables,
  data: InvoiceOverviewInvoiceDataOptions | Error,
): MockedResponse<InvoiceOverviewInvoiceQueryVariables, InvoiceOverviewInvoiceQuery> {
  return {
    request: { query: InvoiceOverviewInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newInvoiceOverviewInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDrawInterestDataOptions {
  saveCreditFacilityInvoiceDrawInterest?: SaveCreditFacilityInvoiceDrawInterestResultOptions;
}

export function newSaveDrawInterestData(data: SaveDrawInterestDataOptions): SaveDrawInterestMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityInvoiceDrawInterest: maybeNew(
      "SaveCreditFacilityInvoiceDrawInterestResult",
      data["saveCreditFacilityInvoiceDrawInterest"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveDrawInterestResponse(
  variables: SaveDrawInterestMutationVariables,
  data: SaveDrawInterestDataOptions | Error,
): MockedResponse<SaveDrawInterestMutationVariables, SaveDrawInterestMutation> {
  return {
    request: { query: SaveDrawInterestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDrawInterestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteInvoiceDataOptions {
  deleteCreditFacilityInvoice?: EmptyResultOptions;
}

export function newDeleteInvoiceData(data: DeleteInvoiceDataOptions): DeleteInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    deleteCreditFacilityInvoice: maybeNew("EmptyResult", data["deleteCreditFacilityInvoice"] || undefined, {}),
  } as any;
}

export function newDeleteInvoiceResponse(
  variables: DeleteInvoiceMutationVariables,
  data: DeleteInvoiceDataOptions | Error,
): MockedResponse<DeleteInvoiceMutationVariables, DeleteInvoiceMutation> {
  return {
    request: { query: DeleteInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DrawRequestOverviewDrawRequestDataOptions {
  creditFacilityDrawRequests?: CreditFacilityDrawRequestOptions[];
}

export function newDrawRequestOverviewDrawRequestData(
  data: DrawRequestOverviewDrawRequestDataOptions,
): DrawRequestOverviewDrawRequestQuery {
  return {
    __typename: "Query" as const,
    creditFacilityDrawRequests: data["creditFacilityDrawRequests"]?.map((d) => newCreditFacilityDrawRequest(d)) || [],
  } as any;
}

export function newDrawRequestOverviewDrawRequestResponse(
  variables: DrawRequestOverviewDrawRequestQueryVariables,
  data: DrawRequestOverviewDrawRequestDataOptions | Error,
): MockedResponse<DrawRequestOverviewDrawRequestQueryVariables, DrawRequestOverviewDrawRequestQuery> {
  return {
    request: { query: DrawRequestOverviewDrawRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newDrawRequestOverviewDrawRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotPartitionDrawRequestsDataOptions {
  saveLotPartitionDrawRequests?: SaveLotPartitionDrawRequestsResultOptions;
}

export function newSaveLotPartitionDrawRequestsData(
  data: SaveLotPartitionDrawRequestsDataOptions,
): SaveLotPartitionDrawRequestsMutation {
  return {
    __typename: "Mutation" as const,
    saveLotPartitionDrawRequests: maybeNew(
      "SaveLotPartitionDrawRequestsResult",
      data["saveLotPartitionDrawRequests"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveLotPartitionDrawRequestsResponse(
  variables: SaveLotPartitionDrawRequestsMutationVariables,
  data: SaveLotPartitionDrawRequestsDataOptions | Error,
): MockedResponse<SaveLotPartitionDrawRequestsMutationVariables, SaveLotPartitionDrawRequestsMutation> {
  return {
    request: { query: SaveLotPartitionDrawRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotPartitionDrawRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCreditFacilityDrawRequestDataOptions {
  saveCreditFacilityDrawRequest?: SaveCreditFacilityDrawRequestResultOptions;
}

export function newSaveCreditFacilityDrawRequestData(
  data: SaveCreditFacilityDrawRequestDataOptions,
): SaveCreditFacilityDrawRequestMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityDrawRequest: maybeNew(
      "SaveCreditFacilityDrawRequestResult",
      data["saveCreditFacilityDrawRequest"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCreditFacilityDrawRequestResponse(
  variables: SaveCreditFacilityDrawRequestMutationVariables,
  data: SaveCreditFacilityDrawRequestDataOptions | Error,
): MockedResponse<SaveCreditFacilityDrawRequestMutationVariables, SaveCreditFacilityDrawRequestMutation> {
  return {
    request: { query: SaveCreditFacilityDrawRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCreditFacilityDrawRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface RefreshDrawModelBlueprintDataDataOptions {
  refreshDrawModelBlueprintData?: EmptyResultOptions;
}

export function newRefreshDrawModelBlueprintDataData(
  data: RefreshDrawModelBlueprintDataDataOptions,
): RefreshDrawModelBlueprintDataMutation {
  return {
    __typename: "Mutation" as const,
    refreshDrawModelBlueprintData: maybeNew("EmptyResult", data["refreshDrawModelBlueprintData"] || undefined, {}),
  } as any;
}

export function newRefreshDrawModelBlueprintDataResponse(
  variables: RefreshDrawModelBlueprintDataMutationVariables,
  data: RefreshDrawModelBlueprintDataDataOptions | Error,
): MockedResponse<RefreshDrawModelBlueprintDataMutationVariables, RefreshDrawModelBlueprintDataMutation> {
  return {
    request: { query: RefreshDrawModelBlueprintDataDocument, variables },
    result: { data: data instanceof Error ? undefined : newRefreshDrawModelBlueprintDataData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundOverviewFundDataOptions {
  funds?: FundOptions[];
}

export function newFundOverviewFundData(data: FundOverviewFundDataOptions): FundOverviewFundQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundOverviewFundResponse(
  variables: FundOverviewFundQueryVariables,
  data: FundOverviewFundDataOptions | Error,
): MockedResponse<FundOverviewFundQueryVariables, FundOverviewFundQuery> {
  return {
    request: { query: FundOverviewFundDocument, variables },
    result: { data: data instanceof Error ? undefined : newFundOverviewFundData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundOverviewExpectedSaleDateFundDataOptions {
  funds?: FundOptions[];
}

export function newFundOverviewExpectedSaleDateFundData(
  data: FundOverviewExpectedSaleDateFundDataOptions,
): FundOverviewExpectedSaleDateFundQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundOverviewExpectedSaleDateFundResponse(
  variables: FundOverviewExpectedSaleDateFundQueryVariables,
  data: FundOverviewExpectedSaleDateFundDataOptions | Error,
): MockedResponse<FundOverviewExpectedSaleDateFundQueryVariables, FundOverviewExpectedSaleDateFundQuery> {
  return {
    request: { query: FundOverviewExpectedSaleDateFundDocument, variables },
    result: { data: data instanceof Error ? undefined : newFundOverviewExpectedSaleDateFundData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFundDataOptions {
  saveFund?: SaveFundResultOptions;
}

export function newSaveFundData(data: SaveFundDataOptions): SaveFundMutation {
  return {
    __typename: "Mutation" as const,
    saveFund: maybeNew("SaveFundResult", data["saveFund"] || undefined, {}),
  } as any;
}

export function newSaveFundResponse(
  variables: SaveFundMutationVariables,
  data: SaveFundDataOptions | Error,
): MockedResponse<SaveFundMutationVariables, SaveFundMutation> {
  return {
    request: { query: SaveFundDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFundData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveFundMetroDataOptions {
  saveFundMetro?: SaveFundMetroResultOptions;
}

export function newSaveFundMetroData(data: SaveFundMetroDataOptions): SaveFundMetroMutation {
  return {
    __typename: "Mutation" as const,
    saveFundMetro: maybeNew("SaveFundMetroResult", data["saveFundMetro"] || undefined, {}),
  } as any;
}

export function newSaveFundMetroResponse(
  variables: SaveFundMetroMutationVariables,
  data: SaveFundMetroDataOptions | Error,
): MockedResponse<SaveFundMetroMutationVariables, SaveFundMetroMutation> {
  return {
    request: { query: SaveFundMetroDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveFundMetroData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateCreditFacilityPaymentDataOptions {
  saveCreditFacilityPayment?: SaveCreditFacilityPaymentResultOptions;
}

export function newCreateCreditFacilityPaymentData(
  data: CreateCreditFacilityPaymentDataOptions,
): CreateCreditFacilityPaymentMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityPayment: maybeNew(
      "SaveCreditFacilityPaymentResult",
      data["saveCreditFacilityPayment"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateCreditFacilityPaymentResponse(
  variables: CreateCreditFacilityPaymentMutationVariables,
  data: CreateCreditFacilityPaymentDataOptions | Error,
): MockedResponse<CreateCreditFacilityPaymentMutationVariables, CreateCreditFacilityPaymentMutation> {
  return {
    request: { query: CreateCreditFacilityPaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateCreditFacilityPaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PaymentOverviewPaymentDataOptions {
  creditFacilityPayments?: CreditFacilityPaymentOptions[];
}

export function newPaymentOverviewPaymentData(data: PaymentOverviewPaymentDataOptions): PaymentOverviewPaymentQuery {
  return {
    __typename: "Query" as const,
    creditFacilityPayments: data["creditFacilityPayments"]?.map((d) => newCreditFacilityPayment(d)) || [],
  } as any;
}

export function newPaymentOverviewPaymentResponse(
  variables: PaymentOverviewPaymentQueryVariables,
  data: PaymentOverviewPaymentDataOptions | Error,
): MockedResponse<PaymentOverviewPaymentQueryVariables, PaymentOverviewPaymentQuery> {
  return {
    request: { query: PaymentOverviewPaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newPaymentOverviewPaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotPartitionDrawPaymentDataOptions {
  saveLotPartitionDrawPayment?: SaveLotPartitionDrawPaymentResultOptions;
}

export function newSaveLotPartitionDrawPaymentData(
  data: SaveLotPartitionDrawPaymentDataOptions,
): SaveLotPartitionDrawPaymentMutation {
  return {
    __typename: "Mutation" as const,
    saveLotPartitionDrawPayment: maybeNew(
      "SaveLotPartitionDrawPaymentResult",
      data["saveLotPartitionDrawPayment"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveLotPartitionDrawPaymentResponse(
  variables: SaveLotPartitionDrawPaymentMutationVariables,
  data: SaveLotPartitionDrawPaymentDataOptions | Error,
): MockedResponse<SaveLotPartitionDrawPaymentMutationVariables, SaveLotPartitionDrawPaymentMutation> {
  return {
    request: { query: SaveLotPartitionDrawPaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotPartitionDrawPaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCreditFacilityPaymentDataOptions {
  saveCreditFacilityPayment?: SaveCreditFacilityPaymentResultOptions;
}

export function newSaveCreditFacilityPaymentData(
  data: SaveCreditFacilityPaymentDataOptions,
): SaveCreditFacilityPaymentMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityPayment: maybeNew(
      "SaveCreditFacilityPaymentResult",
      data["saveCreditFacilityPayment"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCreditFacilityPaymentResponse(
  variables: SaveCreditFacilityPaymentMutationVariables,
  data: SaveCreditFacilityPaymentDataOptions | Error,
): MockedResponse<SaveCreditFacilityPaymentMutationVariables, SaveCreditFacilityPaymentMutation> {
  return {
    request: { query: SaveCreditFacilityPaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCreditFacilityPaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeletePaymentDataOptions {
  deleteCreditFacilityPayment?: EmptyResultOptions;
}

export function newDeletePaymentData(data: DeletePaymentDataOptions): DeletePaymentMutation {
  return {
    __typename: "Mutation" as const,
    deleteCreditFacilityPayment: maybeNew("EmptyResult", data["deleteCreditFacilityPayment"] || undefined, {}),
  } as any;
}

export function newDeletePaymentResponse(
  variables: DeletePaymentMutationVariables,
  data: DeletePaymentDataOptions | Error,
): MockedResponse<DeletePaymentMutationVariables, DeletePaymentMutation> {
  return {
    request: { query: DeletePaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeletePaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveCreditFacilityInvoiceDataOptions {
  saveCreditFacilityInvoice?: SaveCreditFacilityInvoiceResultOptions;
}

export function newSaveCreditFacilityInvoiceData(
  data: SaveCreditFacilityInvoiceDataOptions,
): SaveCreditFacilityInvoiceMutation {
  return {
    __typename: "Mutation" as const,
    saveCreditFacilityInvoice: maybeNew(
      "SaveCreditFacilityInvoiceResult",
      data["saveCreditFacilityInvoice"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveCreditFacilityInvoiceResponse(
  variables: SaveCreditFacilityInvoiceMutationVariables,
  data: SaveCreditFacilityInvoiceDataOptions | Error,
): MockedResponse<SaveCreditFacilityInvoiceMutationVariables, SaveCreditFacilityInvoiceMutation> {
  return {
    request: { query: SaveCreditFacilityInvoiceDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveCreditFacilityInvoiceData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreditFacilityInvoicePopulatedDataOptions {
  creditFacilityInvoices?: CreditFacilityInvoiceOptions[];
}

export function newCreditFacilityInvoicePopulatedData(
  data: CreditFacilityInvoicePopulatedDataOptions,
): CreditFacilityInvoicePopulatedQuery {
  return {
    __typename: "Query" as const,
    creditFacilityInvoices: data["creditFacilityInvoices"]?.map((d) => newCreditFacilityInvoice(d)) || [],
  } as any;
}

export function newCreditFacilityInvoicePopulatedResponse(
  variables: CreditFacilityInvoicePopulatedQueryVariables,
  data: CreditFacilityInvoicePopulatedDataOptions | Error,
): MockedResponse<CreditFacilityInvoicePopulatedQueryVariables, CreditFacilityInvoicePopulatedQuery> {
  return {
    request: { query: CreditFacilityInvoicePopulatedDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreditFacilityInvoicePopulatedData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundLoanManagementFundDataOptions {
  funds?: FundOptions[];
}

export function newFundLoanManagementFundData(data: FundLoanManagementFundDataOptions): FundLoanManagementFundQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundLoanManagementFundResponse(
  variables: FundLoanManagementFundQueryVariables,
  data: FundLoanManagementFundDataOptions | Error,
): MockedResponse<FundLoanManagementFundQueryVariables, FundLoanManagementFundQuery> {
  return {
    request: { query: FundLoanManagementFundDocument, variables },
    result: { data: data instanceof Error ? undefined : newFundLoanManagementFundData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface FundLoanManagementFundDrawRequestsDataOptions {
  funds?: FundOptions[];
}

export function newFundLoanManagementFundDrawRequestsData(
  data: FundLoanManagementFundDrawRequestsDataOptions,
): FundLoanManagementFundDrawRequestsQuery {
  return { __typename: "Query" as const, funds: data["funds"]?.map((d) => newFund(d)) || [] } as any;
}

export function newFundLoanManagementFundDrawRequestsResponse(
  variables: FundLoanManagementFundDrawRequestsQueryVariables,
  data: FundLoanManagementFundDrawRequestsDataOptions | Error,
): MockedResponse<FundLoanManagementFundDrawRequestsQueryVariables, FundLoanManagementFundDrawRequestsQuery> {
  return {
    request: { query: FundLoanManagementFundDrawRequestsDocument, variables },
    result: { data: data instanceof Error ? undefined : newFundLoanManagementFundDrawRequestsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteCreditFacilityDrawRequestDataOptions {
  deleteCreditFacilityDrawRequest?: EmptyResultOptions;
}

export function newDeleteCreditFacilityDrawRequestData(
  data: DeleteCreditFacilityDrawRequestDataOptions,
): DeleteCreditFacilityDrawRequestMutation {
  return {
    __typename: "Mutation" as const,
    deleteCreditFacilityDrawRequest: maybeNew("EmptyResult", data["deleteCreditFacilityDrawRequest"] || undefined, {}),
  } as any;
}

export function newDeleteCreditFacilityDrawRequestResponse(
  variables: DeleteCreditFacilityDrawRequestMutationVariables,
  data: DeleteCreditFacilityDrawRequestDataOptions | Error,
): MockedResponse<DeleteCreditFacilityDrawRequestMutationVariables, DeleteCreditFacilityDrawRequestMutation> {
  return {
    request: { query: DeleteCreditFacilityDrawRequestDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteCreditFacilityDrawRequestData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface QueueJobsDataOptions {
  addJobs?: EmptyResultOptions;
}

export function newQueueJobsData(data: QueueJobsDataOptions): QueueJobsMutation {
  return { __typename: "Mutation" as const, addJobs: maybeNew("EmptyResult", data["addJobs"] || undefined, {}) } as any;
}

export function newQueueJobsResponse(
  variables: QueueJobsMutationVariables,
  data: QueueJobsDataOptions | Error,
): MockedResponse<QueueJobsMutationVariables, QueueJobsMutation> {
  return {
    request: { query: QueueJobsDocument, variables },
    result: { data: data instanceof Error ? undefined : newQueueJobsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreditFacilityDrawRequestCreatePollingDataOptions {
  creditFacilityDrawRequests?: CreditFacilityDrawRequestOptions[];
}

export function newCreditFacilityDrawRequestCreatePollingData(
  data: CreditFacilityDrawRequestCreatePollingDataOptions,
): CreditFacilityDrawRequestCreatePollingQuery {
  return {
    __typename: "Query" as const,
    creditFacilityDrawRequests: data["creditFacilityDrawRequests"]?.map((d) => newCreditFacilityDrawRequest(d)) || [],
  } as any;
}

export function newCreditFacilityDrawRequestCreatePollingResponse(
  variables: CreditFacilityDrawRequestCreatePollingQueryVariables,
  data: CreditFacilityDrawRequestCreatePollingDataOptions | Error,
): MockedResponse<CreditFacilityDrawRequestCreatePollingQueryVariables, CreditFacilityDrawRequestCreatePollingQuery> {
  return {
    request: { query: CreditFacilityDrawRequestCreatePollingDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreditFacilityDrawRequestCreatePollingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface AddDrawsToPaymentDataOptions {
  addOpenDrawsToCreditFacilityPayment?: AddOpenDrawsToCreditFacilityPaymentResultOptions;
}

export function newAddDrawsToPaymentData(data: AddDrawsToPaymentDataOptions): AddDrawsToPaymentMutation {
  return {
    __typename: "Mutation" as const,
    addOpenDrawsToCreditFacilityPayment: maybeNew(
      "AddOpenDrawsToCreditFacilityPaymentResult",
      data["addOpenDrawsToCreditFacilityPayment"] || undefined,
      {},
    ),
  } as any;
}

export function newAddDrawsToPaymentResponse(
  variables: AddDrawsToPaymentMutationVariables,
  data: AddDrawsToPaymentDataOptions | Error,
): MockedResponse<AddDrawsToPaymentMutationVariables, AddDrawsToPaymentMutation> {
  return {
    request: { query: AddDrawsToPaymentDocument, variables },
    result: { data: data instanceof Error ? undefined : newAddDrawsToPaymentData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotAcqPurchaseAgreementDataOptions {
  saveLotAcqPurchaseAgreement?: SaveLotAcqPurchaseAgreementResultOptions;
}

export function newSaveLotAcqPurchaseAgreementData(
  data: SaveLotAcqPurchaseAgreementDataOptions,
): SaveLotAcqPurchaseAgreementMutation {
  return {
    __typename: "Mutation" as const,
    saveLotAcqPurchaseAgreement: maybeNew(
      "SaveLotAcqPurchaseAgreementResult",
      data["saveLotAcqPurchaseAgreement"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveLotAcqPurchaseAgreementResponse(
  variables: SaveLotAcqPurchaseAgreementMutationVariables,
  data: SaveLotAcqPurchaseAgreementDataOptions | Error,
): MockedResponse<SaveLotAcqPurchaseAgreementMutationVariables, SaveLotAcqPurchaseAgreementMutation> {
  return {
    request: { query: SaveLotAcqPurchaseAgreementDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotAcqPurchaseAgreementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteLotAcqPurchaseAgreementDataOptions {
  deleteLotAcqPurchaseAgreement?: EmptyResultOptions;
}

export function newDeleteLotAcqPurchaseAgreementData(
  data: DeleteLotAcqPurchaseAgreementDataOptions,
): DeleteLotAcqPurchaseAgreementMutation {
  return {
    __typename: "Mutation" as const,
    deleteLotAcqPurchaseAgreement: maybeNew("EmptyResult", data["deleteLotAcqPurchaseAgreement"] || undefined, {}),
  } as any;
}

export function newDeleteLotAcqPurchaseAgreementResponse(
  variables: DeleteLotAcqPurchaseAgreementMutationVariables,
  data: DeleteLotAcqPurchaseAgreementDataOptions | Error,
): MockedResponse<DeleteLotAcqPurchaseAgreementMutationVariables, DeleteLotAcqPurchaseAgreementMutation> {
  return {
    request: { query: DeleteLotAcqPurchaseAgreementDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteLotAcqPurchaseAgreementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotAcqPurchaseAgreementDocumentsDataOptions {
  documents?: DocumentOptions[];
}

export function newLotAcqPurchaseAgreementDocumentsData(
  data: LotAcqPurchaseAgreementDocumentsDataOptions,
): LotAcqPurchaseAgreementDocumentsQuery {
  return { __typename: "Query" as const, documents: data["documents"]?.map((d) => newDocument(d)) || [] } as any;
}

export function newLotAcqPurchaseAgreementDocumentsResponse(
  variables: LotAcqPurchaseAgreementDocumentsQueryVariables,
  data: LotAcqPurchaseAgreementDocumentsDataOptions | Error,
): MockedResponse<LotAcqPurchaseAgreementDocumentsQueryVariables, LotAcqPurchaseAgreementDocumentsQuery> {
  return {
    request: { query: LotAcqPurchaseAgreementDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotAcqPurchaseAgreementDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotAcqSettlementStatementDataOptions {
  saveLotAcqSettlementStatement?: SaveLotAcqSettlementStatementResultOptions;
}

export function newSaveLotAcqSettlementStatementData(
  data: SaveLotAcqSettlementStatementDataOptions,
): SaveLotAcqSettlementStatementMutation {
  return {
    __typename: "Mutation" as const,
    saveLotAcqSettlementStatement: maybeNew(
      "SaveLotAcqSettlementStatementResult",
      data["saveLotAcqSettlementStatement"] || undefined,
      {},
    ),
  } as any;
}

export function newSaveLotAcqSettlementStatementResponse(
  variables: SaveLotAcqSettlementStatementMutationVariables,
  data: SaveLotAcqSettlementStatementDataOptions | Error,
): MockedResponse<SaveLotAcqSettlementStatementMutationVariables, SaveLotAcqSettlementStatementMutation> {
  return {
    request: { query: SaveLotAcqSettlementStatementDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotAcqSettlementStatementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeleteLotAcqSettlementStatementDataOptions {
  deleteLotAcqSettlementStatement?: EmptyResultOptions;
}

export function newDeleteLotAcqSettlementStatementData(
  data: DeleteLotAcqSettlementStatementDataOptions,
): DeleteLotAcqSettlementStatementMutation {
  return {
    __typename: "Mutation" as const,
    deleteLotAcqSettlementStatement: maybeNew("EmptyResult", data["deleteLotAcqSettlementStatement"] || undefined, {}),
  } as any;
}

export function newDeleteLotAcqSettlementStatementResponse(
  variables: DeleteLotAcqSettlementStatementMutationVariables,
  data: DeleteLotAcqSettlementStatementDataOptions | Error,
): MockedResponse<DeleteLotAcqSettlementStatementMutationVariables, DeleteLotAcqSettlementStatementMutation> {
  return {
    request: { query: DeleteLotAcqSettlementStatementDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeleteLotAcqSettlementStatementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendLotAcqSettlementStatementForBookingDataOptions {
  sendLotAcqSettlementStatementForBooking?: LotAcqSettlementStatementOptions;
}

export function newSendLotAcqSettlementStatementForBookingData(
  data: SendLotAcqSettlementStatementForBookingDataOptions,
): SendLotAcqSettlementStatementForBookingMutation {
  return {
    __typename: "Mutation" as const,
    sendLotAcqSettlementStatementForBooking: maybeNew(
      "LotAcqSettlementStatement",
      data["sendLotAcqSettlementStatementForBooking"] || undefined,
      {},
    ),
  } as any;
}

export function newSendLotAcqSettlementStatementForBookingResponse(
  variables: SendLotAcqSettlementStatementForBookingMutationVariables,
  data: SendLotAcqSettlementStatementForBookingDataOptions | Error,
): MockedResponse<
  SendLotAcqSettlementStatementForBookingMutationVariables,
  SendLotAcqSettlementStatementForBookingMutation
> {
  return {
    request: { query: SendLotAcqSettlementStatementForBookingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendLotAcqSettlementStatementForBookingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface ProcessLotAcqSettlementStatementOcrDataOptions {
  processLotAcqSettlementStatementOcr?: LotAcqSettlementStatementOptions;
}

export function newProcessLotAcqSettlementStatementOcrData(
  data: ProcessLotAcqSettlementStatementOcrDataOptions,
): ProcessLotAcqSettlementStatementOcrMutation {
  return {
    __typename: "Mutation" as const,
    processLotAcqSettlementStatementOcr: maybeNew(
      "LotAcqSettlementStatement",
      data["processLotAcqSettlementStatementOcr"] || undefined,
      {},
    ),
  } as any;
}

export function newProcessLotAcqSettlementStatementOcrResponse(
  variables: ProcessLotAcqSettlementStatementOcrMutationVariables,
  data: ProcessLotAcqSettlementStatementOcrDataOptions | Error,
): MockedResponse<ProcessLotAcqSettlementStatementOcrMutationVariables, ProcessLotAcqSettlementStatementOcrMutation> {
  return {
    request: { query: ProcessLotAcqSettlementStatementOcrDocument, variables },
    result: { data: data instanceof Error ? undefined : newProcessLotAcqSettlementStatementOcrData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotAcqSettlementStatementDocumentsDataOptions {
  documents?: DocumentOptions[];
}

export function newLotAcqSettlementStatementDocumentsData(
  data: LotAcqSettlementStatementDocumentsDataOptions,
): LotAcqSettlementStatementDocumentsQuery {
  return { __typename: "Query" as const, documents: data["documents"]?.map((d) => newDocument(d)) || [] } as any;
}

export function newLotAcqSettlementStatementDocumentsResponse(
  variables: LotAcqSettlementStatementDocumentsQueryVariables,
  data: LotAcqSettlementStatementDocumentsDataOptions | Error,
): MockedResponse<LotAcqSettlementStatementDocumentsQueryVariables, LotAcqSettlementStatementDocumentsQuery> {
  return {
    request: { query: LotAcqSettlementStatementDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotAcqSettlementStatementDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotPartitionDocumentsDataOptions {
  documents?: DocumentOptions[];
  lotPartitions?: LotPartitionOptions[];
}

export function newLotPartitionDocumentsData(data: LotPartitionDocumentsDataOptions): LotPartitionDocumentsQuery {
  return {
    __typename: "Query" as const,
    documents: data["documents"]?.map((d) => newDocument(d)) || [],
    lotPartitions: data["lotPartitions"]?.map((d) => newLotPartition(d)) || [],
  } as any;
}

export function newLotPartitionDocumentsResponse(
  variables: LotPartitionDocumentsQueryVariables,
  data: LotPartitionDocumentsDataOptions | Error,
): MockedResponse<LotPartitionDocumentsQueryVariables, LotPartitionDocumentsQuery> {
  return {
    request: { query: LotPartitionDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotPartitionDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotPartitionDocumentsDataOptions {
  saveDocuments?: SaveDocumentsResultOptions;
}

export function newSaveLotPartitionDocumentsData(
  data: SaveLotPartitionDocumentsDataOptions,
): SaveLotPartitionDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveLotPartitionDocumentsResponse(
  variables: SaveLotPartitionDocumentsMutationVariables,
  data: SaveLotPartitionDocumentsDataOptions | Error,
): MockedResponse<SaveLotPartitionDocumentsMutationVariables, SaveLotPartitionDocumentsMutation> {
  return {
    request: { query: SaveLotPartitionDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotPartitionDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePropertySaleSettlementStatementDataOptions {
  savePropertySaleSettlementStatement?: SavePropertySaleSettlementStatementResultOptions;
}

export function newSavePropertySaleSettlementStatementData(
  data: SavePropertySaleSettlementStatementDataOptions,
): SavePropertySaleSettlementStatementMutation {
  return {
    __typename: "Mutation" as const,
    savePropertySaleSettlementStatement: maybeNew(
      "SavePropertySaleSettlementStatementResult",
      data["savePropertySaleSettlementStatement"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePropertySaleSettlementStatementResponse(
  variables: SavePropertySaleSettlementStatementMutationVariables,
  data: SavePropertySaleSettlementStatementDataOptions | Error,
): MockedResponse<SavePropertySaleSettlementStatementMutationVariables, SavePropertySaleSettlementStatementMutation> {
  return {
    request: { query: SavePropertySaleSettlementStatementDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePropertySaleSettlementStatementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotOverviewLotDataOptions {
  lots?: LotOptions[];
}

export function newLotOverviewLotData(data: LotOverviewLotDataOptions): LotOverviewLotQuery {
  return { __typename: "Query" as const, lots: data["lots"]?.map((d) => newLot(d)) || [] } as any;
}

export function newLotOverviewLotResponse(
  variables: LotOverviewLotQueryVariables,
  data: LotOverviewLotDataOptions | Error,
): MockedResponse<LotOverviewLotQueryVariables, LotOverviewLotQuery> {
  return {
    request: { query: LotOverviewLotDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotOverviewLotData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveLotPartitionsDataOptions {
  saveLotPartitions?: SaveLotPartitionsResultOptions;
}

export function newSaveLotPartitionsData(data: SaveLotPartitionsDataOptions): SaveLotPartitionsMutation {
  return {
    __typename: "Mutation" as const,
    saveLotPartitions: maybeNew("SaveLotPartitionsResult", data["saveLotPartitions"] || undefined, {}),
  } as any;
}

export function newSaveLotPartitionsResponse(
  variables: SaveLotPartitionsMutationVariables,
  data: SaveLotPartitionsDataOptions | Error,
): MockedResponse<SaveLotPartitionsMutationVariables, SaveLotPartitionsMutation> {
  return {
    request: { query: SaveLotPartitionsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveLotPartitionsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveDocumentsDataOptions {
  saveDocuments?: SaveDocumentsResultOptions;
}

export function newSaveDocumentsData(data: SaveDocumentsDataOptions): SaveDocumentsMutation {
  return {
    __typename: "Mutation" as const,
    saveDocuments: maybeNew("SaveDocumentsResult", data["saveDocuments"] || undefined, {}),
  } as any;
}

export function newSaveDocumentsResponse(
  variables: SaveDocumentsMutationVariables,
  data: SaveDocumentsDataOptions | Error,
): MockedResponse<SaveDocumentsMutationVariables, SaveDocumentsMutation> {
  return {
    request: { query: SaveDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newSaveDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface LotDocumentsDataOptions {
  lots?: LotOptions[];
}

export function newLotDocumentsData(data: LotDocumentsDataOptions): LotDocumentsQuery {
  return { __typename: "Query" as const, lots: data["lots"]?.map((d) => newLot(d)) || [] } as any;
}

export function newLotDocumentsResponse(
  variables: LotDocumentsQueryVariables,
  data: LotDocumentsDataOptions | Error,
): MockedResponse<LotDocumentsQueryVariables, LotDocumentsQuery> {
  return {
    request: { query: LotDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newLotDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface CreateDirectUnderwritingContractsDataOptions {
  createDirectUnderwritingContracts?: CreateDirectUnderwritingContractsResultOptions;
}

export function newCreateDirectUnderwritingContractsData(
  data: CreateDirectUnderwritingContractsDataOptions,
): CreateDirectUnderwritingContractsMutation {
  return {
    __typename: "Mutation" as const,
    createDirectUnderwritingContracts: maybeNew(
      "CreateDirectUnderwritingContractsResult",
      data["createDirectUnderwritingContracts"] || undefined,
      {},
    ),
  } as any;
}

export function newCreateDirectUnderwritingContractsResponse(
  variables: CreateDirectUnderwritingContractsMutationVariables,
  data: CreateDirectUnderwritingContractsDataOptions | Error,
): MockedResponse<CreateDirectUnderwritingContractsMutationVariables, CreateDirectUnderwritingContractsMutation> {
  return {
    request: { query: CreateDirectUnderwritingContractsDocument, variables },
    result: { data: data instanceof Error ? undefined : newCreateDirectUnderwritingContractsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SavePropertySaleSettlementStatementEditorDataOptions {
  savePropertySaleSettlementStatement?: SavePropertySaleSettlementStatementResultOptions;
}

export function newSavePropertySaleSettlementStatementEditorData(
  data: SavePropertySaleSettlementStatementEditorDataOptions,
): SavePropertySaleSettlementStatementEditorMutation {
  return {
    __typename: "Mutation" as const,
    savePropertySaleSettlementStatement: maybeNew(
      "SavePropertySaleSettlementStatementResult",
      data["savePropertySaleSettlementStatement"] || undefined,
      {},
    ),
  } as any;
}

export function newSavePropertySaleSettlementStatementEditorResponse(
  variables: SavePropertySaleSettlementStatementEditorMutationVariables,
  data: SavePropertySaleSettlementStatementEditorDataOptions | Error,
): MockedResponse<
  SavePropertySaleSettlementStatementEditorMutationVariables,
  SavePropertySaleSettlementStatementEditorMutation
> {
  return {
    request: { query: SavePropertySaleSettlementStatementEditorDocument, variables },
    result: { data: data instanceof Error ? undefined : newSavePropertySaleSettlementStatementEditorData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface DeletePropertySaleSettlementStatementDataOptions {
  deletePropertySaleSettlementStatement?: EmptyResultOptions;
}

export function newDeletePropertySaleSettlementStatementData(
  data: DeletePropertySaleSettlementStatementDataOptions,
): DeletePropertySaleSettlementStatementMutation {
  return {
    __typename: "Mutation" as const,
    deletePropertySaleSettlementStatement: maybeNew(
      "EmptyResult",
      data["deletePropertySaleSettlementStatement"] || undefined,
      {},
    ),
  } as any;
}

export function newDeletePropertySaleSettlementStatementResponse(
  variables: DeletePropertySaleSettlementStatementMutationVariables,
  data: DeletePropertySaleSettlementStatementDataOptions | Error,
): MockedResponse<
  DeletePropertySaleSettlementStatementMutationVariables,
  DeletePropertySaleSettlementStatementMutation
> {
  return {
    request: { query: DeletePropertySaleSettlementStatementDocument, variables },
    result: { data: data instanceof Error ? undefined : newDeletePropertySaleSettlementStatementData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface SendPropertySaleSettlementStatementForBookingDataOptions {
  sendPropertySaleSettlementStatementForBooking?: PropertySaleSettlementStatementOptions;
}

export function newSendPropertySaleSettlementStatementForBookingData(
  data: SendPropertySaleSettlementStatementForBookingDataOptions,
): SendPropertySaleSettlementStatementForBookingMutation {
  return {
    __typename: "Mutation" as const,
    sendPropertySaleSettlementStatementForBooking: maybeNew(
      "PropertySaleSettlementStatement",
      data["sendPropertySaleSettlementStatementForBooking"] || undefined,
      {},
    ),
  } as any;
}

export function newSendPropertySaleSettlementStatementForBookingResponse(
  variables: SendPropertySaleSettlementStatementForBookingMutationVariables,
  data: SendPropertySaleSettlementStatementForBookingDataOptions | Error,
): MockedResponse<
  SendPropertySaleSettlementStatementForBookingMutationVariables,
  SendPropertySaleSettlementStatementForBookingMutation
> {
  return {
    request: { query: SendPropertySaleSettlementStatementForBookingDocument, variables },
    result: { data: data instanceof Error ? undefined : newSendPropertySaleSettlementStatementForBookingData(data) },
    error: data instanceof Error ? data : undefined,
  };
}
interface PropertySaleSettlementStatementDocumentsDataOptions {
  documents?: DocumentOptions[];
}

export function newPropertySaleSettlementStatementDocumentsData(
  data: PropertySaleSettlementStatementDocumentsDataOptions,
): PropertySaleSettlementStatementDocumentsQuery {
  return { __typename: "Query" as const, documents: data["documents"]?.map((d) => newDocument(d)) || [] } as any;
}

export function newPropertySaleSettlementStatementDocumentsResponse(
  variables: PropertySaleSettlementStatementDocumentsQueryVariables,
  data: PropertySaleSettlementStatementDocumentsDataOptions | Error,
): MockedResponse<
  PropertySaleSettlementStatementDocumentsQueryVariables,
  PropertySaleSettlementStatementDocumentsQuery
> {
  return {
    request: { query: PropertySaleSettlementStatementDocumentsDocument, variables },
    result: { data: data instanceof Error ? undefined : newPropertySaleSettlementStatementDocumentsData(data) },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };

import { dateTimeTypePolicy, dateTypePolicy } from "src/utils/dates";

export const scalarTypePolicies = {
  Address: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  AnchorFloatingDrawModel: { fields: { asOfDate: dateTypePolicy } },
  AnchorFloatingDrawModelCostItem: { fields: { date: dateTypePolicy } },
  AnchorMultilotDrawModel: { fields: { asOfDate: dateTypePolicy } },
  AnchorMultilotDrawModelCostItem: { fields: { date: dateTypePolicy } },
  Asset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Configuration: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, completedDate: dateTimeTypePolicy },
  },
  ConfigurationToOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  CreditFacilityDraw: {
    fields: { drawDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreditFacilityDrawRequest: {
    fields: { preparationDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreditFacilityInvoice: {
    fields: { invoiceDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreditFacilityInvoiceDrawInterest: {
    fields: { interestDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  CreditFacilityPayment: {
    fields: { paymentDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  Elevation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ElevationStyle: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  EquityFinancingCost: {
    fields: { interestDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  ExteriorImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Floor: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Fund: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, closedBooksDate: dateTypePolicy } },
  FundMetro: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  GoldmanDrawModel: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, asOfDate: dateTypePolicy },
  },
  GoldmanDrawModelCostItem: { fields: { date: dateTypePolicy } },
  HelloWorld: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HomePriceAppreciationMonthlyMultiplier: {
    fields: { valuationDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  Homeowner: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, lastActive: dateTimeTypePolicy },
  },
  InteriorImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InternalUser: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Lot: {
    fields: {
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      underwrittenDate: dateTypePolicy,
      acquisitionDate: dateTypePolicy,
      fundContributionDate: dateTypePolicy,
      underContractDate: dateTypePolicy,
      contingencyExpirationDate: dateTypePolicy,
      expectedCloseDate: dateTypePolicy,
    },
  },
  LotAcqSettlementStatement: { fields: { settlementDate: dateTypePolicy } },
  LotPartition: {
    fields: {
      moveInDate: dateTypePolicy,
      createdAt: dateTimeTypePolicy,
      updatedAt: dateTimeTypePolicy,
      valuationDate: dateTypePolicy,
      expectedCompletionDate: dateTypePolicy,
      listDate: dateTypePolicy,
      saleDate: dateTypePolicy,
      salesReadyDate: dateTypePolicy,
      preListDate: dateTypePolicy,
      permitSubmittedDate: dateTypePolicy,
      permitApprovedDate: dateTypePolicy,
      verticalBuildStartDate: dateTypePolicy,
      underContractDate: dateTypePolicy,
      appraisalDate: dateTypePolicy,
      remediationExpectedCompletionDate: dateTypePolicy,
      manualExpectedSaleDate: dateTypePolicy,
      expectedSaleDate: dateTypePolicy,
    },
  },
  LotPartitionContract: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LotPartitionDraw: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LotPartitionDrawPayment: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LotPartitionDrawRequest: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LotPartitionEstimate: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  LotPartitionInvoice: { fields: { invoiceDate: dateTypePolicy } },
  LotPartitionPayment: {
    fields: { paymentDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  LotPartitionValuation: {
    fields: { valuationDate: dateTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy },
  },
  Metro: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Option: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionToOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionToSpecLevel: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Plan: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  PropertySaleSettlementStatement: { fields: { settlementDate: dateTypePolicy } },
  History: { fields: { recordedAt: dateTimeTypePolicy } },
  SeasonalityMonthlyMultiplier: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SpecLevel: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SpecLevelStyle: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  User: { fields: { deactivatedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
};
